import "core-js/modules/esnext.string.match-all.js";
import { getImage, GatsbyImage, withArtDirection } from 'gatsby-plugin-image';
import React, { useState, useCallback, useEffect, createContext, useContext, createElement, isValidElement, cloneElement, useRef, useMemo, forwardRef } from 'react';
import { useTheme, ThemeProvider as ThemeProvider$1, responsiveFontSizes, createTheme, makeStyles, alpha as alpha$1, withStyles as withStyles$1 } from '@material-ui/core/styles';
import _merge from 'lodash/merge';
import styled, { ThemeProvider as ThemeProvider$2, css, createGlobalStyle, keyframes, useTheme as useTheme$2 } from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useI18next, Link as Link$3 } from 'gatsby-plugin-react-i18next';
import { useIsomorphicLayoutEffect } from 'react-use';
import gsap$1, { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useQuery } from '@apollo/client';
import { Box, Accordion as Accordion$1, alpha, getLuminance, AccordionSummary, AccordionDetails, darken, lighten, TextField as TextField$1, Grid, Backdrop as Backdrop$1, useTheme as useTheme$1, useMediaQuery as useMediaQuery$1, Link as Link$1, withStyles, FormControlLabel, Switch, Container as Container$4, Select, Modal, MenuItem, Unstable_TrapFocus, AppBar, Toolbar, Button as Button$1, Fade, IconButton, SvgIcon, Paper, Portal as Portal$1, FormControl as FormControl$1, Checkbox as Checkbox$2, FormHelperText as FormHelperText$1, FormLabel as FormLabel$1, FormGroup, NativeSelect, Tooltip, List, ListItemSecondaryAction, Slider as Slider$1, InputLabel as InputLabel$1, Slide, ListItem, ButtonBase, ListItemText } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { spacing, style } from '@material-ui/system';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import { useField } from 'formik';
import { throttle, pickBy, get as get$1, findIndex as findIndex$1, kebabCase, noop as noop$2 } from 'lodash';
import MuiTextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ExpoScaleEase } from 'gsap/EasePack';
import * as ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollToPlugin__default, { ScrollToPlugin as ScrollToPlugin$1 } from 'gsap/ScrollToPlugin';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import SlickSlider from 'react-slick';
import ReactContentfulImage from 'react-contentful-image';
import { Link as Link$2, Location } from '@gatsbyjs/reach-router';
import { MoreVert, Cancel, LinkedIn, Facebook, Instagram, YouTube, Menu, Close, CloudUpload, Settings, PauseRounded, PlayArrowRounded, Forward10Rounded, Replay10Rounded, ClosedCaption, Subject, Subtitles, FullscreenExitRounded, FullscreenRounded, ChevronRight, ChevronLeft, VolumeOffRounded, VolumeUpRounded, VolumeDownRounded, VolumeMuteRounded } from '@material-ui/icons';
import LocationIcon from '@material-ui/icons/Language';
import Box$1 from '@material-ui/core/Box';
import Container$5 from '@material-ui/core/Container';
import { useInView } from 'react-intersection-observer';
import { darken as darken$1, lighten as lighten$1 } from '@material-ui/core/styles/colorManipulator';
import { Portal, PortalWithState } from 'react-portal';
import Helmet from 'react-helmet';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem$1 from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';
import FormControlLabel$1 from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import axios from 'axios';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var defaultOptions$1 = {};
function getDefaultOptions() {
  return defaultOptions$1;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds$1(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$2 = match$1;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$6 = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$2,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale$6;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
const isBrowser = typeof window !== 'undefined';
const capitalize$1 = word => typeof word === 'string' ? word.charAt(0).toUpperCase() + word.slice(1) : word;
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const getDataFromJsonQuery = (data, rootNodeName) => {
  try {
    return data[rootNodeName].edges.map(item => item.node);
  } catch (err) {
    console.log("Error parsing JSON data for ".concat(rootNodeName), err);
    return [];
  }
};
const isIntersectionObserverSupported = () => {
  return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const calcPageFillRadius = (x, y, windowWidth, windowHeight) => {
  const l = Math.max(x - 0, windowWidth - x);
  const h = Math.max(y - 0, windowHeight - y);
  return Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2));
};
const getDevicePixelRatio = function () {
  let maxDpr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2.0;
  return isBrowser ? Math.min(Math.max(Math.round(window.devicePixelRatio), 1), maxDpr).toFixed(1) : '1.0';
};
const reduceImages = edges => edges.reduce((acc, cur) => ({
  ...acc,
  [cur.node.name]: getImage(cur.node)
}), {});
const groupBy = (data, type) => data.reduce((acc, cur) => {
  cur[type].forEach(t => {
    if (!acc[t]) acc[t] = [];
    acc[t].push(cur);
  });
  return acc;
}, {});

/**
 * Add a script tag to the DOM. Return true early if that id is already in the DOM
 * @param  {String} src The path to the script
 * @param  {HTMLElement} location The DOM location to insert the script
 * @param  {String} id The id to be set on the script tag.
 * @return {Boolean} return true if script is added and false if the id was already in the DOM
 */
function loadScript(src, location, id) {
  if (!location || !src) {
    throw new Error("src and location are required parameters.");
  }
  if (document.getElementById(id)) return false;
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  location.appendChild(script);
  return true;
}
function checkScrollAmount(element) {
  return Math.max(element.scrollHeight - element.clientHeight, 0);
}
const HOUR_MS = 1000 * 60 * 60;
function timestampToTime(timestamp) {
  var helperDate = addSeconds$1(new Date(0), timestamp);
  if (helperDate.getTime() >= HOUR_MS) return format(helperDate, 'hh:mm:ss');
  return format(helperDate, 'mm:ss');
}
const msToTime = ms => {
  const toStringWPad = num => num.toString().padStart(2, '0');

  // const milliseconds = Math.floor((ms % 1000) / 100)
  const hours = Math.floor(ms / (1000 * 60 * 60) % 24);
  const hoursTxt = hours ? "".concat(toStringWPad(hours), ":") : '';
  const minutesTxt = toStringWPad(Math.floor(ms / (1000 * 60) % 60));
  const secondsTxt = toStringWPad(Math.floor(ms / 1000 % 60));
  return "".concat(hoursTxt).concat(minutesTxt, ":").concat(secondsTxt);
};
const setCookie = (cname, cvalue, exdays,
// Note: If you want the cookie to apply only to the current subdomain, leave domain undefined.
domain) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  const cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, ";path=/").concat(domain ? ";domain=".concat(domain) : '');
  document.cookie = cookie;
};
const getCookie = cname => {
  if (typeof document === 'undefined') return undefined;
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
const getExpiredCookie = function (key) {
  let domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const domainStr = domain && "Domain=".concat(domain, ";");
  return "".concat(key, "=;Path=/;").concat(domainStr, "Expires=Thu, 01 Jan 1970 00:00:00 GMT");
};
const deleteAllCookies = () => {
  const {
    hostname
  } = window.location;
  const temp = hostname.split('.').reverse();
  const root_domain = '.' + temp[1] + '.' + temp[0];
  const domain = hostname === 'localhost' ? hostname : root_domain;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    const expiredRootCookie = getExpiredCookie(name, domain);
    const expiredSubCookie = getExpiredCookie(name);
    document.cookie = expiredSubCookie;
    document.cookie = expiredRootCookie;
  }
};
const storageItemExists$1 = item => typeof window !== 'undefined' && localStorage.getItem(item) !== null;
const getStorageItem = item => typeof window !== 'undefined' && localStorage.getItem(item);
const setStorageItem = (item, value) => typeof window !== 'undefined' && localStorage.setItem(item, value);
const removeStorageItem = item => typeof window !== 'undefined' && localStorage.removeItem(item);
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
const transformValues = payload => {
  Object.keys(payload).forEach(key => {
    payload[key] = typeof payload[key] === 'string' ? payload[key].replace(/[' -]/g, '_').toLowerCase() : payload[key];
  });
  return payload;
};
const trackEvent = originalPayload => {
  // if (IS_DEVELOPMENT) {
  //   return console.log('trackEvent [dev]', payload)
  // }

  const payload = transformValues(originalPayload);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
const hsIdentify = params => {
  const _hsq = window._hsq = window._hsq || [];
  _hsq.push(['identify', params]);
};
function identify(params) {
  if (IS_DEVELOPMENT) {
    return console.log('identify [dev]', params);
  }
  hsIdentify(params);
}
const tracking = {
  identify: identify,
  track: trackEvent
};
const signature = "%c\n\n######              ]######\n######              ]######\n######              ]######\n######              ]######\n######   ,,,,,,,,   ]######  ,,,,,,,\n######  #######k    ]######  ]#####b\n###### #######k     ]######  ]#####b\n############k       ]######  ]#####b\n##########k         ]######  ]#####b\n###########K        ]######  ]#####b\n######@######K      ]######  ]#####b\n###### 7#######K    ]######  ]#####b\n######   5#######K  ]######  ]#####b\n######    '#######K ]######  ]#####b\n \n     ,s###########  ]######   %c#####%c\n   x##############  ]######  %c#######%c\n  #########WWWWWWW  ]######   %c#####%c\n @######,           ]######\n @#####b            ]######   #######M\n @######,           ]###### @#######k\n  @###############  ]#############^\n   7@#############  ]###########k\n     |7%W#########  ]#########m\n                    ]###########Q\n                    ]######@######Q\n                    ]###### 7#######Q\n                    ]######   7#######p\n                    ^^^^^^^    ^^^^^^^^\n\n#  #   ####    ##     #     #####  #  #\n####   #--    #__#    #       #    ####\n#  #   ####  #    #   ####    #    #  #\n\n----------------------------------------\nHiring now @ https://careers.klick.com\n----------------------------------------\n\n";
const consoleKlickSignature = () => {
  console.log(signature, 'color: inherit;', 'color: #0343FB;', 'color: inherit;', 'color: #0343FB;', 'color: inherit;', 'color: #0343FB;', 'color: inherit;');
};

// NOTE: The paths below are what will be required post-build in the dist folder, and does not represent the path as it appears in /src
const klickBoldWoff = require('./_assets/fonts/Klick-Bold/Klick-Bold.woff').default;
const klickBoldWoff2 = require('./_assets/fonts/Klick-Bold/Klick-Bold.woff2').default;
const PublicaSansRegularWoff = require('./_assets/fonts/PublicaSans/PublicaSans-Regular.woff').default;
const PublicaSansRegularWoff2 = require('./_assets/fonts/PublicaSans/PublicaSans-Regular.woff2').default;
const PublicaSansMediumWoff = require('./_assets/fonts/PublicaSans/PublicaSans-Medium.woff').default;
const PublicaSansMediumWoff2 = require('./_assets/fonts/PublicaSans/PublicaSans-Medium.woff2').default;
const brandColors = {
  klick: '#0343fb',
  consulting: '#993399',
  katalyst: '#009999',
  appliedsciences: '#cf253f',
  ventures: '#3ccb2a',
  careers: '#0343fb',
  group: '#0343fb',
  sensei: '#473762',
  IDX: '#0343fb',
  Anniversary25th: '#0343fb',
  btwelve: '#7d12ff',
  media: '#0343fb',
  transformation: '#0343fb',
  bloodball: '#BC1F1A'
};
const brandStyles = {
  klick: {
    palette: {
      primary: brandColors.klick
    }
  },
  media: {
    palette: {
      primary: brandColors.media
    }
  },
  transformation: {
    palette: {
      primary: brandColors.transformation
    }
  },
  consulting: {
    palette: {
      primary: brandColors.consulting
    }
  },
  katalyst: {
    palette: {
      primary: brandColors.katalyst
    }
  },
  appliedsciences: {
    palette: {
      primary: brandColors.appliedsciences
    }
  },
  ventures: {
    palette: {
      primary: brandColors.ventures
    }
  },
  careers: {
    palette: {
      primary: brandColors.careers
    }
  },
  IDX: {
    palette: {
      primary: brandColors.IDX
    }
  },
  Anniversary25th: {
    palette: {
      primary: brandColors.Anniversary25th
    }
  },
  btwelve: {
    palette: {
      primary: brandColors.btwelve
    }
  },
  bloodball: {
    palette: {
      primary: brandColors.bloodball
    }
  }
};
const PublicaSansRegular = {
  fontFamily: 'PublicaSans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: "\n    local('PublicaSans-Regular'),\n    url(".concat(PublicaSansRegularWoff2, ") format('woff2'),\n    url('").concat(PublicaSansRegularWoff, "') format('woff');\n  ")
};
const PublicaSansMedium = {
  fontFamily: 'PublicaSans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: "\n    local('PublicaSans-Medium'),\n    url(".concat(PublicaSansMediumWoff2, ") format('woff2'),\n    url('").concat(PublicaSansMediumWoff, "') format('woff');\n  ")
};
const KlickBold = {
  fontFamily: 'KlickBold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: "\n    local('KlickBold'),\n    url(".concat(klickBoldWoff2, ") format('woff2'),\n    url('").concat(klickBoldWoff, "') format('woff');\n  ")
};
const getThemeBaseline = () => ({
  defaults: {
    spacing: {
      small: {
        xs: 4,
        md: 6,
        lg: 8
      },
      medium: {
        xs: 8,
        md: 8,
        lg: 14
      },
      large: {
        xs: 8,
        md: 16,
        lg: 28
      }
    }
  },
  palette: {
    fpo: {
      main: '#ff00bc'
    },
    background: {
      off: '#f6f6f6'
    }
  },
  typography: {
    fontFamily: "'PublicaSans', Verdana, sans-serif",
    fontFamilyKlickBold: "'KlickBold', sans-serif",
    fontPaths: {
      klickBoldWoff2,
      klickBoldWoff,
      PublicaSansMediumWoff2,
      PublicaSansMediumWoff,
      PublicaSansRegularWoff2,
      PublicaSansRegularWoff
    },
    font: {
      primary: "'PublicaSans', Verdana, sans-serif",
      secondary: "'KlickBold', sans-serif"
    },
    button: {
      textTransform: 'none',
      fontWeight: 700
    },
    h1: {
      fontFamily: "'KlickBold', sans-serif",
      fontSize: '8.4rem',
      fontWeight: 400,
      lineHeight: 1,
      letterSpacing: '-0.04em',
      marginBottom: '0.3em'
    },
    h2: {
      fontFamily: "'KlickBold', sans-serif",
      fontSize: '4.5652rem',
      fontWeight: 400,
      lineHeight: 1,
      letterSpacing: '-0.04em',
      marginBottom: '0.6em'
    },
    h3: {
      fontFamily: "'PublicaSans', Verdana, sans-serif",
      fontWeight: 700,
      fontSize: '3.7003rem',
      // lineHeight: 1.1666,
      lineHeight: 1,
      letterSpacing: '0em',
      marginBottom: '0.6666em'
    },
    h4: {
      fontFamily: "'PublicaSans', Verdana, sans-serif",
      fontSize: '2.8354rem',
      fontWeight: 700,
      // lineHeight: 1.2333,
      lineHeight: 1,
      letterSpacing: '0em',
      marginBottom: '0.7333em'
    },
    h5: {
      fontFamily: "'PublicaSans', Verdana, sans-serif",
      fontSize: '1.9706rem',
      fontWeight: 700,
      lineHeight: 1,
      letterSpacing: '0em',
      marginBottom: '0.8em'
    },
    h6: {
      fontFamily: "'PublicaSans', Verdana, sans-serif",
      fontSize: '1.1057rem',
      fontWeight: 700,
      lineHeight: 1.3666,
      letterSpacing: '0rem',
      marginBottom: '0.8666em'
    },
    subtitle1: {
      fontWeight: '700',
      fontSize: '1.5rem',
      lineHeight: '1.5',
      letterSpacing: '0em'
    },
    subtitle2: {
      fontWeight: '700',
      fontSize: '1.3rem',
      lineHeight: '1.334',
      letterSpacing: '0em'
    }
  },
  shape: {
    borderRadius: 0
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [PublicaSansRegular, PublicaSansMedium, KlickBold]
      }
    }
  }
});
const xsStyles = {
  h1: {
    fontSize: '3rem'
  },
  h2: {
    fontSize: '2.4884rem'
  },
  h3: {
    fontSize: '2.0989rem'
  },
  h4: {
    fontSize: '1.7095rem'
  },
  h5: {
    fontSize: '1.32rem'
  },
  h6: {
    fontSize: '0.9305rem'
  }
};
const getOnWhiteThemeOverrides = brandStyle => ({
  palette: {
    primary: {
      main: brandStyle.palette.primary
    },
    secondary: {
      main: '#000'
    },
    text: {
      primary: '#000000'
    },
    dotFill: brandStyle.palette.primary,
    background: {
      default: '#ffffff'
    }
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#000'
      },
      arrow: {
        color: '#000'
      }
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: '#f6f5f5'
      }
    },
    MuiInputBase: {
      root: {
        '&$disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    MuiInputLabel: {
      root: {
        '&$error': {
          color: '#dE1717'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$error': {
          borderColor: '#dE1717'
        }
      }
    },
    MuiFormHelperText: {
      root: {
        '&$error': {
          color: '#dE1717'
        }
      }
    }
  }
});
const getOnBlackThemeOverrides = brandStyle => ({
  palette: {
    type: 'dark',
    primary: {
      main: brandStyle.palette.primary
    },
    secondary: {
      main: '#ffffff'
    },
    text: {
      primary: '#ffffff'
    },
    dotFill: brandStyle.palette.primary,
    background: {
      default: '#000000'
    }
  }
});
const getOnPrimaryThemeOverrides = brandStyle => ({
  palette: {
    type: 'dark',
    primary: {
      main: '#000'
    },
    secondary: {
      main: '#ffffff'
    },
    text: {
      primary: '#ffffff'
    },
    dotFill: '#ffffff',
    background: {
      default: brandStyle.palette.primary
    }
  },
  overrides: {
    MuiButton: {
      root: {
        '&$disabled': {
          color: 'rgba(0, 0, 255, 0.75)'
        }
      },
      label: {
        minWidth: '0'
      }
    },
    MuiFormLabel: {
      root: {
        color: '#fff',
        '&$focused, &$error': {
          color: '#fff'
        }
      }
    },
    MuiInputBase: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.20)'
      },
      input: {
        color: '#fff'
      }
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)'
        },
        '&$focused $notchedOutline': {
          borderColor: '#fff'
        },
        '&$error $notchedOutline': {
          borderColor: '#DE1717'
        }
      }
    },
    MuiFormHelperText: {
      root: {
        '&$error': {
          color: '#fff'
        }
      }
    },
    MuiCheckbox: {
      root: {
        color: 'rgba(0, 0, 0, 0.34)'
      }
    },
    MuiListItem: {
      root: {
        color: '#fff'
      }
    }
  }
});
const getTheme = _ref => {
  let {
    baseTheme,
    brandName,
    themeType,
    themeOverrides,
    brandOverrides
  } = _ref;
  const theme = responsiveFontSizes(createTheme(_merge({}, baseTheme, {
    brandName,
    themeType
  }, themeOverrides, {
    overrides: brandOverrides
  })), {
    factor: 3,
    disableAlign: true
  });
  const xsOverideTheme = _merge({}, theme, {
    typography: xsStyles
  });
  return xsOverideTheme;
};
const getThemes = () => Object.keys(brandStyles).reduce((acc, cur) => {
  var _brandStyle$themeOver, _brandStyle$themeOver2, _brandStyle$themeOver3;
  const brandStyle = brandStyles[cur];
  const brandName = cur;
  const baseTheme = getThemeBaseline();
  const onWhite = getTheme({
    baseTheme,
    brandName,
    themeType: 'onWhite',
    themeOverrides: getOnWhiteThemeOverrides(brandStyle),
    brandOverrides: brandStyle === null || brandStyle === void 0 || (_brandStyle$themeOver = brandStyle.themeOverrides) === null || _brandStyle$themeOver === void 0 ? void 0 : _brandStyle$themeOver.OnWhite
  });
  const onBlack = getTheme({
    baseTheme,
    brandName,
    themeType: 'onBlack',
    themeOverrides: getOnBlackThemeOverrides(brandStyle),
    brandOverrides: brandStyle === null || brandStyle === void 0 || (_brandStyle$themeOver2 = brandStyle.themeOverrides) === null || _brandStyle$themeOver2 === void 0 ? void 0 : _brandStyle$themeOver2.OnBlack
  });
  const onPrimary = getTheme({
    baseTheme,
    brandName,
    themeType: 'onPrimary',
    themeOverrides: getOnPrimaryThemeOverrides(brandStyle),
    brandOverrides: brandStyle === null || brandStyle === void 0 || (_brandStyle$themeOver3 = brandStyle.themeOverrides) === null || _brandStyle$themeOver3 === void 0 ? void 0 : _brandStyle$themeOver3.onPrimary
  });
  const curItem = {
    [cur]: {
      onWhite,
      onBlack,
      onPrimary
    }
  };
  return {
    ...acc,
    ...curItem
  };
}, {});
const themes = getThemes();
const klickOnWhite = themes['klick'].onWhite;
const ThemeProvider = _ref2 => {
  let {
    brandName,
    themeType = 'onWhite',
    theme,
    children
  } = _ref2;
  const parentTheme = useTheme();
  const curBrandName = brandName || parentTheme.brandName || 'klick';
  const curTheme = theme || themes[curBrandName][themeType];
  return /*#__PURE__*/React.createElement(ThemeProvider$1, {
    theme: curTheme
  }, /*#__PURE__*/React.createElement(ThemeProvider$2, {
    theme: curTheme
  }, children));
};
const match = {
  isPortrait: '(orientation: portrait)',
  isLandscape: '(orientation: landscape)',
  isXS: klickOnWhite.breakpoints.down('xs'),
  isBelowSM: klickOnWhite.breakpoints.down('sm'),
  isSM: klickOnWhite.breakpoints.up('sm'),
  isMD: klickOnWhite.breakpoints.up('md'),
  isLG: klickOnWhite.breakpoints.up('lg'),
  isXL: klickOnWhite.breakpoints.up('xl'),
  isRetina: "(min-resolution: 2dppx)",
  crawlerList: '(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)',
  getQuery: query => match[query].replace('@media ', '')
};
const ScrollStateContext = /*#__PURE__*/React.createContext();
const ScrollDispatchContext = /*#__PURE__*/React.createContext();
const ScrollProvider = _ref => {
  let {
    children
  } = _ref;
  const [scrollEnabled, setScrollState] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const setScrollEnabled = useCallback(scrollState => {
    setScrollState(scrollState);
    const newScrollPosition = scrollState ? enableScroll(scrollPosition) : disableScroll();
    setScrollPosition(newScrollPosition);
  }, [scrollPosition]);
  return /*#__PURE__*/React.createElement(ScrollStateContext.Provider, {
    value: scrollEnabled
  }, /*#__PURE__*/React.createElement(ScrollDispatchContext.Provider, {
    value: setScrollEnabled
  }, children));
};
const useScrollStateContext = () => {
  const context = React.useContext(ScrollStateContext);
  if (context === undefined) {
    throw new Error('useScrollStateContext must be used within a ScrollProvider');
  }
  return context;
};
const useScrollDispatchContext = () => {
  const context = React.useContext(ScrollDispatchContext);
  if (context === undefined) {
    throw new Error('ScrollDispatchContext must be used within a ScrollProvider');
  }
  return context;
};
const disableScroll = () => {
  const scrollPosition = window.pageYOffset;
  document.querySelector('html').setAttribute('style', 'overflow: hidden;'); // Prevents scroll bouncing
  document.body.setAttribute('style', "\n      position: fixed;\n      width: 100%;\n      top: -".concat(scrollPosition, "px;\n    "));
  return scrollPosition;
};
const enableScroll = scrollPosition => {
  document.querySelector('html').removeAttribute('style');
  document.body.removeAttribute('style');
  window.scrollTo(0, scrollPosition);
  return scrollPosition;
};
const IntroContext = /*#__PURE__*/React.createContext();
const IntroProvider = _ref => {
  let {
    children
  } = _ref;
  const [skipIntro, setSkipIntro] = useState(false);
  const value = {
    skipIntro,
    setSkipIntro
  };
  return /*#__PURE__*/React.createElement(IntroContext.Provider, {
    value: value
  }, children);
};
const useIntroContext = () => {
  const context = React.useContext(IntroContext);
  if (context === undefined) {
    throw new Error('useIntroContext must be used within a IntroProvider');
  }
  return context;
};
const EnhancedContext = /*#__PURE__*/React.createContext();
const STORAGE_KEY = 'isEnhanced';
const EnhancedProvider = _ref => {
  let {
    children
  } = _ref;
  const [enhanced, setEnhanced] = useState(true);
  const [hasInitialized, setHasInitialized] = useState(false);
  const toggleEnhanced = value => {
    typeof value === 'boolean' && setEnhanced(value);
  };
  const value = {
    enhanced,
    toggleEnhanced
  };
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  useEffect(() => {
    if (hasInitialized && enhanced !== null) {
      window.localStorage.setItem(STORAGE_KEY, enhanced);
    }
  }, [enhanced, hasInitialized]);
  useEffect(() => {
    const storage = window.localStorage.getItem(STORAGE_KEY);
    const storageValue = storage !== null ? storage === 'true' : true;
    const initialValue = !prefersReducedMotion ? storageValue : null;
    setEnhanced(initialValue);
    setHasInitialized(true);
  }, [enhanced, prefersReducedMotion]);
  return /*#__PURE__*/React.createElement(EnhancedContext.Provider, {
    value: value
  }, children);
};
const useEnhancedContext = () => {
  const context = React.useContext(EnhancedContext);
  if (context === undefined) {
    throw new Error('useEnhancedContext must be used within a EnhancedProvider');
  }
  return context;
};
const AccessibilityContext = /*#__PURE__*/React.createContext();
const STATES = {
  hidden: 'hidden',
  modal: 'modal'
};
const _useAccessibility = () => {
  const [accessibilityUIState, setAccessibilityUIState] = React.useState(STATES.hidden);
  const isAccessibilityVisible = accessibilityUIState === STATES.modal;
  const showAccessibilityModal = React.useCallback(trackId => {
    tracking.track({
      event: 'modal_open',
      eventModel: {
        modal_id: 'accessibility_modal',
        ...(trackId && {
          track_id: trackId
        })
      }
    });
    setAccessibilityUIState(STATES.modal);
  }, []);
  const closeAccessibilityModal = React.useCallback(() => {
    setAccessibilityUIState(STATES.hidden);
  }, []);
  return {
    isAccessibilityVisible,
    showAccessibilityModal,
    closeAccessibilityModal
  };
};
const AccessibilityProvider = _ref => {
  let {
    children
  } = _ref;
  const accessibility = _useAccessibility();
  return /*#__PURE__*/React.createElement(AccessibilityContext.Provider, {
    value: accessibility
  }, children);
};
const useAccessibilityContext = () => {
  const context = React.useContext(AccessibilityContext);
  if (context === undefined) {
    throw new Error('useAccessibilityContext must be used within a AccessibilityProvider');
  }
  return context;
};
const ModalContext = /*#__PURE__*/React.createContext();
const ModalProvider = _ref => {
  let {
    children,
    disableBlur = false
  } = _ref;
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const value = {
    isModalOpen,
    setIsModalOpen
  };
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: value
  }, children);
};
const useModalContext = () => {
  const context = React.useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModalContext must be used within a ModalProvider');
  }
  return context;
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};
var t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n(n) {
  var r = {
      type: "tag",
      name: "",
      voidElement: !1,
      attrs: {},
      children: []
    },
    i = n.match(/<\/?([^\s]+?)[/\s>]/);
  if (i && (r.name = i[1], (voidElements[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
    var s = n.indexOf("--\x3e");
    return {
      type: "comment",
      comment: -1 !== s ? n.slice(4, s) : ""
    };
  }
  for (var a = new RegExp(t), c = null; null !== (c = a.exec(n));) if (c[0].trim()) if (c[1]) {
    var o = c[1].trim(),
      l = [o, ""];
    o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
  } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
  return r;
}
var r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,
  i = /^\s*$/,
  s = Object.create(null);
function a(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function (e) {
        var t = [];
        for (var n in e) t.push(n + '="' + e[n] + '"');
        return t.length ? " " + t.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(a, "") + "</" + t.name + ">";
    case "comment":
      return e + "\x3c!--" + t.comment + "--\x3e";
  }
}
var c = {
  parse: function (e, t) {
    t || (t = {}), t.components || (t.components = s);
    var a,
      c = [],
      o = [],
      l = -1,
      m = !1;
    if (0 !== e.indexOf("<")) {
      var u = e.indexOf("<");
      c.push({
        type: "text",
        content: -1 === u ? e : e.substring(0, u)
      });
    }
    return e.replace(r, function (r, s) {
      if (m) {
        if (r !== "</" + a.name + ">") return;
        m = !1;
      }
      var u,
        f = "/" !== r.charAt(1),
        h = r.startsWith("\x3c!--"),
        p = s + r.length,
        d = e.charAt(p);
      if (h) {
        var v = n(r);
        return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
      }
      if (f && (l++, "tag" === (a = n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
        type: "text",
        content: e.slice(p, e.indexOf("<", p))
      }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
        u = -1 === l ? c : o[l].children;
        var x = e.indexOf("<", p),
          g = e.slice(p, -1 === x ? void 0 : x);
        i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
          type: "text",
          content: g
        });
      }
    }), c;
  },
  stringify: function (e) {
    return e.reduce(function (e, t) {
      return e + a("", t);
    }, "");
  }
};
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};
var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape
};
var i18nInstance$1;
var I18nContext = createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$9(_objectSpread$9({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);
    this.usedNamespaces = {};
  }
  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance$1 = instance;
}
function getI18n() {
  return i18nInstance$1;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function warn() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  });
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
var _excluded = ["format"],
  _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return isValidElement(child);
  });
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  var newTarget = _objectSpread$8({}, target);
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
        clone = _objectWithoutProperties(child, _excluded);
      var keys = Object.keys(clone);
      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};
  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }
  getData(children);
  var ast = c.parse("<0>".concat(targetString, "</0>"));
  var opts = _objectSpread$8(_objectSpread$8({}, data), combinedTOpts);
  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, _objectSpread$8(_objectSpread$8({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          var inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);
          mem.push(cloneElement(child, _objectSpread$8(_objectSpread$8({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, _objectSpread$8(_objectSpread$8({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(cloneElement(child, _objectSpread$8(_objectSpread$8({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;
        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }
      return mem;
    }, []);
  }
  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}
function Trans(_ref) {
  var children = _ref.children,
    count = _ref.count,
    parent = _ref.parent,
    i18nKey = _ref.i18nKey,
    context = _ref.context,
    _ref$tOptions = _ref.tOptions,
    tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
    values = _ref.values,
    defaults = _ref.defaults,
    components = _ref.components,
    ns = _ref.ns,
    i18nFromProps = _ref.i18n,
    tFromProps = _ref.t,
    shouldUnescape = _ref.shouldUnescape,
    additionalProps = _objectWithoutProperties(_ref, _excluded2);
  var _ref2 = useContext(I18nContext) || {},
    i18nFromContext = _ref2.i18n,
    defaultNSFromContext = _ref2.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }
  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };
  if (context) tOptions.context = context;
  var reactI18nextOptions = _objectSpread$8(_objectSpread$8({}, getDefaults()), i18n.options && i18n.options.react);
  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread$8(_objectSpread$8({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };
  var combinedTOpts = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });
  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var usePrevious = function usePrevious(value, ignore) {
  var ref = useRef();
  useEffect(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {},
    i18nFromContext = _ref.i18n,
    defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  var i18nOptions = _objectSpread$7(_objectSpread$7(_objectSpread$7({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense,
    keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT),
    _useState2 = _slicedToArray(_useState, 2),
    t = _useState2[0],
    setT = _useState2[1];
  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
      bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}
function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
    defaultNS = _ref.defaultNS,
    children = _ref.children;
  var value = useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value: value
  }, children);
}
var dist$1 = {};
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALES = exports.LOCALES = void 0;
  exports.LOCALES = {
    'en-US': {
      long: 'English',
      short: 'EN',
      code: 'en-US'
    },
    de: {
      long: 'Deutsch',
      short: 'DE',
      code: 'de'
    },
    es: {
      long: 'Español',
      short: 'ES',
      code: 'es'
    },
    ja: {
      long: '日本',
      short: 'JA',
      code: 'ja'
    },
    'pt-BR': {
      long: 'Português',
      short: 'PT',
      code: 'pt-BR'
    },
    'fr-FR': {
      long: 'Français',
      short: 'FR',
      code: 'fr-FR'
    }
  };
  exports.SUPPORTED_LOCALES = Object.keys(exports.LOCALES);
  exports.DEFAULT_LOCALE = exports.LOCALES['en-US'];
})(dist$1);
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Logger);
    this.init(concreteLogger, options);
  }
  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.observers = {};
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
    obj = _getLastOfPath.obj,
    k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
    obj = _getLastOfPath2.obj,
    k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
    obj = _getLastOfPath3.obj,
    k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);
  var _super = _createSuper$3(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    _classCallCheck(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);
  var _super = _createSuper$2(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (_typeof(options) === 'object') options = _objectSpread$4({}, options);
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _this$extractFromKey.key,
        namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: "".concat(namespace).concat(nsSeparator).concat(key),
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace
            };
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();
var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function deepFindWithDefaults(data, defaultData, key) {
  var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
          _opt$split2 = _toArray(_opt$split),
          key = _opt$split2[0],
          rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val, opt.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
          formatName = _parseFormatStr.formatName,
          formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);
  var _super = _createSuper$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ;else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (n) {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(function (data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
          isUpdate: isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);
function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function noop$1() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get();
      this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function (k) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = options.lng || this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
_defineProperty(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
const locale$5 = {
  translation: {
    // Common
    Cancel: 'Abbrechen',
    Save: 'Speichern',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'Wählen Sie Ihre bevorzugte Sprache aus dem Dropdown-Menü aus und klicken Sie auf „Übernehmen“. Die Webseite wird automatisch neu geladen.',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': 'Wir verwenden Cookies und andere Tracking-Technologien, um die Navigation zu unterstützen, Ihre Nutzung unserer Dienste zu analysieren und unsere Werbe- und Marketingbemühungen zu unterstützen.',
    'View cookie options': 'Cookie-Optionen anzeigen',
    'Accept All': 'Accept All',
    Decline: 'Ablehnen',
    'Cookies at Klick.': 'Cookies bei Klick.',
    'Tracking Enabled': 'Tracking aktiviert',
    'Tracking Disabled': 'Tracking deaktiviert',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'Bei Klick sind wir der Meinung, dass das Surfen auf unseren Websites für alle möglichst angenehm sein sollte. Daher haben wir Einstellungen für einen verbesserten Zugriff vorgenommen.',
    'Reduced Motion Enabled': 'Reduzierte Animation aktiviert',
    'Reduced Motion Disabled': 'Reduzierte Animation deaktiviert',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'Die Klick Group ist ein Ökosystem von genialen Köpfen, die seit 1997 daran arbeiten, das volle Potenzial ihrer Mitarbeiter und Kunden auszuschöpfen.',
    // Copyright
    'All rights reserved': 'Alle Rechte vorbehalten',
    'is a trademark of': 'ist eine Marke von',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>Hier ist etwas</0> <2>ganz anders.</2>',
    Careers: 'Karriere',
    'Discover Klick': 'Entdecken Sie Klick',
    'Contact Us': 'Kontakt',
    Newsletter: 'Newsletter',
    'Privacy Policy': 'Datenschutzrichtlinie',
    'Global Capabilities': 'Globale Kapazitäten',
    'Cookie Settings': 'Cookie-Einstellungen',
    'Accessibility Settings': 'Zugriffseinstellungen',
    'Accessibility Statement': 'Zugriffserklärung',
    'Do Not Sell Or Share My Personal Information': 'Meine personenbezogenen Daten dürfen weder verkauft noch weitergegeben werden',
    'Follow us on': 'Folgen Sie uns auf'
  }
};
const locale$4 = {
  translation: {
    // Common
    Cancel: 'Cancel',
    Save: 'Save',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': 'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.',
    'View cookie options': 'View cookie options',
    'Accept All': 'Accept All',
    Decline: 'Decline',
    'Cookies at Klick.': 'Cookies at Klick.',
    'Tracking Enabled': 'Tracking Enabled',
    'Tracking Disabled': 'Tracking Disabled',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.',
    'Reduced Motion Enabled': 'Reduced Motion Enabled',
    'Reduced Motion Disabled': 'Reduced Motion Disabled',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.',
    // Copyright
    'All rights reserved': 'All rights reserved',
    'is a trademark of': 'is a trademark of',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>There’s something</0> <2>different here.</2>',
    Careers: 'Careers',
    'Discover Klick': 'Discover Klick',
    'Contact Us': 'Contact Us',
    Newsletter: 'Newsletter',
    'Privacy Policy': 'Privacy Policy',
    'Global Capabilities': 'Global Capabilities',
    'Cookie Settings': 'Cookie Settings',
    'Accessibility Settings': 'Accessibility Settings',
    'Accessibility Statement': 'Accessibility Statement',
    'Do Not Sell Or Share My Personal Information': 'Do Not Sell Or Share My Personal Information',
    'Follow us on': 'Follow us on'
  }
};
const locale$3 = {
  translation: {
    // Common
    Cancel: 'Cancelar',
    Save: 'Guardar',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'Elija su idioma preferido del menú desplegable y presione aplicar. La página del sitio web se volverá a cargar automáticamente.',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': 'Utilizamos cookies y demás tecnologías de seguimiento para ayudar con la navegación, analizar su uso de nuestros servicios y ayudar con nuestros esfuerzos promocionales y de comercialización.',
    'View cookie options': 'Ver opciones de cookies',
    'Accept All': 'Accept All',
    Decline: 'Rechazar',
    'Cookies at Klick.': 'Cookies en Klick.',
    'Tracking Enabled': 'Seguimiento habilitado',
    'Tracking Disabled': 'Seguimiento deshabilitado',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'En Klick creemos que todos deberían tener una gran experiencia al visualizar nuestros sitios. Por lo tanto, hemos agregado configuraciones para mejorar la accesibilidad.',
    'Reduced Motion Enabled': 'Movimiento reducido habilitado',
    'Reduced Motion Disabled': 'Movimiento reducido deshabilitado',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'Klick Group es un ecosistema de mentes brillantes que trabajan para aprovechar todo el potencial de sus empleados y clientes desde 1997.',
    // Copyright
    'All rights reserved': 'Todos los derechos reservados',
    'is a trademark of': 'es una marca registrada de',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>Hay algo</0> <2>diferente aquí.</2>',
    Careers: 'Carreras',
    'Discover Klick': 'Descubra Klick',
    'Contact Us': 'Contáctenos',
    Newsletter: 'Boletín informativo',
    'Privacy Policy': 'Política de privacidad',
    'Global Capabilities': 'Capacidades globales',
    'Cookie Settings': 'Configuraciones de cookies',
    'Accessibility Settings': 'Configuraciones de accesibilidad',
    'Accessibility Statement': 'Declaración de accesibilidad',
    'Do Not Sell Or Share My Personal Information': 'No vender ni compartir mi información personal',
    'Follow us on': 'Síganos en'
  }
};
const locale$2 = {
  translation: {
    // Common
    Cancel: 'Annuler',
    Save: 'Enregistrer',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'Choisissez votre langue préférée dans le menu déroulant, puis cliquez sur Appliquer. La page du site Web se rechargera automatiquement.',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': 'Nous utilisons des cookies et d’autres technologies de suivi pour faciliter la navigation, analyser votre utilisation de nos services et optimiser nos initiatives promotionnelles et de marketing.',
    'View cookie options': 'Afficher les options relatives aux cookies',
    'Accept All': 'Accept All',
    Decline: 'Déclin',
    'Cookies at Klick.': 'Cookies chez Klick.',
    'Tracking Enabled': 'Suivi activé',
    'Tracking Disabled': 'Suivi désactivé',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'Chez Klick, nous pensons que tout le monde devrait bénéficier d’une excellente expérience en consultant nos sites. Par conséquent, nous avons ajouté des paramètres pour améliorer l’accessibilité.',
    'Reduced Motion Enabled': 'Mouvement réduit activé',
    'Reduced Motion Disabled': 'Mouvement réduit désactivé',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'Le Groupe de sociétés Klick est un écosystème d’esprits brillants s’efforçant de réaliser pleinement le potentiel de leurs collaborateurs et clients depuis 1997.',
    // Copyright
    'All rights reserved': 'Tous droits réservés',
    'is a trademark of': 'est une marque déposée de',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>Quelque chose</0> <2>est différent ici.</2>',
    Careers: 'Carrières',
    'Discover Klick': 'Découvrir Klick',
    'Contact Us': 'Nous contacter',
    Newsletter: 'Newsletter',
    'Privacy Policy': 'Politique de confidentialité',
    'Global Capabilities': 'Capacités mondiales',
    'Cookie Settings': 'Paramètres relatifs aux cookies',
    'Accessibility Settings': 'Paramètres d’accessibilité',
    'Accessibility Statement': 'Déclaration d’accessibilité',
    'Do Not Sell Or Share My Personal Information': 'Ne vendez pas et ne partagez pas mes informations personnelles',
    'Follow us on': 'Suivez-nous sur'
  }
};
const locale$1 = {
  translation: {
    // Common
    Cancel: 'キャンセル',
    Save: '保存',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'ドロップダウン メニューから希望する言語を選択し、[適用] をクリックします。ウェブサイトのページが自動的にリロードされます。',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': '当社は、ナビゲーションの支援、当社のサービス利用の分析、プロモーションおよびマーケティング活動の支援に、Cookie およびその他の追跡技術を使用しています。',
    'View cookie options': 'Cookie のオプションを表示',
    'Accept All': 'Accept All',
    Decline: '拒む',
    'Cookies at Klick.': 'Klick の Cookie。',
    'Tracking Enabled': '追跡を有効にする',
    'Tracking Disabled': '追跡を無効にする',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'Klick では、すべての人が当社のサイトを快適に閲覧できることが重要だと考えています。そこで、アクセシビリティを向上させるための設定を追加しました。',
    'Reduced Motion Enabled': '減速モーション有効',
    'Reduced Motion Disabled': '減速モーション無効',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'Klick Group は、1997 年以来、従業員と顧客の潜在能力を最大限に引き出すことを目的としている優秀な人材のエコシステムです。',
    // Copyright
    'All rights reserved': '無断転載を禁じます',
    'is a trademark of': '商標',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>何かが</0><2>違います。</2>',
    Careers: 'キャリア',
    'Discover Klick': 'Klick を発見',
    'Contact Us': 'お問い合わせ',
    Newsletter: 'ニュースレター',
    'Privacy Policy': 'プライバシー ポリシー',
    'Global Capabilities': 'グローバルな機能',
    'Cookie Settings': 'Cookie の設定',
    'Accessibility Settings': 'アクセシビリティの設定',
    'Accessibility Statement': 'アクセシビリティに関する声明',
    'Do Not Sell Or Share My Personal Information': '個人情報を販売したり共有したりしないでください。',
    'Follow us on': 'フォロー:'
  }
};
const locale = {
  translation: {
    // Common
    Cancel: 'Cancelar',
    Save: 'Salvar',
    // LanguagePicker
    Apply: 'Apply',
    'Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload.': 'Escolha seu idioma de preferência no menu suspenso e clique em aplicar. A página do site será recarregada automaticamente.',
    // CookieBanner
    'We use cookies and other tracking technologies to assist with navigation, analyze your use of our services, and assist with our promotional and marketing efforts.': 'Usamos cookies e outras tecnologias de rastreamento para auxiliar na navegação, analisar seu uso dos nossos serviços e ajudar nossos esforços promocionais e de marketing.',
    'View cookie options': 'Ver opções de cookies',
    'Accept All': 'Accept All',
    Decline: 'Recusar',
    'Cookies at Klick.': 'Cookies na Klick.',
    'Tracking Enabled': 'Rastreamento Ativado',
    'Tracking Disabled': 'Rastreamento Desativado',
    // AccessibilityDialog
    'At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.': 'Na Klick, acreditamos que todos devem ter uma ótima experiência de visualização dos nossos sites. Portanto, acrescentamos configurações para melhorar a acessibilidade.',
    'Reduced Motion Enabled': 'Movimento reduzido ativado',
    'Reduced Motion Disabled': 'Movimento reduzido desativado',
    // EyebrowBar
    'The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997.': 'O Klick Group de empresas é um ecossistema de mentes brilhantes que trabalham para realizar todo o potencial de seus funcionários e clientes desde 1997.',
    // Copyright
    'All rights reserved': 'Todos os direitos reservados',
    'is a trademark of': 'é uma marca comercial da',
    // Footer
    '<0>There’s something</0> <2>different here.</2>': '<0>Há algo</0> <2>diferente aqui.</2>',
    Careers: 'Carreiras',
    'Discover Klick': 'Descubra a Klick',
    'Contact Us': 'Fale conosco',
    Newsletter: 'Boletim informativo',
    'Privacy Policy': 'Política de Privacidade',
    'Global Capabilities': 'Capacidades Globais',
    'Cookie Settings': 'Configurações de Cookies',
    'Accessibility Settings': 'Configurações de Acessibilidade',
    'Accessibility Statement': 'Declaração de Acessibilidade',
    'Do Not Sell Or Share My Personal Information': 'Não venda ou compartilhe minhas informações pessoais',
    'Follow us on': 'Siga-nos no'
  }
};
if (isBrowser) {
  const languageCookie = getCookie('klick_language');
  if (languageCookie) {
    setStorageItem('gatsby-i18next-language', languageCookie);
  }
}
const i18nInstance = createInstance({
  fallbackLng: dist$1.DEFAULT_LOCALE.code,
  debug: false,
  supportedLngs: dist$1.SUPPORTED_LOCALES,
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default
  },

  resources: {
    'en-US': locale$4,
    de: locale$5,
    es: locale$3,
    ja: locale$1,
    'fr-FR': locale$2,
    'pt-BR': locale
  }
});
i18nInstance.use(initReactI18next).init();
const withI18next = Component => {
  return function I18nextComponent(props) {
    return /*#__PURE__*/React.createElement(I18nextProvider, {
      i18n: i18nInstance
    }, /*#__PURE__*/React.createElement(Component, props));
  };
};
const useI18nBridge = () => {
  const {
    language
  } = useI18next();
  if (!isBrowser && language) {
    i18nInstance.changeLanguage(language);
  }
  React.useEffect(() => {
    i18nInstance.changeLanguage(language);
  }, [language]);
};
const useInstance = function () {
  let initialValueOrFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const ref = useRef();
  if (!ref.current) {
    ref.current = typeof initialValueOrFunction === 'function' ? initialValueOrFunction() : initialValueOrFunction;
  }
  return ref.current;
};
gsap.registerPlugin(ScrollTrigger);
const useParallax = _ref => {
  let {
    triggerRef,
    refs = [],
    depths = []
  } = _ref;
  const timeline = useInstance(() => gsap.timeline({
    paused: true
  }));
  useIsomorphicLayoutEffect(() => {
    if (!triggerRef.current) return;
    ScrollTrigger.create({
      trigger: triggerRef.current,
      scrub: true,
      start: 'top bottom',
      end: 'bottom top',
      animation: timeline
    });
    refs.forEach((ref, index) => {
      const depth = depths[index];
      timeline.fromTo(ref.current, {
        y: depth
      }, {
        y: -depth,
        ease: 'none'
      }, 0);
    });
  }, [triggerRef, refs, timeline, depths]);
  return timeline;
};
gsap.registerPlugin(ScrollTrigger);
const useScrollAnimation = _ref => {
  let {
    ref,
    from,
    start = 'top 95%',
    end = 'top 60%',
    enabled = true
  } = _ref;
  useIsomorphicLayoutEffect(() => {
    if (!enabled) return;
    const element = ref.current;
    const ctx = gsap.context(() => {
      const timeline = gsap.timeline({
        paused: true
      });
      timeline.from(element, {
        ...from,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: element,
          start,
          end,
          scrub: true
        }
      });
    });
    return () => {
      ctx.revert();
    };
  }, [enabled, ref, from, start, end]);
};
const useIntersect = function () {
  let {
    root = null,
    rootMargin,
    threshold = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [entry, setEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(null);
  useEffect(() => {
    if (!isIntersectionObserverSupported()) {
      return;
    }
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new window.IntersectionObserver(_ref => {
      let [entry] = _ref;
      return setEntry(entry);
    }, {
      root,
      rootMargin,
      threshold
    });
    const {
      current: currentObserver
    } = observer;
    if (node) {
      currentObserver.observe(node);
    }
    return () => currentObserver.disconnect();
  }, [node, root, rootMargin, threshold]);
  return [setNode, entry];
};
const useQueryLatestData = (query, options) => {
  // Implementing this way using useState allows for "data"
  // to be cached/displayed even while Apollo is re-fetching
  // Without it, you will get content blinking in-out twice.
  const [latestData, setLatestData] = React.useState();
  const response = useQuery(query, options);
  React.useEffect(() => {
    if (!response.data) return;
    setLatestData(response.data);
  }, [response.data]);
  return {
    ...response,
    latestData
  };
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledTypography = styled(Typography).withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "sc-pgcect-0"
})(["&:last-child{margin-bottom:0;}"]);

// HEADING
const Heading = styled( /*#__PURE__*/forwardRef((props, ref) => {
  const {
    font,
    variant,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({
    ref: ref,
    color: "textPrimary",
    variant: variant,
    component: variant
  }, restProps));
})).withConfig({
  displayName: "Typography__Heading",
  componentId: "sc-pgcect-1"
})(["", " ", ""], spacing, _ref => {
  let {
    font,
    theme
  } = _ref;
  return font && "\nfont-family: ".concat(theme.typography.font[font], ";\nfont-weight: ").concat(font === 'primary' ? 700 : 400, ";\n");
});
// PARAGRAPH
const P = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    variant,
    ...props
  } = _ref2;
  const hasCustomVariant = !!customVariants[variant];
  const Component = hasCustomVariant ? customVariants[variant] : DefaultP;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    variant: hasCustomVariant ? undefined : variant
  }, props));
});
const DefaultP = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    variant = 'body1',
    color = 'textPrimary',
    paragraph = true,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({
    ref: ref,
    paragraph: paragraph,
    variant: variant,
    color: color
  }, restProps));
});
const Blurb1 = styled(DefaultP).withConfig({
  displayName: "Typography__Blurb1",
  componentId: "sc-pgcect-2"
})(["font-weight:700;font-size:1.5625rem;line-height:1.235;", "{font-size:1.8219rem;}", "{font-size:2.0243rem;}"], match.isSM, match.isMD);
const Blurb2 = styled(DefaultP).withConfig({
  displayName: "Typography__Blurb2",
  componentId: "sc-pgcect-3"
})(["font-weight:400;font-size:1.25rem;line-height:1.6;"]);
const customVariants = {
  blurb1: Blurb1,
  blurb2: Blurb2
};
const Ul = styled(_ref3 => {
  let {
    color,
    variant = 'blurb2',
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(P, _extends({
    component: "ul",
    $color: color,
    variant: variant
  }, props));
}).withConfig({
  displayName: "Typography__Ul",
  componentId: "sc-pgcect-4"
})(["display:inline-block;margin:0;padding:0;margin-left:1em;list-style:none;li:before{content:'\u2022';color:", ";font-weight:bold;display:inline-block;width:1em;margin-left:-1em;}"], _ref4 => {
  let {
    theme,
    $color
  } = _ref4;
  return $color || theme.palette.primary.main;
});
const Ol = styled(_ref5 => {
  let {
    color,
    variant = 'blurb2',
    ...props
  } = _ref5;
  return /*#__PURE__*/React.createElement(P, _extends({
    component: "ol",
    $color: color,
    variant: variant
  }, props));
}).withConfig({
  displayName: "Typography__Ol",
  componentId: "sc-pgcect-5"
})(["display:inline-block;margin:0;padding:0;list-style:none;counter-reset:li;li{padding-left:2em;position:relative;padding-bottom:1em;}li:before{counter-increment:li;content:counter(li,decimal-leading-zero);color:", ";font-weight:bold;position:absolute;left:0;}"], _ref6 => {
  let {
    theme,
    $color
  } = _ref6;
  return $color || theme.palette.primary.main;
});
const Hr = props => /*#__PURE__*/React.createElement(Box, _extends({
  component: "hr",
  my: 8,
  width: "80%",
  borderColor: "text.secondary"
}, props));
const Decorator = styled.div.attrs(() => ({
  // Note: see a11y role details here https://www.w3.org/TR/wai-aria-1.1/#presentation
  role: 'none'
})).withConfig({
  displayName: "Typography__Decorator",
  componentId: "sc-pgcect-6"
})(["", ""], _ref7 => {
  let {
    $align = 'center',
    $size = 6,
    $width = '4vw',
    $minWidth = '50px',
    $display = 'inline-block'
  } = _ref7;
  return css(["display:", ";padding:0;border:0;border-top-width:", "px;border-top-style:solid;border-top-color:", ";background:none;width:", ";min-width:", ";margin-top:30px;margin-bottom:30px;margin-left:auto;margin-right:auto;", " ", ""], $display, $size, _ref8 => {
    let {
      theme
    } = _ref8;
    return theme.palette.primary.main;
  }, $width, $minWidth, $align === 'left' && "margin-left: 0;", $align === 'right' && "margin-right: 0;");
});
const NoWrap = styled.span.withConfig({
  displayName: "Typography__NoWrap",
  componentId: "sc-pgcect-7"
})(["white-space:nowrap;"]);
const AvoidWrap = styled.span.withConfig({
  displayName: "Typography__AvoidWrap",
  componentId: "sc-pgcect-8"
})(["display:inline-block;"]);
const Em = styled.em.withConfig({
  displayName: "Typography__Em",
  componentId: "sc-pgcect-9"
})(["color:", ";font-style:inherit;"], _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.palette.primary.main;
});

// item.summary can be a string, or a React.node. If it is a string, it will be wrapped in a <Heading> component by default.
// item.details can be a string, or a React.node. If it is a string, it will be wrapped in a <P> component by default.

const Accordion = _ref => {
  let {
    name,
    items,
    summaryHeadingVariant = 'h3',
    summaryHeadingComponent = 'h3',
    summaryExtraMUIProps = {},
    detailsExtraMUIProps = {},
    accordionExtraMUIProps = {},
    contained = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(AccordionContainer, rest, items.map((_ref2, index) => {
    let {
      summary,
      details,
      expandable = true,
      ...restItemProps
    } = _ref2;
    const itemId = "".concat(name, "-item-").concat(index);
    const summaryId = "".concat(name, "-summary-").concat(index);
    const itemSummary = typeof summary === 'string' ? /*#__PURE__*/React.createElement(StyledHeading$3, {
      variant: summaryHeadingVariant,
      component: summaryHeadingComponent
    }, summary) : summary;
    const itemDetails = typeof details === 'string' ? /*#__PURE__*/React.createElement(P, null, details) : details;
    const Accordion = contained ? ContainedAccordion : SimpleAccordion;
    const AccordionSummary = contained ? ContainedAccordionSummary : SimpleAccordionSummary;
    const AccordionDetails = contained ? ContainedAccordionDetails : SimpleAccordionDetails;
    return expandable ? /*#__PURE__*/React.createElement(Accordion, _extends({
      key: index
    }, accordionExtraMUIProps, restItemProps), /*#__PURE__*/React.createElement(AccordionSummary, _extends({
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
      "aria-controls": "panel-".concat(summaryId, "-content"),
      id: "panel-".concat(itemId, "-header")
    }, summaryExtraMUIProps), itemSummary), /*#__PURE__*/React.createElement(AccordionDetails, detailsExtraMUIProps, itemDetails)) : /*#__PURE__*/React.createElement(NoExpandItem, {
      key: index
    }, itemSummary);
  }));
};
const altContrast = (color, value) => getLuminance(color) >= 0.1 ? darken(color, value) : lighten(color, value);
const AccordionContainer = styled.div.withConfig({
  displayName: "Accordion__AccordionContainer",
  componentId: "sc-130ut3-0"
})([""]);
const StyledHeading$3 = styled(Heading).withConfig({
  displayName: "Accordion__StyledHeading",
  componentId: "sc-130ut3-1"
})(["margin-bottom:0;"]);
const StyledAccordion = styled(Accordion$1).withConfig({
  displayName: "Accordion__StyledAccordion",
  componentId: "sc-130ut3-2"
})(["background:transparent;border:none;box-shadow:none;:before{display:none;}&.Mui-expanded{margin-top:0;margin-bottom:0;}"]);
const SimpleAccordion = styled(StyledAccordion).withConfig({
  displayName: "Accordion__SimpleAccordion",
  componentId: "sc-130ut3-3"
})(["background-color:", "}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return alpha(theme.palette.background.default, 0.9);
});
const ContainedAccordion = styled(StyledAccordion).withConfig({
  displayName: "Accordion__ContainedAccordion",
  componentId: "sc-130ut3-4"
})([""]);
const NoExpandItem = styled.div.withConfig({
  displayName: "Accordion__NoExpandItem",
  componentId: "sc-130ut3-5"
})(["padding:", ";background-color:", ";margin-top:8px;margin-bottom:16px;min-height:64px;display:flex;align-items:center;"], _ref4 => {
  let {
    theme
  } = _ref4;
  return "".concat(theme.spacing(1), "px ").concat(theme.spacing(9), "px ").concat(theme.spacing(1), "px ").concat(theme.spacing(3), "px");
}, _ref5 => {
  let {
    theme
  } = _ref5;
  const color = theme.palette.background.default;
  const lum = getLuminance(color);
  return lum !== 0 && lum !== 1 ? alpha(altContrast(theme.palette.background.default, 0.9), 0.75) : alpha(altContrast(theme.palette.background.default, 1), 1);
});
const StyledAccordionSummary = styled(AccordionSummary).withConfig({
  displayName: "Accordion__StyledAccordionSummary",
  componentId: "sc-130ut3-6"
})(["padding:", ";& div[class*='MuiAccordionSummary-content']{margin:0;}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return "".concat(theme.spacing(1), "px ").concat(theme.spacing(3), "px");
});
const ContainedAccordionSummary = styled(StyledAccordionSummary).withConfig({
  displayName: "Accordion__ContainedAccordionSummary",
  componentId: "sc-130ut3-7"
})(["background-color:", ";margin-top:8px;margin-bottom:8px;& [class*='MuiTypography-colorTextPrimary'],& [class*='MuiButtonBase-root']{color:", ";}"], _ref7 => {
  let {
    theme
  } = _ref7;
  const color = theme.palette.background.default;
  const lum = getLuminance(color);
  return lum !== 0 && lum !== 1 ? alpha(altContrast(theme.palette.background.default, 0.9), 0.75) : alpha(altContrast(theme.palette.background.default, 1), 1);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  const color = theme.palette.background.default;
  const lum = getLuminance(color);
  return lum >= 0.1 ? '#fff' : '#000';
});
const SimpleAccordionSummary = styled(StyledAccordionSummary).withConfig({
  displayName: "Accordion__SimpleAccordionSummary",
  componentId: "sc-130ut3-8"
})(["min-height:64px;border-top:", ";& [class*='MuiTypography-colorTextPrimary'],& [class*='MuiButtonBase-root']{color:", "};}"], _ref9 => {
  let {
    theme
  } = _ref9;
  return "1px solid  ".concat(theme.palette.text.primary);
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.palette.primary.main;
});
const StyledAccordionDetails = styled(AccordionDetails).withConfig({
  displayName: "Accordion__StyledAccordionDetails",
  componentId: "sc-130ut3-9"
})(["display:block;background:transparent;padding:0;"]);
const ContainedAccordionDetails = styled(StyledAccordionDetails).withConfig({
  displayName: "Accordion__ContainedAccordionDetails",
  componentId: "sc-130ut3-10"
})(["& > *{padding:", ";margin-bottom:", ";background-color:", ";", "{padding:", ";}}& > *:nth-child(even){background-color:", ";}& > *:last-child{margin-bottom:0;}"], _ref11 => {
  let {
    theme
  } = _ref11;
  return "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px");
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return "".concat(theme.spacing(1), "px");
}, _ref13 => {
  let {
    theme
  } = _ref13;
  const color = theme.palette.background.default;
  const lum = getLuminance(color);
  const value = lum === 1 ? '0.1' : '0.5';
  return alpha(altContrast(color, value), 0.6);
}, match.isMD, _ref14 => {
  let {
    theme
  } = _ref14;
  return "".concat(theme.spacing(5), "px ").concat(theme.spacing(8), "px");
}, _ref15 => {
  let {
    theme
  } = _ref15;
  const color = theme.palette.background.default;
  const lum = getLuminance(color);
  const value = lum === 1 ? '0.2' : '0.8';
  return alpha(altContrast(color, value), 0.6);
});
const SimpleAccordionDetails = styled(StyledAccordionDetails).withConfig({
  displayName: "Accordion__SimpleAccordionDetails",
  componentId: "sc-130ut3-11"
})(["& > *{padding:", ";", "{padding:", ";}}"], _ref16 => {
  let {
    theme
  } = _ref16;
  return "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px ").concat(theme.spacing(2), "px");
}, match.isMD, _ref17 => {
  let {
    theme
  } = _ref17;
  return "".concat(theme.spacing(5), "px ").concat(theme.spacing(2), "px");
});
const getOptionValueDefault$1 = option => {
  var _option$structured_fo;
  return (option === null || option === void 0 || (_option$structured_fo = option.structured_formatting) === null || _option$structured_fo === void 0 ? void 0 : _option$structured_fo.main_text) || option;
};
const getOptionLabelDefault$1 = option => {
  var _option$structured_fo2;
  return (option === null || option === void 0 || (_option$structured_fo2 = option.structured_formatting) === null || _option$structured_fo2 === void 0 ? void 0 : _option$structured_fo2.main_text) || option;
};
const onFetchDefault = results => results;
const onClearDefault = () => {};
const autocompleteService = {
  current: null
};
const placeDetailsService = {
  current: null
};
const useStyles$2 = makeStyles(theme => ({
  paper: {
    paddingBottom: '26px',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: '1px'
    },
    '&::after': {
      content: '" "',
      display: 'block',
      height: '18px',
      width: '144px',
      position: 'absolute',
      right: '8px',
      bottom: '8px',
      background: "url('data:image/png;base64,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') no-repeat"
    }
  },
  listbox: {
    paddingBottom: 0
  }
}));
function AddressField(props) {
  const {
    helperText,
    variant = 'outlined',
    type = 'text',
    label,
    getOptionLabel = getOptionLabelDefault$1,
    getOptionValue = getOptionValueDefault$1,
    onFetch = onFetchDefault,
    onClear = onClearDefault,
    onSelect,
    requestConfig,
    forcePopupIcon = false,
    googleApiKey,
    placeholder,
    ...restProps
  } = props;
  if (!googleApiKey) throw new Error("A Google Maps api key must exist be supplied via the prop 'googleApiKey'.");
  const classes = useStyles$2();
  const loaded = React.useRef(false);
  const sessionToken = React.useRef(null);
  const lastSearch = React.useRef(null);
  const lastDetailsSearch = React.useRef(null);
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const {
    1: meta,
    2: helpers
  } = useField(restProps);
  if (isBrowser && !loaded.current) {
    loadScript("https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&libraries=places"), document.querySelector('head'), 'google-maps');
    loaded.current = true;
  }
  const fetchPlaces = React.useMemo(() => throttle((request, callback) => {
    // callback(dummyResponse)
    autocompleteService.current.getPlacePredictions({
      ...request,
      ...requestConfig
    }, callback);
  }, 200), [requestConfig]);
  const fetchPlaceDetails = React.useMemo(() => throttle((request, callback) => {
    // callback(dummyDetails)
    placeDetailsService.current.getDetails(request, callback);
  }, 200), []);
  React.useEffect(() => {
    let isMounted = true;
    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }
    if (!inputValue) {
      setOptions(value ? [value] : []);
      return undefined;
    }
    if (lastSearch.current === inputValue) return undefined;
    lastSearch.current = inputValue;
    if (!sessionToken.current) {
      sessionToken.current = new window.google.maps.places.AutocompleteSessionToken();
    }
    fetchPlaces({
      input: inputValue,
      sessionToken: sessionToken.current,
      fields: ['address_components'],
      types: ['address']
    }, results => {
      if (!isMounted) return;
      let newOptions = value ? [value] : [];
      if (results) {
        newOptions = [...newOptions, ...onFetch(results)];
      }
      setOptions(newOptions);
    });
    return () => {
      isMounted = false;
    };
  }, [fetchPlaces, onFetch, inputValue, value]);
  React.useEffect(() => {
    if (!placeDetailsService.current && window.google && onSelect) {
      placeDetailsService.current = new window.google.maps.places.PlacesService(document.createElement('div'));
    }
    if (!value || !onSelect || !value.place_id || lastDetailsSearch.current === value.place_id) {
      return undefined;
    }
    lastDetailsSearch.current = value.place_id;
    fetchPlaceDetails({
      placeId: value.place_id,
      fields: ['address_components']
    }, results => {
      onSelect(formatResults(results));
      sessionToken.current = null;
    });
  }, [value, fetchPlaceDetails, onSelect]);
  const handleClear = () => {
    lastSearch.current = null;
    lastDetailsSearch.current = null;
    onClear();
  };
  return /*#__PURE__*/React.createElement(Autocomplete, _extends({
    options: options,
    classes: classes,
    getOptionLabel: getOptionLabel,
    forcePopupIcon: forcePopupIcon,
    filterSelectedOptions: true,
    value: value,
    onChange: (e, newValue) => {
      setValue(newValue);
      helpers.setValue(newValue ? getOptionValue(newValue) : meta.initialValue);
    },
    onInputChange: (e, newValue) => {
      if (newValue === '' && value) {
        handleClear();
      }
      setInputValue(newValue);
    },
    onBlur: () => {
      helpers.setTouched(true);
      if (restProps.freeSolo) {
        helpers.setValue(inputValue);
      }
    },
    renderInput: params => {
      return /*#__PURE__*/React.createElement(StyledMuiTextField$2, _extends({}, params, {
        inputProps: {
          ...params.inputProps,
          autoComplete: 'new-password'
        },
        placeholder: placeholder,
        variant: variant,
        type: type,
        label: label,
        error: meta.touched && !!meta.error,
        helperText: meta.touched && meta.error || helperText
      }));
    },
    renderOption: option => {
      const matches = option.structured_formatting.main_text_matched_substrings;
      const parts = parse(option.structured_formatting.main_text, matches.map(match => [match.offset, match.offset + match.length]));
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(StyledIcon, null)), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: true
      }, parts.map((part, index) => /*#__PURE__*/React.createElement("span", {
        key: index,
        style: {
          fontWeight: part.highlight ? 700 : 400
        }
      }, part.text)), /*#__PURE__*/React.createElement(P, {
        variant: "body2",
        color: "textSecondary"
      }, option.structured_formatting.secondary_text)));
    }
  }, restProps));
}
const StyledIcon = styled(LocationOnIcon).withConfig({
  displayName: "AddressField__StyledIcon",
  componentId: "sc-19d5vni-0"
})(["margin-right:", "px;"], props => props.theme.spacing(2));
const StyledMuiTextField$2 = styled(TextField$1).withConfig({
  displayName: "AddressField__StyledMuiTextField",
  componentId: "sc-19d5vni-1"
})(["label.Mui-focused{color:", ";}&.Mui-disabled,.Mui-disabled{cursor:not-allowed;}"], props => props.theme.palette.text.secondary);
const formatResults = results => {
  const formattedResults = {};
  for (const component of results.address_components) {
    const componentType = component.types[0];
    switch (componentType) {
      case 'street_number':
        {
          formattedResults.address = "".concat(component.long_name, " ");
          break;
        }
      case 'route':
        {
          formattedResults.address += component.short_name;
          break;
        }
      case 'postal_code':
        {
          formattedResults.postal_code = "".concat(component.long_name);
          break;
        }
      case 'postal_code_suffix':
        {
          formattedResults.postal_code = "".concat(formattedResults.postal_code, "-").concat(component.long_name);
          break;
        }
      case 'locality':
        {
          formattedResults.city = component.long_name;
          break;
        }
      case 'administrative_area_level_1':
        {
          formattedResults.region = component.long_name;
          break;
        }
      case 'country':
        {
          formattedResults.country = component.long_name;
          break;
        }
    }
  }
  return formattedResults;
};
const getOptionValueDefault = option => option.value;
const getOptionLabelDefault = option => option.label;
function AutoCompleteField(props) {
  const {
    helperText,
    variant = 'outlined',
    type = 'text',
    label,
    getOptionLabel = getOptionLabelDefault,
    getOptionValue = getOptionValueDefault,
    options,
    forcePopupIcon = false,
    ...restProps
  } = props;
  const [value, setValue] = React.useState(null);
  const [field, meta, helpers] = useField(restProps);
  return /*#__PURE__*/React.createElement(Autocomplete, _extends({
    options: options,
    getOptionLabel: getOptionLabel,
    forcePopupIcon: forcePopupIcon,
    onChange: (e, newValue) => {
      setValue(newValue);
      helpers.setValue(newValue ? getOptionValue(newValue) : meta.initialValue);
    },
    value: value,
    onBlur: () => {
      helpers.setTouched(true);
    },
    renderInput: params => {
      return /*#__PURE__*/React.createElement(StyledMuiTextField$1, _extends({}, params, {
        variant: variant,
        type: type,
        label: label,
        error: meta.touched && !!meta.error,
        helperText: meta.touched && meta.error || helperText
      }));
    }
  }, restProps));
}
const StyledMuiTextField$1 = styled(MuiTextField).withConfig({
  displayName: "AutoCompleteField__StyledMuiTextField",
  componentId: "sc-mjnjxv-0"
})(["label.Mui-focused{color:", ";}"], props => props.theme.palette.text.secondary);

// The BreakoutItem is intended to be used inside the TwoColumnGrid, so you can have one of the items "break out" of the container. We often do this with the CircleImg to give a dramatic effect.
function BreakoutItem(_ref) {
  let {
    children,
    alignFrom = 'left',
    sizeLg: _sizeLg = '100%'
  } = _ref;
  const {
    sizeMd,
    sizeLg,
    sizeXl
  } = getMediaSizes(_sizeLg);
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    pt: "100%",
    height: {
      md: sizeMd,
      lg: sizeLg,
      xl: sizeXl
    }
  }, /*#__PURE__*/React.createElement(BreakoutItemContainer, {
    $alignFrom: alignFrom,
    $sizeMd: sizeMd,
    $sizeLg: sizeLg,
    $sizeXl: sizeXl
  }, children));
}
const BreakoutItemContainer = styled(Box).withConfig({
  displayName: "BreakoutItem__BreakoutItemContainer",
  componentId: "sc-1ydncfp-0"
})(["position:absolute;top:0;height:100%;width:100%;", " ", "{height:", ";width:", ";}", "{height:", ";width:", ";}", "{height:", ";width:", ";}"], _ref2 => {
  let {
    $alignFrom = 'left'
  } = _ref2;
  return "".concat($alignFrom, ": 0;");
}, match.isMD, _ref3 => {
  let {
    $sizeMd
  } = _ref3;
  return $sizeMd;
}, _ref4 => {
  let {
    $sizeMd
  } = _ref4;
  return $sizeMd;
}, match.isLG, _ref5 => {
  let {
    $sizeLg
  } = _ref5;
  return $sizeLg;
}, _ref6 => {
  let {
    $sizeLg
  } = _ref6;
  return $sizeLg;
}, match.isXL, _ref7 => {
  let {
    $sizeXl
  } = _ref7;
  return $sizeXl;
}, _ref8 => {
  let {
    $sizeXl
  } = _ref8;
  return $sizeXl;
});
function getMediaSizes(_sizeLg) {
  const sizeMd = typeof _sizeLg === 'string' ? _sizeLg : "".concat(_sizeLg * 0.7, "px");
  const sizeLg = typeof _sizeLg === 'string' ? _sizeLg : "".concat(_sizeLg * 1, "px");
  const sizeXl = typeof _sizeLg === 'string' ? _sizeLg : "".concat(_sizeLg * 1, "px");
  return {
    sizeMd,
    sizeLg,
    sizeXl
  };
}
const Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    variant = 'contained',
    color = 'primary',
    ...rest
  } = _ref;
  const SizedButton = buttonSizes[rest.size] || buttonSizes['default'];
  return /*#__PURE__*/React.createElement(SizedButton, _extends({
    ref: ref,
    disableElevation: true,
    variant: variant,
    color: color
  }, rest));
});
const StyledButton$2 = styled(MuiButton).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-vj133d-0"
})(["&.MuiButton-sizeLarge,&[class*='MuiButton-sizeLarge-']{padding:16px 30px;}&.MuiButton-outlinedPrimary,&[class*='MuiButton-outlinedPrimary-']{color:", ";border-color:", ";border-width:2px;padding:16px 30px;line-height:1.5em;}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.text.primary;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
});
const XLargeButton = styled( /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    size,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(StyledButton$2, _extends({
    ref: ref,
    size: "large"
  }, rest));
})).withConfig({
  displayName: "Button__XLargeButton",
  componentId: "sc-vj133d-1"
})(["&.MuiButton-sizeLarge,&[class*='MuiButton-sizeLarge-']{padding:35px 50px;white-space:nowrap;}"]);
const XXLargeButton = styled(XLargeButton).withConfig({
  displayName: "Button__XXLargeButton",
  componentId: "sc-vj133d-2"
})(["padding:35px 95px;font-size:", ";"], _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.typography.pxToRem(22);
});
const buttonSizes = {
  xlarge: XLargeButton,
  xxlarge: XXLargeButton,
  default: StyledButton$2
};
const ButtonLoader = _ref => {
  let {
    loading,
    loaderColor = 'primary',
    disabled,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(ButtonContainer$1, null, /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    disabled: loading || disabled
  })), loading && /*#__PURE__*/React.createElement(LoaderContainer, null, /*#__PURE__*/React.createElement(CircularProgress, {
    color: loaderColor
  })));
};
ButtonLoader.defaultProps = {
  loading: false
};
const ButtonContainer$1 = styled.div.withConfig({
  displayName: "ButtonLoader__ButtonContainer",
  componentId: "sc-1178l7q-0"
})(["position:relative;display:inline-block;"]);
const LoaderContainer = styled.div.withConfig({
  displayName: "ButtonLoader__LoaderContainer",
  componentId: "sc-1178l7q-1"
})(["position:absolute;right:-50px;top:50%;transform:translate(0,-50%);"]);
const CircleImage = _ref => {
  let {
    sources,
    alt = '',
    ...restProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    pt: "100%"
  }, /*#__PURE__*/React.createElement(ImgContainer, null, /*#__PURE__*/React.createElement(GatsbyImage, _extends({
    image: sources,
    alt: alt
  }, restProps))));
};
const ImgContainer = styled.div.withConfig({
  displayName: "CircleImage__ImgContainer",
  componentId: "sc-i610k3-0"
})(["border-radius:50%;overflow:hidden;position:absolute;transform:translateZ(0);top:0;left:0;height:100%;width:100%;"]);
function ClientOnly(_ref) {
  let {
    children,
    ...rest
  } = _ref;
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", rest, children);
}
const useGSAPLabels = props => {
  const {
    stepPrefix,
    animationName,
    useGlobals = true
  } = props || {};
  const [labels, setLabels] = React.useState();
  const [scrollTrigger, setScrollTrigger] = React.useState();
  React.useEffect(() => {
    if (!scrollTrigger) return;
    scrollTrigger.refresh();
    const getLabels = () => {
      const {
        animation: timeline,
        start,
        end
      } = scrollTrigger;
      const labelObject = getLabelPixels(timeline, start, end, stepPrefix);
      setLabels(labelObject);
    };
    ScrollTrigger.addEventListener('refresh', throttle(getLabels, 3000));
    getLabels();
    return () => {
      ScrollTrigger.removeEventListener('refresh', throttle(getLabels, 3000));
    };
  }, [scrollTrigger, stepPrefix]);
  React.useEffect(() => {
    var _window;
    if (!labels || !useGlobals) return;
    const animation = {
      [animationName]: labels
    };
    window.$animations = {
      ...(((_window = window) === null || _window === void 0 ? void 0 : _window.$animations) || {}),
      ...animation
    };
  }, [labels, animationName, useGlobals]);
  return {
    labels,
    setScrollTrigger
  };
};
const convertToPixels = (timeline, mainDuration, start, end, isNested, stepPrefix) => {
  const labels = stepPrefix ? pickBy(timeline.labels, (val, key) => key.startsWith(stepPrefix)) : timeline.labels;
  return objReduce(labels, (acc, key) => ({
    ...acc,
    [key]: Math.round((labels[key] + (isNested ? timeline.startTime() : 0)) / mainDuration * (end - start) + start)
  }), {});
};
const getLabelPixels = (mainTl, start, end, stepPrefix) => {
  const children = mainTl.getChildren(true, false, true);
  const childLabels = children.reduce((acc, childTl) => ({
    ...acc,
    ...convertToPixels(childTl, mainTl.duration(), start, end, true, stepPrefix)
  }), {});
  return {
    ...childLabels,
    ...convertToPixels(mainTl, mainTl.duration(), start, end, false, stepPrefix)
  };
};
const objReduce = (obj, fn, init) => Object.keys(obj).reduce(fn, init);
const useResizeObserver = target => {
  const [entries, setEntries] = useState([]);
  useEffect(() => {
    if (!target) return;
    const resizeObserver = new ResizeObserver(elements => setEntries(elements));
    resizeObserver.observe(target);
    return () => resizeObserver.disconnect();
  }, [target]);
  return entries;
};
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin__default);
gsap.registerPlugin(ExpoScaleEase);
const ContentReveal = props => {
  var _contentRef$current;
  const {
    background,
    reveal,
    animationLabelCallback
  } = props;
  const stickyContainerRef = React.useRef();
  const contentRef = React.useRef();
  const revealMaskRef = React.useRef();
  const revealMaskInnerRef = React.useRef();
  const revealRef = React.useRef();
  const timeline = useInstance(() => gsap.timeline());
  const contentSize = useResizeObserver((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || (_contentRef$current = _contentRef$current.firstChild) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.firstChild);
  const {
    labels,
    setScrollTrigger
  } = useGSAPLabels({
    stepPrefix: 'anim_step',
    animationName: 'content_reveal'
  });
  React.useEffect(() => {
    if (animationLabelCallback) animationLabelCallback(labels);
  }, [labels, animationLabelCallback]);
  useIsomorphicLayoutEffect(() => {
    const animationRefs = {
      revealMaskRef,
      revealMaskInnerRef,
      revealRef,
      timeline,
      contentRef
    };
    buildAnimation(animationRefs);
    const scrollTrigger = ScrollTrigger.create({
      trigger: stickyContainerRef.current,
      scrub: true,
      start: 'top top',
      end: 'bottom bottom',
      animation: timeline,
      ease: 'none'
    });
    setScrollTrigger(scrollTrigger);
  }, [timeline, contentSize]);
  return /*#__PURE__*/React.createElement(StickyContainer$2, {
    ref: stickyContainerRef
  }, /*#__PURE__*/React.createElement(StickyItem, null, /*#__PURE__*/React.createElement(ContentContainer$1, {
    ref: contentRef
  }, background), /*#__PURE__*/React.createElement(RevealContainer, null, /*#__PURE__*/React.createElement(RevealMask, {
    ref: revealMaskRef
  }, /*#__PURE__*/React.createElement(RevealMaskInner, {
    ref: revealMaskInnerRef
  }, /*#__PURE__*/React.createElement(Reveal, {
    ref: revealRef
  }, reveal))))));
};
const buildAnimation = _ref => {
  let {
    revealMaskRef,
    revealMaskInnerRef,
    revealRef,
    timeline,
    contentRef
  } = _ref;
  const progress = timeline.progress();
  timeline.pause(0).clear();
  gsap.set([revealMaskRef.current, revealRef.current], {
    clearProps: 'all'
  });
  const scaleFactor = 0.001;
  const scrollAmount = checkScrollAmount(contentRef.current) || 0;
  if (scrollAmount > 0) timeline.fromTo(contentRef.current, {
    scrollTo: {
      y: 0
    }
  }, {
    scrollTo: {
      y: scrollAmount
    }
  }, 0);
  timeline.fromTo(revealMaskRef.current, {
    scale: scaleFactor
  }, {
    duration: 3,
    scale: 1,
    ease: ExpoScaleEase.config(scaleFactor, 1, 'power2.inOut')
  }, 0);
  timeline.fromTo(revealMaskInnerRef.current, {
    scale: 1 / scaleFactor
  }, {
    duration: 3,
    scale: 1,
    ease: ExpoScaleEase.config(1 / scaleFactor, 1, 'power2.inOut')
  }, 0).addLabel('anim_step1');
  timeline.progress(progress);
};
const StickyContainer$2 = styled.div.withConfig({
  displayName: "ContentReveal__StickyContainer",
  componentId: "sc-ifp1sh-0"
})(["position:relative;height:250vh;"]);
const StickyItem = styled.div.withConfig({
  displayName: "ContentReveal__StickyItem",
  componentId: "sc-ifp1sh-1"
})(["position:sticky;width:100%;height:100vh;top:0;"]);
const ContentContainer$1 = styled.div.withConfig({
  displayName: "ContentReveal__ContentContainer",
  componentId: "sc-ifp1sh-2"
})(["position:relative;width:100%;height:100vh;z-index:1;overflow:hidden;"]);
const RevealContainer = styled.div.withConfig({
  displayName: "ContentReveal__RevealContainer",
  componentId: "sc-ifp1sh-3"
})(["position:absolute;top:0;width:100%;height:100vh;overflow:hidden;z-index:2;"]);
const RevealMask = styled.div.withConfig({
  displayName: "ContentReveal__RevealMask",
  componentId: "sc-ifp1sh-4"
})(["border-radius:50%;overflow:hidden;position:absolute;top:100%;left:100%;transform:translate(-50%,-50%) scale(0);@media ", "{width:260vh;height:260vh;}@media ", "{width:260vw;height:260vw;}"], match.isPortrait, match.isLandscape);
const RevealMaskInner = styled.div.withConfig({
  displayName: "ContentReveal__RevealMaskInner",
  componentId: "sc-ifp1sh-5"
})(["width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
const Reveal = styled.div.withConfig({
  displayName: "ContentReveal__Reveal",
  componentId: "sc-ifp1sh-6"
})(["height:100vh;width:100vw;position:absolute;top:50%;left:50%;transform:translate(-100%,-100%);transform-origin:bottom right;"]);
const Copyright = props => {
  const currentYear = new Date().getFullYear();
  return /*#__PURE__*/React.createElement(P, _extends({
    variant: "body2"
  }, props), "\xA9 ", currentYear, " ", /*#__PURE__*/React.createElement(Trans, null, "All rights reserved"), ".", ' ', /*#__PURE__*/React.createElement("span", null, "Klick\xA0Health", /*#__PURE__*/React.createElement("sup", null, "\xAE"), " ", /*#__PURE__*/React.createElement(Trans, null, "is a trademark of"), " Klick Inc."));
};
const defaultProps$2 = {
  titleProps: {}
};
function ResponsiveDialog(_ref) {
  let {
    dialogTitle,
    titleHeadingProps = defaultProps$2.titleProps,
    open,
    dialogContent,
    dialogActions,
    onClose,
    ...dialogProps
  } = _ref;
  const {
    setIsModalOpen
  } = useModalContext();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  React.useEffect(() => {
    setIsModalOpen(open);
  }, [open, setIsModalOpen]);
  return /*#__PURE__*/React.createElement(StyledDialog, _extends({
    fullScreen: fullScreen,
    open: open,
    onClose: onClose,
    "aria-labelledby": "responsive-dialog-title",
    PaperProps: {
      bgcolor: 'blue'
    },
    BackdropComponent: StyledBackDrop
  }, dialogProps, {
    maxWidth: "sm"
  }), /*#__PURE__*/React.createElement(StyledDialogTitle, {
    disableTypography: true,
    id: "responsive-dialog-title"
  }, dialogTitle), /*#__PURE__*/React.createElement(DialogContent, null, dialogContent), /*#__PURE__*/React.createElement(StyledDialogActions, null, dialogActions));
}
const StyledBackDrop = styled(Backdrop$1).withConfig({
  displayName: "Dialog__StyledBackDrop",
  componentId: "sc-12ftw3j-0"
})(["", ""], _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["background-color:", ";backdrop-filter:blur(10px);"], alpha$1(theme.palette.secondary.main, 0.5));
});
const StyledDialogTitle = styled(DialogTitle).withConfig({
  displayName: "Dialog__StyledDialogTitle",
  componentId: "sc-12ftw3j-1"
})(["", ""], _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["padding-top:", "px;"], theme.spacing(3));
});
const StyledDialogActions = styled(DialogActions).withConfig({
  displayName: "Dialog__StyledDialogActions",
  componentId: "sc-12ftw3j-2"
})(["", ""], _ref4 => {
  let {
    theme
  } = _ref4;
  return css(["padding:", "px ", "px;"], theme.spacing(3), theme.spacing(3));
});
const StyledDialog = styled(Dialog).withConfig({
  displayName: "Dialog__StyledDialog",
  componentId: "sc-12ftw3j-3"
})(["", ""], _ref5 => {
  let {
    theme
  } = _ref5;
  return css(["[class*='MuiDialog-paper-']{background-color:", ";", "{min-width:600px;border-right:4px solid ", ";}}"], theme.palette.background.default, match.isSM, theme.palette.primary.main);
});
const DoubleSlideshow = _ref => {
  let {
    initialSlide = 0,
    slides,
    autoplay,
    autoplayDelay = 4000,
    pauseOnHover = false,
    rounded = true,
    decorators = false,
    center = false,
    ...rest
  } = _ref;
  const [currentSlide, setCurrentSlide] = React.useState(initialSlide);
  const titleRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const eyebrowRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const eyebrowDecoratorRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const subtitleRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const subtitleDecoratorRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const bgRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const imageRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const contentRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const buttonRefs = React.useRef(slides.map(() => /*#__PURE__*/React.createRef(null)));
  const lastSlide = React.useRef(initialSlide);
  const isAnimating = React.useRef(false);
  const directionRef = React.useRef(null);
  const autoplayIntervalRef = React.useRef(null);
  const nextSlide = React.useCallback(() => {
    if (isAnimating.current) return;
    directionRef.current = 1;
    setCurrentSlide(prevSlide => (prevSlide + 1) % slides.length);
  }, [slides.length]);
  const previousSlide = React.useCallback(() => {
    if (isAnimating.current) return;
    directionRef.current = -1;
    setCurrentSlide(prevSlide => prevSlide === 0 ? slides.length - 1 : prevSlide - 1);
  }, [slides.length]);
  React.useEffect(() => {
    titleRefs.current.forEach(ref => {
      const title = ref.current.children[0];
      wrapTextWithSpan(title);
    });
    gsap.set([bgRefs.current[initialSlide].current, imageRefs.current[initialSlide].current, contentRefs.current[initialSlide].current], {
      opacity: 1
    });
    gsap.set([contentRefs.current[initialSlide].current], {
      pointerEvents: 'all'
    });
    gsap.set([bgRefs.current.map(ref => [ref.current, ref.current.children]), imageRefs.current.map(ref => [ref.current, ref.current.children])], {
      'will-change': 'transform'
    });
    gsap.set([...titleRefs.current.map(ref => ref.current.children[0]), ...subtitleRefs.current.filter(ref => {
      var _ref$current;
      return !!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.children[0]);
    }).map(ref => ref.current.children[0])], {
      'will-change': 'transform, opacity'
    });
  }, [initialSlide]);
  React.useEffect(() => {
    var _subtitleRefs$current, _eyebrowRefs$current$, _subtitleRefs$current2, _eyebrowRefs$current$2;
    if (currentSlide === lastSlide.current) return;
    const mm = gsap.matchMedia();
    isAnimating.current = true;
    const lastIndex = lastSlide.current;
    const lastSlideBg = bgRefs.current[lastIndex].current;
    const lastSlideImage = imageRefs.current[lastIndex].current;
    const lastSlideContent = contentRefs.current[lastIndex].current;
    const lastSlideTitle = titleRefs.current[lastIndex].current.children[0];
    const lastSlideSubtitle = (_subtitleRefs$current = subtitleRefs.current[lastIndex].current) === null || _subtitleRefs$current === void 0 ? void 0 : _subtitleRefs$current.children[0];
    const lastSlideSubtitleDecorator = subtitleDecoratorRefs.current[lastIndex].current;
    const lastSlideEyebrow = (_eyebrowRefs$current$ = eyebrowRefs.current[lastIndex].current) === null || _eyebrowRefs$current$ === void 0 ? void 0 : _eyebrowRefs$current$.children[0];
    const lastSlideEyebrowDecorator = eyebrowDecoratorRefs.current[lastIndex].current;
    const lastSlideButton = buttonRefs.current[lastIndex].current.children[0];
    const newIndex = currentSlide;
    const newSlideBg = bgRefs.current[newIndex].current;
    const newSlideContent = contentRefs.current[newIndex].current;
    const newSlideImage = imageRefs.current[newIndex].current;
    const newSlideTitle = titleRefs.current[newIndex].current.children[0];
    const newSlideSubtitle = (_subtitleRefs$current2 = subtitleRefs.current[newIndex].current) === null || _subtitleRefs$current2 === void 0 ? void 0 : _subtitleRefs$current2.children[0];
    const newSlideSubtitleDecorator = subtitleDecoratorRefs.current[newIndex].current;
    const newSlideEyebrow = (_eyebrowRefs$current$2 = eyebrowRefs.current[newIndex].current) === null || _eyebrowRefs$current$2 === void 0 ? void 0 : _eyebrowRefs$current$2.children[0];
    const newSlideEyebrowDecorator = eyebrowDecoratorRefs.current[newIndex].current;
    const newSlideButton = buttonRefs.current[newIndex].current.children[0];

    // const direction = determineCarouselDirection(
    //   lastIndex,
    //   newIndex,
    //   slides.length
    // );
    const direction = directionRef.current;
    const tl = gsap.timeline({
      defaults: {
        duration: 1.1,
        ease: 'power3.inOut'
      },
      onComplete: () => {
        isAnimating.current = false;
        lastSlide.current = newIndex;
      }
    });
    mm.add('(min-width: 0px)', () => {
      gsap.set(contentRefs.current.map(ref => ref.current), {
        opacity: 0,
        pointerEvents: 'none'
      });
      gsap.set(newSlideContent, {
        pointerEvents: 'all'
      });
      gsap.set([lastSlideContent, newSlideContent], {
        opacity: 1
      });
      tl.addLabel('titleOut', 0).addLabel('ImageTransition', 0.1).addLabel('titleIn', 0.25).addLabel('subtitleIn', 0.85).to(lastSlideTitle, {
        startAt: {
          xPercent: 0
        },
        xPercent: direction * 30,
        duration: 0.55
      }, 'titleOut');
      if (lastSlideSubtitle) {
        tl.to(lastSlideSubtitle, {
          startAt: {
            yPercent: 0,
            opacity: 1
          },
          yPercent: -100,
          opacity: 0,
          duration: 0.55
        }, 'titleOut');
        if (decorators) {
          tl.to(lastSlideSubtitleDecorator, {
            startAt: {
              opacity: 1
            },
            opacity: 0,
            duration: 0.55
          }, 'titleOut');
        }
      }
      if (lastSlideEyebrow) {
        tl.to(lastSlideEyebrow, {
          startAt: {
            yPercent: 0,
            opacity: 1
          },
          yPercent: -100,
          opacity: 0,
          duration: 0.55
        }, 'titleOut');
        if (decorators) {
          tl.to(lastSlideEyebrowDecorator, {
            startAt: {
              opacity: 1
            },
            opacity: 0,
            duration: 0.55
          }, 'titleOut');
        }
      }
      tl.to(lastSlideButton, {
        startAt: {
          xPercent: 0,
          opacity: 1
        },
        xPercent: direction * 50,
        opacity: 0,
        duration: 0.55
      }, 'titleOut').to([gsap.utils.selector(lastSlideTitle)('.char-inner')], {
        startAt: {
          xPercent: 0
        },
        xPercent: -direction * 100,
        duration: 0.55
      }, 'titleOut');
      if (newSlideSubtitle) {
        tl.to(newSlideSubtitle, {
          startAt: {
            yPercent: -200,
            opacity: 0
          },
          yPercent: 0,
          opacity: 1,
          duration: 0.55,
          immediateRender: true
        }, 'subtitleIn');
        if (decorators) {
          tl.to(newSlideSubtitleDecorator, {
            startAt: {
              opacity: 0
            },
            opacity: 1,
            duration: 0.55,
            immediateRender: true
          }, 'subtitleIn');
        }
      }
      if (newSlideEyebrow) {
        tl.to(newSlideEyebrow, {
          startAt: {
            yPercent: -200,
            opacity: 0
          },
          yPercent: 0,
          opacity: 1,
          duration: 0.55,
          immediateRender: true
        }, 'subtitleIn');
        if (decorators) {
          tl.to(newSlideEyebrowDecorator, {
            startAt: {
              opacity: 0
            },
            opacity: 1,
            duration: 0.55,
            immediateRender: true
          }, 'subtitleIn');
        }
      }
      tl.to(newSlideButton, {
        startAt: {
          xPercent: -50,
          opacity: 0
        },
        xPercent: 0,
        opacity: 1,
        duration: 0.55,
        immediateRender: true
      }, 'subtitleIn').to(newSlideTitle, {
        startAt: {
          xPercent: -direction * 30
        },
        xPercent: 0
      }, 'titleIn').to([gsap.utils.selector(newSlideTitle)('.char-inner')], {
        startAt: {
          xPercent: direction * 100
        },
        xPercent: 0,
        immediateRender: true
      }, 'titleIn').to(lastSlideBg, {
        xPercent: direction * 100,
        onComplete: () => gsap.set(lastSlideBg, {
          opacity: 0
        })
      }, 'ImageTransition').to(lastSlideBg.children[0], {
        xPercent: -direction * 30,
        startAt: {
          rotation: 0
        },
        rotation: -direction * 20,
        scaleX: 2.8
      }, 'ImageTransition').to(newSlideBg, {
        startAt: {
          opacity: 1,
          xPercent: -direction * 80
        },
        xPercent: 0
      }, 'ImageTransition').to(newSlideBg.children[0], {
        startAt: {
          xPercent: direction * 30,
          scaleX: 2.8,
          rotation: direction * 20
        },
        xPercent: 0,
        scaleX: 1,
        rotation: 0
      }, 'ImageTransition');
    });
    mm.add(match.getQuery('isSM'), () => {
      tl.to(lastSlideImage, {
        xPercent: -direction * 100,
        onComplete: () => gsap.set(lastSlideImage, {
          opacity: 0
        })
      }, 'ImageTransition').to(lastSlideImage.children[0], {
        xPercent: direction * 30,
        startAt: {
          rotation: 0
        },
        rotation: -direction * 20,
        scaleX: 2.8
      }, 'ImageTransition').to(newSlideImage, {
        startAt: {
          opacity: 1,
          xPercent: direction * 80
        },
        xPercent: 0
      }, 'ImageTransition').to(newSlideImage.children[0], {
        startAt: {
          xPercent: -direction * 30,
          scaleX: 2.8,
          rotation: direction * 20
        },
        xPercent: 0,
        scaleX: 1,
        rotation: 0
      }, 'ImageTransition');
    });
    if (autoplay) {
      clearInterval(autoplayIntervalRef.current);
      autoplayIntervalRef.current = setInterval(nextSlide, autoplayDelay);
    }
    return () => {
      mm.revert();
    };
  }, [currentSlide, autoplay, autoplayDelay, nextSlide]);
  React.useEffect(() => {
    if (!autoplay) return;
    autoplayIntervalRef.current = setInterval(nextSlide, autoplayDelay);
    return () => {
      clearInterval(autoplayIntervalRef.current);
    };
  }, [autoplay, autoplayDelay, nextSlide]);
  const handleMouseEnter = () => {
    if (pauseOnHover) clearInterval(autoplayIntervalRef.current);
  };
  const handleMouseLeave = () => {
    if (!autoplay || !pauseOnHover) return;
    autoplayIntervalRef.current = setInterval(nextSlide, autoplayDelay);
  };
  return /*#__PURE__*/React.createElement(SlideShowContainer, _extends({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, rest), /*#__PURE__*/React.createElement(ImageBgContainer, null, slides.map((slide, index) => /*#__PURE__*/React.createElement(SlideImage, {
    ref: bgRefs.current[index],
    key: index,
    image: slide.bg,
    className: lastSlide.current === index ? 'current' : undefined
  }))), /*#__PURE__*/React.createElement(ImageContainer$2, {
    $rounded: rounded
  }, slides.map((slide, index) => /*#__PURE__*/React.createElement(SlideImage, {
    ref: imageRefs.current[index],
    key: index,
    image: slide.image,
    className: lastSlide.current === index ? 'current' : undefined
  }))), /*#__PURE__*/React.createElement(ContentContainer, null, slides.map((slide, index) => /*#__PURE__*/React.createElement(SlideContent, {
    ref: contentRefs.current[index],
    key: index,
    $center: center
  }, !!slide.eyebrow && /*#__PURE__*/React.createElement(EyebrowContainer, {
    ref: eyebrowRefs.current[index]
  }, slide.eyebrow), decorators && !!slide.eyebrow && /*#__PURE__*/React.createElement(StyledDecorator$1, {
    ref: eyebrowDecoratorRefs.current[index],
    color: "inherit"
  }), /*#__PURE__*/React.createElement(TitleContainer, {
    ref: titleRefs.current[index]
  }, slide.title), decorators && !!slide.subtitle && /*#__PURE__*/React.createElement(StyledDecorator$1, {
    ref: subtitleDecoratorRefs.current[index],
    color: "inherit"
  }), !!slide.subtitle && /*#__PURE__*/React.createElement(SubtitleContainer, {
    ref: subtitleRefs.current[index]
  }, slide.subtitle), /*#__PURE__*/React.createElement(ButtonContainer, {
    ref: buttonRefs.current[index],
    $center: center
  }, slide.button)))), slides.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrevArrow, {
    onClick: previousSlide
  }), /*#__PURE__*/React.createElement(NextArrow, {
    onClick: nextSlide
  })) : null);
};
function wrapTextWithSpan(node) {
  // If the node is a text node
  if (node.nodeType === 3) {
    const text = node.nodeValue;
    // const wrappedText = Array.from(text)
    //   .map((char) => {
    //     return `<span class="char"><span class="char-inner" style="will-change: transform">${char}</span></span>`
    //   })
    //   .join('')

    const wrappedText = text.split(' ').map(word => "<span class=\"word\">".concat(word.split('').map(char => "<span class=\"char\"><span class=\"char-inner\" style=\"will-change: transform\">".concat(char, "</span></span>")).join(''), "</span>")).join('<span class="char"> </span>');

    // Convert wrappedText into actual DOM nodes and insert them
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = wrappedText;
    while (tempDiv.firstChild) {
      node.parentNode.insertBefore(tempDiv.firstChild, node);
    }
    node.parentNode.removeChild(node);
  } else if (node.nodeType === 1 && node.childNodes) {
    // If the node is an element, check its children
    Array.from(node.childNodes).forEach(child => wrapTextWithSpan(child));
  }
}
const SlideImage = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    image,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(SlideItem, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(SlideItemInner, {
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }));
});
const NextArrow = _ref3 => {
  let {
    onClick
  } = _ref3;
  return /*#__PURE__*/React.createElement(NextContainer, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Arrow, null));
};
const PrevArrow = _ref4 => {
  let {
    onClick
  } = _ref4;
  return /*#__PURE__*/React.createElement(PrevContainer, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Arrow, null));
};
const SlideContent = styled.div.withConfig({
  displayName: "DoubleSlideshow__SlideContent",
  componentId: "sc-11y50bs-0"
})(["position:relative;opacity:0;grid-area:1 / 1 / -1 / -1;text-align:", ";", "{padding:0 80px;}"], _ref5 => {
  let {
    $center
  } = _ref5;
  return $center ? 'center' : 'left';
}, match.isMD);
const TitleContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__TitleContainer",
  componentId: "sc-11y50bs-1"
})(["text-align:center;br{display:inline;}", "{text-align:left;br{display:none;}}.word{white-space:nowrap;}.char{display:inline-block;vertical-align:bottom;overflow:hidden;white-space:pre;}.char-inner{overflow:hidden;display:block;}"], match.isMD);
const EyebrowContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__EyebrowContainer",
  componentId: "sc-11y50bs-2"
})(["padding:2rem 0;text-align:center;max-width:80vw;margin:0 auto;"]);
const SubtitleContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__SubtitleContainer",
  componentId: "sc-11y50bs-3"
})(["margin:1.25rem auto 0;text-align:center;max-width:80vw;", "{position:absolute;margin:3.5rem auto 0;text-align:left;transform:translateY(-50%);}"], match.isMD);
const ButtonContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__ButtonContainer",
  componentId: "sc-11y50bs-4"
})(["margin:3.5rem auto 0;white-space:nowrap;max-width:80vw;text-align:center;", "{", "}"], match.isMD, _ref6 => {
  let {
    $center
  } = _ref6;
  return !$center && css(["position:absolute;right:0;left:auto;transform:translateY(-50%);margin:3.5rem auto 0;"]);
});
const SlideItem = styled.div.withConfig({
  displayName: "DoubleSlideshow__SlideItem",
  componentId: "sc-11y50bs-5"
})(["grid-area:1 / 1 / -1 / -1;position:relative;width:100%;height:100%;overflow:hidden;display:grid;place-items:center;opacity:0;pointer-events:none;&.current{opacity:1;z-index:50;}"]);
const SlideItemInner = styled.div.withConfig({
  displayName: "DoubleSlideshow__SlideItemInner",
  componentId: "sc-11y50bs-6"
})(["position:relative;width:120%;height:120%;display:grid;place-items:center;grid-area:1 / 1 / -1 / -1;background-size:cover;background-position:50% 50%;"]);
const Slider = styled.div.withConfig({
  displayName: "DoubleSlideshow__Slider",
  componentId: "sc-11y50bs-7"
})(["grid-area:main;position:relative;overflow:hidden;display:grid;place-items:center;width:100%;height:100vh;pointer-events:none;"]);
const ContentContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__ContentContainer",
  componentId: "sc-11y50bs-8"
})(["grid-area:main;display:grid;place-items:center;pointer-events:none;z-index:19;padding:0 24px;"]);
const ImageContainer$2 = styled(Slider).withConfig({
  displayName: "DoubleSlideshow__ImageContainer",
  componentId: "sc-11y50bs-9"
})(["display:none;position:absolute;width:25vw;min-width:300px;aspect-ratio:0.65;height:auto;z-index:2;border-radius:", ";&:before{display:block;content:' ';position:absolute;width:100%;height:100%;background-image:radial-gradient(rgb(0 0 0 / 52%) 40%,transparent 80%);z-index:100;}", "{display:grid;}"], _ref7 => {
  let {
    $rounded
  } = _ref7;
  return $rounded ? "max(12.5vw, 150px)" : '0';
}, match.isMD);
const ImageBgContainer = styled(Slider).withConfig({
  displayName: "DoubleSlideshow__ImageBgContainer",
  componentId: "sc-11y50bs-10"
})(["z-index:1;"]);
const StyledDecorator$1 = styled(Decorator).withConfig({
  displayName: "DoubleSlideshow__StyledDecorator",
  componentId: "sc-11y50bs-11"
})(["border-top-color:", ";margin-top:0;"], _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.palette.text.primary;
});
const Arrow = styled.div.withConfig({
  displayName: "DoubleSlideshow__Arrow",
  componentId: "sc-11y50bs-12"
})(["position:relative;display:inline-block;vertical-align:middle;color:#fff;box-sizing:border-box;width:20px;height:20px;border-width:4px 4px 0 0;border-style:solid;border-color:rgba(255,255,255,0);margin:10px;transform:translate3d(1px,-1px,0) scale(0.3);transition:all 250ms ease-out;transition-delay:175ms;cursor:pointer;&:before{content:'';box-sizing:border-box;right:0;top:-3px;position:absolute;height:4px;opacity:0;box-shadow:inset 0 0 0 32px;transform:rotate(-45deg) translate3d(-90px,0,0);width:35px;transform-origin:right top;transition:transform 250ms ease-out,opacity 200ms ease-out;transition-delay:175ms;}"]);
const ArrowContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__ArrowContainer",
  componentId: "sc-11y50bs-13"
})(["height:40px;width:40px;border-radius:20px;background:#000;position:absolute;top:auto;bottom:5vh;z-index:19;transform:translate3d(0,-50%,0) rotate(45deg) scale(1.5);opacity:0;cursor:pointer;overflow:hidden;transition:transform 250ms ease-out,opacity 100ms ease-out;", "{top:calc(160vw - 20px);bottom:auto;}&.isTouch{opacity:1;", "{border-color:rgba(255,255,255,1);opacity:1;&:before{opacity:1;transform:rotate(-45deg) translate3d(0,0,0);}}}&:hover{opacity:1;}", "{top:50%;}"], match.isMD, Arrow, match.isMD);
const PrevContainer = styled(ArrowContainer).withConfig({
  displayName: "DoubleSlideshow__PrevContainer",
  componentId: "sc-11y50bs-14"
})(["transform:translate3d(0,-50%,0) rotate(-135deg) scale(1.5);left:15px;", "{left:25px;}"], match.isMD);
const NextContainer = styled(ArrowContainer).withConfig({
  displayName: "DoubleSlideshow__NextContainer",
  componentId: "sc-11y50bs-15"
})(["right:15px;", "{right:25px;}"], match.isMD);
const SlideShowContainer = styled.div.withConfig({
  displayName: "DoubleSlideshow__SlideShowContainer",
  componentId: "sc-11y50bs-16"
})(["background:black;display:grid;grid-template-areas:'main';position:relative;width:100%;height:100vh;overflow:hidden;place-items:center;", "{opacity:0.8;&:hover{opacity:1;}}", "{border-color:rgba(255,255,255,1);&:before{opacity:1;transform:rotate(-45deg) translate3d(0,0,0);}}"], ArrowContainer, Arrow);
const DotCircle = props => {
  const {
    width = '1200px',
    dotWidth = '5rem',
    align,
    offsetX = '0px',
    offsetY = '0px',
    dotPosition = '0deg',
    finalDotPosition,
    animate = true
  } = props;
  const circleRef = React.useRef();
  const dotRef = React.useRef();
  React.useLayoutEffect(() => {
    if (!animate || !finalDotPosition) return;
    const ctx = gsap.context(() => {
      const dot = dotRef.current;
      const circle = circleRef.current;
      const timeline = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: circle,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
      timeline.to(dot, {
        rotate: finalDotPosition
      });
    });
    return () => {
      ctx.revert();
    };
  }, [animate, finalDotPosition]);
  return /*#__PURE__*/React.createElement(Container$3, {
    style: {
      '--circle-width': width,
      '--offset-x': offsetX,
      '--offset-y': offsetY,
      left: align === 'left' ? '50%' : 'unset',
      right: align === 'right' ? '50%' : 'unset'
    }
  }, /*#__PURE__*/React.createElement(Circle$2, {
    ref: circleRef
  }), /*#__PURE__*/React.createElement(Dot, {
    ref: dotRef,
    style: {
      '--dot-width': dotWidth
    },
    $dotPosition: dotPosition
  }));
};
const Container$3 = styled.div.withConfig({
  displayName: "DotCircle__Container",
  componentId: "sc-1eusg7e-0"
})(["width:var(--circle-width);height:var(--circle-width);top:50%;position:absolute;transform:translate(0%,-50%) translate(var(--offset-x),var(--offset-y));"]);
const Circle$2 = styled.div.withConfig({
  displayName: "DotCircle__Circle",
  componentId: "sc-1eusg7e-1"
})(["width:100%;height:100%;border-radius:100%;position:absolute;border:2px dashed rgba(0,0,0,0.075);top:0;left:0;will-change:transform;"]);
const Dot = styled.div.withConfig({
  displayName: "DotCircle__Dot",
  componentId: "sc-1eusg7e-2"
})(["width:100%;height:100%;position:absolute;top:0;left:0;transform:", ";will-change:transform;&:before{content:'';position:absolute;display:block;border-radius:100%;background:", ";top:0;left:50%;transform:translate(-50%,-50%);width:var(--dot-width);height:var(--dot-width);}"], _ref => {
  let {
    $dotPosition
  } = _ref;
  return "rotate(".concat($dotPosition, ")");
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primary.main;
});
const KlickLogo = _ref => {
  let {
    brandName,
    shapeK1Ref,
    shapeLRef,
    shapeIRef,
    shapeCRef,
    shapeK2Ref,
    shapeDotRef,
    shapeSubRef,
    orientation = 'portrait',
    ...rest
  } = _ref;
  const parentTheme = useTheme();
  const brand = brandName || parentTheme.brandName || 'klick';
  const textColor = parentTheme.palette.text.primary;
  const backgroundColor = parentTheme.palette.background.default;
  const primaryColor = parentTheme.themeType === 'onPrimary' ? parentTheme.palette.text.primary : brandColors[brand];
  const brandConfig = brandNames[brand];
  const Label = brandConfig.label;
  const viewBox = brandConfig.viewBox[orientation];
  const svgRef = useRef();
  return /*#__PURE__*/React.createElement(StyledSVG, _extends({
    ref: svgRef,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: textColor
  }, /*#__PURE__*/React.createElement("polygon", {
    ref: shapeK1Ref,
    points: "79.99 152.24 145.74 79.41 82.44 79.41 50.08 117.75 50.08 0 0 0 0 242.11 50.08 242.11 50.08 190.1 93.82 242.11 158 242.11 79.99 152.24"
  }), /*#__PURE__*/React.createElement("rect", {
    ref: shapeLRef,
    x: "170.25",
    width: "50.09",
    height: "242.11"
  }), /*#__PURE__*/React.createElement("rect", {
    ref: shapeIRef,
    x: "244.85",
    y: "79.41",
    width: "50.09",
    height: "162.71"
  }), /*#__PURE__*/React.createElement("circle", {
    ref: shapeDotRef,
    cx: "269.89",
    cy: "293.59",
    r: "25.2",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    ref: shapeCRef,
    d: "M145.75,431.05V382.16H93.58c-22,0-33.48-15.16-33.48-32.9s12.57-32,33.48-32h52.17V268.39H93.42c-50.7,0-83.81,35.42-83.81,80.88,0,49.28,38.17,81.82,83.81,81.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    ref: shapeK2Ref,
    d: "M250.26,420.65,316,347.81h-63.3l-32.37,38.35V268.39H170.25V510.51h50.09v-52l43.74,52h64.19Z"
  }), /*#__PURE__*/React.createElement(StyledGroup, {
    ref: shapeSubRef,
    $shouldTransform: brand !== 'IDX' && brand !== 'Anniversary25th',
    $orientation: orientation
  }, /*#__PURE__*/React.createElement(Label, {
    orientation: orientation,
    primaryColor: primaryColor,
    backgroundColor: backgroundColor
  }))));
};
const StyledGroup = styled.g.withConfig({
  displayName: "KlickLogo__StyledGroup",
  componentId: "sc-qwxhoa-0"
})(["transform:", ";"], _ref2 => {
  let {
    $orientation,
    $shouldTransform
  } = _ref2;
  return $orientation === 'portrait' || !$shouldTransform ? 'none' : "translate(35%, -223%) scale(2.5)";
});
const LabelGroup = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M93,557.56c0,12.38-8.81,21.25-21.43,21.25S50,569.88,50,557.56s9-21.19,21.61-21.19c10.36,0,18.87,6.55,20.71,15.77H83.64a12.26,12.26,0,0,0-12-8.63c-7.68,0-13.21,5.9-13.21,14s5.53,14.11,13.21,14.11c6.19,0,11.07-3.75,12.32-9.17H71.62v-7H92.93C92.93,556,93,556.85,93,557.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.37,578.27h-8.63a60.55,60.55,0,0,1-.53-7.85c-.12-4.35-2.21-7.2-5.66-7.2H125v15h-8.28V537H136c8.39,0,13.75,4.58,13.75,11.9,0,5.06-2.5,8.81-6.85,10.6,4,1.3,6.43,4.58,6.67,9.88C149.66,572.8,149.84,576.67,150.37,578.27Zm-9-27.91c0-3.75-2.44-6.13-6.25-6.13H125v12.32h10.12C138.89,556.55,141.33,554.11,141.33,550.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.38,557.56c0,12.32-9,21.25-21.61,21.25s-21.61-8.93-21.61-21.25,9.05-21.19,21.61-21.19S215.38,545.3,215.38,557.56Zm-34.76-.06c0,8,5.53,13.75,13.15,13.75S207,565.48,207,557.5,201.45,544,193.77,544,180.62,549.64,180.62,557.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.39,563.22c0,9.22-6.78,15.59-16.48,15.59s-16.49-6.37-16.49-15.59V537h8.21V562.8c0,5.06,3.33,8.45,8.28,8.45s8.21-3.39,8.21-8.45V537h8.27Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.48,550.72c0,8.09-5.83,13.74-14.17,13.74h-9.7v13.81h-8.27V537h18C322.65,537,328.48,542.56,328.48,550.72Zm-8.45.11a6.25,6.25,0,0,0-6.61-6.6h-8.81v13.21h8.81A6.28,6.28,0,0,0,320,550.83Z"
}));
const LabelKlick = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M32.82,536.72v41.33H24.55v-17H8.36v17H.11V536.72H8.38v17.07H24.57V536.72Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.27,544v9.7H91.36v7H72.27v10H93v7.38H64V536.72H93V544Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.78,570.33h-18l-2.67,7.72h-8.9l15.59-41.28h10l15.58,41.28h-8.92Zm-2.38-6.84-6.6-18.8-6.61,18.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.3,570.69v7.36H187.93V536.72h8.27v34Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.36,544H255.29v34H247V544H234.94v-7.25h32.42Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.05,536.72v41.33h-8.27v-17H303.6v17h-8.27V536.72h8.27v17.07h16.18V536.72Z"
}));
const LabelMedia = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  style: {
    transform: "translateX(-5%)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.92,536.71v41.29h-8.27v-31.06l-11.07,31.06h-7.08l-11.01-31.06v31.06h-8.27v-41.29h11.96l10.89,30.4,10.89-30.4h11.96Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.23,543.97v9.7h19.1v7.02h-19.1v10h20.7v7.32h-28.97v-41.29h28.97v7.26h-20.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.3,557.3c0,12.14-8.81,20.7-21.24,20.7h-14.46v-41.29h14.46c12.43,0,21.24,8.51,21.24,20.58Zm-8.45-.06c0-7.79-5.29-13.27-12.91-13.27h-6.07v26.71h6.07c7.62,0,12.91-5.53,12.91-13.45Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.64,578h-8.27v-41.29h8.27v41.29Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.56,570.33h-17.97l-2.74,7.67h-8.87l15.59-41.29h10l15.59,41.29h-8.92l-2.68-7.67Zm-2.38-6.84l-6.6-18.8-6.6,18.8h13.21Z"
})));
const LabelTransformation = _ref3 => {
  let {
    orientation
  } = _ref3;
  return /*#__PURE__*/React.createElement("g", {
    style: orientation === 'landscape' ? {
      transform: "scale(1.2) translate(-2%, -13%)"
    } : {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8234 533.92H11.2034V549.75H7.35341V533.92H1.74341V530.54H16.8234V533.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1134 549.75H36.1034C35.9634 549.09 35.8834 547.48 35.8534 546.1C35.7934 544.08 34.8334 542.75 33.2234 542.75H28.2934V549.75H24.4434V530.54H33.4134C37.3134 530.54 39.8034 532.67 39.8034 536.08C39.8034 538.43 38.6434 540.18 36.6234 541.01C38.4734 541.62 39.6134 543.14 39.7234 545.6C39.7834 547.21 39.8634 549 40.1134 549.75ZM35.9034 536.77C35.9034 535.03 34.7634 533.92 32.9934 533.92H28.2834V539.65H32.9934C34.7634 539.65 35.9034 538.51 35.9034 536.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4934 546.18H53.1334L51.8634 549.75H47.7434L54.9934 530.54H59.6434L66.8934 549.75H62.7434L61.4934 546.18ZM60.3834 543L57.3134 534.25L54.2434 543H60.3834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6832 530.54V549.75H85.7832L78.3632 535.72V549.75H74.5132V530.54H79.4132L86.8332 544.57V530.54H90.6832Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.283 536.52H109.543C109.483 534.61 108.103 533.39 106.003 533.39C104.123 533.39 102.763 534.36 102.763 535.88C102.763 540.09 113.803 536.88 113.803 544.1C113.803 547.75 110.563 550 105.993 550C101.423 550 98.3832 547.45 98.3032 543.58H102.153C102.183 545.49 103.673 546.87 106.193 546.87C108.353 546.87 109.873 545.85 109.873 544.24C109.873 540.09 98.8332 543.19 98.8332 536.13C98.8332 532.53 101.853 530.26 106.113 530.26C110.373 530.26 113.223 532.75 113.283 536.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.273 533.92V538.79H133.773V542.03H125.273V549.75H121.423V530.54H134.513V533.92H125.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.233 540.12C162.233 545.85 158.023 550 152.183 550C146.343 550 142.133 545.85 142.133 540.12C142.133 534.39 146.343 530.27 152.183 530.27C158.023 530.27 162.233 534.42 162.233 540.12ZM146.073 540.09C146.073 543.8 148.643 546.48 152.193 546.48C155.743 546.48 158.343 543.8 158.343 540.09C158.343 536.38 155.773 533.81 152.193 533.81C148.613 533.81 146.073 536.44 146.073 540.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.523 549.75H181.513C181.373 549.09 181.293 547.48 181.263 546.1C181.203 544.08 180.243 542.75 178.633 542.75H173.703V549.75H169.853V530.54H178.823C182.723 530.54 185.213 532.67 185.213 536.08C185.213 538.43 184.053 540.18 182.033 541.01C183.883 541.62 185.023 543.14 185.133 545.6C185.193 547.21 185.273 549 185.523 549.75ZM181.313 536.77C181.313 535.03 180.173 533.92 178.403 533.92H173.693V539.65H178.403C180.173 539.65 181.313 538.51 181.313 536.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.413 530.54V549.75H210.563V535.3L205.413 549.75H202.123L197.003 535.3V549.75H193.153V530.54H198.713L203.783 544.68L208.853 530.54H214.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.793 546.18H227.433L226.163 549.75H222.043L229.293 530.54H233.943L241.193 549.75H237.043L235.793 546.18ZM234.683 543L231.613 534.25L228.543 543H234.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.893 533.92H258.273V549.75H254.423V533.92H248.803V530.54H263.883V533.92H263.893Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.363 549.75H271.513V530.54H275.363V549.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.083 540.12C303.083 545.85 298.873 550 293.033 550C287.193 550 282.983 545.85 282.983 540.12C282.983 534.39 287.193 530.27 293.033 530.27C298.873 530.27 303.083 534.42 303.083 540.12ZM286.923 540.09C286.923 543.8 289.493 546.48 293.043 546.48C296.593 546.48 299.193 543.8 299.193 540.09C299.193 536.38 296.623 533.81 293.043 533.81C289.463 533.81 286.923 536.44 286.923 540.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.873 530.54V549.75H321.973L314.553 535.72V549.75H310.703V530.54H315.603L323.023 544.57V530.54H326.873Z"
  }));
};
const LabelKatalyst = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M13.77,553.27l13.28,17.45H19.16L6.81,554.16v16.56H0v-34H6.81v15.73L19.3,536.71h7.89Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.47,564.4H52.67l-2.25,6.32h-7.3l12.84-34h8.23l12.83,34H69.67Zm-2-5.64-5.44-15.48-5.44,15.48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.29,542.69h-9.94v28H98.54v-28h-10v-6h26.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.26,564.4h-14.8l-2.25,6.32h-7.3l12.83-34H148l12.83,34h-7.35Zm-2-5.64-5.44-15.48-5.44,15.48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.38,564.69v6H178.85v-34h6.81v28Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.79,556.9v13.82H224V557.1L210.8,536.71h7.69l8.82,14.51,8.77-14.51h7.74Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.49,547.3h-6.62c-.09-3.38-2.54-5.54-6.27-5.54-3.33,0-5.73,1.71-5.73,4.41,0,7.45,19.55,1.76,19.55,14.55,0,6.47-5.73,10.44-13.82,10.44s-13.47-4.51-13.62-11.37h6.81c0,3.38,2.7,5.83,7.16,5.83,3.82,0,6.51-1.81,6.51-4.65,0-7.35-19.55-1.87-19.55-14.36,0-6.37,5.34-10.39,12.89-10.39C279.1,536.22,284.39,540.63,284.49,547.3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.49,542.69h-9.95v28h-6.81v-28h-9.94v-6h26.7Z"
}));
const LabelConsulting = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M14.34,564.48C6,564.48,0,558.55,0,550.38s6-14.07,14.34-14.07c7.47,0,13.08,4.7,14.1,11.58H22.79a8.35,8.35,0,0,0-8.45-6.52c-5.1,0-8.73,3.75-8.73,9s3.63,9.12,8.73,9.12a8.4,8.4,0,0,0,8.45-6.59h5.65C27.46,559.74,21.81,564.48,14.34,564.48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.58,550.38c0,8.17-6,14.1-14.35,14.1s-14.34-5.93-14.34-14.1,6-14.07,14.34-14.07S68.58,542.24,68.58,550.38Zm-23.08,0c0,5.29,3.68,9.12,8.73,9.12S63,555.63,63,550.34s-3.67-9-8.77-9S45.5,545.12,45.5,550.34Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.4,536.71v27.41h-7l-10.59-20v20H81.33V536.71h7l10.59,20v-20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.37,545.24H133c-.08-2.73-2.06-4.46-5.06-4.46-2.69,0-4.62,1.38-4.62,3.55,0,6,15.76,1.42,15.76,11.74,0,5.21-4.62,8.41-11.14,8.41s-10.86-3.64-11-9.17h5.49c0,2.73,2.17,4.71,5.77,4.71,3.08,0,5.25-1.47,5.25-3.76,0-5.92-15.76-1.5-15.76-11.57,0-5.14,4.3-8.38,10.39-8.38C134,536.31,138.29,539.87,138.37,545.24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.25,554.13c0,6.12-4.5,10.35-10.94,10.35s-10.95-4.23-10.95-10.35V536.71h5.45v17.14a5.48,5.48,0,1,0,10.95,0V536.71h5.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205,559.26v4.86H186.79V536.71h5.5v22.55Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.81,541.53h-8v22.59H219.3V541.53h-8v-4.82h21.53Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.15,564.12h-5.49V536.71h5.49Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.21,536.71v27.41h-7l-10.58-20v20h-5.5V536.71h7l10.58,20v-20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.48,550.38c0,8.21-5.84,14.1-14.22,14.1s-14.34-5.93-14.34-14.1,6-14.07,14.34-14.07c6.87,0,12.52,4.35,13.75,10.47h-5.73a8.14,8.14,0,0,0-8-5.73c-5.1,0-8.77,3.91-8.77,9.29s3.67,9.36,8.77,9.36a8.06,8.06,0,0,0,8.18-6.08H314.3V549h14.14C328.44,549.35,328.48,549.9,328.48,550.38Z"
}));
const LabelAppliedSciences = _ref4 => {
  let {
    orientation
  } = _ref4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    style: orientation === 'landscape' ? {
      transform: "translateY(-3%)"
    } : {}
  }, /*#__PURE__*/React.createElement("g", {
    style: orientation === 'landscape' ? {
      transform: "translateX(-3%)"
    } : {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.56,561.34H102.27l-2,5.68H93.69l11.53-30.55h7.4L124.15,567h-6.6Zm-1.76-5.06-4.88-13.91L104,556.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,546.64c0,6-4.31,10.17-10.47,10.17H143V567h-6.11V536.47H150.2C156.36,536.47,160.67,540.61,160.67,546.64Zm-6.25.09a4.62,4.62,0,0,0-4.88-4.89H143v9.78h6.52A4.64,4.64,0,0,0,154.42,546.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,546.64c0,6-4.32,10.17-10.48,10.17h-7.17V567h-6.12V536.47h13.29C193.5,536.47,197.82,540.61,197.82,546.64Zm-6.25.09a4.63,4.63,0,0,0-4.89-4.89h-6.51v9.78h6.51A4.65,4.65,0,0,0,191.57,546.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.44,561.61V567H211.19V536.47h6.12v25.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,567h-6.12V536.47h6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.28,541.84V549h14.13v5.19H272.28v7.4h15.31V567H266.16V536.47h21.43v5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48,551.7c0,9-6.51,15.32-15.71,15.32h-10.7V536.47h10.7C322,536.47,328.48,542.77,328.48,551.7Zm-6.25,0c0-5.77-3.92-9.82-9.55-9.82h-4.49v19.77h4.49C318.31,561.61,322.23,557.51,322.23,551.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.49,591H67.55c-.09-3-2.29-5-5.63-5-3,0-5.15,1.54-5.15,4,0,6.69,17.56,1.58,17.56,13.07,0,5.81-5.15,9.38-12.41,9.38s-12.11-4-12.24-10.22H55.8c0,3,2.42,5.24,6.43,5.24,3.43,0,5.85-1.63,5.85-4.18,0-6.6-17.56-1.67-17.56-12.9,0-5.72,4.8-9.33,11.57-9.33C68.65,581,73.41,585,73.49,591Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,612.43c-9.29,0-16-6.61-16-15.72S92.72,581,102,581c8.32,0,14.57,5.24,15.71,12.9h-6.29a9.31,9.31,0,0,0-9.42-7.26c-5.68,0-9.73,4.18-9.73,10s4,10.17,9.73,10.17a9.38,9.38,0,0,0,9.42-7.35h6.29C116.62,607.14,110.33,612.43,102,612.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,612h-6.12V581.48H137Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.6,586.85V594h14.13v5.19H158.6v7.4h15.32V612H152.49V581.48h21.43v5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,581.48V612h-7.79l-11.8-22.32V612h-6.11V581.48h7.79L207.1,603.8V581.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,612.43c-9.28,0-16-6.61-16-15.72s6.69-15.67,16-15.67c8.32,0,14.57,5.24,15.72,12.9h-6.3a9.31,9.31,0,0,0-9.42-7.26c-5.67,0-9.72,4.18-9.72,10s4.05,10.17,9.72,10.17a9.38,9.38,0,0,0,9.42-7.35h6.3C257,607.14,250.67,612.43,242.35,612.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.38,586.85V594h14.13v5.19H277.38v7.4H292.7V612H271.26V581.48H292.7v5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.64,591H321.7c-.09-3-2.29-5-5.63-5-3,0-5.15,1.54-5.15,4,0,6.69,17.56,1.58,17.56,13.07,0,5.81-5.15,9.38-12.41,9.38s-12.11-4-12.24-10.22H310c0,3,2.42,5.24,6.43,5.24,3.43,0,5.85-1.63,5.85-4.18,0-6.6-17.56-1.67-17.56-12.9,0-5.72,4.79-9.33,11.57-9.33C322.8,581,327.56,585,327.64,591Z"
  }))));
};
const LabelLabs = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M121.58,571v7.28H94.2V537.05h8.28v34Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.59,570.67h-18l-2.71,7.64H153l15.6-41.3h10l15.59,41.3h-8.93Zm-2.4-6.84L173.59,545,167,563.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.41,567.4c0,6.54-4.76,11-11.38,11H228.55v-41.3h19.67c6.67,0,11.43,4.22,11.43,10.47a9.87,9.87,0,0,1-6.24,9.46A10.31,10.31,0,0,1,261.41,567.4Zm-15-23.21h-9.63V554.3h9.63a5,5,0,0,0,5.12-4.88,1,1,0,0,0,0-.24,4.87,4.87,0,0,0-4.74-5ZM253,566a5,5,0,0,0-4.76-5.24H236.83v10.42h11a5,5,0,0,0,5.13-4.88V566Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.36,549.9h-8c-.12-4.11-3.1-6.73-7.62-6.73-4,0-7,2.09-7,5.36,0,9,23.74,2.14,23.74,17.68,0,7.85-7,12.67-16.78,12.67s-16.37-5.47-16.55-13.8h8.28c.06,4.1,3.27,7.08,8.68,7.08,4.64,0,7.93-2.2,7.93-5.65,0-8.94-23.75-2.26-23.75-17.45,0-7.73,6.48-12.62,15.64-12.62C320.82,536.44,327.26,541.81,327.36,549.9Z"
}));
const LabelVentures = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M33.34,536.56l-12.54,34H12.87l-12.59-34h7.1l9.46,27.19,9.4-27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.14,542.54v8H70.87v5.78H55.14v8.23h17v6H48.33v-34H72.19v6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.5,536.56v34h-8.67L95.7,545.72v24.83H88.89v-34h8.67l13.13,24.83V536.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.33,542.54h-9.94v28h-6.81v-28h-9.94v-6h26.69Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201,558.16c0,7.59-5.58,12.84-13.57,12.84s-13.57-5.25-13.57-12.84v-21.6h6.76v21.26c0,4.16,2.75,6.95,6.81,6.95s6.76-2.79,6.76-6.95V536.56H201Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246,570.55h-7.1a47.48,47.48,0,0,1-.45-6.46c-.09-3.58-1.81-5.93-4.65-5.93h-8.72v12.39h-6.81v-34h15.87c6.91,0,11.32,3.77,11.32,9.8a8.89,8.89,0,0,1-5.63,8.72c3.28,1.07,5.29,3.77,5.48,8.13A36.92,36.92,0,0,0,246,570.55Zm-7.45-23a4.76,4.76,0,0,0-5.14-5h-8.33v10.14h8.33A4.8,4.8,0,0,0,238.54,547.58Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.06,542.54v8h15.73v5.78H269.06v8.23h17.05v6H262.25v-34h23.86v6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.55,547.14h-6.61c-.1-3.38-2.55-5.53-6.27-5.53-3.33,0-5.73,1.71-5.73,4.4,0,7.45,19.54,1.77,19.54,14.55,0,6.47-5.73,10.44-13.81,10.44s-13.47-4.51-13.62-11.37h6.81c.05,3.38,2.69,5.83,7.15,5.83,3.82,0,6.51-1.81,6.51-4.65,0-7.35-19.54-1.87-19.54-14.36,0-6.36,5.34-10.38,12.88-10.38C322.16,536.07,327.45,540.48,327.55,547.14Z"
}));
const LabelCareers = _ref5 => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M48.92,567c-9.08,0-15.54-6.43-15.54-15.3s6.5-15.21,15.54-15.21c8.1,0,14.19,5.1,15.3,12.5H58.09a9.1,9.1,0,0,0-9.17-7.07c-5.51,0-9.46,4.07-9.46,9.72s3.95,9.9,9.46,9.9a9.09,9.09,0,0,0,9.17-7.16h6.13C63.14,561.8,57,567,48.92,567Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.38,561H89.45l-2,5.52H81.08l11.23-29.73H99.5l11.22,29.73H104.3Zm-1.71-4.93-4.76-13.53-4.75,13.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8,566.56h-6.21a44.91,44.91,0,0,1-.39-5.68c-.07-3.12-1.57-5.17-4.06-5.17h-7.62v10.83h-5.91V536.83h13.88c6,0,9.9,3.31,9.9,8.58a7.76,7.76,0,0,1-4.92,7.62c2.87.94,4.62,3.3,4.79,7.1A33,33,0,0,0,154.8,566.56Zm-6.5-20.09a4.15,4.15,0,0,0-3.88-4.41,3.75,3.75,0,0,0-.67,0h-7.23v8.85h7.28a4.18,4.18,0,0,0,4.49-3.86,3.85,3.85,0,0,0,0-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,542.12v7h13.74v5.06H181.88v7.19h14.9v5.27H175.92V536.83h20.86v5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,542.12v7H238v5.06H224.23v7.19h14.91v5.27H218.28V536.83h20.86v5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.88,566.56h-6.21a44.91,44.91,0,0,1-.39-5.68c-.08-3.12-1.57-5.17-4.06-5.17h-7.63v10.83h-5.95V536.83h13.87c6.05,0,9.9,3.31,9.9,8.58a7.76,7.76,0,0,1-4.92,7.62c2.86.94,4.62,3.3,4.79,7.1A33,33,0,0,0,284.88,566.56Zm-6.5-20.09a4.15,4.15,0,0,0-3.88-4.41,3.75,3.75,0,0,0-.67,0h-7.29v8.85h7.29a4.19,4.19,0,0,0,4.54-3.81,4.53,4.53,0,0,0,0-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,546.09h-5.78c-.09-3-2.27-4.84-5.49-4.84-2.92,0-5,1.5-5,3.85,0,6.52,17.09,1.54,17.09,12.73,0,5.68-5,9.08-12.09,9.08S304.59,563,304.45,557h6c0,2.95,2.35,5.1,6.25,5.1,3.34,0,5.68-1.59,5.68-4.08,0-6.42-17.09-1.62-17.09-12.55,0-5.56,4.66-9.08,11.26-9.08C322.92,536.44,327.54,540.26,327.63,546.09Z"
  }));
};
const LabelIDX = _ref6 => {
  let {
    primaryColor,
    orientation
  } = _ref6;
  if (orientation === 'portrait') return /*#__PURE__*/React.createElement(LabelGroup, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M496.796 0.383694H494.11V508.531H496.796V0.383694Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.473 303.814H663.697V205.066H692.473V303.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.84 254.632C842.84 283.269 821.564 303.989 792.055 303.989H752.71V205.066H792.055C821.564 205.066 842.84 225.82 842.84 254.632ZM813.506 254.632C813.506 240.679 804.333 230.773 791.776 230.773H781.486V278.421H791.776C804.333 278.421 813.506 268.27 813.506 254.318V254.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.192 230.459V242.179H968.548V266.596H928.192V278.56H971.373V303.814H899.416V205.066H971.373V230.459H928.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.53 287.315H1061.82L1056.86 303.814H1025.82L1060.7 205.066H1095.58L1130.46 303.814H1099.42L1094.53 287.315ZM1088.88 268.584L1078.18 233.18L1067.33 268.584H1088.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.17 238.377H1231.26C1231.28 236.799 1230.96 235.234 1230.34 233.784C1229.72 232.333 1228.8 231.028 1227.65 229.952C1226.49 228.876 1225.12 228.052 1223.63 227.533C1222.14 227.013 1220.56 226.81 1218.99 226.936C1213.23 226.936 1208.7 229.901 1208.7 234.261C1208.7 249.365 1262.31 236.11 1262.31 273.084C1262.31 293.245 1244.1 305.244 1218.99 305.244C1194.74 305.244 1177.37 291.989 1176.96 270.363H1205.87C1205.87 276.991 1211.8 281.769 1220.42 281.769C1227.39 281.769 1232.97 278.665 1232.97 274.165C1232.97 259.934 1179.36 272.317 1179.36 235.796C1179.36 215.914 1196.28 203.357 1219.72 203.357C1242.39 203.671 1259.17 218.042 1259.17 238.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.36 230.459V242.179H1476.71V266.596H1436.36V278.56H1479.54V303.814H1407.58V205.066H1479.54V230.459H1436.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.65 303.814L1585.89 272.944L1567.16 303.814H1532.59L1566.71 253.725L1533.71 205.066H1568.27L1585.89 234.994L1603.54 205.066H1638.1L1605.11 253.725L1639.36 303.814H1604.65Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.92 305.244C1700.61 305.244 1678.6 283.932 1678.6 254.457C1678.6 224.983 1700.47 203.671 1730.92 203.671C1758.44 203.671 1779.16 221.111 1782.26 246.539H1752.79C1751.53 241.742 1748.69 237.514 1744.71 234.547C1740.74 231.581 1735.88 230.054 1730.92 230.215C1717.53 230.215 1708.07 240.365 1708.07 254.632C1708.07 268.898 1717.53 279.049 1730.92 279.049C1735.89 279.156 1740.75 277.587 1744.72 274.594C1748.69 271.6 1751.53 267.358 1752.79 262.55H1782.37C1779.16 287.594 1758.44 305.244 1730.92 305.244Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.66 205.066V303.814H1893.98V267.015H1868.17V303.814H1839.4V205.066H1868.17V241.621H1893.98V205.066H1922.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.39 287.315H2011.67L2006.75 303.814H1975.71L2010.59 205.066H2045.47L2080.35 303.814H2049.3L2044.39 287.315ZM2038.77 268.584L2028.03 233.18L2017.32 268.584H2038.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2222.59 205.066V303.814H2186.17L2162.21 245.563V303.814H2133.44V205.066H2169.82L2193.95 263.317V205.066H2222.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2382.83 254.632C2382.83 284.246 2361.69 305.419 2331.34 305.419C2301 305.419 2279.02 284.106 2279.02 254.632C2279.02 225.157 2300.89 203.845 2331.34 203.845C2355.76 203.845 2376.48 219.367 2380.87 240.645H2350.91C2349.19 237.001 2346.44 233.933 2343.02 231.811C2339.59 229.688 2335.62 228.601 2331.59 228.68C2318.19 228.68 2308.6 239.528 2308.6 254.492C2308.6 269.456 2318.19 280.304 2331.59 280.304C2335.62 280.439 2339.61 279.404 2343.07 277.325C2346.53 275.246 2349.31 272.21 2351.09 268.584H2331.48V247.237H2382.55C2382.69 249.086 2382.83 252.051 2382.83 254.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2468.21 230.459V242.179H2508.53V266.596H2468.21V278.56H2511.36V303.814H2439.4V205.066H2511.36V230.459H2468.21Z"
  }));
};
const Label25th = _ref7 => {
  let {
    orientation
  } = _ref7;
  if (orientation === 'portrait') return /*#__PURE__*/React.createElement(LabelGroup, null);
  return /*#__PURE__*/React.createElement("g", {
    style: {
      transform: 'translateX(35%)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.978 352.707V431.679H155V424.223C155 328.351 211.609 294.58 249.174 272.729C293.763 246.903 323.81 220.561 323.81 191.77C323.81 172.395 310.776 158.489 291.76 158.489C272.745 158.489 253.701 172.395 253.701 201.213H161.009C163.012 126.187 218.112 79 293.737 79C369.361 79 418.45 123.221 418.45 186.79C418.45 250.36 365.355 287.641 321.78 312.976C294.23 328.379 270.193 339.808 264.677 352.707H422.95H422.978Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.705 352.708C270.22 339.782 294.257 328.38 321.807 312.977C349.961 296.595 382.093 276.077 401.301 245.897C386.318 264.185 362.336 276.023 335.335 276.023C312.889 276.023 292.584 267.832 277.738 254.606C269.123 260.702 259.546 266.743 249.174 272.756C211.609 294.581 155 328.38 155 424.25V431.707H422.978V352.735H264.705V352.708Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: 'multiply'
    },
    d: "M321.807 312.975C340.905 301.873 361.815 288.864 379.321 272.238H250.024C249.723 272.4 249.448 272.564 249.146 272.754C211.609 294.579 155 328.378 155 424.248V431.705H422.978V352.733H264.705C270.22 339.807 294.257 328.404 321.807 313.002V312.975Z",
    fill: "url(#paint0_linear_3_254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.932 353.823C187.077 353.823 155.137 384.846 155 423.379C155 423.651 155 423.951 155 424.223V431.679H422.978V353.795H225.932V353.823Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 314.445C719 385.471 660.91 436.657 580.757 436.657C507.631 436.657 451.516 389.471 447.016 323.888H543.193C547.693 341.277 562.236 354.203 580.757 354.203C602.298 354.203 620.821 336.324 620.821 307.995C620.821 281.68 604.301 263.775 580.757 263.775C564.239 263.775 551.206 272.728 544.181 291.096H453.519L483.593 83.9792H701.988V162.951H549.202L541.19 226.547C557.709 208.668 582.267 198.246 613.823 198.246C680.447 198.246 719 246.93 719 314.472V314.445Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 314.445C719 385.471 660.91 436.657 580.757 436.657C507.631 436.657 451.516 389.471 447.016 323.888H543.193C547.693 341.277 562.236 354.203 580.757 354.203C602.298 354.203 620.821 336.324 620.821 307.995C620.821 281.68 604.301 263.775 580.757 263.775C564.239 263.775 551.206 272.728 544.181 291.096H453.519L483.593 83.9792H701.988V162.951H549.202L541.19 226.547C557.709 208.668 582.267 198.246 613.823 198.246C680.447 198.246 719 246.93 719 314.472V314.445Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: 'multiply'
    },
    d: "M580.759 263.803C596.234 263.803 608.664 271.585 615.36 284.348L680.145 220.098C663.078 206.166 640.742 198.219 613.823 198.219C582.267 198.219 557.736 208.642 541.19 226.521L549.203 162.924H701.988V162.407H535.016C498.96 162.407 468.391 188.667 463.26 224.071L453.547 291.097H544.208C551.232 272.728 564.239 263.775 580.785 263.775L580.759 263.803Z",
    fill: "url(#paint1_linear_3_254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: 'multiply'
    },
    d: "M533.918 401.091C581.91 401.091 620.82 362.014 620.82 313.82C620.82 312.623 620.765 311.398 620.737 310.201C619.778 337.223 601.722 354.203 580.757 354.203C562.236 354.203 547.693 341.278 543.192 323.915H447.62C452.614 367.374 489.329 401.119 533.918 401.119V401.091Z",
    fill: "url(#paint2_linear_3_254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.335 126.405C380.693 126.405 417.463 159.795 417.573 201.022C418.148 196.424 418.478 191.716 418.478 186.79C418.478 123.221 365.876 79 293.737 79C221.597 79 163.012 126.187 161.009 201.213H253.098C253.098 159.904 289.922 126.432 335.335 126.432V126.405Z",
    fill: "#0343FB"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: 'multiply'
    },
    d: "M401.273 245.897C409.561 232.89 415.432 218.059 417.545 201.023C417.435 159.796 380.665 126.406 335.307 126.406C289.95 126.406 253.07 159.878 253.07 201.187H253.647C253.647 172.368 272.69 158.463 291.706 158.463C310.721 158.463 323.756 172.368 323.756 191.744C323.756 213.841 306.056 234.495 277.684 254.578C292.528 267.831 312.835 275.995 335.28 275.995C362.281 275.995 386.237 264.157 401.246 245.871L401.273 245.897Z",
    fill: "url(#paint3_linear_3_254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 -2H0V509H3V-2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_254",
    x1: "288.989",
    y1: "261.597",
    x2: "288.989",
    y2: "455.325",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.09",
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.24",
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.44",
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.69",
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.96",
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_254",
    x1: "607.841",
    y1: "302.444",
    x2: "538.383",
    y2: "124.84",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.11",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.2",
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.31",
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.43",
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.56",
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.69",
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.83",
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.97",
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_254",
    x1: "447.62",
    y1: "355.646",
    x2: "620.82",
    y2: "355.646",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_254",
    x1: "282.788",
    y1: "272.866",
    x2: "384",
    y2: "132.328",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.33",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  }))));
};
const viewBoxDefaults = {
  portrait: '0 0 328.48 578.88',
  landscape: '0 0 1434.48 508.88'
};
const brandNames = {
  group: {
    label: LabelGroup,
    viewBox: viewBoxDefaults
  },
  klick: {
    label: LabelKlick,
    viewBox: viewBoxDefaults
  },
  media: {
    label: LabelMedia,
    viewBox: viewBoxDefaults
  },
  transformation: {
    label: LabelTransformation,
    viewBox: viewBoxDefaults
  },
  katalyst: {
    label: LabelKatalyst,
    viewBox: viewBoxDefaults
  },
  consulting: {
    label: LabelConsulting,
    viewBox: viewBoxDefaults
  },
  appliedsciences: {
    label: LabelAppliedSciences,
    viewBox: viewBoxDefaults
  },
  ventures: {
    label: LabelVentures,
    viewBox: viewBoxDefaults
  },
  labs: {
    label: LabelLabs,
    viewBox: viewBoxDefaults
  },
  careers: {
    label: LabelCareers,
    viewBox: viewBoxDefaults
  },
  IDX: {
    label: LabelIDX,
    viewBox: {
      portrait: viewBoxDefaults.portrait,
      landscape: '0 0 2511.36 510.51'
    }
  },
  Anniversary25th: {
    label: Label25th,
    viewBox: viewBoxDefaults
  },
  btwelve: {
    label: LabelGroup,
    viewBox: viewBoxDefaults
  },
  bloodball: {
    label: LabelKlick,
    viewBox: viewBoxDefaults
  }
};
const StyledSVG = styled.svg.withConfig({
  displayName: "KlickLogo__StyledSVG",
  componentId: "sc-qwxhoa-1"
})(["display:block;"]);
const Planet = _ref => {
  let {
    orbitTimeline,
    angleTimeline,
    labelRef,
    startPosition,
    color,
    size,
    label,
    isMobile,
    hasTrailingPlanet
  } = _ref;
  const pointRef = React.useRef();
  const planetRef = React.useRef();
  const solarPathRef = React.useRef();
  useIsomorphicLayoutEffect(() => {
    const point = pointRef.current;
    const planet = planetRef.current;
    const solarPath = solarPathRef.current;
    const label = labelRef.current;
    angleTimeline.to(point, {
      rotateX: isMobile ? -45 : -65,
      duration: 0.5
    }, 0).to(point, {
      rotateX: 0,
      duration: 0.5
    }, 0.5);
    orbitTimeline.add('rotate').set(point, {
      rotateY: 0,
      rotateZ: 360
    }, 'rotate').fromTo(planet, {
      backgroundPositionX: '50%'
    }, {
      duration: 0.25,
      backgroundPositionX: '58%'
    }, 'rotate').fromTo(planet, {
      backgroundPositionX: '58%'
    }, {
      duration: 0.25,
      backgroundPositionX: '72%'
    }).call(() => {
      if (orbitTimeline.progress() > 0.5) {
        return label.classList.add('onleft');
      }
      return label.classList.remove('onleft');
    }).fromTo(planet, {
      backgroundPositionX: '28%'
    }, {
      duration: 0.25,
      backgroundPositionX: '42%'
    }).fromTo(planet, {
      backgroundPositionX: '42%'
    }, {
      duration: 0.25,
      backgroundPositionX: '50%'
    }).fromTo(solarPath, {
      rotateZ: 0
    }, {
      rotateZ: 360
    }, 'rotate').to(point, {
      rotateY: 0,
      rotateZ: 0
    }, 'rotate');
    orbitTimeline.progress(startPosition);
  }, [angleTimeline, orbitTimeline, startPosition, size, labelRef, isMobile]);
  return /*#__PURE__*/React.createElement(SolarPath, {
    ref: solarPathRef
  }, /*#__PURE__*/React.createElement(Point, {
    ref: pointRef
  }, /*#__PURE__*/React.createElement(PlanetOrb, {
    ref: planetRef,
    $color: color,
    $size: size
  }), /*#__PURE__*/React.createElement(Label$1, {
    ref: labelRef,
    $size: size,
    variant: "blurb2",
    component: "h3",
    $hasTrailingPlanet: hasTrailingPlanet
  }, label)));
};
const SolarPath = styled.div.withConfig({
  displayName: "Planet__SolarPath",
  componentId: "sc-u5gi5u-0"
})(["position:absolute;top:0;width:100%;height:100%;transform-style:preserve-3d;"]);
const PlanetOrb = styled.div.withConfig({
  displayName: "Planet__PlanetOrb",
  componentId: "sc-u5gi5u-1"
})(["position:absolute;", " top:0;border-radius:50%;transform-style:preserve-3d;background:", ";background-image:radial-gradient(circle,rgba(0,0,0,0) 10%,rgba(0,0,0,0.7) 30%);background-position-y:50%;background-size:1000%;background-repeat:no-repeat;", "{", "}"], _ref2 => {
  let {
    $size
  } = _ref2;
  const sxSize = $size * 2;
  return css(["width:", "vw;height:", "vw;margin-top:-", "vw;margin-left:-", "vw;"], sxSize, sxSize, sxSize / 2, sxSize / 2);
}, _ref3 => {
  let {
    $color
  } = _ref3;
  return $color;
}, match.isSM, _ref4 => {
  let {
    $size
  } = _ref4;
  return css(["width:", "vw;height:", "vw;margin-top:-", "vw;margin-left:-", "vw;"], $size, $size, $size / 2, $size / 2);
});
const Point = styled.div.withConfig({
  displayName: "Planet__Point",
  componentId: "sc-u5gi5u-2"
})(["position:absolute;transform-style:preserve-3d;left:50%;top:-1px;border:solid 3px red;"]);
const Label$1 = styled(P).withConfig({
  displayName: "Planet__Label",
  componentId: "sc-u5gi5u-3"
})(["position:absolute;top:50%;left:0;text-align:left;font-size:1rem;line-height:0.9em;text-shadow:0.1em 0.1em 0.2em #00000052;", " ", " @media screen and (max-height:380px){font-size:0.75em;}"], _ref5 => {
  let {
    $hasTrailingPlanet
  } = _ref5;
  return $hasTrailingPlanet && css(["margin-top:20px;margin-left:20px;"]);
}, _ref6 => {
  let {
    $size
  } = _ref6;
  return css(["transform:translate(-100%,-50%) translateX(-", "vw);text-align:right;&.onleft{text-align:left;transform:translate(", "vw,-50%);}", "{font-size:2vw;text-align:left;transform-origin:left;transform:translate(", "vw,-50%);&.selected{font-size:1rem;}&.onleft{transform:translate(-100%,-50%) translateX(-", "vw);}}"], $size / 2 + 2, $size / 2 + 2, match.isSM, $size / 2 + 2, $size / 2 + 2);
});
const Ring = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color = "rgb(113, 103, 255, 20%)",
    ...props
  } = _ref;
  const {
    width = '300px'
  } = props;
  return /*#__PURE__*/React.createElement(StyledRing, _extends({
    ref: ref,
    $width: width,
    $color: color
  }, props));
});
const StyledRing = styled.div.withConfig({
  displayName: "Ring__StyledRing",
  componentId: "sc-ieever-0"
})(["--width:", ";width:var(--width);height:var(--width);background:", ";border:rgb(255 255 255 / 20%) 1px solid;border-radius:100%;"], _ref2 => {
  let {
    $width
  } = _ref2;
  return $width;
}, _ref3 => {
  let {
    $color
  } = _ref3;
  return "radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0) 50%,\n    ".concat($color, " 100%\n  )");
});
Ring.defaultProps = {
  width: 300
};
gsap.registerPlugin(ScrollTrigger);
const anglePlayhead = {
  playhead: 0
};
const gsapDefaults = {
  duration: 1,
  ease: 'none'
};
const OnFocusScroll = top => {
  window.scrollTo({
    top
  });
};
const Ecosystem = _ref => {
  let {
    planets
  } = _ref;
  const stickyContainerRef = React.useRef();
  const galaxyRef = React.useRef();
  const {
    labels,
    setScrollTrigger
  } = useGSAPLabels({
    stepPrefix: 'anim_step',
    animationName: 'ecosystem'
  });
  const planetsAngleTimeline = useInstance(() => gsap.timeline({
    paused: true,
    defaults: gsapDefaults
  }));
  const planetsWTimelines = useInstance(() => {
    return planets.map(planet => ({
      ...planet,
      position: 0,
      labelRef: /*#__PURE__*/React.createRef(),
      contentRef: /*#__PURE__*/React.createRef(),
      angleTimeline: planetsAngleTimeline,
      orbitTimeline: gsap.timeline({
        paused: true,
        defaults: gsapDefaults
      })
    }));
  });
  const megaTimeline = useInstance(() => gsap.timeline({
    defaults: gsapDefaults
  }));
  const trailingPlanetLabels = React.useMemo(() => {
    return planets.filter(item => !!item.trailingPlanetLabel).map(item => item.trailingPlanetLabel);
  }, [planets]);
  const theme = useTheme$1();
  const isMobile = useMediaQuery$1(theme.breakpoints.down('xs'));
  let planetJSX = [];
  let planetContentJSX = [];
  planetsWTimelines.forEach((props, index) => {
    planetJSX.push( /*#__PURE__*/React.createElement(Planet, _extends({
      key: index,
      isMobile: isMobile,
      hasTrailingPlanet: !!props.trailingPlanetLabel
    }, props)));
    planetContentJSX.push( /*#__PURE__*/React.createElement(PlanetContent, {
      ref: props.contentRef,
      variant: "blurb1",
      key: index,
      $color: props.color,
      onFocus: () => OnFocusScroll(labels === null || labels === void 0 ? void 0 : labels['anim_step' + index])
    }, props.content));
  });
  useIsomorphicLayoutEffect(() => {
    const galaxy = galaxyRef.current;
    const stickyContainer = stickyContainerRef.current;

    // ZOOM
    megaTimeline.to({}, {
      duration: 2
    }).add('zoom');
    planetsWTimelines.forEach(planet => {
      megaTimeline.to(planet.labelRef.current, {
        opacity: 0,
        duration: 0.2
      }, 'zoom').fromTo(planet, {
        position: planet.startPosition
      }, {
        position: 0.75
      }, 'zoom+=0.8');
    });
    megaTimeline.to(galaxy, {
      x: '-27%',
      y: '-10%',
      z: 250,
      rotationX: isMobile ? 45 : 65,
      duration: 3,
      ease: 'power2.inOut'
    }, 'zoom').to(anglePlayhead, {
      playhead: 0.5,
      duration: 3,
      ease: 'power2.inOut'
    }, 'zoom');

    // ORBIT
    megaTimeline.add('orbit');
    planetsWTimelines.forEach((planet, index) => {
      var _trailingPlanet$label;
      if (trailingPlanetLabels.includes(planet.label)) return;
      const content = planet.contentRef.current;
      const hasTrailingPlanet = !!planet.trailingPlanetLabel;

      // this makes the position "wrap" between 0 and 1, so when it reaches 1.25, it will actually set to 0.25
      const wrapPositionBetweenRange = gsap.utils.wrap(0, 1);
      const trailingPlanet = planetsWTimelines.find(p => p.label === planet.trailingPlanetLabel);
      const currentPlanets = [planet, trailingPlanet].filter(Boolean);
      const currentPlanetLabels = [planet.labelRef.current, trailingPlanet === null || trailingPlanet === void 0 || (_trailingPlanet$label = trailingPlanet.labelRef) === null || _trailingPlanet$label === void 0 ? void 0 : _trailingPlanet$label.current];
      megaTimeline.set(currentPlanetLabels, {
        clearProps: 'fontSize,lineHeight,x,y'
      }).set(currentPlanetLabels, getPlanetLabelSettings({
        isMobile,
        hasTrailingPlanet
      })).to(currentPlanets, {
        position: hasTrailingPlanet ? gsap.utils.wrap([1.27, 1.23]) : 1.25,
        ease: 'power1.out',
        stagger: 0.05,
        duration: 2,
        modifiers: {
          position: pos => wrapPositionBetweenRange(pos)
        }
      }, index === 0 ? 'orbit' : '-=0.8').to(currentPlanetLabels, {
        opacity: 1
      }, '>-1').to(content, {
        opacity: 1,
        pointerEvents: 'all'
      }, '>').to(content, {
        duration: 0.5,
        scrollTo: {
          y: checkScrollAmount(content)
        },
        delay: 0
      }, '>').to(currentPlanets, {
        position: 0.75,
        ease: 'power1.in'
      }, '>2').to(currentPlanetLabels, {
        opacity: 0,
        duration: 0.5
      }, '>-1.5').set(currentPlanetLabels, getPlanetLabelSettings({
        isMobile,
        hasTrailingPlanet
      })).set(currentPlanetLabels, {
        clearProps: 'fontSize,lineHeight,x,y'
      }).to(content, {
        opacity: 0,
        pointerEvents: 'none',
        duration: 0.5
      }, '>-1.5').addLabel('anim_step' + index, '>-1');
    });

    // ZOOM OUT
    megaTimeline.add('zoomOut');
    planetsWTimelines.slice().reverse().forEach((planet, index) => {
      if (planet.startPosition > 0.5) {
        megaTimeline.to(planet, {
          position: planet.startPosition
        }, "zoomOut+=".concat(index * 0.5));
      } else {
        megaTimeline.to(planet, {
          position: 1
        }, "zoomOut+=".concat(index * 0.5)).fromTo(planet, {
          position: 0
        }, {
          position: planet.startPosition,
          ease: 'power1.out'
        }, '>');
      }
      megaTimeline.to(planet.labelRef.current, {
        opacity: 1,
        duration: 0.2
      }, '>-0.2');
    });
    megaTimeline.to(galaxy, {
      x: '0%',
      y: 0,
      z: 0,
      rotationX: 0,
      duration: 3,
      ease: 'power2.inOut'
    }, 'zoomOut+=1.2').to(anglePlayhead, {
      playhead: 1,
      duration: 3,
      ease: 'power2.inOut'
    }, 'zoomOut+=1.2').to({}, {
      duration: 2
    });
    const scrollTrigger = ScrollTrigger.create({
      trigger: stickyContainer,
      scrub: true,
      start: 'top top',
      end: 'bottom bottom',
      animation: megaTimeline,
      onUpdate: function () {
        planetsAngleTimeline.progress(anglePlayhead.playhead || 0);
        planetsWTimelines.forEach(planet => {
          planet.orbitTimeline.progress(planet.position || planet.startPosition);
        });
      }
    });
    setScrollTrigger(scrollTrigger);
    return () => {
      planetsAngleTimeline.clear();
      megaTimeline.remove(planetsAngleTimeline);
      planetsWTimelines.forEach(planet => {
        planet.orbitTimeline.clear();
      });
      megaTimeline.clear();
      scrollTrigger.kill();
    };
  }, [megaTimeline, planetsAngleTimeline, planetsWTimelines, isMobile, trailingPlanetLabels, setScrollTrigger]);
  return /*#__PURE__*/React.createElement(StickyContainer$1, {
    ref: stickyContainerRef
  }, /*#__PURE__*/React.createElement(StyledConstellation, null, /*#__PURE__*/React.createElement(Universe, null, /*#__PURE__*/React.createElement(Galaxy, {
    ref: galaxyRef
  }, /*#__PURE__*/React.createElement(SolarSystem, null, /*#__PURE__*/React.createElement(Ring, {
    width: "100%"
  }), /*#__PURE__*/React.createElement(Ring, {
    width: "78%"
  }), /*#__PURE__*/React.createElement(Ring, {
    width: "55%",
    color: "rgb(0 0 0 / 100%)"
  }), /*#__PURE__*/React.createElement(StyledLogo$1, {
    brandName: "group"
  }), planetJSX)), planetContentJSX)));
};
function getPlanetLabelSettings(_ref2) {
  let {
    isMobile,
    hasTrailingPlanet
  } = _ref2;
  const lookup = {
    withTrailingPlanet: {
      mobile: {
        fontSize: '4vw',
        x: gsap.utils.wrap(['-120%', undefined]),
        y: gsap.utils.wrap(['45%', undefined])
      },
      desktop: {
        fontSize: gsap.utils.wrap(['2vw', '3vw']),
        x: gsap.utils.wrap(['30%', undefined]),
        y: gsap.utils.wrap(['45%', undefined])
      }
    },
    withoutTrailingPlanet: {
      mobile: {
        fontSize: '4vw'
      },
      desktop: {
        fontSize: '4vw'
      }
    }
  };
  const planetKey = hasTrailingPlanet ? 'withTrailingPlanet' : 'withoutTrailingPlanet';
  const mobileKey = isMobile ? 'mobile' : 'desktop';
  return lookup[planetKey][mobileKey];
}
const PlanetContent = styled.div.withConfig({
  displayName: "Ecosystem__PlanetContent",
  componentId: "sc-1hqh0b-0"
})(["position:absolute;top:50%;left:50%;display:flex;justify-content:center;width:90%;text-align:left;transform:translate(-50%,10%);opacity:0;visibility:visible;pointer-events:none;height:auto;max-height:35vh;-ms-overflow-style:none;scrollbar-width:none;overflow-y:scroll;&::-webkit-scrollbar{display:none;}@media screen and (max-height:380px){background:rgba(0,0,0,0.75);}& > p{", "{max-width:100%;width:600px;transform:translateX(50%);}}& > ul{column-count:2;padding-left:6%;font-size:1rem;}& > ul > li{padding-left:1em;margin-bottom:0.7em;}& > ul > li:before{color:", ";}", "{top:60%;& > ul{padding-left:10%;}}"], match.isLG, _ref3 => {
  let {
    $color
  } = _ref3;
  return $color;
}, match.isSM);
const Systems = styled.div.withConfig({
  displayName: "Ecosystem__Systems",
  componentId: "sc-1hqh0b-1"
})(["position:absolute;width:100%;height:100%;background-position:center 40%;background-repeat:no-repeat;background-size:cover;"]);
const StickyContainer$1 = styled.div.withConfig({
  displayName: "Ecosystem__StickyContainer",
  componentId: "sc-1hqh0b-2"
})(["position:relative;height:1000vh;"]);
const StyledConstellation = styled.div.withConfig({
  displayName: "Ecosystem__StyledConstellation",
  componentId: "sc-1hqh0b-3"
})(["position:sticky;top:0;width:100%;height:100vh;background-position:center 40%;background-repeat:no-repeat;background-size:cover;overflow:hidden;"]);
const Universe = styled(Systems).withConfig({
  displayName: "Ecosystem__Universe",
  componentId: "sc-1hqh0b-4"
})(["perspective:1000px;"]);
const Galaxy = styled(Systems).withConfig({
  displayName: "Ecosystem__Galaxy",
  componentId: "sc-1hqh0b-5"
})(["transform-style:preserve-3d;"]);
const SolarSystem = styled.div.withConfig({
  displayName: "Ecosystem__SolarSystem",
  componentId: "sc-1hqh0b-6"
})(["display:flex;justify-content:center;align-items:center;position:absolute;left:50%;top:50%;width:90vw;height:90vw;max-height:90vh;max-width:90vh;transform:translate(-50%,-50%);transform-style:preserve-3d;& > *{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}", "{width:54vw;height:54vw;}"], match.isSM);
const StyledLogo$1 = styled(KlickLogo).withConfig({
  displayName: "Ecosystem__StyledLogo",
  componentId: "sc-1hqh0b-7"
})(["position:absolute;width:15%;"]);
const FadeIn = _ref => {
  let {
    children,
    from,
    distance = 30,
    start,
    end,
    enabled = true
  } = _ref;
  const child = React.Children.only(children);
  const ref = useRef();
  const directions = {
    top: {
      y: -distance,
      opacity: 0
    },
    left: {
      x: -distance,
      opacity: 0
    },
    bottom: {
      y: distance,
      opacity: 0
    },
    right: {
      x: distance,
      opacity: 0
    }
  };
  useScrollAnimation({
    ref: child.ref || ref,
    from: typeof from === 'string' ? directions[from] : from,
    start,
    end,
    enabled: enabled
  });
  return child.ref ? child : /*#__PURE__*/React.cloneElement(child, {
    ref
  });
};
var FadeIn$1 = /*#__PURE__*/React.memo(FadeIn);
const Carousel = _ref => {
  let {
    carouselProps,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(CarouselContainer, props, /*#__PURE__*/React.createElement(SlickSlider, carouselProps, children));
};

/*
  Majority of the styling below is part of out of the box slick-carousel
  adjustments have been made to padding around carousel and to prev/next buttons
  and also the navigation dots.
 */
const CarouselContainer = styled.div.withConfig({
  displayName: "Carousel__CarouselContainer",
  componentId: "sc-159pr7d-0"
})(["padding:0 45px 37px;position:relative;overflow:hidden;margin-bottom:30px;.slick-list,.slick-slider,.slick-track{position:relative;display:block;}.slick-loading .slick-slide,.slick-loading .slick-track{visibility:hidden;}.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent;}.slick-list{overflow:hidden;margin:0;padding:0;}.slick-list:focus{outline:0;}.slick-list.dragging{cursor:pointer;cursor:hand;}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);-o-transform:translate3d(0,0,0);transform:translate3d(0,0,0);}.slick-track{top:0;left:0;}.slick-track:after,.slick-track:before{display:table;content:'';}.slick-track:after{clear:both;}.slick-slide{display:none;float:left;height:100%;min-height:1px;}[dir='rtl'] .slick-slide{float:right;}.slick-slide img{display:block;}.slick-slide.slick-loading img{display:none;}.slick-slide.dragging img{pointer-events:none;}.slick-initialized .slick-slide{display:block;}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent;}.slick-arrow.slick-hidden{display:none;}.slick-dots,.slick-next,.slick-prev{position:absolute;display:block;padding:0;}.slick-dots li button:before,.slick-next:before,.slick-prev:before{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}.slick-loading .slick-list{background:url(ajax-loader.gif) center center no-repeat #fff;}.slick-next,.slick-prev{font-size:0;line-height:0;top:50%;width:20px;height:20px;-webkit-transform:translate(0,-50%);-ms-transform:translate(0,-50%);transform:translate(0,-50%);cursor:pointer;color:transparent;border:none;outline:0;background:0 0;z-index:1;}.slick-next:focus,.slick-next:hover,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:0;background:0 0;}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1;}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:0.25;}.slick-next:before,.slick-prev:before{font-size:25px;height:30px;line-height:26px;opacity:0.75;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;font-weight:bold;}.slick-next:after,.slick-prev:after{content:'';background:", ";height:30px;width:30px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:50%;z-index:1;}.slick-prev{left:-37px;}[dir='rtl'] .slick-prev{right:-37px;left:auto;}.slick-prev:before{content:'\u2039';}.slick-next:before,[dir='rtl'] .slick-prev:before{content:'\u203A';}.slick-next{right:-37px;}[dir='rtl'] .slick-next{right:auto;left:-37px;}[dir='rtl'] .slick-next:before{content:'\u2039';}.slick-dotted.slick-slider{margin-bottom:30px;}.slick-dots{bottom:-37px;width:100%;margin:0;list-style:none;text-align:center;}.slick-dots li{position:relative;display:inline-block;width:20px;height:20px;margin:0 5px;padding:0;cursor:pointer;}.slick-dots li button{font-size:0;line-height:0;display:block;width:20px;height:20px;padding:5px;cursor:pointer;color:transparent;border:0;outline:0;background:0 0;}.slick-dots li button:focus,.slick-dots li button:hover{outline:0;}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1;}.slick-dots li button:before{font-size:40px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:'\u2022';text-align:center;opacity:0.25;color:#000;}.slick-dots li.slick-active button:before{opacity:0.75;color:", ";}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primary.main;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
});
const ContentfulImage = _ref => {
  let {
    src,
    alt,
    focalPoint,
    width,
    height,
    ...rest
  } = _ref;
  const hasFocalPoint = !!focalPoint;
  const container = React.useRef();
  const [cResizeEntry] = useResizeObserver(container === null || container === void 0 ? void 0 : container.current);
  const [imageOffset, setImageOffset] = React.useState({
    x: 0,
    y: 0
  });
  const [loaded, setLoaded] = React.useState(0);
  React.useEffect(() => {
    if (!container.current || !hasFocalPoint || !loaded || !cResizeEntry) return;
    const {
      width: clientWidth,
      height: clientHeight
    } = cResizeEntry === null || cResizeEntry === void 0 ? void 0 : cResizeEntry.contentRect;

    // calculate the normalized (0-1) position of the focal point
    const xFPPercent = focalPoint.x / width;
    const yFPPercent = focalPoint.y / height;

    // Get Scaled Coordinates
    const scaleX = clientWidth / width;
    const scaleY = clientHeight / height;
    const scaleFactor = Math.max(scaleX, scaleY);
    const scaledWidth = width * scaleFactor;
    const scaledHeight = height * scaleFactor;
    // calculate the focal points position relative to the current image
    const focalX = scaledWidth * xFPPercent;
    const focalY = scaledHeight * yFPPercent;

    // Calculate percentage needed to move to center
    const cCenterX = clientWidth / 2;
    const cCenterY = clientHeight / 2;
    const centerPercentX = (focalX - cCenterX) / (scaledWidth - clientWidth) * 100;
    const centerPercentY = (focalY - cCenterY) / (scaledHeight - clientHeight) * 100;

    // Clamp numbers between 0-100
    const offsetX = Math.max(Math.min(centerPercentX, 100), 0);
    const offsetY = Math.max(Math.min(centerPercentY, 100), 0);
    setImageOffset({
      x: offsetX,
      y: offsetY
    });
  }, [focalPoint, width, height, cResizeEntry, loaded, hasFocalPoint]);
  let url = src;
  const hasHttps = !!~src.indexOf('https:');
  if (hasHttps) url = src.split('https:')[1];
  return /*#__PURE__*/React.createElement(Container$2, {
    ref: container
  }, /*#__PURE__*/React.createElement(StyledImg$1, _extends({
    style: {
      objectPosition: "".concat(imageOffset.x, "% ").concat(imageOffset.y, "%")
    },
    src: url,
    alt: alt ? alt : ''
  }, !alt && {
    role: 'presentation'
  }, rest, {
    onLoad: () => {
      setLoaded(loaded => loaded + 1);
    }
  })));
};
const Container$2 = styled.div.withConfig({
  displayName: "ContentfulImage__Container",
  componentId: "sc-1ll1mhe-0"
})(["position:absolute;top:0;height:100%;width:100%;"]);
const StyledImg$1 = styled(ReactContentfulImage).withConfig({
  displayName: "ContentfulImage__StyledImg",
  componentId: "sc-1ll1mhe-1"
})(["height:100%;width:100%;object-fit:cover;display:block;"]);
const OPTIONS = {
  DEFAULT: [{
    mediaQuery: 'default',
    params: {
      w: 320
    }
  }, {
    mediaQuery: 'sm',
    params: {
      w: 640
    }
  }, {
    mediaQuery: 'md',
    params: {
      w: 764
    }
  }, {
    mediaQuery: 'lg',
    params: {
      w: 960
    }
  }],
  HERO: [{
    mediaQuery: 'default',
    params: {
      h: 600
    }
  }, {
    mediaQuery: 'sm',
    params: {
      w: 960
    }
  }, {
    mediaQuery: 'md',
    params: {
      w: 1280
    }
  }, {
    mediaQuery: 'lg',
    params: {
      w: 1440
    }
  }],
  MEDIA_TILE: [{
    mediaQuery: 'default',
    params: {
      w: 600
    }
  }, {
    mediaQuery: 'sm',
    params: {
      w: 450
    }
  }, {
    mediaQuery: 'md',
    params: {
      w: 400
    }
  }],
  MEDIA_TILE_DENSE: [{
    mediaQuery: 'default',
    params: {
      w: 200
    }
  }],
  COLLECTION_ITEM: [{
    mediaQuery: 'default',
    params: {
      w: 600
    }
  }, {
    mediaQuery: 'sm',
    params: {
      w: 600
    }
  }, {
    mediaQuery: 'md',
    params: {
      w: 960
    }
  }, {
    mediaQuery: 'lg',
    params: {
      w: 1280
    }
  }],
  COLLECTION: [{
    mediaQuery: 'default',
    params: {
      w: 600,
      h: 515
    }
  }, {
    mediaQuery: 'sm',
    params: {
      w: 600,
      h: 515
    }
  }, {
    mediaQuery: 'md',
    params: {
      w: 364,
      h: 320
    }
  }, {
    mediaQuery: 'lg',
    params: {
      w: 480,
      h: 380
    }
  }],
  POV_CAROUSEL: [{
    mediaQuery: 'default',
    params: {
      h: 800
    }
  }, {
    mediaQuery: 'sm',
    params: {
      h: 710
    }
  }]
};
const ContentfulImageWrapper = _ref => {
  let {
    context = 'DEFAULT',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(ContentfulImage, _extends({}, rest, {
    sizes: OPTIONS[context]
  }));
};
const InternalLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    href,
    to,
    useReachLink = false,
    ...rest
  } = _ref;
  const LinkComponent = useReachLink ? Link$2 : Link$3;
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    ref: ref,
    to: href || to
  }, rest));
});
const ExternalLink = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    to,
    href,
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement("a", _extends({
    ref: ref,
    href: href || to,
    target: "_blank",
    rel: "noopener noreferrer"
  }, props), children);
});
const TextLink = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    underline = 'always',
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(StyledMUILink, _extends({
    ref: ref,
    underline: underline
  }, props));
});
const StyledMUILink = styled(Link$1).withConfig({
  displayName: "Links__StyledMUILink",
  componentId: "sc-9tc29i-0"
})(["text-decoration-color:", ";color:", ";&:hover{cursor:pointer;text-decoration-color:", ";}"], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.primary.main;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.palette.text.primary;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.primary.main;
});
const Link = /*#__PURE__*/forwardRef((_ref7, ref) => {
  let {
    href,
    type,
    external = false,
    component,
    onClick,
    linkTracking = true,
    trackId,
    ...rest
  } = _ref7;
  const isInternal = !external && (!href || /^[/#](?!\/)/.test(href));
  const LinkComponent = isInternal ? InternalLink : ExternalLink;
  const handleClick = e => {
    if (linkTracking && (!isInternal || trackId)) {
      const element = e.currentTarget;
      tracking.track({
        event: isInternal ? 'user_interaction' : 'outbound_click',
        eventModel: {
          ...(trackId ? {
            track_id: trackId
          } : {}),
          link_id: element.id,
          link_classes: element.className,
          link_url: element === null || element === void 0 ? void 0 : element.href.replace('@', '_at_'),
          link_domain: isInternal ? window.location.hostname : new URL(element.href).hostname,
          outbound: !isInternal
        }
      });
    }
    if (typeof onClick === 'function') onClick(e);
  };
  return type === 'text' ? /*#__PURE__*/React.createElement(TextLink, _extends({
    ref: ref,
    href: href,
    component: component || LinkComponent,
    onClick: handleClick
  }, rest)) : /*#__PURE__*/React.createElement(LinkComponent, _extends({
    ref: ref,
    href: href,
    onClick: handleClick
  }, rest));
});
const ConsentText = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(P, _extends({
  ref: ref,
  variant: "body2"
}, props), "By completing this form, I agree to receive marketing communications from Klick. View our\xA0", /*#__PURE__*/React.createElement(Link, {
  href: "https://www.klick.com/privacy",
  type: "text"
}, "Privacy Policy"), "\xA0for full details."));
const IOSStyleSwitch = withStyles(theme => {
  const padding = 2;
  const width = 48;
  const height = 28;
  const radius = height - padding * 2;
  const xTransform = width - radius - padding * 2;
  return {
    root: {
      width: width,
      height: height,
      padding: 0,
      margin: theme.spacing(1)
    },
    switchBase: {
      padding: padding,
      color: 'white',
      '&$checked': {
        color: 'white',
        transform: "translateX(".concat(xTransform, "px)"),
        '& + $track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 'none'
        }
      },
      '&$focusVisible $thumb': {
        color: theme.palette.primary.main,
        border: '6px solid #fff'
      }
    },
    thumb: {
      width: radius,
      height: radius
    },
    track: {
      borderRadius: height / 2,
      border: "2px solid ".concat(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    checked: {},
    focusVisible: {}
  };
})(_ref => {
  let {
    classes,
    ...props
  } = _ref;
  const {
    label,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    label: label,
    control: /*#__PURE__*/React.createElement(Switch, _extends({
      focusVisibleClassName: classes.focusVisible,
      disableRipple: true,
      classes: {
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }
    }, rest))
  });
});
const AccessibilityDialog = () => {
  const {
    isAccessibilityVisible,
    closeAccessibilityModal
  } = useAccessibilityContext();
  const {
    toggleEnhanced,
    enhanced
  } = useEnhancedContext();
  const [hasTempReducedMotion, setHasTempReducedMotion] = React.useState(isAccessibilityVisible);
  React.useEffect(() => {
    setHasTempReducedMotion(!enhanced);
  }, [enhanced, toggleEnhanced]);
  const toggleTempReducedMotionState = () => {
    setHasTempReducedMotion(!hasTempReducedMotion);
  };
  const cancelAndClose = React.useCallback(async function (event, reason) {
    if (reason === 'backdropClick') return;
    setHasTempReducedMotion(!enhanced);
    if (enhanced === hasTempReducedMotion) {
      // Note: This gives a small delay so that you can see the settings will revert on cancel.
      await sleep(350);
    }
    closeAccessibilityModal();
  }, [enhanced, hasTempReducedMotion, setHasTempReducedMotion, closeAccessibilityModal]);
  const saveSettings = () => {
    toggleEnhanced(!hasTempReducedMotion);
    cancelAndClose();
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(ResponsiveDialog, {
    open: isAccessibilityVisible,
    onClose: cancelAndClose,
    dialogTitle: /*#__PURE__*/React.createElement(Heading, {
      variant: "h5",
      component: "h2"
    }, /*#__PURE__*/React.createElement(Trans, null, "Accessibility Settings")),
    dialogContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(P, {
      variant: "blurb2"
    }, /*#__PURE__*/React.createElement(Trans, null, "At Klick we believe everyone should have a great experience viewing our sites. Therefore we have added settings to improve accessibility.")), /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(IOSStyleSwitch, {
      checked: hasTempReducedMotion,
      onChange: toggleTempReducedMotionState,
      name: "consent-toggle",
      inputProps: {
        'aria-label': 'consent checkbox'
      },
      label: hasTempReducedMotion ? /*#__PURE__*/React.createElement(Trans, null, "Reduced Motion Enabled") : /*#__PURE__*/React.createElement(Trans, null, "Reduced Motion Disabled")
    }))),
    dialogActions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: cancelAndClose,
      color: "default"
    }, /*#__PURE__*/React.createElement(Trans, null, "Cancel")), /*#__PURE__*/React.createElement(Button, {
      onClick: saveSettings,
      color: "primary"
    }, /*#__PURE__*/React.createElement(Trans, null, "Save")))
  }));
};
var AccessibilityDialog$1 = withI18next(AccessibilityDialog);
async function sleep(ms) {
  await new Promise(resolve => setTimeout(resolve, ms));
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}
var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }
    return false;
  });
};
var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
};
var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};
var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }
  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;
  if (allowTouchMove(event.target)) {
    return false;
  }
  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }
  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }
  event.stopPropagation();
  return true;
};
var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }
  var lock = {
    targetElement: targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray(locks), [lock]);
  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };
    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};
var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
  if (isIosDevice) {
    // Clear all locks ontouchstart/ontouchmove handlers, and the references.
    locks.forEach(function (lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });
    if (documentListenerAdded) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }

    // Reset initial clientY.
    initialClientY = -1;
  } else {
    restoreOverflowSetting();
  }
  locks = [];
};
var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }
  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });
  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};
const LanguagePicker = _ref => {
  var _languageDisplayNames;
  let {
    languages = Object.keys(dist$1.LOCALES),
    defaultLanguage = dist$1.DEFAULT_LOCALE.code,
    languageDisplayNamesObj = dist$1.LOCALES,
    hasBreakPoints = true,
    ...rest
  } = _ref;
  const {
    language,
    changeLanguage,
    originalPath
  } = useI18next();
  const [open, setOpen] = React.useState(false);
  const [posX, setPosX] = React.useState(0);
  const [posY, setPosY] = React.useState(0);
  const [languageInputValue, setLanguageInputValue] = React.useState(language);
  const inputRef = React.useRef();
  const backdropRef = React.useRef();
  const buttonRef = React.useRef();
  const displayLanguage = (_languageDisplayNames = languageDisplayNamesObj[language]) === null || _languageDisplayNames === void 0 ? void 0 : _languageDisplayNames.short;
  const backdropSize = useResizeObserver(backdropRef.current);
  React.useEffect(() => {
    if (open && inputRef.current) {
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'unset';
      document.documentElement.style.overflowX = 'hidden';
      document.documentElement.style.overflowY = 'unset';
    }
  }, [open, inputRef]);
  React.useEffect(() => {
    if (!buttonRef.current) return;
    const buttonBounds = buttonRef.current.getBoundingClientRect();
    setPosX(buttonBounds.left + buttonBounds.width / 2);
    setPosY(buttonBounds.top + buttonBounds.height / 2);
  }, [buttonRef, backdropSize, open]);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleInputChange = e => {
    const {
      value
    } = e.target;
    setLanguageInputValue(value);
  };
  const handleApply = () => {
    changeLanguage(languageInputValue, originalPath);
    setCookie('klick_language', languageInputValue, 365, isBrowser && window.location.host === 'localhost:8000' ? undefined : 'klick.com');
    handleClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: open
    // disablePortal
    // disableEscapeKeyDown
    // disableScrollLock
    ,

    keepMounted: true,
    onClose: handleClose,
    style: {
      zIndex: 1300
    }
  }, /*#__PURE__*/React.createElement(Backdrop, {
    ref: backdropRef,
    $hasBreakPoints: hasBreakPoints,
    style: {
      clipPath: "circle(".concat(open ? '100vw' : '0px', " at ").concat(posX, "px ").concat(posY, "px)")
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(BackdropContent, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(P, null, /*#__PURE__*/React.createElement(Trans, null, "Choose your preferred language from the drop down menu and hit apply. The website page will automatically reload."))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 0.5
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onWhite"
  }, /*#__PURE__*/React.createElement(StyledSelect, {
    label: '',
    id: 'LanguagePicker-dropdown',
    name: 'Language Selector',
    variant: "outlined",
    fullWidth: true,
    value: languageInputValue,
    onChange: handleInputChange
  }, languages.map(locale => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "language-menu-".concat(locale),
      value: locale
    }, languageDisplayNamesObj[locale].long);
  }))), /*#__PURE__*/React.createElement(ApplyButton, {
    size: "medium",
    color: "primary",
    onClick: handleApply
  }, /*#__PURE__*/React.createElement(Trans, null, "Apply")), /*#__PURE__*/React.createElement(LocationIcon, {
    style: {
      alignSelf: 'center',
      color: '#fff'
    }
  })))))))), /*#__PURE__*/React.createElement(Button, _extends({
    onClick: handleOpen,
    ref: buttonRef
  }, rest), /*#__PURE__*/React.createElement(LocationIcon, {
    height: "1rem",
    style: {
      marginRight: '8px'
    }
  }), " ", displayLanguage));
};
const Backdrop = styled.div.withConfig({
  displayName: "LanguagePicker__Backdrop",
  componentId: "sc-za78ib-0"
})(["display:block;position:absolute;top:0px;left:0px;width:100%;z-index:1300;background:#000;transition:0.5s;overflow:hidden;padding:0px 32px;"]);
const BackdropContent = styled(Container$4).withConfig({
  displayName: "LanguagePicker__BackdropContent",
  componentId: "sc-za78ib-1"
})(["display:flex;height:100%;align-items:center;padding:36px 0px;"]);
const ApplyButton = styled(Button).withConfig({
  displayName: "LanguagePicker__ApplyButton",
  componentId: "sc-za78ib-2"
})(["width:200px;margin:0px 32px;"]);
const StyledSelect = styled(Select).withConfig({
  displayName: "LanguagePicker__StyledSelect",
  componentId: "sc-za78ib-3"
})(["background:#fff;border-radius:32px;& > div{padding:0px 14px;}"]);
var LanguagePicker$1 = withI18next(LanguagePicker);
const defaultGetDoc = () => document;
const defaultIsEnabled = () => true;
const TrapFocus = _ref => {
  let {
    getDoc = defaultGetDoc,
    isEnabled = defaultIsEnabled,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Unstable_TrapFocus, _extends({
    getDoc: getDoc,
    isEnabled: isEnabled
  }, rest));
};
const DEFAULT_EYEBROW_LINKS = [{
  label: 'Klick Health',
  shortLabel: 'Health',
  href: 'https://www.klick.com',
  role: 'link'
}, {
  label: 'Klick Consulting',
  shortLabel: 'Consulting',
  href: 'https://consulting.klick.com',
  role: 'link'
}];
const DEFAULT_LINKS = [{
  links: [{
    label: 'Klick Health',
    href: 'https://www.klick.com',
    role: 'link',
    brandColor: brandColors.klick
  }, {
    label: 'Klick Katalyst',
    href: 'https://katalyst.klick.com',
    role: 'link',
    brandColor: brandColors.katalyst
  }, {
    label: 'Klick Consulting',
    href: 'https://consulting.klick.com',
    role: 'link',
    brandColor: brandColors.consulting
  }, {
    label: 'Klick Applied Sciences',
    href: 'https://appliedsciences.klick.com',
    role: 'link',
    brandColor: brandColors.appliedsciences
  }, {
    label: 'Klick Media',
    href: 'https://media.klick.com',
    role: 'link',
    brandColor: brandColors.klick
  }, {
    label: 'Klick Ventures',
    href: 'https://ventures.klick.com',
    role: 'link',
    brandColor: brandColors.ventures
  }, {
    label: 'Klick Ideas Exchange',
    href: 'https://idx.klick.com'
  }, {
    label: 'Sensei Labs',
    href: 'https://www.senseilabs.com',
    role: 'link',
    brandColor: brandColors.sensei
  }, {
    label: 'Newsroom',
    href: 'https://www.klick.com/news',
    role: 'link'
  }, {
    label: 'Careers @ Klick',
    ariaLabel: 'Careers at Klick',
    href: 'https://careers.klick.com',
    role: 'link',
    brandColor: brandColors.klick
  }]
}];
const EyebrowBar = props => {
  const {
    links,
    menuLinks,
    selectedTabIndex,
    hasLanguagePicker,
    themeType = 'onBlack'
  } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const [pickerWidth, setPickerWidth] = React.useState(0);
  const fatBarRef = React.useRef();
  const languagePickerRef = React.useRef();
  useIsomorphicLayoutEffect(() => {
    if (!fatBarRef.current) return;
    const fatBar = fatBarRef.current;
    if (isOpen) {
      disableBodyScroll(fatBar);
    } else {
      enableBodyScroll(fatBar);
    }
  }, [isOpen]);
  React.useEffect(() => {
    if (!languagePickerRef.current) return;
    setPickerWidth(languagePickerRef.current.getBoundingClientRect().width);
  }, []);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: themeType
  }, /*#__PURE__*/React.createElement(StyledAppBar$1, {
    elevation: 0,
    position: "relative",
    color: "transparent"
  }, /*#__PURE__*/React.createElement(Box, {
    bgcolor: 'background.default',
    color: "text.primary",
    zIndex: 2
  }, /*#__PURE__*/React.createElement(TabContainer, null, /*#__PURE__*/React.createElement(StyledToolbar, {
    variant: "dense",
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Nav, {
    role: "navigation",
    "aria-label": "Klick Group Quick"
  }, /*#__PURE__*/React.createElement(NavList, null, links.map((linkProps, index) => {
    const {
      shortLabel,
      label,
      href,
      ...rest
    } = linkProps;
    const isActive = index === selectedTabIndex;
    const NavButton = isActive ? ActiveButton : StyledButton$1;
    const activeProps = {
      'aria-current': 'page',
      href: '/'
    };
    const buttonProps = {
      href,
      component: Link,
      trackId: "top_nav_click_".concat(label),
      ...(isActive ? activeProps : {})
    };
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(NavButton, _extends({}, buttonProps, rest), /*#__PURE__*/React.createElement(MobileOnly, null, shortLabel || label), /*#__PURE__*/React.createElement(DesktopOnly, null, label)));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(GroupButton, {
    onClick: handleOpen,
    "aria-expanded": isOpen,
    "aria-label": "Klick Group",
    "aria-haspopup": "menu"
  }, /*#__PURE__*/React.createElement(MobileOnly, null, /*#__PURE__*/React.createElement(MoreVert, {
    fontSize: "small"
  }), "Group"), /*#__PURE__*/React.createElement(DesktopOnly, null, /*#__PURE__*/React.createElement(MoreVert, {
    fontSize: "small"
  }), "Klick Group"))), hasLanguagePicker ? /*#__PURE__*/React.createElement("li", {
    ref: languagePickerRef
  }, /*#__PURE__*/React.createElement(StyledLanguagePicker, null)) : null))))), /*#__PURE__*/React.createElement(Fade, {
    in: isOpen
  }, /*#__PURE__*/React.createElement(FatBar, {
    ref: fatBarRef
  }, /*#__PURE__*/React.createElement(TrapFocus, {
    open: isOpen
  }, /*#__PURE__*/React.createElement(FatBarContent, null, /*#__PURE__*/React.createElement(StyledContainer$1, null, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "400px"
  }, /*#__PURE__*/React.createElement(StyledHeading$2, {
    component: "div",
    variant: "h4",
    font: "primary"
  }, "Klick", /*#__PURE__*/React.createElement("br", null), " Group"), /*#__PURE__*/React.createElement(P, {
    paragraph: false
  }, /*#__PURE__*/React.createElement(Trans, null, "The Klick Group of companies is an ecosystem of brilliant minds working to realize the full potential of their people and clients since 1997."))), /*#__PURE__*/React.createElement(Divider$1, null), /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Klick Group",
    role: "navigation"
  }, /*#__PURE__*/React.createElement(LinkGroup, {
    links: menuLinks
  })), /*#__PURE__*/React.createElement(CloseButton, {
    "aria-label": "Close Menu",
    onClick: handleOpen,
    $offsetRight: pickerWidth
  }, /*#__PURE__*/React.createElement(Cancel, {
    fontSize: "large"
  }))))), /*#__PURE__*/React.createElement(FatBarOverlay, {
    onClick: handleOpen
  })))));
};
const StyledLanguagePicker = styled(LanguagePicker$1).withConfig({
  displayName: "EyebrowBar__StyledLanguagePicker",
  componentId: "sc-cv63mn-0"
})(["padding:10px;min-width:0px;min-height:48px;"]);
const StyledAppBar$1 = styled(AppBar).withConfig({
  displayName: "EyebrowBar__StyledAppBar",
  componentId: "sc-cv63mn-1"
})(["z-index:1200;"]);
const TabContainer = styled(Container$4).withConfig({
  displayName: "EyebrowBar__TabContainer",
  componentId: "sc-cv63mn-2"
})(["", "{padding:0;}"], match.isXS);
const minHeight = '40px';
const StyledToolbar = styled(Toolbar).withConfig({
  displayName: "EyebrowBar__StyledToolbar",
  componentId: "sc-cv63mn-3"
})(["min-height:", ";display:flex;", "{justify-content:flex-end;}"], minHeight, match.isSM);
const StyledButton$1 = styled(Button$1).withConfig({
  displayName: "EyebrowBar__StyledButton",
  componentId: "sc-cv63mn-4"
})(["font-size:", ";min-height:48px;color:inherit;opacity:0.7;", "{width:100%;}", "{min-width:160px;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.typography.pxToRem(12);
}, match.isXS, match.isSM);
const Nav = styled.nav.withConfig({
  displayName: "EyebrowBar__Nav",
  componentId: "sc-cv63mn-5"
})(["", "{width:100%;}"], match.isXS);
const NavList = styled.ul.withConfig({
  displayName: "EyebrowBar__NavList",
  componentId: "sc-cv63mn-6"
})(["list-style:none;margin:0;padding:0;", "{display:flex;}li{display:inline-block;", "{flex:1 1 0;max-width:none;}}"], match.isXS, match.isXS);
const ActiveButton = styled(StyledButton$1).withConfig({
  displayName: "EyebrowBar__ActiveButton",
  componentId: "sc-cv63mn-7"
})(["border-bottom:6px solid ", ";opacity:1;"], props => props.theme.palette.primary.main);
const GroupButton = styled(StyledButton$1).withConfig({
  displayName: "EyebrowBar__GroupButton",
  componentId: "sc-cv63mn-8"
})(["background:", ";min-width:33%;", "{min-width:150px;}&:focus-visible{background:#000;}& > span:first-child > span{padding-right:8px;}& > span:first-child > span > svg{margin-right:8px;}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return lighten(theme.palette.background.default, 0.5);
}, match.isSM);
const CloseButton = styled(GroupButton).withConfig({
  displayName: "EyebrowBar__CloseButton",
  componentId: "sc-cv63mn-9"
})(["position:absolute;color:rgba(255,255,255,0.7);top:0;right:0;z-index:100;opacity:1;&:hover{background:", ";}", "{right:", "px;min-width:", ";}", "{left:", ";right:auto;}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return lighten(theme.palette.background.default, 0.5);
}, match.isSM, props => props.theme.spacing(3), _ref4 => {
  let {
    $offsetRight
  } = _ref4;
  return "calc(150px + ".concat($offsetRight, "px)");
}, match.isLG, _ref5 => {
  let {
    $offsetRight
  } = _ref5;
  return "calc(50% + 466px - ".concat($offsetRight, "px)");
});
const FatBar = styled.div.withConfig({
  displayName: "EyebrowBar__FatBar",
  componentId: "sc-cv63mn-10"
})(["position:absolute;padding-top:48px;top:0;left:0;width:100%;&[style*='opacity: 0']{pointer-events:none;}"]);
const FatBarContent = styled.div.withConfig({
  displayName: "EyebrowBar__FatBarContent",
  componentId: "sc-cv63mn-11"
})(["background:", ";height:calc(100vh - 48px);overflow:auto;", "{height:auto;}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return lighten(theme.palette.background.default, 0.12);
}, match.isSM);
const FatBarOverlay = styled.div.withConfig({
  displayName: "EyebrowBar__FatBarOverlay",
  componentId: "sc-cv63mn-12"
})(["width:100%;height:100vh;background:rgba(0,0,0,0.5);top:0;position:absolute;z-index:-1;"]);
const StyledContainer$1 = styled(Container$4).withConfig({
  displayName: "EyebrowBar__StyledContainer",
  componentId: "sc-cv63mn-13"
})(["padding-top:1.8rem;padding-bottom:1.8rem;", "{padding-top:3.7rem;padding-bottom:3.7rem;display:flex;align-items:center;flex-direction:row;justify-content:space-between;}"], match.isMD);
const StyledHeading$2 = styled(Heading).withConfig({
  displayName: "EyebrowBar__StyledHeading",
  componentId: "sc-cv63mn-14"
})(["margin-bottom:1rem;& br{display:none;}", "{& br{display:inherit;}}"], match.isSM);
const Divider$1 = styled.div.withConfig({
  displayName: "EyebrowBar__Divider",
  componentId: "sc-cv63mn-15"
})(["width:100%;background:", ";margin:1.5rem 0;height:1px;", "{width:1px;margin:0 1.5rem;height:auto;align-self:stretch;}"], _ref7 => {
  let {
    theme
  } = _ref7;
  return alpha(theme.palette.text.primary, 0.3);
}, match.isMD);
const StyledLink$2 = styled(Link).withConfig({
  displayName: "EyebrowBar__StyledLink",
  componentId: "sc-cv63mn-16"
})(["color:#fff;text-decoration:none;display:inline-block;padding:0.4em 1em;margin-left:-1em;position:relative;z-index:1;font-size:1rem;transition:color 0.3s ease-out;", " ", "{white-space:nowrap;font-size:1.3rem;}", "{margin-left:0;}&:before{display:block;content:' ';background:", ";position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;transform:scaleX(0);transform-origin:left;transition:transform 0.3s ease-out;}&:hover,&:focus{color:", ";}&:hover:before,&:focus:before{transform:scaleX(0.99);}"], _ref8 => {
  let {
    $isAltSection
  } = _ref8;
  return $isAltSection && "font-weight: 700;";
}, match.isSM, match.isMD, _ref9 => {
  let {
    $brandColor
  } = _ref9;
  return $brandColor || '#fff';
}, _ref10 => {
  let {
    $brandColor
  } = _ref10;
  return !$brandColor ? '#000' : 'inherit';
});
const LinkGroup = _ref11 => {
  let {
    links,
    ...rest
  } = _ref11;
  const subLinks = (subLinks, component, isAltSection) => /*#__PURE__*/React.createElement("ul", null, subLinks.map((link, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, link.href ? /*#__PURE__*/React.createElement(StyledLink$2, {
    type: "text",
    href: link.href,
    "aria-label": link.ariaLabel || link.label,
    $isAltSection: isAltSection,
    $brandColor: link.brandColor,
    onClick: link.onClick,
    trackId: link.ariaLabel || link.label,
    children: link.label
  }) : link.label)));
  return /*#__PURE__*/React.createElement(LinkGroupBox$1, rest, links.map((link, index) => {
    const isAltSection = index > 0;
    const label = link.label;
    return /*#__PURE__*/React.createElement(Box, {
      key: index
    }, label, subLinks(link.links, link.component, isAltSection));
  }));
};
const LinkGroupBox$1 = styled.div.withConfig({
  displayName: "EyebrowBar__LinkGroupBox",
  componentId: "sc-cv63mn-17"
})(["& > div:last-child{margin-top:2rem;}& ul{list-style:none;padding:0;margin:0;column-count:2;}"]);
const MobileOnly = styled.span.withConfig({
  displayName: "EyebrowBar__MobileOnly",
  componentId: "sc-cv63mn-18"
})(["display:flex;", "{display:none;}"], match.isSM);
const DesktopOnly = styled.span.withConfig({
  displayName: "EyebrowBar__DesktopOnly",
  componentId: "sc-cv63mn-19"
})(["display:none;", "{display:flex;}"], match.isSM);
EyebrowBar.defaultProps = {
  links: DEFAULT_EYEBROW_LINKS,
  menuLinks: DEFAULT_LINKS,
  selectedTabIndex: false
};
var EyebrowBar$1 = withI18next(EyebrowBar);
var dist = {};
Object.defineProperty(dist, "__esModule", {
  value: true
});
const data = {
  businessUnits: [{
    name: 'Business Development',
    geo: 'North America',
    email: 'connect@klick.com',
    contacts: [{
      name: 'Jennifer White',
      title: 'Global Head of Growth'
    }]
  }, {
    name: 'Media Relations',
    email: 'pr@klick.com',
    contacts: [{
      name: 'Sheryl Steinberg',
      title: 'SVP, Communications'
    }]
  }, {
    name: 'Talent Acquisition',
    email: 'careers@klick.com',
    contacts: [{
      name: 'Deanna Pathak',
      title: 'Global Head of Talent Attraction'
    }]
  }, {
    name: 'Business Development',
    geo: 'LATAM',
    email: 'latam@klick.com',
    contacts: [{
      name: 'Roberta Raduan',
      title: 'Managing Director'
    }]
  }, {
    name: 'Business Development',
    geo: 'EMEA',
    email: 'emea@klick.com',
    contacts: [{
      name: 'Jennifer Lambert',
      title: 'Managing Director'
    }]
  }, {
    name: 'Business Development',
    geo: 'APAC',
    email: 'apac@klick.com',
    contacts: [{
      name: 'Mitchell Tan',
      title: 'Managing Director'
    }]
  }],
  offices: [{
    name: 'Toronto',
    location: {
      address: ['175 Bloor Street East', 'Suite 300, North Tower'],
      city: 'Toronto',
      province: 'ON',
      postalCode: 'M4W 3R8',
      country: 'Canada'
    }
  }, {
    name: 'New York',
    location: {
      address: ['240 W 40th Street', '12th Floor'],
      city: 'New York',
      province: 'NY',
      postalCode: '10018',
      country: 'USA'
    }
  }, {
    name: 'London',
    location: {
      address: ['30 Stamford Street'],
      city: 'London',
      postalCode: 'SE1 9LQ',
      country: 'UK'
    }
  }, {
    name: 'Singapore',
    location: {
      address: ['109 North Bridge Road', '#05-21'],
      city: 'Singapore',
      postalCode: '179097',
      country: 'Singapore'
    }
  }, {
    name: 'São Paulo',
    location: {
      address: ['Nações Unidas, 14261, Torre A', 'Cidade Monções'],
      city: 'São Paulo',
      province: 'SP',
      postalCode: '04794-000',
      country: 'Brazil'
    }
  }, {
    name: 'Philadelphia',
    location: {
      address: ['510 Walnut Street', '13th Floor'],
      city: 'Philadelphia',
      province: 'PA',
      postalCode: '19106-3601',
      country: 'USA'
    }
  }]
};
var _default = dist.default = data;
const {
  offices
} = _default;
const Addresses = _ref => {
  let {
    variant = 'h5',
    component = 'span',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledAddresses$1, rest, offices.map((_ref2, index) => {
    let {
      name,
      location
    } = _ref2;
    const {
      address,
      city,
      province,
      postalCode
    } = location;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(Heading, {
      variant: variant,
      component: component
    }, name), /*#__PURE__*/React.createElement("address", {
      className: "vcard"
    }, /*#__PURE__*/React.createElement("span", {
      className: "adr"
    }, address.map((line, index) => {
      const isFirstLine = index === 0;
      const className = isFirstLine ? 'street-address' : 'extended-address';
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("span", {
        className: className
      }, line), /*#__PURE__*/React.createElement("br", null));
    }), /*#__PURE__*/React.createElement("span", {
      className: "locality"
    }, city), province ? /*#__PURE__*/React.createElement(React.Fragment, null, ",\xA0", /*#__PURE__*/React.createElement("abbr", {
      className: "region"
    }, province)) : '', "\xA0\xA0", /*#__PURE__*/React.createElement("span", {
      className: "postal-code"
    }, postalCode))));
  }));
};
const StyledAddresses$1 = styled.ul.withConfig({
  displayName: "Addresses__StyledAddresses",
  componentId: "sc-wq8uvl-0"
})(["display:flex;margin:0;padding:0;list-style-type:none;text-align:left;justify-content:space-between;color:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.text.primary;
});
const Lockup = _ref => {
  let {
    brandName,
    themeType,
    to,
    href,
    trackId,
    tagline = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "There\u2019s something"), " ", /*#__PURE__*/React.createElement("span", null, "different here.")),
    label,
    onClick,
    ...rest
  } = _ref;
  const logoTagline = [/*#__PURE__*/React.createElement(Logo, {
    key: "logo",
    brandName: brandName,
    themeType: themeType,
    "aria-label": "Klick Health"
  }), /*#__PURE__*/React.createElement(Divider, {
    key: "divider"
  }), /*#__PURE__*/React.createElement(Tagline, {
    key: "tagline",
    component: "span"
  }, tagline)];
  return to || href ? /*#__PURE__*/React.createElement(StyledWrapper, _extends({
    as: Link,
    href: to || href,
    "aria-label": label,
    onClick: onClick,
    children: logoTagline,
    trackId: trackId
  }, rest)) : /*#__PURE__*/React.createElement(StyledWrapper, _extends({
    as: Box,
    children: logoTagline
  }, rest));
};
const StyledWrapper = styled.div.withConfig({
  displayName: "Lockup__StyledWrapper",
  componentId: "sc-ntdkjx-0"
})(["display:inline-flex;align-items:center;color:", ";text-decoration:none;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.text.primary;
});
const Logo = styled(KlickLogo).withConfig({
  displayName: "Lockup__Logo",
  componentId: "sc-ntdkjx-1"
})(["width:40px;"]);
const Divider = styled.div.withConfig({
  displayName: "Lockup__Divider",
  componentId: "sc-ntdkjx-2"
})(["width:1px;background:", ";margin:0 2.4rem;align-self:stretch;"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.text.primary;
});
const Tagline = styled(Heading).withConfig({
  displayName: "Lockup__Tagline",
  componentId: "sc-ntdkjx-3"
})(["display:inline-block;vertical-align:middle;margin:0;padding:0;font-size:1rem;font-family:", ";font-weight:400;& > span{white-space:nowrap;", "{white-space:normal;}}", "{font-size:1.2rem;}"], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.typography.font['secondary'];
}, match.isSM, match.isSM);
const OneTrustGlobalStyles = createGlobalStyle([":root{--onetrust-primary-color:", ";--onetrust-on-primary-text-color:", ";}.ot-close-icon{color:#ffffff;background:none !important;}.ot-close-icon:before{content:'\xD7';color:#ffffff !important;font-size:2rem;position:relative;}#onetrust-consent-sdk #onetrust-pc-sdk .privacy-notice-link,#onetrust-consent-sdk #onetrust-pc-sdk .category-vendors-list-handler,#onetrust-consent-sdk #onetrust-pc-sdk .category-vendors-list-handler + a,#onetrust-consent-sdk #onetrust-pc-sdk .category-host-list-handler,#onetrust-consent-sdk #onetrust-pc-sdk .ot-ven-link,#onetrust-consent-sdk #onetrust-pc-sdk #ot-host-lst .ot-host-name a,#onetrust-consent-sdk #onetrust-pc-sdk #ot-host-lst .ot-acc-hdr .ot-host-expand,#onetrust-consent-sdk #onetrust-pc-sdk #ot-host-lst .ot-host-info a,#onetrust-consent-sdk #onetrust-pc-sdk #ot-pc-content #ot-pc-desc .ot-link-btn,#onetrust-consent-sdk #onetrust-pc-sdk .ot-vnd-serv .ot-vnd-item .ot-vnd-info a,#onetrust-consent-sdk #onetrust-pc-sdk #ot-lst-cnt .ot-vnd-info a{color:var(--onetrust-primary-color) !important;text-decoration-color:var(--onetrust-primary-color);}#onetrust-pc-sdk .ot-pc-header.ot-pc-header{border-bottom:none;}#onetrust-pc-sdk .pc-logo.pc-logo,#onetrust-pc-sdk .ot-pc-logo.ot-pc-logo{display:none;}#onetrust-pc-sdk #ot-pc-title#ot-pc-title{font-size:1.5rem;}#onetrust-pc-sdk #ot-pc-content#ot-pc-content#ot-pc-content#ot-pc-content{top:10px;}#onetrust-consent-sdk #onetrust-pc-sdk .ot-acc-grpcntr.ot-acc-txt.ot-acc-grpcntr.ot-acc-txt,#onetrust-consent-sdk #onetrust-pc-sdk .ot-acc-txt .ot-subgrp-tgl .ot-switch.ot-toggle.ot-switch.ot-toggle{background:#000000;}#onetrust-pc-sdk .ot-accordion-layout.ot-cat-item.ot-accordion-layout.ot-cat-item,#onetrust-pc-sdk .ot-accordion-layout.ot-cat-item.ot-accordion-layout.ot-cat-item:first-of-type{border:none;}#onetrust-pc-sdk .ot-plus-minus.ot-plus-minus span{background:var(--onetrust-primary-color);}#onetrust-pc-sdk .ot-plus-minus.ot-plus-minus{height:25px;width:25px;}#onetrust-pc-sdk .ot-vs-config .ot-acc-hdr .ot-plus-minus.ot-plus-minus{top:-2px;}#onetrust-pc-sdk .ot-accordion-layout.ot-cat-item.ot-cat-item{margin:0 0 1px 1px;}#onetrust-pc-sdk .ot-pc-footer.ot-pc-footer{border-top:none;}#onetrust-pc-sdk .ot-vs-list .ot-always-active.ot-always-active,#onetrust-pc-sdk .ot-cat-grp .ot-always-active.ot-always-active{color:#ffffff;}#onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob.ot-switch-nob{background-color:var(--onetrust-primary-color);border:1px solid rgba(255,255,255,0.2);}#onetrust-pc-sdk .ot-tgl input:checked + .ot-switch .ot-switch-nob.ot-switch-nob:before{background-color:#ffffff;}#onetrust-consent-sdk#onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn),#onetrust-consent-sdk#onetrust-consent-sdk #onetrust-pc-sdk .ot-leg-btn-container .ot-active-leg-btn{background-color:var(--onetrust-primary-color);border-color:var(--onetrust-primary-color);color:var(--onetrust-on-primary-text-color);}#onetrust-consent-sdk#onetrust-consent-sdk #onetrust-accept-btn-handler,#onetrust-banner-sdk#onetrust-banner-sdk #onetrust-reject-all-handler{background-color:var(--onetrust-primary-color);border-color:var(--onetrust-primary-color);color:var(--onetrust-on-primary-text-color);}#onetrust-pc-sdk .ot-tgl input:checked+.ot-switch .ot-switch-nob{border:1px solid rgba(255,255,255,0.2);}"], _ref => {
  var _theme$palette;
  let {
    theme,
    $color
  } = _ref;
  return $color || (theme === null || theme === void 0 || (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main) || '#0343fb';
}, _ref2 => {
  var _theme$palette2;
  let {
    theme,
    $color
  } = _ref2;
  return getLuminance($color || (theme === null || theme === void 0 || (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.primary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main) || '#0343fb') > 0.5 ? '#000000' : '#ffffff';
});
const OneTrustController = _ref3 => {
  let {
    color
  } = _ref3;
  const {
    i18n: {
      language
    }
  } = useTranslation();
  React.useLayoutEffect(() => {
    var _window2;
    isBrowser && ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.OneTrust) === null || _window2 === void 0 ? void 0 : _window2.changeLanguage(language));
  }, [language]);
  return /*#__PURE__*/React.createElement(OneTrustGlobalStyles, {
    $color: color
  });
};
const handleToggleInfoDisplay = trackId => {
  var _window3;
  tracking.track({
    event: 'modal_open',
    eventModel: {
      modal_id: 'onetrust_cookie_modal',
      ...(trackId && {
        track_id: trackId
      })
    }
  });
  isBrowser && ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.OneTrust.ToggleInfoDisplay());
};
var OneTrustController$1 = withI18next(OneTrustController);
const TwitterIcon = () => {
  return /*#__PURE__*/React.createElement(SvgIcon, {
    viewBox: "-200 -200 1600 1650"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z",
    fill: "currentColor"
  }));
};
const DEFAULT_SOCIAL_BUTTONS = [{
  label: 'LinkedIn',
  icon: LinkedIn,
  href: 'https://www.linkedin.com/company/klick-health',
  trackId: 'social_linkedin'
}, {
  label: 'Twitter',
  icon: TwitterIcon,
  href: 'https://twitter.com/klickhealth',
  trackId: 'social_twitter'
}, {
  label: 'Facebook',
  icon: Facebook,
  href: 'https://www.facebook.com/KlickHealth',
  trackId: 'social_facebook'
}, {
  label: 'Instagram',
  icon: Instagram,
  href: 'https://www.instagram.com/klick.health',
  trackId: 'social_instagram'
}, {
  label: 'YouTube',
  icon: YouTube,
  href: 'https://www.youtube.com/KlickHealth',
  trackId: 'social_youtube'
}];
const GROUP_LABEL = 'Follow us on';
const SocialButtons = _ref => {
  let {
    buttons = DEFAULT_SOCIAL_BUTTONS,
    color = 'primary',
    groupLabel = GROUP_LABEL,
    noMargin = false,
    location_id = '',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSocialContainer, _extends({}, rest, {
    noMargin: noMargin
  }), groupLabel && /*#__PURE__*/React.createElement("span", null, groupLabel), /*#__PURE__*/React.createElement(StyledNav, {
    "aria-label": "Social Media"
  }, /*#__PURE__*/React.createElement(SocialMediaList, null, buttons.map((_ref2, index) => {
    let {
      icon: Icon,
      svg,
      href,
      label,
      trackId
    } = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(IconButton, {
      component: Link,
      role: "link",
      href: href,
      color: color,
      "aria-label": "".concat(groupLabel || GROUP_LABEL, " ").concat(label),
      trackId: location_id ? "".concat(location_id, "_").concat(trackId) : trackId
    }, Icon && /*#__PURE__*/React.createElement(Icon, null), svg && /*#__PURE__*/React.createElement("img", {
      src: svg,
      alt: label
    })));
  }))));
};
const SocialMediaList = styled.ul.withConfig({
  displayName: "SocialButtons__SocialMediaList",
  componentId: "sc-a6lgws-0"
})(["padding:0;margin:0;list-style-type:none;display:inline-block;li{display:inline-block;", "{margin-left:1rem;}}"], match.isSM);
const StyledNav = styled.nav.withConfig({
  displayName: "SocialButtons__StyledNav",
  componentId: "sc-a6lgws-1"
})(["display:inline-block;"]);
const StyledSocialContainer = styled.div.withConfig({
  displayName: "SocialButtons__StyledSocialContainer",
  componentId: "sc-a6lgws-2"
})(["display:inline-block;position:relative;white-space:nowrap;margin-top:", ";display:flex;justify-content:space-between;flex-wrap:wrap;& > span{display:block;position:relative;left:0.875rem;font-weight:700;}& svg{font-size:2.0875rem;}", "{& > span{width:calc(100% - 0.875rem);}}", "{display:block;margin-top:0;top:0.675rem;& > span{display:inline;width:auto;left:auto;}& svg{font-size:inherit;}}"], _ref3 => {
  let {
    noMargin
  } = _ref3;
  return noMargin ? 'none' : '5rem';
}, match.isXS, match.isSM);
const Footer = props => {
  const {
    contactUrl = '/contact',
    noLocalPage,
    ...rest
  } = props;
  const {
    t
  } = useTranslation();
  const DEFAULT_FOOTER_ITEMS = [{
    label: t('Discover Klick'),
    items: [{
      label: 'Klick Health',
      href: 'https://www.klick.com',
      trackId: 'footer_klick'
    }, {
      label: 'Klick Katalyst',
      href: 'https://katalyst.klick.com',
      trackId: 'footer_katalyst'
    }, {
      label: 'Klick Consulting',
      href: 'https://consulting.klick.com',
      trackId: 'footer_consulting'
    }, {
      label: 'Klick Media',
      href: 'https://media.klick.com',
      trackId: 'footer_media'
    }, {
      label: 'Klick Ideas Exchange',
      href: 'https://idx.klick.com',
      trackId: 'footer_idx'
    }, {
      label: "".concat(t('Careers'), " @ Klick"),
      href: 'https://careers.klick.com',
      trackId: 'footer_careers'
    }, {
      label: 'Newsroom',
      href: 'https://www.klick.com/news',
      trackId: 'footer_news'
    }]
  }, {
    label: '',
    items: [{
      label: t('Contact Us'),
      href: noLocalPage !== null && noLocalPage !== void 0 && noLocalPage.includes('contact') ? 'https://www.klick.com/contact' : contactUrl,
      trackId: 'footer_contact_us'
    }, {
      label: t('Newsletter'),
      href: 'https://www.klick.com/klickwire',
      trackId: 'footer_klickwire'
    }, {
      label: t('Privacy Policy'),
      href: 'https://www.klick.com/privacy',
      trackId: 'footer_privacy'
    }, {
      label: t('Global Capabilities'),
      href: 'https://www.klick.com/global',
      trackId: 'footer_global'
    }, {
      label: t('Cookie Settings'),
      onClick: 'handleToggleInfoDisplay',
      component: 'button'
    }, {
      label: t('Accessibility Settings'),
      onClick: 'showAccessibilityModal',
      component: 'button'
    }, {
      label: t('Accessibility Statement'),
      href: 'https://www.klick.com/accessibility',
      trackId: 'footer_accessibility'
    }, {
      label: t('Do Not Sell Or Share My Personal Information'),
      onClick: 'handleToggleInfoDisplay',
      component: 'button'
    }]
  }];
  const {
    themeType = 'onBlack',
    itemsList = DEFAULT_FOOTER_ITEMS,
    divider = true,
    copyrightOverride
  } = rest;
  const theme = useTheme$1();
  const Copyright$1 = copyrightOverride !== null && copyrightOverride !== void 0 ? copyrightOverride : Copyright;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: themeType
  }, divider && /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(LineDivider, null))), /*#__PURE__*/React.createElement(StyledFooter, {
    component: "footer"
  }, /*#__PURE__*/React.createElement(Container$4, null, /*#__PURE__*/React.createElement(Box, {
    display: {
      xs: 'grid',
      sm: 'flex'
    },
    sx: {
      gap: '40px'
    },
    flexDirection: "row",
    flexWrap: "wrap",
    py: theme.defaults.spacing.medium
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Lockup, {
    href: "/",
    label: "Homepage",
    trackId: "footer_logo",
    tagline: /*#__PURE__*/React.createElement(Trans, null, /*#__PURE__*/React.createElement("span", null, "There\u2019s something"), " ", /*#__PURE__*/React.createElement("span", null, "different here."))
  })), /*#__PURE__*/React.createElement(StyledAddresses, null), /*#__PURE__*/React.createElement(StyledBox$2, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(FooterItemsList, {
    items: itemsList
  }), /*#__PURE__*/React.createElement(StyledSocialButtons, {
    groupLabel: t('Follow us on'),
    location_id: "footer"
  })), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    mt: 10,
    pt: 2,
    borderTop: 1,
    borderColor: "text.primary"
  }, /*#__PURE__*/React.createElement(Copyright$1, null))))));
};
const FooterItemsList = _ref => {
  let {
    items,
    ...rest
  } = _ref;
  const {
    showAccessibilityModal
  } = useAccessibilityContext();
  const onClickActionsMap = {
    handleToggleInfoDisplay: () => handleToggleInfoDisplay('footer'),
    showAccessibilityModal: () => showAccessibilityModal('footer')
  };
  const subItems = (subItems, component, altColor) => {
    return /*#__PURE__*/React.createElement("ul", null, subItems.map((_ref2, index) => {
      let {
        onClick,
        ariaLabel,
        label,
        trackId,
        ...restItem
      } = _ref2;
      const onClickFn = onClickActionsMap[onClick] || onClick || noop;
      const handleClick = function () {
        onClickFn();
      };
      return /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement(StyledLink$1, _extends({
        variant: "body1",
        underline: "hover",
        type: "text",
        trackId: trackId,
        $altColor: altColor,
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: label
      }, restItem)));
    }));
  };
  return /*#__PURE__*/React.createElement(LinkGroupBox, _extends({}, rest, {
    role: "navigation",
    "aria-label": "Footer"
  }), items.map((item, index) => {
    const altColor = index > 0;
    const label = item.label;
    const headLink = item.to ? /*#__PURE__*/React.createElement(StyledLink$1, {
      href: item.href,
      trackId: item.trackId,
      underline: "hover",
      ariaLabel: item.ariaLabel || item.label,
      onClick: item.onClick,
      children: label
    }) : /*#__PURE__*/React.createElement(Heading, {
      variant: "h5",
      component: "span"
    }, label);
    return /*#__PURE__*/React.createElement(Box, {
      key: index
    }, label && headLink, subItems(item.items, item.component, altColor));
  }));
};
const noop = function () {};
const LinkGroupBox = styled.nav.withConfig({
  displayName: "Footer__LinkGroupBox",
  componentId: "sc-13mx184-0"
})(["& > div:last-child{margin-top:2rem;padding-top:2rem;border-top:", " 1px solid;}& ul{list-style:none;padding:0;margin:0;", "{column-count:2;}}& ul > li{break-inside:avoid;}& ", "{color:", ";}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return alpha(theme.palette.text.primary, 0.3);
}, match.isSM, Heading, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.primary.main;
});
const StyledAddresses = styled(Addresses).withConfig({
  displayName: "Footer__StyledAddresses",
  componentId: "sc-13mx184-1"
})(["display:block;flex-grow:1;line-height:1.8rem;", "{columns:2;}", "{width:50%;}& address{font-style:normal;}& > li{display:block;margin-bottom:2rem;", "{padding-right:0.5rem;}", "{margin-bottom:3.2rem;}&:last-child{margin:0;}}& ", "{color:", ";}"], match.isSM, match.isMD, match.isSM, match.isMD, Heading, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.palette.primary.main;
});
const StyledSocialButtons = styled(SocialButtons).withConfig({
  displayName: "Footer__StyledSocialButtons",
  componentId: "sc-13mx184-2"
})(["li{", "{margin-left:0.8rem;}}"], match.isMD);
const StyledBox$2 = styled(Box).withConfig({
  displayName: "Footer__StyledBox",
  componentId: "sc-13mx184-3"
})(["", "{width:44%;}", "{width:33%;}"], match.isMD, match.isLG);
const StyledFooter = styled(Box).withConfig({
  displayName: "Footer__StyledFooter",
  componentId: "sc-13mx184-4"
})(["position:relative;z-index:5;font-size:1rem;line-height:2rem;color:", ";background-color:", ";"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.text.primary;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.palette.background.default;
});
const StyledContainer = styled(Container$4).withConfig({
  displayName: "Footer__StyledContainer",
  componentId: "sc-13mx184-5"
})(["position:relative;"]);
const LineDivider = styled.div.withConfig({
  displayName: "Footer__LineDivider",
  componentId: "sc-13mx184-6"
})(["width:100%;border-bottom:1px solid ", ";position:absolute;top:-1px;"], _ref8 => {
  let {
    theme
  } = _ref8;
  return alpha(theme.palette.text.primary, 0.15);
});
const StyledLink$1 = styled(Link).withConfig({
  displayName: "Footer__StyledLink",
  componentId: "sc-13mx184-7"
})(["color:", ";line-height:1.1em;text-align:left;display:block;padding:0.45em 0;"], _ref9 => {
  let {
    theme,
    $altColor
  } = _ref9;
  return $altColor ? alpha(theme.palette.text.primary, 0.5) : theme.palette.text.primary;
});
var Footer$1 = withI18next(Footer);
gsap.registerPlugin(ScrollTrigger);
const Section = /*#__PURE__*/forwardRef((_ref, passedDownRef) => {
  let {
    component = 'section',
    position = 'relative',
    scrollToOffset = '-74px',
    children,
    name,
    zIndex = 20,
    ...restProps
  } = _ref;
  const theme = useTheme();
  const _sectionRef = useRef();
  const sectionRef = passedDownRef || _sectionRef;
  return /*#__PURE__*/React.createElement(Box, _extends({
    pt: theme.defaults.spacing.medium,
    pb: theme.defaults.spacing.medium,
    component: component,
    ref: sectionRef,
    bgcolor: "background.default"
  }, restProps), /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    position: position,
    zIndex: zIndex
  }, children));
});
const sizeLookup = {
  small: {
    xs: 200,
    md: 250,
    lg: 300
  },
  medium: {
    xs: 300,
    md: 400,
    lg: 500
  },
  large: {
    xs: 400,
    md: 500,
    lg: 600
  }
};
const MAIN_NAV_OFFSET = {
  mobile: '56px',
  desktop: '74px'
};
const Hero = props => {
  const {
    imageQuery,
    imageFilename,
    objectPosition = '50% 100%',
    heading,
    overlay,
    size = 'medium',
    minHeight,
    justifyContent = 'center',
    alignItems = 'center',
    flexDirection = 'row',
    variant = 'h1',
    children,
    ...rest
  } = props;
  let imgSources;
  if (imageQuery && imageFilename) {
    var _imageQuery$portrait;
    const imagesLandscape = reduceImages(imageQuery.landscape.edges);
    const imagesPortrait = imageQuery !== null && imageQuery !== void 0 && (_imageQuery$portrait = imageQuery.portrait) !== null && _imageQuery$portrait !== void 0 && _imageQuery$portrait.edges ? reduceImages(imageQuery.portrait.edges) : undefined;
    imgSources = imagesPortrait ? withArtDirection(imagesLandscape[imageFilename], [{
      media: match.getQuery('isXS'),
      image: imagesPortrait[imageFilename]
    }]) : imagesLandscape[imageFilename];
  }
  const actualMinHeight = minHeight !== null && minHeight !== void 0 ? minHeight : sizeLookup[size];
  return /*#__PURE__*/React.createElement(Section, _extends({}, rest, {
    pt: 0,
    pb: 0
  }), overlay && /*#__PURE__*/React.createElement(Overlay$1, null), imgSources && /*#__PURE__*/React.createElement(ImgHolder, null, /*#__PURE__*/React.createElement(StyledImg, {
    image: imgSources,
    objectFit: "cover",
    objectPosition: objectPosition,
    alt: ""
  })), /*#__PURE__*/React.createElement(Container$5, {
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement(HeroContent$1, {
    position: "relative",
    zIndex: "3",
    paddingTop: {
      xs: MAIN_NAV_OFFSET.mobile,
      md: MAIN_NAV_OFFSET.desktop
    },
    flexDirection: flexDirection,
    minHeight: actualMinHeight,
    display: "flex",
    alignItems: alignItems,
    justifyContent: justifyContent
  }, heading ? /*#__PURE__*/React.createElement(StyledHeading$1, {
    variant: variant
  }, heading) : children)));
};
const StyledHeading$1 = styled(Heading).withConfig({
  displayName: "Hero__StyledHeading",
  componentId: "sc-iyptp3-0"
})(["position:relative;margin:0;color:", ";z-index:2;"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.text.primary;
});
const ImgHolder = styled.div.withConfig({
  displayName: "Hero__ImgHolder",
  componentId: "sc-iyptp3-1"
})(["position:absolute;width:100%;height:100%;z-index:2;"]);
const Overlay$1 = styled.div.withConfig({
  displayName: "Hero__Overlay",
  componentId: "sc-iyptp3-2"
})(["top:0;position:absolute;height:100%;width:100%;background:", ";z-index:3;opacity:0.3;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.background.default;
});
const StyledImg = styled(GatsbyImage).withConfig({
  displayName: "Hero__StyledImg",
  componentId: "sc-iyptp3-3"
})(["height:100%;"]);
const HeroContent$1 = styled(Box$1).withConfig({
  displayName: "Hero__HeroContent",
  componentId: "sc-iyptp3-4"
})(["", "{> span{display:block;position:relative;font-size:0.45em;letter-spacing:0em;margin-top:1em;&:before{content:'';position:absolute;width:1.2em;height:0.15em;top:-0.5em;background-color:", ";}}}"], Heading, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
});
const ScrollIndicator = props => {
  const {
    enhanced
  } = useEnhancedContext();
  return /*#__PURE__*/React.createElement(Container$1, _extends({
    $enhanced: enhanced
  }, props), /*#__PURE__*/React.createElement(Content, {
    $enhanced: enhanced
  }));
};
const dot = keyframes(["0%{transform:scale(.75);opacity:0;}25%{transform:scale(1);opacity:1;}100%{transform:scale(.75);opacity:0;}"]);
const arrow = keyframes(["0%{transform:scale(.75) rotate(45deg);opacity:0;}25%{transform:scale(1) rotate(45deg);opacity:1;}100%{transform:scale(.75) rotate(45deg);opacity:0;}"]);
const Container$1 = styled.div.withConfig({
  displayName: "ScrollIndicator__Container",
  componentId: "sc-1xul4hr-0"
})(["width:12px;position:relative;opacity:1;&::before,&::after{content:'';display:block;margin-left:auto;margin-right:auto;}&::before{width:12px;height:12px;border-radius:10px;border:1px solid ", ";animation:", ";}&::after{width:7px;height:7px;border-right:1px solid ", ";border-bottom:1px solid ", ";transform:rotate(45deg);animation:", ";animation-delay:0.75s;opacity:1;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.text.primary;
}, _ref2 => {
  let {
    $enhanced
  } = _ref2;
  return $enhanced ? css(["", " 1.5s infinite ease-in-out"], dot) : 'none';
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.text.primary;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.text.primary;
}, _ref5 => {
  let {
    $enhanced
  } = _ref5;
  return $enhanced ? css(["", " 1.5s infinite ease-in-out"], arrow) : 'none';
});
const Content = styled.div.withConfig({
  displayName: "ScrollIndicator__Content",
  componentId: "sc-1xul4hr-1"
})(["display:block;&::before,&::after{content:'';display:block;margin:5px auto;border-radius:10px;border:1px solid ", ";animation:", ";}&::before{width:8px;height:8px;animation-delay:0.25s;}&::after{width:6px;height:6px;animation-delay:0.5s;}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.text.primary;
}, _ref7 => {
  let {
    $enhanced
  } = _ref7;
  return $enhanced ? css(["", " 1.5s infinite ease-in-out"], dot) : 'none';
});
gsap$1.registerPlugin(ExpoScaleEase);
const IntroMask = props => {
  const {
    background,
    dot,
    skipIntro,
    mainIntroTimeline,
    mainScrollTimeline,
    isGradientOverlayEnabled
  } = props;
  const noExpand = !background;
  const maskConfig = useRef({
    x: 0,
    y: 0,
    radius: 0,
    scale: 1
  });
  const circleMaskRef = useRef();
  const colorOverlayRef = useRef();
  const introTimeline = useInstance(() => gsap$1.timeline());
  const scrollTimeline = useInstance(() => gsap$1.timeline());
  const [showClippath, setShowClippath] = useState(true);
  useIsomorphicLayoutEffect(() => {
    if (skipIntro) return;
    buildIntroAnimations({
      introTimeline,
      circleMaskRef,
      maskConfig,
      dot
    });
    mainIntroTimeline.add(introTimeline, 0);
    return () => {
      introTimeline.clear();
      mainIntroTimeline.remove(introTimeline);
    };
  }, [dot, introTimeline, mainIntroTimeline, skipIntro]);
  useIsomorphicLayoutEffect(() => {
    if (!skipIntro) return;
    buildScrollAnimations({
      scrollTimeline,
      circleMaskRef,
      maskConfig,
      colorOverlayRef,
      dot,
      noExpand
    });
    mainScrollTimeline.add(scrollTimeline, 0);
    return () => {
      scrollTimeline.clear();
      mainScrollTimeline.remove(scrollTimeline);
    };
  }, [dot, mainScrollTimeline, scrollTimeline, skipIntro]);
  React.useEffect(() => {
    const handleResize = throttle(() => {
      const animationRefs = {
        introTimeline,
        scrollTimeline,
        circleMaskRef,
        maskConfig,
        colorOverlayRef,
        dot,
        noExpand
      };
      !skipIntro ? buildIntroAnimations(animationRefs) : buildScrollAnimations(animationRefs);
    }, 50);
    const handleFullScreen = e => {
      const isFS = e.target.webkitDisplayingFullscreen;
      setShowClippath(!isFS);
    };
    window.addEventListener('resize', handleResize);
    document.addEventListener('webkitfullscreenchange', handleFullScreen);
    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('webkitfullscreenchange', handleFullScreen);
    };
  }, [dot, introTimeline, scrollTimeline, skipIntro, noExpand]);
  return /*#__PURE__*/React.createElement(CircleMask, {
    ref: circleMaskRef,
    showClippath: showClippath
  }, /*#__PURE__*/React.createElement(ColorOverlay, {
    $isGradientOverlayEnabled: isGradientOverlayEnabled,
    ref: colorOverlayRef
  }), /*#__PURE__*/React.createElement(BackgroundContent$1, null, background));
};
const buildIntroAnimations = animationRefs => {
  const {
    introTimeline,
    circleMaskRef,
    dot,
    maskConfig
  } = animationRefs;
  const introTimelineProgress = introTimeline.progress();
  introTimeline.pause(0).clear();
  maskConfig.current = generateMaskConfig({
    circleMaskRef,
    dot
  });
  const {
    introRadius,
    targetX,
    targetY
  } = getAnimationTargets({
    circleMaskRef
  });
  const {
    x,
    y,
    radius
  } = maskConfig.current;
  introTimeline.fromTo(circleMaskRef.current, {
    clipPath: "circle(1px at ".concat(x, "px ").concat(y, "px)")
  }, {
    duration: 0.3,
    clipPath: "circle(".concat(radius, "px at ").concat(x, "px ").concat(y, "px)"),
    ease: 'back.out',
    immediateRender: false,
    delay: 0.5
  }, 0);
  introTimeline.fromTo(circleMaskRef.current, {
    clipPath: "circle(".concat(radius, "px at ").concat(x, "px ").concat(y, "px)")
  }, {
    duration: 0.7,
    clipPath: "circle(".concat(introRadius, "px at ").concat(targetX, "px ").concat(targetY, "px)"),
    immediateRender: false,
    ease: ExpoScaleEase.config(1, introRadius, 'expo.out')
  }, 1.5);
  introTimeline.progress(introTimelineProgress);
  introTimeline.resume();
};
const buildScrollAnimations = animationRefs => {
  const {
    scrollTimeline,
    circleMaskRef,
    colorOverlayRef,
    maskConfig,
    dot,
    noExpand
  } = animationRefs;
  const scrollTimelineProgress = scrollTimeline.progress();
  scrollTimeline.pause(0).clear();
  maskConfig.current = generateMaskConfig({
    circleMaskRef,
    dot
  });
  const {
    introRadius,
    finalRadius,
    targetX,
    targetY
  } = getAnimationTargets({
    circleMaskRef
  });
  if (noExpand) {
    gsap$1.set(circleMaskRef.current, {
      clipPath: "circle(".concat(introRadius, "px at ").concat(targetX, "px ").concat(targetY, "px)")
    });
  } else {
    scrollTimeline.fromTo(circleMaskRef.current, {
      clipPath: "circle(".concat(introRadius, "px at ").concat(targetX, "px ").concat(targetY, "px)")
    }, {
      duration: 10,
      clipPath: "circle(".concat(finalRadius, "px at ").concat(targetX, "px ").concat(targetY, "px)"),
      ease: ExpoScaleEase.config(introRadius, finalRadius)
    }, 0);
    scrollTimeline.to(colorOverlayRef.current, {
      duration: 8,
      opacity: 0
    }, 2);
  }
  scrollTimeline.progress(scrollTimelineProgress);
  scrollTimeline.resume();
};
const getAnimationTargets = _ref => {
  let {
    circleMaskRef
  } = _ref;
  const {
    width,
    height
  } = circleMaskRef.current.getBoundingClientRect();
  const introRadius = Math.min(height * 0.7, width * 0.7) / 2;
  const targetX = width * 0.5;
  const targetY = height * 0.5;
  const finalRadius = calcPageFillRadius(targetX, targetY, width, height);
  return {
    introRadius,
    targetX,
    targetY,
    finalRadius
  };
};
const generateMaskConfig = _ref2 => {
  let {
    dot,
    circleMaskRef
  } = _ref2;
  const dotData = dot.current.getBoundingClientRect();
  const containerData = circleMaskRef.current.getBoundingClientRect();
  const radius = dotData.width * 0.5;
  const dotX = dotData.x + dotData.width / 2;
  const dotY = dotData.y + dotData.height / 2 - containerData.y;
  const maskConfig = {
    x: dotX,
    y: dotY,
    radius: radius,
    scale: 0
  };
  return maskConfig;
};
const CircleMask = styled.div.withConfig({
  displayName: "CircleMask",
  componentId: "sc-a6bh39-0"
})(["position:absolute;top:0;left:0;width:100vw;height:100%;z-index:2;clip-path:", ";pointer-events:none;"], _ref3 => {
  let {
    showClippath
  } = _ref3;
  return showClippath ? 'circle(0px at 150% 150%)' : 'none !important';
});
const BackgroundContent$1 = styled.div.withConfig({
  displayName: "CircleMask__BackgroundContent",
  componentId: "sc-a6bh39-1"
})(["overflow:hidden;position:relative;height:100%;width:100%;pointer-events:all;"]);
const gradientMovementKeyFrames = keyframes(["0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}"]);
const gradientStyles$1 = css(["transition:background 1s;background:radial-gradient( circle,", ",", ",", ",", ",", " );background-size:1000% 1000%;animation:", " 20s ease infinite;"], brandColors.klick, brandColors.consulting, brandColors.klick, brandColors.appliedsciences, brandColors.klick, gradientMovementKeyFrames);
const ColorOverlay = styled.div.withConfig({
  displayName: "CircleMask__ColorOverlay",
  componentId: "sc-a6bh39-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;background-color:", ";opacity:1;z-index:3;pointer-events:none;", ""], _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.primary.main;
}, _ref5 => {
  let {
    $isGradientOverlayEnabled
  } = _ref5;
  return $isGradientOverlayEnabled ? gradientStyles$1 : null;
});
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ExpoScaleEase);
gsap.registerPlugin(ScrollToPlugin$1);
const eyeBrowBarHeight = 48;
const HeroMaskIntro = _ref => {
  let {
    initialBackground,
    background,
    headline,
    onIntroComplete,
    skipAutoScroll = false,
    isGradientOverlayEnabled = false,
    top = "".concat(eyeBrowBarHeight, "px"),
    height = "calc(100vh - ".concat(eyeBrowBarHeight, "px)"),
    enhancedOverride,
    animationLabelCallback,
    percentage = 0.65,
    ...restProps
  } = _ref;
  const noExpand = !background;
  const {
    enhanced: enhancedContext
  } = useEnhancedContext();
  const enhanced = enhancedOverride !== null && enhancedOverride !== void 0 ? enhancedOverride : enhancedContext;
  const {
    skipIntro,
    setSkipIntro
  } = useIntroContext();
  const mainTimeline = useInstance(() => gsap.timeline({
    paused: true
  }));
  const introTimeline = useInstance(() => gsap.timeline());
  const logoTimeline = useInstance(() => gsap.timeline());
  const scrollTimeline = useInstance(() => gsap.timeline());
  const {
    labels,
    setScrollTrigger
  } = useGSAPLabels({
    stepPrefix: 'anim_step',
    animationName: 'intro_hero'
  });
  React.useEffect(() => {
    if (animationLabelCallback) animationLabelCallback(labels);
  }, [labels, animationLabelCallback]);
  const stickyContainerRef = useRef();
  const svg = useRef();
  const letterK1 = useRef();
  const letterL = useRef();
  const letterI = useRef();
  const letterC = useRef();
  const letterK2 = useRef();
  const dot = useRef();
  const subHead = useRef();
  const headlineRef = useRef();
  const scrollIndicatorRef = useRef();
  const sectionRef = useRef();
  const headingContainerSize = useResizeObserver(headlineRef.current);
  useIsomorphicLayoutEffect(() => {
    // SETUP LOGO INTRO ANIMATION
    if (skipIntro || !enhanced) return;
    if (window.scrollY > 0) {
      setSkipIntro(true);
      return;
    }
    let scrollTimeout;
    let handleScroll;
    let handleClick;
    let hasClicked = false;
    const animationRefs = {
      mainTimeline,
      introTimeline,
      scrollTimeline,
      logoTimeline,
      svg,
      letterK1,
      letterL,
      letterI,
      letterC,
      letterK2,
      dot,
      subHead,
      headlineRef,
      scrollIndicatorRef
    };
    mainTimeline.add(introTimeline, 0);
    mainTimeline.add(logoTimeline, 0);
    buildLogoAnimation(animationRefs);
    const currentRef = sectionRef.current;
    /* CB: Without the following line the accessibility modal scroll-lock interferes 
    with this scroll lock and we get permanantly scroll locked */
    document.body.removeAttribute('style');
    disableBodyScroll(currentRef);
    mainTimeline.play();
    handleClick = () => {
      hasClicked = true;
      window.removeEventListener('click', handleClick);
    };
    window.addEventListener('click', handleClick);
    logoTimeline.eventCallback('onComplete', () => {
      scrollTimeout = setTimeout(() => {
        if (window.scrollY === 0 && !hasClicked && !skipAutoScroll && !noExpand) {
          const totalHeight = stickyContainerRef.current.offsetHeight;
          const scrollTarget = totalHeight * percentage;
          gsap.to(window, {
            duration: 1,
            scrollTo: {
              y: scrollTarget
            }
          });
        }
        onIntroComplete && onIntroComplete();
        setSkipIntro(true);
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('click', handleClick);
      }, 1000);
      enableBodyScroll(currentRef);
    });
    return () => {
      enableBodyScroll(currentRef);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('click', handleClick);
      scrollTimeout && clearTimeout(scrollTimeout);
      removeLogoAnimation(animationRefs);
    };
  }, [enhanced, introTimeline, logoTimeline, mainTimeline, scrollTimeline, onIntroComplete, setSkipIntro, skipIntro, skipAutoScroll]);
  useIsomorphicLayoutEffect(() => {
    if (enhanced && skipIntro && !noExpand) {
      var _headlineRef$current;
      const headineContainer = (_headlineRef$current = headlineRef.current) === null || _headlineRef$current === void 0 || (_headlineRef$current = _headlineRef$current.parentNode) === null || _headlineRef$current === void 0 ? void 0 : _headlineRef$current.parentNode;
      if (headineContainer) {
        const scrollAmount = checkScrollAmount(headineContainer);
        if (scrollAmount > 0) {
          scrollTimeline.fromTo(headineContainer, {
            scrollTo: {
              y: 0
            },
            duration: 1
          }, {
            scrollTo: {
              y: scrollAmount
            },
            duration: 1
          }, 0);
        }
      }
    }
  }, [headingContainerSize]);
  useIsomorphicLayoutEffect(() => {
    // SET UP SCROLLABLE PORTION OF INTRO
    if (noExpand) {
      gsap.set(scrollIndicatorRef.current, {
        opacity: 1
      });
      return () => {
        gsap.set(scrollIndicatorRef.current, {
          clearProps: 'all'
        });
      };
    }
    if (enhanced && skipIntro && !noExpand) {
      scrollTimeline.fromTo([headlineRef.current, scrollIndicatorRef.current], {
        autoAlpha: 1
      }, {
        duration: 2,
        autoAlpha: 0
      }, 1).addLabel('anim_step1');
      const scrollTrigger = ScrollTrigger.create({
        trigger: stickyContainerRef.current,
        start: 'top top',
        end: 'bottom bottom',
        animation: scrollTimeline,
        scrub: true
      });
      setScrollTrigger(scrollTrigger);
      return () => {
        scrollTrigger && scrollTrigger.kill();
      };
    }
  }, [enhanced, skipIntro, scrollTimeline, setScrollTrigger]);
  return /*#__PURE__*/React.createElement(Section, _extends({
    ref: sectionRef
  }, restProps, {
    pt: 0,
    pb: 0
  }), /*#__PURE__*/React.createElement(StickyContainer, {
    enhanced: enhanced && !noExpand,
    ref: stickyContainerRef
  }, /*#__PURE__*/React.createElement(StickyElement, {
    top: top,
    heroHeight: height
  }, !!initialBackground && initialBackground, /*#__PURE__*/React.createElement(HeroContent, null, /*#__PURE__*/React.createElement(HeadlineContainer, null, /*#__PURE__*/React.createElement(HeadlineContent, null, /*#__PURE__*/React.createElement(Headline, {
    variant: "h1",
    ref: headlineRef,
    $skipIntro: skipIntro || !enhanced
  }, headline))), /*#__PURE__*/React.createElement(LogoContainer, {
    ref: svg
  }, /*#__PURE__*/React.createElement(LogoSVG, {
    shapeK1Ref: letterK1,
    shapeLRef: letterL,
    shapeIRef: letterI,
    shapeCRef: letterC,
    shapeK2Ref: letterK2,
    shapeDotRef: dot,
    shapeSubRef: subHead,
    overflow: "visible"
  })), enhanced ? /*#__PURE__*/React.createElement(IntroMask, {
    background: background,
    dot: dot,
    skipIntro: skipIntro,
    mainIntroTimeline: introTimeline,
    isGradientOverlayEnabled: isGradientOverlayEnabled,
    mainScrollTimeline: scrollTimeline
  }) : /*#__PURE__*/React.createElement(BrandDot, {
    isGradientOverlayEnabled: isGradientOverlayEnabled
  }), /*#__PURE__*/React.createElement(ScrollIndicatorContainer, {
    ref: scrollIndicatorRef
  }, /*#__PURE__*/React.createElement(ScrollIndicator, null))), !enhanced && background && /*#__PURE__*/React.createElement(BackgroundContent, null, background))));
};
const buildLogoAnimation = animationRefs => {
  const {
    logoTimeline,
    svg,
    letterK1,
    letterL,
    letterI,
    letterC,
    letterK2,
    dot,
    subHead,
    headlineRef,
    scrollIndicatorRef
  } = animationRefs;
  gsap.set(dot.current, {
    opacity: 0
  });
  gsap.set(svg.current, {
    opacity: 1
  });
  logoTimeline.fromTo([letterK1.current, letterL.current, letterI.current, letterC.current, letterK2.current], {
    opacity: 0
  }, {
    duration: 0.5,
    opacity: 1,
    ease: 'expo.inOut'
  }, 0);
  logoTimeline.from(letterK1.current, {
    duration: 0.5,
    y: -200
  }, 0);
  logoTimeline.from(letterL.current, {
    duration: 0.5,
    x: 50,
    y: -150
  }, 0);
  logoTimeline.from(letterI.current, {
    duration: 0.5,
    y: -100
  }, 0);
  logoTimeline.from(letterC.current, {
    duration: 0.5,
    rotation: 270,
    transformOrigin: '100% 0%'
  }, 0);
  logoTimeline.from(letterK2.current, {
    duration: 0.5,
    y: 200
  }, 0);
  logoTimeline.fromTo(subHead.current, {
    opacity: 0
  }, {
    duration: 1,
    opacity: 1,
    ease: 'expo.inOut'
  }, 0.3);
  const dotData = dot.current.getBoundingClientRect();
  const targetRadius = window.innerHeight * 0.75 / 2;
  const targetScale = targetRadius / (dotData.width / 2);
  logoTimeline.to(svg.current, {
    duration: 0.7,
    scale: targetScale,
    transformOrigin: '80% 50%',
    autoAlpha: 0,
    ease: ExpoScaleEase.config(1, targetScale, 'expo')
  }, 1.5);
  const titleLines = headlineRef.current.querySelectorAll(':scope > span');
  logoTimeline.fromTo(titleLines, {
    opacity: 0
  }, {
    duration: 0.5,
    stagger: 0.05,
    opacity: 1
  }, 1.8);
  logoTimeline.from(titleLines, {
    duration: 0.5,
    stagger: 0.1,
    y: '100%',
    rotationX: -80,
    ease: 'power2'
  }, 1.8);
  logoTimeline.fromTo(scrollIndicatorRef.current, {
    opacity: 0
  }, {
    duration: 0.5,
    opacity: 1
  }, 1.8);
};
const removeLogoAnimation = animationRefs => {
  const {
    mainTimeline,
    introTimeline,
    logoTimeline,
    svg,
    letterK1,
    letterL,
    letterI,
    letterC,
    letterK2,
    dot,
    subHead,
    headlineRef,
    scrollIndicatorRef
  } = animationRefs;
  logoTimeline.clear();
  mainTimeline.remove(introTimeline);
  mainTimeline.remove(logoTimeline);
  logoTimeline.clear();
  introTimeline.clear();
  mainTimeline.clear();
  const titleLines = headlineRef.current.querySelectorAll(':scope > span');
  gsap.set([svg.current, letterK1.current, letterL.current, letterI.current, letterC.current, letterK2.current, dot.current, subHead.current, headlineRef.current, scrollIndicatorRef.current, titleLines], {
    clearProps: 'all'
  });
};
const stickyLength = '2000px';
const stickyLengthSm = '4000px';
const StickyContainer = styled.div.withConfig({
  displayName: "HeroMaskIntro__StickyContainer",
  componentId: "sc-1t2ayvs-0"
})(["width:100%;height:", ";", ";", "{height:", ";}"], stickyLength, props => !props.enhanced && "\n      height: auto;\n\n      ".concat(StickyElement, " {\n        position: relative;\n        height: auto;\n        top: 0;\n      }\n\n      ").concat(HeroContent, " {\n        position: relative;\n        min-height: 100vh;\n        height: fit-content;\n      }\n\n      ").concat(BackgroundContent, " {\n        height: 100vh;\n        position: static;\n      }\n\n      ").concat(HeadlineContainer, " {\n        max-height: none;\n        min-height: 100vh;\n        height: fit-content;\n      }\n\n      ").concat(HeadlineContent, " {\n        min-height: 100vh;\n      }\n    "), match.isSM, _ref2 => {
  let {
    enhanced
  } = _ref2;
  return enhanced ? stickyLengthSm : 'auto';
});
const ScrollIndicatorContainer = styled.div.withConfig({
  displayName: "HeroMaskIntro__ScrollIndicatorContainer",
  componentId: "sc-1t2ayvs-1"
})(["position:absolute;z-index:3;bottom:90px;left:50%;transform:translate(-50%,0);opacity:0;", "{bottom:50px;}"], match.isMD);
const gradientStyles = css(["background:radial-gradient( circle,", ",", ",", ",", ",", " );background-size:1000% 1000%;"], brandColors.klick, brandColors.consulting, brandColors.klick, brandColors.appliedsciences, brandColors.klick);
const BrandDot = styled.div.withConfig({
  displayName: "HeroMaskIntro__BrandDot",
  componentId: "sc-1t2ayvs-2"
})(["position:absolute;background:", ";border-radius:50%;left:50%;top:50%;transform:translate(-50%,-50%);", " @media ", "{height:75vh;width:75vh;}@media ", "{height:75vw;width:75vw;}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
}, _ref4 => {
  let {
    isGradientOverlayEnabled
  } = _ref4;
  return isGradientOverlayEnabled ? gradientStyles : null;
}, match.isLandscape, match.isPortrait);
const StickyElement = styled.div.withConfig({
  displayName: "HeroMaskIntro__StickyElement",
  componentId: "sc-1t2ayvs-3"
})(["width:100%;height:", ";position:sticky;overflow:hidden;top:", ";"], _ref5 => {
  let {
    heroHeight
  } = _ref5;
  return heroHeight;
}, _ref6 => {
  let {
    top
  } = _ref6;
  return top;
});
const HeroContent = styled.div.withConfig({
  displayName: "HeroMaskIntro__HeroContent",
  componentId: "sc-1t2ayvs-4"
})(["height:100%;"]);
const BackgroundContent = styled.div.withConfig({
  displayName: "HeroMaskIntro__BackgroundContent",
  componentId: "sc-1t2ayvs-5"
})(["overflow:hidden;position:relative;height:100%;width:100%;"]);
const Headline = styled(Heading).withConfig({
  displayName: "HeroMaskIntro__Headline",
  componentId: "sc-1t2ayvs-6"
})(["width:100%;z-index:3;text-align:center;perspective:600px;margin:0;> span{display:block;opacity:", ";}"], _ref7 => {
  let {
    $skipIntro
  } = _ref7;
  return $skipIntro ? 1 : 0;
});
const LogoContainer = styled.div.withConfig({
  displayName: "HeroMaskIntro__LogoContainer",
  componentId: "sc-1t2ayvs-7"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:0;padding:0;z-index:3;max-width:100px;pointer-events:none;opacity:0;", "{max-width:150px;}", "{max-width:250px;}@media (orientation:landscape){height:50vh;width:auto;}@media (orientation:portrait){width:50vw;}"], match.isSM, match.isMD);
const LogoSVG = styled(KlickLogo).withConfig({
  displayName: "HeroMaskIntro__LogoSVG",
  componentId: "sc-1t2ayvs-8"
})(["margin:0;padding:0;width:100%;height:100%;transform:scale(1);"]);
const HeadlineContainer = styled.div.withConfig({
  displayName: "HeroMaskIntro__HeadlineContainer",
  componentId: "sc-1t2ayvs-9"
})(["height:100%;max-height:100%;-ms-overflow-style:none;scrollbar-width:none;overflow-y:scroll;pointer-events:none;&::-webkit-scrollbar{display:none;}"]);
const HeadlineContent = styled.div.withConfig({
  displayName: "HeroMaskIntro__HeadlineContent",
  componentId: "sc-1t2ayvs-10"
})(["min-height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;padding-top:10vh;padding-bottom:10vh;"]);
const InView = _ref => {
  let {
    rootMargin = '500px 0px',
    threshold = 0,
    ...rest
  } = _ref;
  const [inViewRef, isInView] = useInView({
    threshold,
    rootMargin
  });
  return /*#__PURE__*/React.createElement(InViewContext.Provider, {
    value: {
      isInView: isInView
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: inViewRef
  }, rest)));
};
const InViewContext = /*#__PURE__*/React.createContext();
const useInViewContext = () => {
  const context = React.useContext(InViewContext);
  if (context === undefined) {
    throw new Error('useInViewContext must be used within InViewProvider');
  }
  return context;
};
gsap.registerPlugin(ExpoScaleEase);
const LogoCarousel = _ref => {
  let {
    children,
    columnNum = 6
  } = _ref;
  const columns = chunkToColumns(children, columnNum);
  let columnRefs = useInstance(() => new Array(columnNum));
  const columnJSX = columns.map((column, i) => {
    if (!columnRefs[i]) columnRefs[i] = [];
    const logos = [...column, column[0]].map((logo, ii) => {
      const ref = /*#__PURE__*/React.createRef();
      columnRefs[i][ii] = ref;
      return /*#__PURE__*/React.createElement(LogoWrapper, {
        key: ii,
        ref: ref
      }, logo);
    });
    return /*#__PURE__*/React.createElement(Column, {
      key: i
    }, logos);
  });
  useIsomorphicLayoutEffect(() => {
    const timelines = [];
    columnRefs.forEach(column => {
      const timeline = gsap.timeline({
        paused: true,
        repeat: -1
      });
      const logos = column.map(logo => logo.current);
      logos.forEach((logo, i) => {
        if (i) {
          timeline.fromTo(logo, {
            opacity: 0,
            rotationX: -80,
            yPercent: 50
          }, {
            duration: 0.5,
            opacity: 1,
            rotationX: 0,
            yPercent: 0,
            ease: 'power2'
          }, i === 0 ? 0 : '<');
          timeline.addPause();
        }
        if (i !== logos.length - 1) {
          timeline.to(logos, {
            duration: 0.5,
            opacity: 0,
            rotationX: 80,
            yPercent: -50,
            ease: 'power2'
          }, '+=1');
        }
      });
      timelines.push(timeline);
    });
    let interval = setInterval(() => {
      const randomTlIndex = randomIntFromInterval(0, timelines.length - 1);
      timelines[randomTlIndex].play();
    }, 3000);
    return () => {
      timelines.forEach(timeline => {
        timeline.clear();
      });
      clearInterval(interval);
    };
  }, [columnRefs]);
  return /*#__PURE__*/React.createElement(LogoCarouselContainer, null, columnJSX);
};
function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
const chunkToColumns = function (array) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (size !== 1) size = Math.ceil(parseInt(size, 10));
  const length = array == null ? 0 : array.length;
  if (!length) return [];
  let result = Array(size);
  let i = 0;
  array.forEach(item => {
    if (!result[i]) result[i] = [];
    result[i].push(item);
    i = i === size - 1 ? 0 : i + 1;
  });
  return result;
};
const LogoCarouselContainer = styled.ul.withConfig({
  displayName: "LogoCarousel__LogoCarouselContainer",
  componentId: "sc-16w8t1s-0"
})(["padding:0;margin:0;display:flex;flex-wrap:wrap;justify-content:center;list-style-type:none;"]);
const LogoWrapper = styled.div.withConfig({
  displayName: "LogoCarousel__LogoWrapper",
  componentId: "sc-16w8t1s-1"
})(["position:relative;width:100%;& > *{width:100%;}&:not(:first-child){position:absolute;top:0;left:50%;transform:translateX(-50%);}"]);
const Column = styled.li.withConfig({
  displayName: "LogoCarousel__Column",
  componentId: "sc-16w8t1s-2"
})(["position:relative;width:50%;", "{width:25%;}", "{width:16.6666%;}"], match.isSM, match.isMD);
const LazyLoad = _ref => {
  let {
    children,
    rootMargin = '500px 0px',
    threshold = 0,
    triggerOnce = true,
    ...rest
  } = _ref;
  const [inViewRef, isInViewLoad] = useInView({
    threshold,
    rootMargin,
    triggerOnce
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: inViewRef
  }, rest), isInViewLoad && children);
};
const HamburgerNav = _ref => {
  let {
    links,
    ...rest
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles$1({
    isOpen
  });
  const toggleNav = () => {
    setIsOpen(!isOpen);
  };
  const removeHiddenLinks = _ref2 => {
    let {
      hideFromHamburger
    } = _ref2;
    return !hideFromHamburger;
  };
  const linkHTML = links.filter(removeHiddenLinks).map((_ref3, index) => {
    let {
      hash,
      label,
      to,
      href,
      type,
      onClick
    } = _ref3;
    const props = {};
    if (href || to) {
      props.href = href || to;
      props.component = Link;
    }
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(Button$1, _extends({
      className: classes.menuListItem,
      onClick: onClick || toggleNav,
      disableRipple: true,
      role: type || 'link'
    }, props), label));
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.root
  }, rest), /*#__PURE__*/React.createElement(IconButton, {
    className: classes.hamburger,
    onClick: toggleNav,
    "aria-expanded": isOpen,
    "aria-label": "Main Menu",
    "aria-haspopup": "menu"
  }, /*#__PURE__*/React.createElement(Menu, null)), /*#__PURE__*/React.createElement(Modal, {
    open: isOpen,
    "aria-label": "Mobile Menu"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onPrimary"
  }, /*#__PURE__*/React.createElement(Container$4, {
    className: classes.menu
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    pt: 2
  }, /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/",
    "aria-label": "Homepage"
  }, /*#__PURE__*/React.createElement(KlickLogo, {
    className: classes.logo,
    orientation: "landscape"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.grow
  }), /*#__PURE__*/React.createElement(IconButton, {
    className: classes.hamburger,
    onClick: toggleNav,
    "aria-label": "Close Menu",
    "aria-expanded": isOpen
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1,
    pt: 3,
    pb: 15
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Main",
    role: "navigation"
  }, /*#__PURE__*/React.createElement("ul", {
    className: classes.menuList
  }, linkHTML)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SocialButtons, {
    className: classes.social,
    color: "secondary",
    groupLabel: false,
    location_id: "hamburger",
    noMargin: true
  }), /*#__PURE__*/React.createElement(Copyright, null)))))))));
};
const useStyles$1 = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  hamburger: {
    zIndex: '1500',
    backgroundColor: _ref4 => {
      let {
        isOpen
      } = _ref4;
      return isOpen ? darken$1(theme.palette.primary.main, 0.2) : 'unset';
    },
    '&:hover': {
      backgroundColor: _ref5 => {
        let {
          isOpen
        } = _ref5;
        return !isOpen ? theme.palette.primary.main : darken$1(theme.palette.primary.main, 0.5);
      }
    }
  },
  menu: {
    position: 'fixed',
    zIndex: '1500',
    top: '0',
    left: '0',
    maxWidth: 'none',
    height: '100vh',
    overflowY: 'auto',
    display: _ref6 => {
      let {
        isOpen
      } = _ref6;
      return isOpen ? 'block' : 'none';
    },
    background: theme.palette.primary.main,
    transform: _ref7 => {
      let {
        isOpen
      } = _ref7;
      return isOpen ? 'translate(0, 0)' : 'translate(100%, 0)';
    }
  },
  menuList: {
    padding: '0',
    margin: '0',
    listStyleType: 'none'
  },
  menuListItem: {
    width: '100%',
    textAlign: 'left',
    fontSize: '1.6rem',
    fontWeight: 'normal',
    display: 'block',
    '&.Mui-focusVisible': {
      background: 'rgba(255,255,255,0.16)'
    }
  },
  social: {
    marginBottom: "".concat(theme.spacing(3), "px")
  },
  logo: {
    height: '50px',
    [theme.breakpoints.up('md')]: {
      margin: "".concat(theme.spacing(1), "px 0"),
      height: '58px'
    }
  }
}));
const BaseMainNavBar = _ref => {
  let {
    defaultTheme,
    location,
    pathThemes,
    links,
    logoBrandName,
    nonMenuItems,
    className,
    hamburgerBreakpoint: _hamburgerBreakpoint = 'MD',
    logoOverride,
    logoUrlOverride
  } = _ref;
  const intersectionRef = useRef();
  const appBarRef = useRef();
  const appBarSize = useResizeObserver(appBarRef.current);
  const [height, setHeight] = useState(0);
  const [setNode, entry] = useIntersect({
    rootMargin: '0px 0px 0px'
  });
  const hamburgerBreakpoint = _hamburgerBreakpoint.toUpperCase();
  useEffect(() => {
    setNode(intersectionRef.current);
  }, [setNode]);
  useEffect(() => {
    if (!appBarRef.current) return;
    const {
      height
    } = appBarRef.current.getBoundingClientRect();
    document.documentElement.style.scrollPaddingTop = height + 16 + 'px';
    setHeight(height);
  }, [appBarSize, appBarRef]);
  const isSticky = !!entry.boundingClientRect && entry.boundingClientRect.top <= 0 && !entry.isIntersecting;
  const isSingleButton = links.length === 1;
  const pathTheme = getPathTheme(location.pathname, pathThemes);
  const currentTheme = isSticky ? 'onBlack' : pathTheme.type || defaultTheme;
  const initBgFade = pathTheme.initBgFade;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: currentTheme
  }, /*#__PURE__*/React.createElement("div", {
    ref: intersectionRef
  }), /*#__PURE__*/React.createElement(StyledAppBar, {
    ref: appBarRef,
    elevation: 0,
    position: "sticky",
    component: "nav",
    "aria-label": "Main Navigation Bar",
    $isSticky: isSticky,
    $initBgFade: initBgFade,
    className: isSticky ? "".concat(className, " isMainNavSticky") : className,
    $height: height
  }, /*#__PURE__*/React.createElement(BaseMainNavBarContent, {
    isSingleButton: isSingleButton,
    location: location,
    links: links,
    logoBrandName: logoBrandName,
    hamburgerBreakpoint: hamburgerBreakpoint,
    nonMenuItems: nonMenuItems,
    logoOverride: logoOverride,
    logoUrlOverride: logoUrlOverride
  })));
};
const MainNavBarButtons = _ref2 => {
  let {
    links,
    className = '',
    location,
    isSingleButton,
    hamburgerBreakpoint
  } = _ref2;
  return /*#__PURE__*/React.createElement(MenuNav, {
    "aria-label": "Main",
    role: "navigation",
    className: className
  }, /*#__PURE__*/React.createElement(MainNavBarButtonsList, null, links.map((link, index) => {
    if (link.type === 'custom') return /*#__PURE__*/React.createElement(ButtonListItem, {
      $showBreakpointOverride: link.showBreakpointOverride,
      $hamburgerBreakpoint: hamburgerBreakpoint,
      $isSingleButton: isSingleButton,
      key: index
    }, link.content);
    const isButton = link.type === 'button';
    const isCurrentPage = getIsCurrentPage({
      link,
      location
    });
    return /*#__PURE__*/React.createElement(ButtonListItem, {
      $showBreakpointOverride: link.showBreakpointOverride,
      $hamburgerBreakpoint: hamburgerBreakpoint,
      $isSingleButton: isSingleButton,
      key: index
    }, /*#__PURE__*/React.createElement(StyledButton, _extends({
      component: link.component || Link,
      size: "large",
      variant: isButton ? 'contained' : 'text',
      color: isButton ? 'primary' : 'default',
      href: link.href || link.to,
      disableElevation: isButton,
      $isCurrentPage: isCurrentPage,
      $isSingleButton: isSingleButton,
      trackId: "main_navbar_".concat(link.label),
      onClick: e => {
        var _link$props, _link$props$onClick;
        (_link$props = link.props) === null || _link$props === void 0 || (_link$props$onClick = _link$props.onClick) === null || _link$props$onClick === void 0 || _link$props$onClick.call(_link$props, e);
      },
      "aria-current": isCurrentPage ? 'page' : undefined
    }, link.props), link.label));
  })));
};
const BaseMainNavBarContent = /*#__PURE__*/React.memo(_ref3 => {
  let {
    links,
    isSingleButton,
    location,
    logoBrandName,
    nonMenuItems,
    hamburgerBreakpoint,
    logoOverride,
    logoUrlOverride
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container$4, null, /*#__PURE__*/React.createElement(Toolbar, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement(Link, {
    href: logoUrlOverride || '/',
    "aria-label": "Homepage",
    trackId: "main_nav_bar_logo"
  }, logoOverride ? logoOverride : /*#__PURE__*/React.createElement(StyledKlickLogo$1, {
    orientation: "landscape",
    brandName: logoBrandName
  })), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }), (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/React.createElement(MainNavBarButtons, {
    isSingleButton: isSingleButton,
    hamburgerBreakpoint: hamburgerBreakpoint,
    links: links,
    location: location
  }), (nonMenuItems === null || nonMenuItems === void 0 ? void 0 : nonMenuItems.length) > 0 && nonMenuItems, links.length > 0 && /*#__PURE__*/React.createElement(StyledHamburgerNav, {
    $hamburgerBreakpoint: hamburgerBreakpoint,
    links: links,
    $isSingleButton: isSingleButton
  })));
});
const normalPathname = pathname => pathname === '/' ? pathname : pathname === null || pathname === void 0 ? void 0 : pathname.replace(/\/$/, '');
const getPathTheme = (pathname, pathThemes) => {
  const themeKey = Object.keys(pathThemes).find(key => {
    const npath = normalPathname(pathname);
    return npath === key || (npath === null || npath === void 0 ? void 0 : npath.indexOf(key)) === 0 && key !== '/';
  });
  return themeKey ? pathThemes[themeKey] : false;
};
function getIsCurrentPage(_ref4) {
  var _location$pathname;
  let {
    link,
    location
  } = _ref4;
  const url = link.href || link.to;
  if (!url) return;
  return url.replace(/\//g, '') === ((_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.replace(/\//g, ''));
}
const StyledAppBar = styled(AppBar).withConfig({
  displayName: "MainNavBar__StyledAppBar",
  componentId: "sc-1s23qmp-0"
})(["background-color:", ";transition:background-color 0.5s ease-in;margin-bottom:", ";position:relative;position:sticky;"], _ref5 => {
  let {
    $isSticky,
    $initBgFade,
    $height,
    theme
  } = _ref5;
  return $isSticky || $height > 120 ? '#000' : $initBgFade ? alpha(theme.palette.background.default, $initBgFade) : 'transparent';
}, _ref6 => {
  let {
    $height
  } = _ref6;
  return "-".concat($height, "px");
});
const MenuNav = styled.nav.withConfig({
  displayName: "MainNavBar__MenuNav",
  componentId: "sc-1s23qmp-1"
})([""]);
const MainNavBarButtonsList = styled.ul.withConfig({
  displayName: "MainNavBar__MainNavBarButtonsList",
  componentId: "sc-1s23qmp-2"
})(["display:flex;flex-direction:row;align-items:center;list-style-type:none;margin:0;padding:0;"]);
const ButtonListItem = styled.li.withConfig({
  displayName: "MainNavBar__ButtonListItem",
  componentId: "sc-1s23qmp-3"
})(["margin:", ";&:last-of-type{margin:0;}", ""], _ref7 => {
  let {
    theme
  } = _ref7;
  return "0 ".concat(theme.spacing(3), "px 0 0");
}, _ref8 => {
  let {
    $hamburgerBreakpoint,
    $isSingleButton,
    $showBreakpointOverride
  } = _ref8;
  const showBreakpoint = ($showBreakpointOverride === null || $showBreakpointOverride === void 0 ? void 0 : $showBreakpointOverride.toUpperCase()) || $hamburgerBreakpoint;
  return css(["display:", ";", "{display:inline-block;}"], $isSingleButton || showBreakpoint === 'XS' ? 'inline-block' : 'none', match["is".concat(showBreakpoint)]);
});
const StyledButton = styled(Button).withConfig({
  displayName: "MainNavBar__StyledButton",
  componentId: "sc-1s23qmp-4"
})(["", " &.MuiButton-sizeLarge,&[class*='MuiButton-sizeLarge-']{", "}"], _ref9 => {
  let {
    theme,
    variant,
    $isCurrentPage
  } = _ref9;
  return $isCurrentPage && variant === 'text' && "border-bottom: 3px solid ".concat(theme.palette.text.primary, ";");
}, _ref10 => {
  let {
    $isSingleButton
  } = _ref10;
  return $isSingleButton && "padding: 16px 24px;";
});
const StyledHamburgerNav = styled(HamburgerNav).withConfig({
  displayName: "MainNavBar__StyledHamburgerNav",
  componentId: "sc-1s23qmp-5"
})(["", "{margin-left:24px;}display:", ";", ""], match.isSM, _ref11 => {
  let {
    $isSingleButton,
    $hamburgerBreakpoint
  } = _ref11;
  return $isSingleButton ? 'none' : 'flex';
}, _ref12 => {
  let {
    $hamburgerBreakpoint
  } = _ref12;
  return css(["", "{display:none;}"], match["is".concat($hamburgerBreakpoint)]);
});
const StyledKlickLogo$1 = styled(KlickLogo).withConfig({
  displayName: "MainNavBar__StyledKlickLogo",
  componentId: "sc-1s23qmp-6"
})(["height:40px;", "{margin:", ";height:58px;}"], match.isLG, _ref13 => {
  let {
    theme
  } = _ref13;
  return "".concat(theme.spacing(1), "px 0");
});
const MainNavBar = _ref14 => {
  let {
    ...props
  } = _ref14;
  return /*#__PURE__*/React.createElement(Location, null, _ref15 => {
    let {
      location
    } = _ref15;
    return /*#__PURE__*/React.createElement(BaseMainNavBar, _extends({
      location: location
    }, props));
  });
};
MainNavBar.defaultProps = {
  pathThemes: [],
  defaultTheme: 'onWhite',
  links: [{
    label: 'Get in touch',
    to: '/contact',
    type: 'button'
  }]
};
const Page404 = _ref => {
  let {
    bodyTextOverride
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onWhite"
  }, /*#__PURE__*/React.createElement(ErrorContainer, null, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(StyledHeading, {
    variant: "h1"
  }, "4", /*#__PURE__*/React.createElement("span", null, "0"), "4"), /*#__PURE__*/React.createElement(Circle$1, null), /*#__PURE__*/React.createElement(Copy, {
    variant: "blurb1"
  }, bodyTextOverride ? bodyTextOverride : /*#__PURE__*/React.createElement(React.Fragment, null, "There\u2019s nothing different here. ", /*#__PURE__*/React.createElement("br", null), "Get back to something ", /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, "different"), ".")))));
};
const ErrorContainer = styled(Section).withConfig({
  displayName: "Page404__ErrorContainer",
  componentId: "sc-1lh7pik-0"
})(["position:relative;margin:0;padding:0;width:100%;height:100vh;"]);
const ErrorContent = styled.div.withConfig({
  displayName: "Page404__ErrorContent",
  componentId: "sc-1lh7pik-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:0;padding:0;width:80%;text-align:center;a{color:", ";text-decoration:underline;}"], props => props.theme.palette.primary.main);
const StyledHeading = styled(Heading).withConfig({
  displayName: "Page404__StyledHeading",
  componentId: "sc-1lh7pik-2"
})(["margin:0 0 50px 0;position:relative;z-index:2;padding:0;font-size:38vw;", "{font-size:18vw;}", "{font-size:18vw;}> span{visibility:hidden;}"], match.isSM, match.isXL);
const Copy = styled(P).withConfig({
  displayName: "Page404__Copy",
  componentId: "sc-1lh7pik-3"
})(["margin:0;padding:0;", "{br{display:none;}}"], match.isSM);
const Circle$1 = styled.div.withConfig({
  displayName: "Page404__Circle",
  componentId: "sc-1lh7pik-4"
})(["position:absolute;top:0;left:50%;transform:translate(-50%,0%);display:block;margin:0 10px;padding:0;width:40vw;height:40vw;border-radius:50%;background-color:", ";", "{margin:0 20px;width:20vw;height:20vw;max-width:288px;max-height:288px;}"], props => props.theme.palette.primary.main, match.isSM);
const portraitMedia = "".concat(match.getQuery('isPortrait'), " and ").concat(match.getQuery('isSM'));
gsap.registerPlugin(ExpoScaleEase);
const Person = /*#__PURE__*/forwardRef((props, personRef) => {
  const {
    firstName,
    lastName,
    title,
    bio,
    designation,
    id,
    headshot,
    portrait,
    landscape,
    imagetype,
    listImageTransform,
    modalStyles
  } = props;
  const [isOpen, setIsOpen] = useState();
  const imageContainerRef = useRef();
  const closeBtnRef = useRef();
  const bioContentRef = useRef();
  const bioNameRef = useRef();
  const bioTitleRef = useRef();
  const bioCopyRef = useRef();
  const headshotRef = useRef();
  const headshotContainerRef = useRef();
  const circleCloneRef = useRef();
  const personContentRef = useRef();
  const timeline = useInstance(() => gsap.timeline({
    paused: true,
    onStart: function () {
      tracking.track({
        event: 'modal_open',
        eventModel: {
          modal_id: "bio_view_".concat(firstName, "_").concat(lastName)
        }
      });
    },
    onComplete: function () {
      ScrollTrigger.getAll().forEach(scrollTrigger => {
        scrollTrigger.disable();
      });
      disableBodyScroll(personContentRef.current);
    },
    onReverseComplete: function () {
      this.pause(0).clear();
      setIsOpen(false);
    }
  }));
  const sources = withArtDirection(landscape, [{
    media: portraitMedia,
    image: portrait
  }]);
  const handleClick = () => {
    if (isOpen) {
      enableBodyScroll(personContentRef.current);
      ScrollTrigger.getAll().forEach(scrollTrigger => {
        scrollTrigger.enable();
      });
      timeline.reverse();
    } else {
      setIsOpen(true);
    }
  };
  useIsomorphicLayoutEffect(() => {
    if (isOpen) {
      animate({
        headshotRef,
        headshotContainerRef,
        circleCloneRef,
        imageContainerRef,
        bioContentRef,
        bioNameRef,
        bioTitleRef,
        bioCopyRef,
        closeBtnRef,
        timeline
      });
      return () => {
        clearAllBodyScrollLocks();
      };
    }
  }, [isOpen, headshotRef, headshotContainerRef, circleCloneRef, imageContainerRef, bioContentRef, bioNameRef, bioTitleRef, bioCopyRef, closeBtnRef, timeline]);
  return /*#__PURE__*/React.createElement(PersonContainer, {
    ref: personRef,
    id: id
  }, /*#__PURE__*/React.createElement(HeadshotContainer, {
    imagetype: imagetype,
    ref: headshotContainerRef
  }, /*#__PURE__*/React.createElement("div", {
    ref: headshotRef
  }, /*#__PURE__*/React.createElement(Headshot, {
    $listImageTransform: listImageTransform,
    $imagetype: imagetype,
    image: headshot,
    alt: designation ? "".concat(firstName, " ").concat(lastName, ", ").concat(designation, ", ").concat(title) : "".concat(firstName, " ").concat(lastName, ", ").concat(title)
  }))), /*#__PURE__*/React.createElement(HeadshotButton, {
    "aria-label": "Headshot of ".concat(firstName, " ").concat(lastName),
    onClick: () => {
      handleClick();
    }
  }), isOpen && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onPrimary"
  }, /*#__PURE__*/React.createElement(TrapFocus, {
    open: isOpen
  }, /*#__PURE__*/React.createElement(PortalContainer, {
    tabIndex: -1,
    style: modalStyles
  }, /*#__PURE__*/React.createElement(CircleClone, {
    ref: circleCloneRef
  }), /*#__PURE__*/React.createElement(PersonContentContainer, null, /*#__PURE__*/React.createElement(HeaderGutter, null, /*#__PURE__*/React.createElement(CloseBtn, {
    onClick: handleClick,
    ref: closeBtnRef
  }, "Close")), /*#__PURE__*/React.createElement(PersonContent, {
    ref: personContentRef,
    imagetype: imagetype
  }, /*#__PURE__*/React.createElement(StyledGutter, {
    $imagetype: imagetype
  }, /*#__PURE__*/React.createElement(ImageContainer$1, {
    imagetype: imagetype,
    ref: imageContainerRef
  }, /*#__PURE__*/React.createElement("img", {
    className: "landscape",
    src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    className: "portrait",
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAQAAAAEnG+bAAAAD0lEQVR42mNkQAGMQ4ELAAVGAA1+PhR8AAAAAElFTkSuQmCC",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedHeadShot, {
    image: sources,
    $listImageTransform: listImageTransform,
    $imagetype: imagetype,
    alt: designation ? "".concat(firstName, " ").concat(lastName, ", ").concat(designation, ", ").concat(title) : "".concat(firstName, " ").concat(lastName, ", ").concat(title)
  }))), /*#__PURE__*/React.createElement(BioContent, {
    ref: bioContentRef
  }, /*#__PURE__*/React.createElement(BioContentInner, {
    imagetype: imagetype
  }, /*#__PURE__*/React.createElement("div", {
    ref: bioNameRef
  }, /*#__PURE__*/React.createElement(Name, {
    variant: "h2"
  }, firstName, ' ', /*#__PURE__*/React.createElement(AvoidWrap, null, lastName, designation && /*#__PURE__*/React.createElement(React.Fragment, null, ", ", /*#__PURE__*/React.createElement(NoWrap, null, designation))))), /*#__PURE__*/React.createElement(JobTitle, {
    paragraph: false,
    ref: bioTitleRef
  }, title), /*#__PURE__*/React.createElement(BioCopy, {
    ref: bioCopyRef
  }, bio)))))))))));
});
const animate = _ref => {
  let {
    headshotRef,
    headshotContainerRef,
    circleCloneRef,
    imageContainerRef,
    bioContentRef,
    bioNameRef,
    bioTitleRef,
    bioCopyRef,
    closeBtnRef,
    timeline
  } = _ref;
  const targetRect = headshotRef.current.getBoundingClientRect();
  const winWidth = window.innerWidth;
  const winHeight = window.innerHeight;
  const {
    x,
    y,
    width,
    height
  } = targetRect;
  const diameter = calcPageFillRadius(x + width * 0.5, y + height * 0.5, winWidth, winHeight) * 2;
  const scale = diameter / Math.min(height, width);
  timeline.set(circleCloneRef.current, {
    opacity: 0
  }).to(headshotRef.current, {
    duration: 0.3,
    opacity: 0
  }).set(circleCloneRef.current, {
    opacity: 1
  }).fromTo(circleCloneRef.current, {
    x,
    y,
    width,
    height
  }, {
    scale,
    duration: 0.3,
    ease: ExpoScaleEase.config(1, scale)
  }).fromTo(imageContainerRef.current, {
    x: '-70%',
    opacity: 0
  }, {
    duration: 0.4,
    x: '-50%',
    opacity: 1
  }, 0.8).from([bioNameRef.current, bioTitleRef.current, bioCopyRef.current], {
    duration: 0.4,
    stagger: 0.15,
    opacity: 0,
    x: '+=50px',
    ease: 'power2'
  }, 0.8).from(closeBtnRef.current, {
    opacity: 0,
    y: '-=50px',
    duration: 0.4,
    ease: 'power2'
  }, 0.8).play();
};
const PersonContainer = styled.div.withConfig({
  displayName: "Person__PersonContainer",
  componentId: "sc-uy633y-0"
})(["position:relative;width:100%;height:100%;"]);
const PortalContainer = styled.div.withConfig({
  displayName: "Person__PortalContainer",
  componentId: "sc-uy633y-1"
})(["position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;"]);
const CircleClone = styled.div.withConfig({
  displayName: "Person__CircleClone",
  componentId: "sc-uy633y-2"
})(["position:absolute;opacity:0;background:", ";border-radius:100%;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return "".concat(theme.palette.background.default);
});
const BioCopy = styled.div.withConfig({
  displayName: "Person__BioCopy",
  componentId: "sc-uy633y-3"
})(["padding:0 0 100px 0;", "{padding:0 0 100px 0;}", "{padding:0 0 100px 0;}", "{padding:0 6vw 100px 0;}"], match.isSM, match.isMD, match.isLG);
const CloseBtn = styled.button.withConfig({
  displayName: "Person__CloseBtn",
  componentId: "sc-uy633y-4"
})(["height:55px;width:55px;border-radius:50%;background:", ";position:relative;color:transparent;position:absolute;top:15px;right:15px;border:0;z-index:3;", "{top:42px;right:42px;}&:before,&:after{content:'';position:absolute;left:50%;width:20px;height:2px;background:", ";}&:before{transform:translate(-52%,6px) rotate(-45deg);}&:after{transform:translate(-52%,6px) rotate(45deg);}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.secondary.main;
}, match.isSM, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.primary.main;
});
const HeadshotContainer = styled.div.withConfig({
  displayName: "Person__HeadshotContainer",
  componentId: "sc-uy633y-5"
})(["position:relative;background:", ";border-radius:50%;border:none;padding:0;width:100%;height:100%;display:block;overflow:hidden;transform:translate(0,0);font-size:0;cursor:pointer;"], _ref5 => {
  let {
    theme,
    imagetype
  } = _ref5;
  return imagetype === 'full' ? theme.palette.primary.main : 'none';
});
const HeadshotButton = styled.button.withConfig({
  displayName: "Person__HeadshotButton",
  componentId: "sc-uy633y-6"
})(["position:absolute;top:0px;left:0px;width:100%;height:100%;color:white;font-size:1rem;line-height:1.2;white-space:nowrap;text-decoration:none;cursor:pointer;background:transparent;border:none;"]);
const PersonContentContainer = styled.div.withConfig({
  displayName: "Person__PersonContentContainer",
  componentId: "sc-uy633y-7"
})(["height:100%;width:100%;position:fixed;top:0;left:0;z-index:100;overflow:hidden;"]);
const personContentStylesRound = css(["", "{margin-top:13vh;}"], match.isMD);
const personContentStylesFull = css(["", "{height:auto;padding-top:0;overflow:hidden;}"], match.isSM);
const PersonContent = styled.div.withConfig({
  displayName: "Person__PersonContent",
  componentId: "sc-uy633y-8"
})(["height:100%;padding-top:60px;overflow-y:auto;overflow-x:hidden;", ""], _ref6 => {
  let {
    imagetype
  } = _ref6;
  switch (imagetype) {
    case 'round':
      {
        return personContentStylesRound;
      }
    case 'full':
    default:
      {
        return personContentStylesFull;
      }
  }
});
const BioContent = styled.div.withConfig({
  displayName: "Person__BioContent",
  componentId: "sc-uy633y-9"
})(["", "{width:100%;height:100%;overflow-y:auto;overflow-x:hidden;position:relative;z-index:2;}"], match.isSM);
const bioContentInnerRound = css(["margin-top:25px;", "{margin-top:0;padding-left:50%;}"], match.isMD);
const bioContentInnerFull = css(["margin-top:25px;", "{margin-top:0;padding:13vh 8% 0 50%;}", "{padding-left:50%;}", "{padding-left:50%;}"], match.isSM, match.isMD, match.isLG);
const BioContentInner = styled.div.withConfig({
  displayName: "Person__BioContentInner",
  componentId: "sc-uy633y-10"
})(["", ""], _ref7 => {
  let {
    imagetype
  } = _ref7;
  switch (imagetype) {
    case 'round':
      {
        return bioContentInnerRound;
      }
    case 'full':
    default:
      {
        return bioContentInnerFull;
      }
  }
});
const imageContainerStylesFull = css(["background:", ";@media ", "{& > img{display:block;height:100%;&.landscape{display:none;}}}", "{position:absolute;left:26%;bottom:0;border-radius:0%;background:none;width:auto;height:95vh;z-index:1;pointer-events:none;& > img{display:block;height:100%;&.portait{display:none;}}& > div{position:absolute;bottom:0;left:0;width:100%;height:100%;}}"], _ref8 => {
  let {
    theme
  } = _ref8;
  return "".concat(theme.palette.primary.main);
}, portraitMedia, match.isSM);
const imageContainerStylesRound = css(["& > img{&.landscape{display:none;}&.portrait{display:none;}}", "{position:absolute;width:350px;height:350px;left:26%;top:0;pointer-events:none;z-index:1;}", "{width:550px;height:550px;}"], match.isMD, match.isLG);
const ImageContainer$1 = styled.div.withConfig({
  displayName: "Person__ImageContainer",
  componentId: "sc-uy633y-11"
})(["text-align:center;position:relative;margin-top:60px;width:250px;height:250px;border-radius:50%;overflow:hidden;margin:0;left:50%;", ""], _ref9 => {
  let {
    imagetype
  } = _ref9;
  switch (imagetype) {
    case 'round':
      {
        return imageContainerStylesRound;
      }
    case 'full':
    default:
      {
        return imageContainerStylesFull;
      }
  }
});
const headShotStylesFull = css(["bottom:-6px;height:95%;", "{bottom:0;height:100%;left:auto;right:50%;transform:", ";border-radius:0;}@media ", "{transform:translate(44%,0);}", "{height:100%;transform:", ";}"], match.isSM, props => props.override ? "translate(".concat(props.override, ", 0)") : "translate(37%, 0)", portraitMedia, match.isMD, props => props.override ? "translate(".concat(props.override, ", 0)") : "translate(49%, 0)");
const ExpandedHeadShot = styled(GatsbyImage).withConfig({
  displayName: "Person__ExpandedHeadShot",
  componentId: "sc-uy633y-12"
})(["overflow:hidden;transform:", ";", ""], _ref10 => {
  let {
    $listImageTransform
  } = _ref10;
  return $listImageTransform ? $listImageTransform : '';
}, _ref11 => {
  let {
    $imagetype
  } = _ref11;
  switch ($imagetype) {
    case 'round':
      {
        return "";
      }
    case 'full':
    default:
      {
        return headShotStylesFull;
      }
  }
});
const HeaderGutter = styled(Container$4).withConfig({
  displayName: "Person__HeaderGutter",
  componentId: "sc-uy633y-13"
})(["position:relative;z-index:3;"]);
const StyledGutter = styled(Container$4).withConfig({
  displayName: "Person__StyledGutter",
  componentId: "sc-uy633y-14"
})(["", ";position:relative;z-index:2;", "{max-width:none;}"], _ref12 => {
  let {
    $imagetype
  } = _ref12;
  return $imagetype === 'full' && "height: 100vh";
}, match.isSM);
const Name = styled(Heading).withConfig({
  displayName: "Person__Name",
  componentId: "sc-uy633y-15"
})(["margin:0;"]);
const JobTitle = styled(P).withConfig({
  displayName: "Person__JobTitle",
  componentId: "sc-uy633y-16"
})(["position:relative;padding-bottom:1.5em;margin-bottom:1.5em;&:after{content:' ';border-bottom:1px black solid;width:70px;height:3px;position:absolute;bottom:0;left:0;}"]);
const Headshot = styled(GatsbyImage).withConfig({
  displayName: "Person__Headshot",
  componentId: "sc-uy633y-17"
})(["max-width:100%;max-height:", ";transform:", ";"], _ref13 => {
  let {
    $imagetype
  } = _ref13;
  return $imagetype === 'full' ? "95%" : "100%";
}, _ref14 => {
  let {
    $listImageTransform
  } = _ref14;
  return $listImageTransform ? $listImageTransform : '';
});
const People = _ref => {
  let {
    peopleData,
    peopleImages,
    imagetype = 'full',
    shouldShowNamesInListView = false,
    dotRefs,
    modalStyles
  } = _ref;
  const headshots = reduceImages(peopleImages.headshot.edges);
  const portraits = reduceImages(peopleImages.portrait.edges);
  const landscapes = reduceImages(peopleImages.landscape.edges);
  const PeopleHtml = peopleData.map((data, index) => {
    return /*#__PURE__*/React.createElement(PeopleListItem, {
      key: "".concat(data.publicId, "-").concat(index),
      shouldShowNamesInListView: shouldShowNamesInListView,
      count: peopleData.length
    }, /*#__PURE__*/React.createElement(Person, _extends({}, data, {
      imagetype: imagetype,
      headshot: headshots[data.publicId],
      portrait: portraits[data.publicId],
      landscape: landscapes[data.publicId],
      id: "peopleCircle-".concat(index + 1),
      ref: dotRefs.current[index],
      modalStyles: modalStyles
    })), shouldShowNamesInListView && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NameAndTitle, null, /*#__PURE__*/React.createElement(P, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement("strong", null, data.firstName, " ", data.lastName), data.designation && /*#__PURE__*/React.createElement(React.Fragment, null, ",\xA0", /*#__PURE__*/React.createElement(AvoidWrap, null, data.designation))), /*#__PURE__*/React.createElement(P, {
      variant: "body2"
    }, data.title)), /*#__PURE__*/React.createElement(StyledDecorator, null)));
  });
  return /*#__PURE__*/React.createElement(PeopleList, {
    id: "peopleList"
  }, PeopleHtml);
};
const PeopleList = styled.ul.withConfig({
  displayName: "People__PeopleList",
  componentId: "sc-1kyik1k-0"
})(["list-style:none;display:flex;flex-direction:row;flex-wrap:wrap;align-content:flex-start;align-items:flex-start;justify-content:center;margin:0;padding:0;"]);
const StyledDecorator = styled(Decorator).withConfig({
  displayName: "People__StyledDecorator",
  componentId: "sc-1kyik1k-1"
})(["opacity:0.5;width:100%;margin-top:35px;margin-bottom:30px;", "{margin-bottom:80px;}"], match.isSM);
const PeopleListItem = styled.li.withConfig({
  displayName: "People__PeopleListItem",
  componentId: "sc-1kyik1k-2"
})(["width:100%;margin:0;display:block;", "{flex:0 0 50%;padding:8px;&:nth-child(-n + 2){padding-top:0;}&:nth-child(even){padding-right:0;}&:nth-child(odd){padding-left:0;}}", "{", "}", "{", "}"], match.isXS, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.only('sm');
}, _ref3 => {
  let {
    count
  } = _ref3;
  const primaryRowCount = 4;
  const secondaryRowCount = 3;
  const mod = count % (primaryRowCount + secondaryRowCount);
  // 4 / 3 stagger
  return css(["flex:0 0 23.5%;margin:0 1%;&:nth-child(7n - 3){margin-right:0;}&:nth-child(7n - 6){margin-left:0;}&:nth-child(7n){margin-right:12.75%;}&:nth-child(7n - 2){margin-left:12.75%;}", " ", " ", " ", ""], mod === 1 && css(["&:nth-child(", "){margin-right:25.5%;}&:nth-child(", "){margin-left:12.75%;margin-right:1%;}&:nth-child(", "){margin:0 1%;}&:nth-child(", "){margin-right:12.75%;margin-left:1%;}&:nth-child(", "){margin:0 1% 0 0;}&:nth-child(", "){margin:0 1%;}"], count - 5, count - 4, count - 3, count - 2, count - 1, count), mod === 3 && css(["&:nth-child(", "){margin-right:25.5%;}"], count), mod === 5 && css(["&:nth-child(", "){margin-right:25.5%;}&:nth-child(", "){margin-left:0;margin-right:1%;}&:nth-child(", "){margin-left:1%;margin-right:25.5%;}"], count - 2, count - 1, count), mod === 6 && css(["&:nth-child(", "){margin-right:25.5%;}&:nth-child(", "){margin-left:12.75%;margin-right:1%;}&:nth-child(", "){margin-left:1%;margin-right:1%;}&:nth-child(", "){margin-left:1%;margin-right:12.75%;}"], count - 3, count - 2, count - 1, count));
}, match.isMD, _ref4 => {
  let {
    count
  } = _ref4;
  const primaryRowCount = 5;
  const secondaryRowCount = 4;
  const mod = count % (primaryRowCount + secondaryRowCount);
  return css(["flex:0 0 18.4%;margin:0 1%;&:nth-child(9n - 8){margin-left:0;}&:nth-child(9n - 4){margin-right:0;}", " ", " ", " ", " ", " ", ""], mod === 1 && css(["&:nth-child(", "){margin-left:1%;margin-right:20.4%;}&:nth-child(", "){margin:0 1%;}&:nth-child(", "){margin-left:1%;margin-right:21.4%;}&:nth-child(", "),&:nth-child(", "),&:nth-child(", "){margin:0 1%;}"], count - 6, count - 5, count - 3, count - 2, count - 1, count), mod === 2 && css(["&:nth-child(", "){margin-left:19%;}&:nth-child(", "){margin-right:0%;}&:nth-child(", "),&:nth-child(", "){margin:0 1%;}"], count - 10, count - 7, count - 6, count - 1), mod === 4 && css(["&:nth-child(", "){margin-right:20.4%;}"], count), mod === 6 && css(["&:nth-child(", "){margin-left:20%;}&:nth-child(", "){margin-right:20%;}&:nth-child(", "){margin:0 1%;}&:nth-child(", "){margin-right:21%;}"], count - 5, count - 3, count - 1, count), mod === 7 && css(["&:nth-child(", "),&:nth-child(", "){margin-right:20.4%;}&:nth-child(", "){margin:0 1% 0 0;}"], count - 3, count, count - 2), mod === 8 && css(["&:nth-child(", "){margin-right:20%;}&:nth-child(", "){margin-right:1%;}"], count - 4, count - 3));
});
const NameAndTitle = styled.div.withConfig({
  displayName: "People__NameAndTitle",
  componentId: "sc-1kyik1k-3"
})(["min-height:100px;margin-top:30px;text-align:center;", "{min-height:75px;}"], match.isMD);
const ScrollToTop = _ref => {
  let {
    offset = 0,
    placement = 0,
    behavior = 'smooth',
    ...props
  } = _ref;
  const ref = React.useRef();
  let scrollElementRef = null;
  const children = React.Children.map(props.children, (element, i) => {
    if (i === 0) {
      scrollElementRef = element.ref || ref;
      return element.ref ? element : /*#__PURE__*/React.cloneElement(element, {
        ref
      });
    } else return element;
  });
  React.useEffect(() => {
    const docTop = document.documentElement.scrollTop;
    const scrollElTop = scrollElementRef.current.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    const offsetTotal = windowHeight * placement + offset;
    const top = docTop + scrollElTop - offsetTotal;
    window.scrollTo({
      behavior,
      top
    });
  }, [offset, placement, behavior, scrollElementRef]);
  return children;
};
function SeoBase(_ref) {
  let {
    siteUrl,
    description = '',
    type = 'website',
    author,
    meta = [],
    title,
    siteTitle,
    path,
    socialThumbPath,
    location,
    ...rest
  } = _ref;
  if (!title) throw new Error('You must specify a title for the SEO component.');
  const {
    i18n: {
      language
    }
  } = useTranslation();
  const lang = language;
  const {
    titleTemplate = "%s | ".concat(siteTitle)
  } = rest;
  const {
    pathname
  } = location;
  const metaPath = path || pathname;
  const metaFullUrl = "".concat(siteUrl).concat(metaPath).replace(/\/+$/, '');
  const socialThumbUrl = "".concat(siteUrl).concat(socialThumbPath);
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang,
      prefix: 'og: http://ogp.me/ns#'
    },
    title: title,
    titleTemplate: titleTemplate,
    meta: [{
      name: "description",
      content: description
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: description
    }, {
      property: "og:type",
      content: type
    }, {
      property: "og:url",
      content: metaFullUrl
    }, {
      property: "og:image",
      content: socialThumbUrl
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:creator",
      content: author
    }, {
      name: "twitter:title",
      content: title
    }, {
      name: "twitter:description",
      content: description
    }, {
      name: "twitter:image",
      content: socialThumbUrl
    }].concat(meta)
  }, /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "http://res.cloudinary.com"
  }));
}
const Seo = _ref2 => {
  let {
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Location, null, _ref3 => {
    let {
      location
    } = _ref3;
    return /*#__PURE__*/React.createElement(SeoBase, _extends({
      location: location
    }, props));
  });
};
function ShadowBox(_ref) {
  let {
    children,
    top = true,
    bottom = true,
    shadowHeight = 60,
    shadowColorY = 'background.default',
    shadowColorTop,
    shadowColorBottom,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledBox$1, _extends({
    $top: top,
    $bottom: bottom,
    $shadowHeightTop: shadowHeight,
    $shadowHeightBottom: shadowHeight,
    $shadowColorTop: shadowColorTop || shadowColorY,
    $shadowColorBottom: shadowColorBottom || shadowColorY
  }, rest), children);
}
const StyledBox$1 = styled(Box).withConfig({
  displayName: "ShadowBox__StyledBox",
  componentId: "sc-c89zz9-0"
})(["position:relative;", ""], _ref2 => {
  let {
    theme,
    $shadowColorTop,
    $shadowColorBottom,
    $bottom,
    $top,
    $shadowHeightTop,
    $shadowHeightBottom
  } = _ref2;
  return css([":before{display:", ";position:absolute;z-index:2;content:'';top:0;width:100%;height:", "px;background-image:linear-gradient( ", ",", " );}:after{display:", ";position:absolute;z-index:2;content:'';bottom:0;width:100%;height:", "px;background-image:linear-gradient( ", ",", " );}"], $top ? 'block' : 'none', $shadowHeightTop, get$1(theme.palette, $shadowColorTop), alpha(get$1(theme.palette, $shadowColorTop), 0), $bottom ? 'block' : 'none', $shadowHeightBottom, alpha(get$1(theme.palette, $shadowColorBottom), 0), get$1(theme.palette, $shadowColorBottom));
});
const SkipToContentBar = props => {
  const {
    showAccessibilityModal
  } = useAccessibilityContext();
  return /*#__PURE__*/React.createElement(HiddenContentSection, _extends({}, props, {
    component: "nav",
    "aria-label": "Skip to content section"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    onClick: e => e.target.blur(),
    href: "#main-content",
    role: "link",
    variant: "contained",
    size: "large",
    color: "default"
  }, "Skip To Content")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    color: "default",
    onClick: e => {
      e.target.blur();
      showAccessibilityModal();
    },
    variant: "contained"
  }, "Accessibility Settings"))));
};
const HiddenContentSection = styled(Paper).withConfig({
  displayName: "SkipToContentBar__HiddenContentSection",
  componentId: "sc-vzkllw-0"
})(["left:50%;top:0;position:absolute;z-index:2000;padding:8px;transform:translate(-50%,calc(-100% - 32px));&>ul{list-style:none;margin:0px;padding:0px;&>li{list-style:none;margin-left:8px;padding:0;display:inline-block;}}&:focus-within{transform:translate(-50%,0%)}}"]);
const marginBottom = style({
  prop: '$spacing',
  cssProperty: 'marginBottom',
  themeKey: 'spacing'
});
const Stack = _ref => {
  let {
    spacing = 'medium',
    ...rest
  } = _ref;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    $spacing: theme.defaults.spacing[spacing] || spacing
  }, rest));
};
const StyledBox = styled(Box).withConfig({
  displayName: "Stack__StyledBox",
  componentId: "sc-1ufnma8-0"
})(["& > *{", "}& > *:last-child{margin-bottom:0;}"], marginBottom);
const defaultProps$1 = {
  columnContents: ['COLUMN ONE CONTENT HERE', 'COLUMN TWO CONTENT HERE'],
  columnProps: [{}, {}],
  columnWidths: ['50%', '50%'],
  fade: [true, true],
  innerSpacing: {
    mobile: 4,
    breakingPoint: 12
  }
};
const TwoColumnGrid = props => {
  const {
    direction = 'row',
    alignItems = 'center',
    breakingPoint = 'md',
    columnContents = defaultProps$1.columnContents,
    columnWidths = defaultProps$1.columnWidths,
    columnProps = defaultProps$1.columnProps,
    fade = defaultProps$1.fade,
    innerSpacing = defaultProps$1.innerSpacing,
    children,
    ...rest
  } = props;
  const columnOneFadeDirection = direction === 'row-reverse' ? 'right' : 'left';
  const columnTwoFadeDirection = direction === 'row-reverse' ? 'left' : 'right';
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: {
      [breakingPoint]: 'flex'
    },
    alignItems: {
      [breakingPoint]: alignItems
    },
    flexDirection: {
      [breakingPoint]: direction
    }
  }, rest), /*#__PURE__*/React.createElement(FadeIn$1, {
    from: columnOneFadeDirection,
    enabled: fade[0]
  }, /*#__PURE__*/React.createElement(Box, _extends({
    paddingLeft: {
      [breakingPoint]: direction === 'row' ? 0 : innerSpacing.breakingPoint / 2
    },
    paddingRight: {
      [breakingPoint]: direction === 'row-reverse' ? 0 : innerSpacing.breakingPoint / 2
    },
    paddingBottom: {
      xs: innerSpacing.mobile / 2,
      [breakingPoint]: 0
    },
    width: {
      xs: '100%',
      [breakingPoint]: columnWidths[0]
    }
  }, columnProps[0]), columnContents[0])), /*#__PURE__*/React.createElement(FadeIn$1, {
    from: columnTwoFadeDirection,
    enabled: fade[1]
  }, /*#__PURE__*/React.createElement(Box, _extends({
    paddingLeft: {
      [breakingPoint]: direction === 'row' ? innerSpacing.breakingPoint / 2 : 0
    },
    paddingRight: {
      [breakingPoint]: direction === 'row-reverse' ? innerSpacing.breakingPoint / 2 : 0
    },
    paddingTop: {
      xs: innerSpacing.mobile / 2,
      [breakingPoint]: 0
    },
    width: {
      xs: '100%',
      [breakingPoint]: columnWidths[1]
    }
  }, columnProps[1]), columnContents[1])));
};
const Breakpoint = _ref => {
  let {
    children,
    query
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
Breakpoint.displayName = 'Breakpoint';
const Default = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
Default.displayName = 'Default';

/**
 * A helper for conditionally rendering children based 
 * on media queries using a mobile first approach. 
 * 
 * How does it work?
 * - Like a switch will only match(render) one condition at a time
 * - Order matters, order <Breakpoints> like you would in CSS for mobile first
 * - <Default> will be used if no other <Breakpoint>'s match.
 * 
 * Usage:
    <MobileFirstSwitch>
      <Default>
        <h1>MOBILE Breakpoint</h1>
      </Default>
      <Breakpoint query={match.isMD}>
        <h1>MEDIUM Breakpoint</h1>
      </Breakpoint>
      <Breakpoint query={match.isLG}>
        <h1>LARGE Breakpoint</h1>
      </Breakpoint>
    </MobileFirstSwitch>
 */
const MobileFirstSwitch = _ref3 => {
  let {
    children
  } = _ref3;
  let defaultBreakpoint = null;
  let matchedBreakpoint = null;
  const [resizeCount, setResizeCount] = useState(0);
  const onMediaQueryChange = useCallback(() => setResizeCount(resizeCount + 1), [resizeCount]);
  useEffect(() => {
    const items = React.Children.toArray(children);
    const mediaQueryLists = items.map(item => {
      return typeof item.props.query === 'string' ? window.matchMedia(item.props.query) : null;
    }).filter(item => item !== null);
    mediaQueryLists.forEach(queryList =>
    // queryList.addEventListener('change', onMediaQueryChange)
    // For safari iOS compatibility you must use addListener / removeListener
    queryList.addListener(onMediaQueryChange));
    return () => {
      mediaQueryLists.forEach(queryList =>
      // queryList.removeEventListener('change', onMediaQueryChange)
      // For safari iOS compatibility you must use addListener / removeListener
      queryList.removeListener(onMediaQueryChange));
    };
  }, [children, onMediaQueryChange]);
  React.Children.forEach(children, child => {
    const isValidChild = child !== null && child.type && child.type.displayName;
    const isDefaultBreakpoint = isValidChild && child.type.displayName === 'Default';
    const hasValidQuery = isValidChild && typeof child.props.query === 'string';
    const childContent = isValidChild && child.props.children;
    if (isDefaultBreakpoint) {
      defaultBreakpoint = childContent;
    }
    if (!isDefaultBreakpoint && hasValidQuery && isBrowser) {
      const {
        matches
      } = window.matchMedia(child.props.query);
      matchedBreakpoint = matches === true ? childContent : matchedBreakpoint;
    }
  });
  return matchedBreakpoint !== null ? matchedBreakpoint : defaultBreakpoint;
};
var plyrCSS = "@charset \"UTF-8\";@keyframes plyr-progress{to{background-position:25px 0;background-position:var(--plyr-progress-loading-size,25px) 0}}@keyframes plyr-popup{0%{opacity:.5;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes plyr-fade-in{0%{opacity:0}to{opacity:1}}.plyr{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;align-items:center;direction:ltr;display:flex;flex-direction:column;font-family:inherit;font-family:var(--plyr-font-family,inherit);font-variant-numeric:tabular-nums;font-weight:400;font-weight:var(--plyr-font-weight-regular,400);line-height:1.7;line-height:var(--plyr-line-height,1.7);max-width:100%;min-width:200px;position:relative;text-shadow:none;transition:box-shadow .3s ease;z-index:0}.plyr audio,.plyr iframe,.plyr video{display:block;height:100%;width:100%}.plyr button{font:inherit;line-height:inherit;width:auto}.plyr:focus{outline:0}.plyr--full-ui{box-sizing:border-box}.plyr--full-ui *,.plyr--full-ui :after,.plyr--full-ui :before{box-sizing:inherit}.plyr--full-ui a,.plyr--full-ui button,.plyr--full-ui input,.plyr--full-ui label{touch-action:manipulation}.plyr__badge{background:#4a5464;background:var(--plyr-badge-background,#4a5464);border-radius:2px;border-radius:var(--plyr-badge-border-radius,2px);color:#fff;color:var(--plyr-badge-text-color,#fff);font-size:9px;font-size:var(--plyr-font-size-badge,9px);line-height:1;padding:3px 4px}.plyr--full-ui ::-webkit-media-text-track-container{display:none}.plyr__captions{animation:plyr-fade-in .3s ease;bottom:0;display:none;font-size:13px;font-size:var(--plyr-font-size-small,13px);left:0;padding:10px;padding:var(--plyr-control-spacing,10px);position:absolute;text-align:center;transition:transform .4s ease-in-out;width:100%}.plyr__captions span:empty{display:none}@media (min-width:480px){.plyr__captions{font-size:15px;font-size:var(--plyr-font-size-base,15px);padding:20px;padding:calc(var(--plyr-control-spacing, 10px)*2)}}@media (min-width:768px){.plyr__captions{font-size:18px;font-size:var(--plyr-font-size-large,18px)}}.plyr--captions-active .plyr__captions{display:block}.plyr:not(.plyr--hide-controls) .plyr__controls:not(:empty)~.plyr__captions{transform:translateY(-40px);transform:translateY(calc(var(--plyr-control-spacing, 10px)*-4))}.plyr__caption{background:#000c;background:var(--plyr-captions-background,#000c);border-radius:2px;-webkit-box-decoration-break:clone;box-decoration-break:clone;color:#fff;color:var(--plyr-captions-text-color,#fff);line-height:185%;padding:.2em .5em;white-space:pre-wrap}.plyr__caption div{display:inline}.plyr__control{background:#0000;border:0;border-radius:4px;border-radius:var(--plyr-control-radius,4px);color:inherit;cursor:pointer;flex-shrink:0;overflow:visible;padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7);position:relative;transition:all .3s ease}.plyr__control svg{fill:currentColor;display:block;height:18px;height:var(--plyr-control-icon-size,18px);pointer-events:none;width:18px;width:var(--plyr-control-icon-size,18px)}.plyr__control:focus{outline:0}.plyr__control:focus-visible{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}a.plyr__control{text-decoration:none}.plyr__control.plyr__control--pressed .icon--not-pressed,.plyr__control.plyr__control--pressed .label--not-pressed,.plyr__control:not(.plyr__control--pressed) .icon--pressed,.plyr__control:not(.plyr__control--pressed) .label--pressed,a.plyr__control:after,a.plyr__control:before{display:none}.plyr--full-ui ::-webkit-media-controls{display:none}.plyr__controls{align-items:center;display:flex;justify-content:flex-end;text-align:center}.plyr__controls .plyr__progress__container{flex:1;min-width:0}.plyr__controls .plyr__controls__item{margin-left:2.5px;margin-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item:first-child{margin-left:0;margin-right:auto}.plyr__controls .plyr__controls__item.plyr__progress__container{padding-left:2.5px;padding-left:calc(var(--plyr-control-spacing, 10px)/4)}.plyr__controls .plyr__controls__item.plyr__time{padding:0 5px;padding:0 calc(var(--plyr-control-spacing, 10px)/2)}.plyr__controls .plyr__controls__item.plyr__progress__container:first-child,.plyr__controls .plyr__controls__item.plyr__time+.plyr__time,.plyr__controls .plyr__controls__item.plyr__time:first-child{padding-left:0}.plyr [data-plyr=airplay],.plyr [data-plyr=captions],.plyr [data-plyr=fullscreen],.plyr [data-plyr=pip],.plyr__controls:empty{display:none}.plyr--airplay-supported [data-plyr=airplay],.plyr--captions-enabled [data-plyr=captions],.plyr--fullscreen-enabled [data-plyr=fullscreen],.plyr--pip-supported [data-plyr=pip]{display:inline-block}.plyr__menu{display:flex;position:relative}.plyr__menu .plyr__control svg{transition:transform .3s ease}.plyr__menu .plyr__control[aria-expanded=true] svg{transform:rotate(90deg)}.plyr__menu .plyr__control[aria-expanded=true] .plyr__tooltip{display:none}.plyr__menu__container{animation:plyr-popup .2s ease;background:#ffffffe6;background:var(--plyr-menu-background,#ffffffe6);border-radius:8px;border-radius:var(--plyr-menu-radius,8px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-menu-shadow,0 1px 2px #00000026);color:#4a5464;color:var(--plyr-menu-color,#4a5464);font-size:15px;font-size:var(--plyr-font-size-base,15px);margin-bottom:10px;position:absolute;right:-3px;text-align:left;white-space:nowrap;z-index:3}.plyr__menu__container>div{overflow:hidden;transition:height .35s cubic-bezier(.4,0,.2,1),width .35s cubic-bezier(.4,0,.2,1)}.plyr__menu__container:after{border:4px solid #0000;border-top-color:#ffffffe6;border:var(--plyr-menu-arrow-size,4px) solid #0000;border-top-color:var(--plyr-menu-background,#ffffffe6);content:\"\";height:0;position:absolute;right:14px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7 - var(--plyr-menu-arrow-size, 4px)/2);top:100%;width:0}.plyr__menu__container [role=menu]{padding:7px;padding:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container [role=menuitem],.plyr__menu__container [role=menuitemradio]{margin-top:2px}.plyr__menu__container [role=menuitem]:first-child,.plyr__menu__container [role=menuitemradio]:first-child{margin-top:0}.plyr__menu__container .plyr__control{align-items:center;color:#4a5464;color:var(--plyr-menu-color,#4a5464);display:flex;font-size:13px;font-size:var(--plyr-font-size-menu,var(--plyr-font-size-small,13px));padding:4.66667px 10.5px;padding:calc(var(--plyr-control-spacing, 10px)*.7/1.5) calc(var(--plyr-control-spacing, 10px)*.7*1.5);-webkit-user-select:none;user-select:none;width:100%}.plyr__menu__container .plyr__control>span{align-items:inherit;display:flex;width:100%}.plyr__menu__container .plyr__control:after{border:4px solid #0000;border:var(--plyr-menu-item-arrow-size,4px) solid #0000;content:\"\";position:absolute;top:50%;transform:translateY(-50%)}.plyr__menu__container .plyr__control--forward{padding-right:28px;padding-right:calc(var(--plyr-control-spacing, 10px)*.7*4)}.plyr__menu__container .plyr__control--forward:after{border-left-color:#728197;border-left-color:var(--plyr-menu-arrow-color,#728197);right:6.5px;right:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--forward:focus-visible:after,.plyr__menu__container .plyr__control--forward:hover:after{border-left-color:initial}.plyr__menu__container .plyr__control--back{font-weight:400;font-weight:var(--plyr-font-weight-regular,400);margin:7px;margin:calc(var(--plyr-control-spacing, 10px)*.7);margin-bottom:3.5px;margin-bottom:calc(var(--plyr-control-spacing, 10px)*.7/2);padding-left:28px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*4);position:relative;width:calc(100% - 14px);width:calc(100% - var(--plyr-control-spacing, 10px)*.7*2)}.plyr__menu__container .plyr__control--back:after{border-right-color:#728197;border-right-color:var(--plyr-menu-arrow-color,#728197);left:6.5px;left:calc(var(--plyr-control-spacing, 10px)*.7*1.5 - var(--plyr-menu-item-arrow-size, 4px))}.plyr__menu__container .plyr__control--back:before{background:#dcdfe5;background:var(--plyr-menu-back-border-color,#dcdfe5);box-shadow:0 1px 0 #fff;box-shadow:0 1px 0 var(--plyr-menu-back-border-shadow-color,#fff);content:\"\";height:1px;left:0;margin-top:3.5px;margin-top:calc(var(--plyr-control-spacing, 10px)*.7/2);overflow:hidden;position:absolute;right:0;top:100%}.plyr__menu__container .plyr__control--back:focus-visible:after,.plyr__menu__container .plyr__control--back:hover:after{border-right-color:initial}.plyr__menu__container .plyr__control[role=menuitemradio]{padding-left:7px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7)}.plyr__menu__container .plyr__control[role=menuitemradio]:after,.plyr__menu__container .plyr__control[role=menuitemradio]:before{border-radius:100%}.plyr__menu__container .plyr__control[role=menuitemradio]:before{background:#0000001a;content:\"\";display:block;flex-shrink:0;height:16px;margin-right:10px;margin-right:var(--plyr-control-spacing,10px);transition:all .3s ease;width:16px}.plyr__menu__container .plyr__control[role=menuitemradio]:after{background:#fff;border:0;height:6px;left:12px;opacity:0;top:50%;transform:translateY(-50%) scale(0);transition:transform .3s ease,opacity .3s ease;width:6px}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:before{background:#00b2ff;background:var(--plyr-control-toggle-checked-background,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)))}.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:after{opacity:1;transform:translateY(-50%) scale(1)}.plyr__menu__container .plyr__control[role=menuitemradio]:focus-visible:before,.plyr__menu__container .plyr__control[role=menuitemradio]:hover:before{background:#23282f1a}.plyr__menu__container .plyr__menu__value{align-items:center;display:flex;margin-left:auto;margin-right:-5px;margin-right:calc(var(--plyr-control-spacing, 10px)*.7*-1 - -2px);overflow:hidden;padding-left:24.5px;padding-left:calc(var(--plyr-control-spacing, 10px)*.7*3.5);pointer-events:none}.plyr--full-ui input[type=range]{-webkit-appearance:none;appearance:none;background:#0000;border:0;border-radius:26px;border-radius:calc(var(--plyr-range-thumb-height, 13px)*2);color:#00b2ff;color:var(--plyr-range-fill-background,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));display:block;height:19px;height:calc(var(--plyr-range-thumb-active-shadow-width, 3px)*2 + var(--plyr-range-thumb-height, 13px));margin:0;min-width:0;padding:0;transition:box-shadow .3s ease;width:100%}.plyr--full-ui input[type=range]::-webkit-slider-runnable-track{background:#0000;background-image:linear-gradient(90deg,currentColor 0,#0000 0);background-image:linear-gradient(to right,currentColor var(--value,0),#0000 var(--value,0));border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-webkit-transition:box-shadow .3s ease;transition:box-shadow .3s ease;-webkit-user-select:none;user-select:none}.plyr--full-ui input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:-4px;margin-top:calc((var(--plyr-range-thumb-height, 13px) - var(--plyr-range-track-height, 5px))/2*-1);position:relative;-webkit-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-track{background:#0000;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-moz-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-moz-range-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);position:relative;-moz-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-moz-range-progress{background:currentColor;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px)}.plyr--full-ui input[type=range]::-ms-track{color:#0000}.plyr--full-ui input[type=range]::-ms-fill-upper,.plyr--full-ui input[type=range]::-ms-track{background:#0000;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-fill-lower{background:#0000;background:currentColor;border:0;border-radius:2.5px;border-radius:calc(var(--plyr-range-track-height, 5px)/2);height:5px;height:var(--plyr-range-track-height,5px);-ms-transition:box-shadow .3s ease;transition:box-shadow .3s ease;user-select:none}.plyr--full-ui input[type=range]::-ms-thumb{background:#fff;background:var(--plyr-range-thumb-background,#fff);border:0;border-radius:100%;box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33);height:13px;height:var(--plyr-range-thumb-height,13px);margin-top:0;position:relative;-ms-transition:all .2s ease;transition:all .2s ease;width:13px;width:var(--plyr-range-thumb-height,13px)}.plyr--full-ui input[type=range]::-ms-tooltip{display:none}.plyr--full-ui input[type=range]::-moz-focus-outer{border:0}.plyr--full-ui input[type=range]:focus{outline:0}.plyr--full-ui input[type=range]:focus-visible::-webkit-slider-runnable-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr--full-ui input[type=range]:focus-visible::-moz-range-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr--full-ui input[type=range]:focus-visible::-ms-track{outline:2px dashed #00b2ff;outline:2px dashed var(--plyr-focus-visible-color,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));outline-offset:2px}.plyr__poster{background-color:#000;background-color:var(--plyr-video-background,var(--plyr-video-background,#000));background-position:50% 50%;background-repeat:no-repeat;background-size:contain;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s ease;width:100%;z-index:1}.plyr--stopped.plyr__poster-enabled .plyr__poster{opacity:1}.plyr--youtube.plyr--paused.plyr__poster-enabled:not(.plyr--stopped) .plyr__poster{display:none}.plyr__time{font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px))}.plyr__time+.plyr__time:before{content:\"⁄\";margin-right:10px;margin-right:var(--plyr-control-spacing,10px)}@media (max-width:767px){.plyr__time+.plyr__time{display:none}}.plyr__tooltip{background:#fff;background:var(--plyr-tooltip-background,#fff);border-radius:5px;border-radius:var(--plyr-tooltip-radius,5px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-tooltip-shadow,0 1px 2px #00000026);color:#4a5464;color:var(--plyr-tooltip-color,#4a5464);font-size:13px;font-size:var(--plyr-font-size-small,13px);font-weight:400;font-weight:var(--plyr-font-weight-regular,400);left:50%;line-height:1.3;margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:5px 7.5px;padding:calc(var(--plyr-control-spacing, 10px)/2) calc(var(--plyr-control-spacing, 10px)/2*1.5);pointer-events:none;position:absolute;transform:translate(-50%,10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;white-space:nowrap;z-index:2}.plyr__tooltip:before{border-left:4px solid #0000;border-left:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-right:4px solid #0000;border-right:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-top:4px solid #fff;border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,#fff);bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:\"\";height:0;left:50%;position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr .plyr__control:focus-visible .plyr__tooltip,.plyr .plyr__control:hover .plyr__tooltip,.plyr__tooltip--visible{opacity:1;transform:translate(-50%) scale(1)}.plyr .plyr__control:hover .plyr__tooltip{z-index:3}.plyr__controls>.plyr__control:first-child .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip{left:0;transform:translateY(10px) scale(.8);transform-origin:0 100%}.plyr__controls>.plyr__control:first-child .plyr__tooltip:before,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip:before{left:16px;left:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7)}.plyr__controls>.plyr__control:last-child .plyr__tooltip{left:auto;right:0;transform:translateY(10px) scale(.8);transform-origin:100% 100%}.plyr__controls>.plyr__control:last-child .plyr__tooltip:before{left:auto;right:16px;right:calc(var(--plyr-control-icon-size, 18px)/2 + var(--plyr-control-spacing, 10px)*.7);transform:translateX(50%)}.plyr__controls>.plyr__control:first-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control .plyr__tooltip--visible,.plyr__controls>.plyr__control:first-child+.plyr__control:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:first-child+.plyr__control:hover .plyr__tooltip,.plyr__controls>.plyr__control:first-child:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:first-child:hover .plyr__tooltip,.plyr__controls>.plyr__control:last-child .plyr__tooltip--visible,.plyr__controls>.plyr__control:last-child:focus-visible .plyr__tooltip,.plyr__controls>.plyr__control:last-child:hover .plyr__tooltip{transform:translate(0) scale(1)}.plyr__progress{left:6.5px;left:calc(var(--plyr-range-thumb-height, 13px)*.5);margin-right:13px;margin-right:var(--plyr-range-thumb-height,13px);position:relative}.plyr__progress input[type=range],.plyr__progress__buffer{margin-left:-6.5px;margin-left:calc(var(--plyr-range-thumb-height, 13px)*-.5);margin-right:-6.5px;margin-right:calc(var(--plyr-range-thumb-height, 13px)*-.5);width:calc(100% + 13px);width:calc(100% + var(--plyr-range-thumb-height, 13px))}.plyr__progress input[type=range]{position:relative;z-index:2}.plyr__progress .plyr__tooltip{left:0;max-width:120px;overflow-wrap:break-word}.plyr__progress__buffer{-webkit-appearance:none;background:#0000;border:0;border-radius:100px;height:5px;height:var(--plyr-range-track-height,5px);left:0;margin-top:-2.5px;margin-top:calc((var(--plyr-range-track-height, 5px)/2)*-1);padding:0;position:absolute;top:50%}.plyr__progress__buffer::-webkit-progress-bar{background:#0000}.plyr__progress__buffer::-webkit-progress-value{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-webkit-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-moz-progress-bar{background:currentColor;border-radius:100px;min-width:5px;min-width:var(--plyr-range-track-height,5px);-moz-transition:width .2s ease;transition:width .2s ease}.plyr__progress__buffer::-ms-fill{border-radius:100px;-ms-transition:width .2s ease;transition:width .2s ease}.plyr--loading .plyr__progress__buffer{animation:plyr-progress 1s linear infinite;background-image:linear-gradient(-45deg,#23282f99 25%,#0000 0,#0000 50%,#23282f99 0,#23282f99 75%,#0000 0,#0000);background-image:linear-gradient(-45deg,var(--plyr-progress-loading-background,#23282f99) 25%,#0000 25%,#0000 50%,var(--plyr-progress-loading-background,#23282f99) 50%,var(--plyr-progress-loading-background,#23282f99) 75%,#0000 75%,#0000);background-repeat:repeat-x;background-size:25px 25px;background-size:var(--plyr-progress-loading-size,25px) var(--plyr-progress-loading-size,25px);color:#0000}.plyr--video.plyr--loading .plyr__progress__buffer{background-color:#ffffff40;background-color:var(--plyr-video-progress-buffered-background,#ffffff40)}.plyr--audio.plyr--loading .plyr__progress__buffer{background-color:#c1c8d199;background-color:var(--plyr-audio-progress-buffered-background,#c1c8d199)}.plyr__progress__marker{background-color:#fff;background-color:var(--plyr-progress-marker-background,#fff);border-radius:1px;height:5px;height:var(--plyr-range-track-height,5px);position:absolute;top:50%;transform:translate(-50%,-50%);width:3px;width:var(--plyr-progress-marker-width,3px);z-index:3}.plyr__volume{align-items:center;display:flex;position:relative}.plyr__volume input[type=range]{margin-left:5px;margin-left:calc(var(--plyr-control-spacing, 10px)/2);margin-right:5px;margin-right:calc(var(--plyr-control-spacing, 10px)/2);max-width:90px;min-width:60px;position:relative;z-index:2}.plyr--audio{display:block}.plyr--audio .plyr__controls{background:#fff;background:var(--plyr-audio-controls-background,#fff);border-radius:inherit;color:#4a5464;color:var(--plyr-audio-control-color,#4a5464);padding:10px;padding:var(--plyr-control-spacing,10px)}.plyr--audio .plyr__control:focus-visible,.plyr--audio .plyr__control:hover,.plyr--audio .plyr__control[aria-expanded=true]{background:#00b2ff;background:var(--plyr-audio-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));color:#fff;color:var(--plyr-audio-control-color-hover,#fff)}.plyr--full-ui.plyr--audio input[type=range]::-webkit-slider-runnable-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]::-moz-range-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]::-ms-track{background-color:#c1c8d199;background-color:var(--plyr-audio-range-track-background,var(--plyr-audio-progress-buffered-background,#c1c8d199))}.plyr--full-ui.plyr--audio input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--full-ui.plyr--audio input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--full-ui.plyr--audio input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #23282f1a;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#23282f1a)}.plyr--audio .plyr__progress__buffer{color:#c1c8d199;color:var(--plyr-audio-progress-buffered-background,#c1c8d199)}.plyr--video{overflow:hidden}.plyr--video.plyr--menu-open{overflow:visible}.plyr__video-wrapper{background:#000;background:var(--plyr-video-background,var(--plyr-video-background,#000));border-radius:inherit;height:100%;margin:auto;overflow:hidden;position:relative;width:100%}.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{aspect-ratio:16/9}@supports not (aspect-ratio:16/9){.plyr__video-embed,.plyr__video-wrapper--fixed-ratio{height:0;padding-bottom:56.25%;position:relative}}.plyr__video-embed iframe,.plyr__video-wrapper--fixed-ratio video{border:0;height:100%;left:0;position:absolute;top:0;width:100%}.plyr--full-ui .plyr__video-embed>.plyr__video-embed__container{padding-bottom:240%;position:relative;transform:translateY(-38.28125%)}.plyr--video .plyr__controls{background:linear-gradient(#0000,#000000bf);background:var(--plyr-video-controls-background,linear-gradient(#0000,#000000bf));border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;bottom:0;color:#fff;color:var(--plyr-video-control-color,#fff);left:0;padding:5px;padding:calc(var(--plyr-control-spacing, 10px)/2);padding-top:20px;padding-top:calc(var(--plyr-control-spacing, 10px)*2);position:absolute;right:0;transition:opacity .4s ease-in-out,transform .4s ease-in-out;z-index:3}@media (min-width:480px){.plyr--video .plyr__controls{padding:10px;padding:var(--plyr-control-spacing,10px);padding-top:35px;padding-top:calc(var(--plyr-control-spacing, 10px)*3.5)}}.plyr--video.plyr--hide-controls .plyr__controls{opacity:0;pointer-events:none;transform:translateY(100%)}.plyr--video .plyr__control:focus-visible,.plyr--video .plyr__control:hover,.plyr--video .plyr__control[aria-expanded=true]{background:#00b2ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));color:#fff;color:var(--plyr-video-control-color-hover,#fff)}.plyr__control--overlaid{background:#00b2ff;background:var(--plyr-video-control-background-hover,var(--plyr-color-main,var(--plyr-color-main,#00b2ff)));border:0;border-radius:100%;color:#fff;color:var(--plyr-video-control-color,#fff);display:none;left:50%;opacity:.9;padding:15px;padding:calc(var(--plyr-control-spacing, 10px)*1.5);position:absolute;top:50%;transform:translate(-50%,-50%);transition:.3s;z-index:2}.plyr__control--overlaid svg{left:2px;position:relative}.plyr__control--overlaid:focus,.plyr__control--overlaid:hover{opacity:1}.plyr--playing .plyr__control--overlaid{opacity:0;visibility:hidden}.plyr--full-ui.plyr--video .plyr__control--overlaid{display:block}.plyr--full-ui.plyr--video input[type=range]::-webkit-slider-runnable-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]::-moz-range-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]::-ms-track{background-color:#ffffff40;background-color:var(--plyr-video-range-track-background,var(--plyr-video-progress-buffered-background,#ffffff40))}.plyr--full-ui.plyr--video input[type=range]:active::-webkit-slider-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--full-ui.plyr--video input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--full-ui.plyr--video input[type=range]:active::-ms-thumb{box-shadow:0 1px 1px #23282f26,0 0 0 1px #23282f33,0 0 0 3px #ffffff80;box-shadow:var(--plyr-range-thumb-shadow,0 1px 1px #23282f26,0 0 0 1px #23282f33),0 0 0 var(--plyr-range-thumb-active-shadow-width,3px) var(--plyr-audio-range-thumb-active-shadow-color,#ffffff80)}.plyr--video .plyr__progress__buffer{color:#ffffff40;color:var(--plyr-video-progress-buffered-background,#ffffff40)}.plyr:fullscreen{background:#000;border-radius:0!important;height:100%;margin:0;width:100%}.plyr:fullscreen video{height:100%}.plyr:fullscreen .plyr__control .icon--exit-fullscreen{display:block}.plyr:fullscreen .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr:fullscreen.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr:fullscreen .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr--fullscreen-fallback{background:#000;border-radius:0!important;bottom:0;height:100%;left:0;margin:0;position:fixed;right:0;top:0;width:100%;z-index:10000000}.plyr--fullscreen-fallback video{height:100%}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen{display:block}.plyr--fullscreen-fallback .plyr__control .icon--exit-fullscreen+svg{display:none}.plyr--fullscreen-fallback.plyr--hide-controls{cursor:none}@media (min-width:1024px){.plyr--fullscreen-fallback .plyr__captions{font-size:21px;font-size:var(--plyr-font-size-xlarge,21px)}}.plyr__ads{border-radius:inherit;bottom:0;cursor:pointer;left:0;overflow:hidden;position:absolute;right:0;top:0;z-index:-1}.plyr__ads>div,.plyr__ads>div iframe{height:100%;position:absolute;width:100%}.plyr__ads:after{background:#23282f;border-radius:2px;bottom:10px;bottom:var(--plyr-control-spacing,10px);color:#fff;content:attr(data-badge-text);font-size:11px;padding:2px 6px;pointer-events:none;position:absolute;right:10px;right:var(--plyr-control-spacing,10px);z-index:3}.plyr__ads:empty:after{display:none}.plyr__cues{background:currentColor;display:block;height:5px;height:var(--plyr-range-track-height,5px);left:0;opacity:.8;position:absolute;top:50%;transform:translateY(-50%);width:3px;z-index:3}.plyr__preview-thumb{background-color:#fff;background-color:var(--plyr-tooltip-background,#fff);border-radius:8px;border-radius:var(--plyr-menu-radius,8px);bottom:100%;box-shadow:0 1px 2px #00000026;box-shadow:var(--plyr-tooltip-shadow,0 1px 2px #00000026);margin-bottom:10px;margin-bottom:calc(var(--plyr-control-spacing, 10px)/2*2);opacity:0;padding:3px;pointer-events:none;position:absolute;transform:translateY(10px) scale(.8);transform-origin:50% 100%;transition:transform .2s ease .1s,opacity .2s ease .1s;z-index:2}.plyr__preview-thumb--is-shown{opacity:1;transform:translate(0) scale(1)}.plyr__preview-thumb:before{border-left:4px solid #0000;border-left:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-right:4px solid #0000;border-right:var(--plyr-tooltip-arrow-size,4px) solid #0000;border-top:4px solid #fff;border-top:var(--plyr-tooltip-arrow-size,4px) solid var(--plyr-tooltip-background,#fff);bottom:-4px;bottom:calc(var(--plyr-tooltip-arrow-size, 4px)*-1);content:\"\";height:0;left:calc(50% + var(--preview-arrow-offset));position:absolute;transform:translateX(-50%);width:0;z-index:2}.plyr__preview-thumb__image-container{background:#c1c8d1;border-radius:7px;border-radius:calc(var(--plyr-menu-radius, 8px) - 1px);overflow:hidden;position:relative;z-index:0}.plyr__preview-thumb__image-container img,.plyr__preview-thumb__image-container:after{height:100%;left:0;position:absolute;top:0;width:100%}.plyr__preview-thumb__image-container:after{border-radius:inherit;box-shadow:inset 0 0 0 1px #00000026;content:\"\";pointer-events:none}.plyr__preview-thumb__image-container img{max-height:none;max-width:none}.plyr__preview-thumb__time-container{background:linear-gradient(#0000,#000000bf);background:var(--plyr-video-controls-background,linear-gradient(#0000,#000000bf));border-bottom-left-radius:7px;border-bottom-left-radius:calc(var(--plyr-menu-radius, 8px) - 1px);border-bottom-right-radius:7px;border-bottom-right-radius:calc(var(--plyr-menu-radius, 8px) - 1px);bottom:0;left:0;line-height:1.1;padding:20px 6px 6px;position:absolute;right:0;z-index:3}.plyr__preview-thumb__time-container span{color:#fff;font-size:13px;font-size:var(--plyr-font-size-time,var(--plyr-font-size-small,13px))}.plyr__preview-scrubbing{bottom:0;filter:blur(1px);height:100%;left:0;margin:auto;opacity:0;overflow:hidden;pointer-events:none;position:absolute;right:0;top:0;transition:opacity .3s ease;width:100%;z-index:1}.plyr__preview-scrubbing--is-shown{opacity:1}.plyr__preview-scrubbing img{height:100%;left:0;max-height:none;max-width:none;object-fit:contain;position:absolute;top:0;width:100%}.plyr--no-transition{transition:none!important}.plyr__sr-only{clip:rect(1px,1px,1px,1px);border:0!important;height:1px!important;overflow:hidden;padding:0!important;position:absolute!important;width:1px!important}.plyr [hidden]{display:none!important}";
const defaultPlyrControls = ['play-large', 'restart',
// Restart playback
'rewind',
// Rewind by the seek time (default 10 seconds)
'play',
// Play/pause playback
'fast-forward',
// Fast forward by the seek time (default 10 seconds)
'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'airplay', 'fullscreen'];
let Plyr = undefined;
const PlyrVideo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    playerRef,
    noPlyr = false,
    controls,
    ...rest
  } = props;
  const _ref = ref || /*#__PURE__*/React.createRef();
  useEffect(() => {
    if (noPlyr) return;
    const videoEl = _ref.current;
    if (!videoEl) return;
    if (!noPlyr && !Plyr) Plyr = require('plyr');
    const player = new Plyr(videoEl, {
      controls: controls || defaultPlyrControls
    });
    if (playerRef) playerRef.current = player;
  }, [ref, playerRef, noPlyr, controls]);
  return /*#__PURE__*/React.createElement(PlyrVideoWrapper, null, /*#__PURE__*/React.createElement("video", _extends({}, rest, {
    ref: _ref
  }), children));
});
const PlyrVideoWrapper = styled.div.withConfig({
  displayName: "PlyrVideo__PlyrVideoWrapper",
  componentId: "sc-1y1qcby-0"
})(["", " --plyr-color-main:", ";.plyr__captions{z-index:1;}"], plyrCSS, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primary.main;
});
const MobileFirstVideo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isFullViewport = false,
    quality = 80,
    publicId,
    publicIdMobile,
    portraitEnabled = true,
    trackTextId,
    trackTextIds,
    controls,
    autoPlay,
    ...rest
  } = props;
  const [canPlay, setCanPlay] = useState(false);
  const {
    enhanced
  } = useEnhancedContext();
  const shouldAutoplay = enhanced ? autoPlay : false;
  React.useEffect(() => {
    if (canPlay && autoPlay) {
      if (enhanced) ref.current.play();else {
        ref.current.pause();
        ref.current.currentTime = 0;
      }
    }
  }, [ref, autoPlay, enhanced, canPlay]);
  const _publicIdMobile = publicIdMobile || publicId;
  const isPortrait = useMediaQuery$1(match.isPortrait);
  let trackElement = null;
  if (trackTextId) {
    trackElement = /*#__PURE__*/React.createElement("track", {
      default: true,
      kind: "captions",
      label: "English captions",
      srcLang: "en",
      src: "https://res.cloudinary.com/klick/raw/upload/".concat(trackTextId, ".vtt")
    });
  } else if (trackTextIds) {
    trackElement = trackTextIds.map(el => {
      return /*#__PURE__*/React.createElement("track", {
        key: el.src,
        default: !!el.default,
        kind: "captions",
        label: el.label,
        srcLang: el.lang,
        src: el.src
      });
    });
  }
  const videoProps = {
    ref,
    crossOrigin: 'anonymous',
    tabIndex: controls ? '-1' : null,
    onCanPlay: () => {
      setCanPlay(true);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isFullViewport && isPortrait && portraitEnabled ? /*#__PURE__*/React.createElement(MobileFirstSwitch, null, /*#__PURE__*/React.createElement(Default, null, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 1 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_mp4,h_1624,q_".concat(quality, ",vc_h265,w_750/v1/").concat(_publicIdMobile, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_webm,h_1624,q_".concat(quality, ",vc_vp9,w_750/v1/").concat(_publicIdMobile, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_mp4,h_1624,q_".concat(quality, ",vc_auto,w_750/v1/").concat(_publicIdMobile, ".mp4"),
    type: "video/mp4"
  }), trackElement)), /*#__PURE__*/React.createElement(Breakpoint, {
    query: match.getQuery('isSM')
  }, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 2 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_mp4,h_2048,q_".concat(quality, ",vc_h265,w_1536/v1/").concat(_publicIdMobile, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_webm,h_2048,q_".concat(quality, ",vc_vp9,w_1536/v1/").concat(_publicIdMobile, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_fill,f_mp4,h_2048,q_".concat(quality, ",vc_auto,w_1536/v1/").concat(_publicIdMobile, ".mp4"),
    type: "video/mp4"
  }), trackElement))) : /*#__PURE__*/React.createElement(MobileFirstSwitch, null, /*#__PURE__*/React.createElement(Default, null, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 3 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_h265,w_992/").concat(publicId, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_webm,q_".concat(quality, ",vc_vp9,w_992/").concat(publicId, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_auto,w_992/").concat(publicId, ".mp4"),
    type: "video/mp4"
  }), trackElement)), /*#__PURE__*/React.createElement(Breakpoint, {
    query: match.getQuery('isMD')
  }, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 4 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_h265,w_1200/").concat(publicId, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_webm,q_".concat(quality, ",vc_vp9,w_1200/").concat(publicId, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_auto,w_1200/").concat(publicId, ".mp4"),
    type: "video/mp4"
  }), trackElement)), /*#__PURE__*/React.createElement(Breakpoint, {
    query: match.getQuery('isLG')
  }, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 5 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_h265,w_1600/").concat(publicId, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_webm,q_".concat(quality, ",vc_vp9,w_1600/").concat(publicId, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_auto,w_1600/").concat(publicId, ".mp4"),
    type: "video/mp4"
  }), trackElement)), /*#__PURE__*/React.createElement(Breakpoint, {
    query: match.getQuery('isXL')
  }, /*#__PURE__*/React.createElement(PlyrVideo, _extends({}, videoProps, rest, {
    key: isFullViewport ? 6 : null,
    autoPlay: shouldAutoplay
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_h265,w_1920/").concat(publicId, ".mp4"),
    type: "video/mp4; codecs=hvc1"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_webm,q_".concat(quality, ",vc_vp9,w_1920/").concat(publicId, ".webm"),
    type: "video/webm; codecs=vp9"
  }), /*#__PURE__*/React.createElement("source", {
    src: "https://res.cloudinary.com/klick/video/upload/c_scale,f_mp4,q_".concat(quality, ",vc_auto,w_1920/").concat(publicId, ".mp4"),
    type: "video/mp4"
  }), trackElement))));
});
const HeroVideo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    loopedId,
    loopedIdMobile,
    videoId,
    overlay,
    overlayColor,
    playBtnRef,
    poster,
    quality,
    portraitEnabled,
    trackTextId,
    trackTextIds,
    playPercentThreshold = 50,
    autoPlay = true,
    showTranscriptDL = false,
    customTranscriptURL,
    customTranscriptName,
    onFocus,
    videoProps = {},
    playText = 'Play',
    transcriptDLText = 'View Transcript',
    showCaptions,
    ...restProps
  } = props;
  const {
    enhanced
  } = useEnhancedContext();
  const playPercent = useRef(0);
  const trackedPercent = useRef(null);
  const playButtonLabelEl = useRef();
  const videoShortRef = useRef();
  const videoRef = useRef();
  const playerRef = useRef();
  const [hasPlayed, setHasPlayed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const trackId = videoId === null || videoId === void 0 ? void 0 : videoId.split('/').pop();
  useEffect(() => {
    const videoEl = videoRef.current;
    const trackPercent = () => {
      if (trackedPercent.current !== playPercent.current && playPercent.current !== 0) {
        trackedPercent.current = playPercent.current;
        tracking.track({
          event: 'video_progress',
          eventModel: {
            video_title: trackId,
            video_percent: playPercent.current,
            ...(playPercent.current >= playPercentThreshold && {})
          }
        });
        playPercent.current = 0;
        trackedPercent.current = null;
      }
    };
    const handleVideoUpdate = e => {
      const {
        currentTime,
        duration
      } = e.target;
      const currentPercent = millisecsToPercent$1(duration, currentTime);
      if (currentPercent > playPercent.current) {
        playPercent.current = currentPercent;
      }
    };
    const handleVideoEnd = () => {
      if (!hasEnded) {
        tracking.track({
          event: 'video_complete',
          eventModel: {
            video_title: trackId
          }
        });
        setHasEnded(true);
      }
      videoShortRef.current.play();
      const isFullscreen = isFullScreen();
      if (isFullscreen) {
        playerRef.current.fullscreen.exit();
      }
    };
    const handleWindowUnload = e => {
      trackPercent();
    };
    const handleFullScreenChange = () => {
      const isFullscreen = isFullScreen();
      if (!isFullscreen) {
        trackPercent();
        videoEl.currentTime = 0;
        playerRef.current.pause();
        document.body.style.overflow = '';
        setIsPlaying(false);
        if (enhanced) videoShortRef.current.play(true);
      }
    };
    const handleBlur = () => {
      if (isPlaying) {
        window.requestAnimationFrame(() => videoEl.focus());
      }
    };
    if (videoEl) {
      ['', 'webkit', 'moz', 'ms'].forEach(prefix => document.addEventListener(prefix + 'fullscreenchange', handleFullScreenChange));
      videoEl.addEventListener('blur', handleBlur);
      videoEl.addEventListener('webkitendfullscreen', handleFullScreenChange);
      videoEl.addEventListener('timeupdate', handleVideoUpdate);
      videoEl.addEventListener('ended', handleVideoEnd);
      window.addEventListener('beforeunload', handleWindowUnload);
    }
    const resetVideo = () => {
      if (videoEl) {
        ['', 'webkit', 'moz', 'ms'].forEach(prefix => document.removeEventListener(prefix + 'fullscreenchange', handleFullScreenChange));
        videoEl.removeEventListener('blur', handleBlur);
        videoEl.removeEventListener('webkitendfullscreen', handleFullScreenChange);
        videoEl.removeEventListener('timeupdate', handleVideoUpdate);
        videoEl.removeEventListener('ended', handleVideoEnd);
        window.removeEventListener('beforeunload', handleWindowUnload);
      }
    };
    return () => {
      resetVideo();
    };
  }, [hasEnded, trackId, playPercentThreshold, enhanced, isPlaying]);
  const isFullScreen = () => {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
  };
  const handlePlayClick = () => {
    videoShortRef.current.pause();
    const videoEl = videoRef.current;
    playerRef.current.fullscreen.enter();
    playerRef.current.fullscreen.trapFocus();
    playerRef.current.play();
    if (showCaptions) playerRef.current.toggleCaptions(true);
    videoEl.focus();
    setIsPlaying(true);
    if (!hasPlayed) {
      tracking.track({
        event: 'video_start',
        eventModel: {
          video_title: trackId
        }
      });
      setHasPlayed(true);
    }
  };
  const transcriptDownloadUrl = customTranscriptURL || "https://res.cloudinary.com/klick/raw/upload/".concat(trackTextId, ".txt");
  const handleDownloadClick = e => {
    const element = e.currentTarget;
    const isInternal = /^[/#](?!\/)/.test(element.href);
    tracking.track({
      event: 'file_download',
      eventModel: {
        file_extension: 'txt',
        file_name: customTranscriptName || transcriptDownloadUrl.split('/').pop(),
        track_id: "".concat(trackId, "_transcript"),
        link_id: element.id,
        link_classes: element.className,
        link_domain: isInternal ? window.location.hostname : new URL(element.href).hostname,
        link_url: transcriptDownloadUrl.replace(/^blob:/, '')
      }
    });
  };
  return /*#__PURE__*/React.createElement(VideoContainer$2, _extends({
    ref: ref
  }, restProps), /*#__PURE__*/React.createElement(VideoContainerInner, null, /*#__PURE__*/React.createElement(LoopedVideo, _extends({
    ref: videoShortRef,
    publicId: loopedId,
    publicIdMobile: loopedIdMobile,
    isFullViewport: true,
    portraitEnabled: portraitEnabled,
    autoPlay: autoPlay,
    muted: true,
    loop: true,
    playsInline: true,
    poster: poster && poster,
    quality: quality,
    "aria-hidden": true,
    noPlyr: true
  }, videoProps)), videoId && typeof document !== "undefined" && /*#__PURE__*/React.createElement(Portal$1, {
    container: document.body
  }, /*#__PURE__*/React.createElement(FullVideoWrapper, {
    $hidden: !isPlaying
  }, /*#__PURE__*/React.createElement(FullVideo, _extends({
    crossOrigin: "anonymous",
    ref: videoRef,
    playerRef: playerRef,
    publicId: videoId,
    quality: quality,
    trackTextId: trackTextId,
    trackTextIds: trackTextIds
  }, videoProps)))), !isPlaying && overlay && /*#__PURE__*/React.createElement(Overlay, {
    $color: overlayColor
  }), /*#__PURE__*/React.createElement(PlayButton$2, {
    onClick: handlePlayClick,
    onFocus: onFocus,
    ref: playBtnRef,
    "aria-label": "Play",
    $visible: !isPlaying && videoId
  }, /*#__PURE__*/React.createElement("span", {
    ref: playButtonLabelEl
  }, playText)), !isPlaying && showTranscriptDL && /*#__PURE__*/React.createElement(TranscriptButtonContainer, null, /*#__PURE__*/React.createElement(TranscriptButtonContent, null, /*#__PURE__*/React.createElement(TranscriptButton, {
    href: transcriptDownloadUrl,
    download: customTranscriptName,
    linkTracking: false,
    onClick: handleDownloadClick,
    onFocus: onFocus
  }, transcriptDLText)))));
});
const VideoContainer$2 = styled.div.withConfig({
  displayName: "HeroVideo__VideoContainer",
  componentId: "sc-1xcmb1x-0"
})(["overflow:hidden;position:relative;background:#000;height:100%;width:100%;"]);
const VideoContainerInner = styled.div.withConfig({
  displayName: "HeroVideo__VideoContainerInner",
  componentId: "sc-1xcmb1x-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(1);width:100%;height:100%;background-color:#000000;font-size:0;"]);
const LoopedVideo = styled(MobileFirstVideo).withConfig({
  displayName: "HeroVideo__LoopedVideo",
  componentId: "sc-1xcmb1x-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);min-width:100%;min-height:100%;z-index:2;object-fit:cover;@media ", "{width:100%;}"], match.isPortrait);
const FullVideoWrapper = styled.div.withConfig({
  displayName: "HeroVideo__FullVideoWrapper",
  componentId: "sc-1xcmb1x-3"
})(["visibility:", ";display:", ";"], _ref => {
  let {
    $hidden
  } = _ref;
  return $hidden ? 'hidden' : 'visible';
}, _ref2 => {
  let {
    $hidden
  } = _ref2;
  return $hidden ? 'none' : 'block';
});
const FullVideo = styled(MobileFirstVideo).withConfig({
  displayName: "HeroVideo__FullVideo",
  componentId: "sc-1xcmb1x-4"
})(["z-index:1;position:relative;min-width:100%;min-height:100%;"]);
const Overlay = styled.div.withConfig({
  displayName: "HeroVideo__Overlay",
  componentId: "sc-1xcmb1x-5"
})(["top:0;position:absolute;height:100%;width:100%;background:", ";z-index:2;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){opacity:0.7;background:", ";mix-blend-mode:normal;}"], _ref3 => {
  let {
    theme,
    $color
  } = _ref3;
  return $color || theme.palette.primary.main;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.palette.primary.main;
});
const PlayButton$2 = styled.button.withConfig({
  displayName: "HeroVideo__PlayButton",
  componentId: "sc-1xcmb1x-6"
})(["display:", ";border:none;font-family:", ";background:none;position:absolute;border-radius:50%;z-index:3;margin:0;padding:0;width:200px;height:200px;cursor:pointer;color:#ffffff;left:50%;top:50%;transform:translate(-50%,-50%);&:hover,&:focus{span{background:", ";}}span{display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:0;padding:0;width:80px;height:80px;line-height:80px;text-align:center;border-radius:50%;background-color:rgba(0,0,0,0.5);transition:background 0.3s ease-out;color:#ffffff;font-size:16px;cursor:pointer;}"], _ref5 => {
  let {
    $visible
  } = _ref5;
  return $visible ? 'block' : 'none';
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.fontFamily;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.palette.primary.main;
});
const TranscriptButtonContainer = styled.div.withConfig({
  displayName: "HeroVideo__TranscriptButtonContainer",
  componentId: "sc-1xcmb1x-7"
})(["position:absolute;top:0;height:inherit;width:100%;"]);
const TranscriptButtonContent = styled(Container$4).withConfig({
  displayName: "HeroVideo__TranscriptButtonContent",
  componentId: "sc-1xcmb1x-8"
})(["height:inherit;position:relative;"]);
const TranscriptButton = styled(Link).withConfig({
  displayName: "HeroVideo__TranscriptButton",
  componentId: "sc-1xcmb1x-9"
})(["position:absolute;left:24px;bottom:16px;z-index:3;background-color:rgba(0,0,0,0.5);padding:4px 10px;font-family:", ";font-size:0.8125rem;font-weight:700;line-height:1.75;text-decoration:none;color:", ";transition:background 0.3s;&:hover,&:focus{background:", ";outline:none;}"], _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.typography.fontFamily;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.palette.common.white;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.palette.primary.main;
});
const millisecsToPercent$1 = (duration, time) => Math.floor(time / duration * 100);
const ImageVideo = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    videoId,
    playBtnRef,
    trackingLabel = 'unlabeled',
    poster,
    quality,
    image,
    trackTextId,
    ...props
  } = _ref;
  const playPercent = useRef(0);
  const trackedPercent = useRef(null);
  const playButtonLabelEl = useRef();
  const videoRef = useRef();
  const playerRef = useRef();
  const [hasPlayed, setHasPlayed] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    const videoEl = videoRef.current;
    const trackPercent = () => {
      if (trackedPercent.current !== playPercent.current && playPercent.current !== 0) {
        trackedPercent.current = playPercent.current;
        tracking.track({
          event: 'video_progress',
          eventModel: {
            video_title: trackingLabel,
            video_percent: playPercent.current
          }
        });
        playPercent.current = 0;
        trackedPercent.current = null;
      }
    };
    const handleVideoUpdate = e => {
      const {
        currentTime,
        duration
      } = e.target;
      const currentPercent = millisecsToPercent(duration, currentTime);
      if (currentPercent > playPercent.current) {
        playPercent.current = currentPercent;
      }
    };
    const handleVideoEnd = () => {
      if (!hasEnded) {
        tracking.track({
          event: 'video_complete',
          eventModel: {
            video_title: trackingLabel
          }
        });
        setHasEnded(true);
      }
      const isFullscreen = isFullScreen();
      if (isFullscreen) {
        playerRef.current.fullscreen.exit();
      }
    };
    const handleWindowUnload = e => {
      trackPercent();
    };
    const handleFullScreenChange = () => {
      const isFullscreen = isFullScreen();
      if (!isFullscreen) {
        trackPercent();
        setIsPlaying(false);
        playerRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    };
    if (videoEl) {
      ['', 'webkit', 'moz', 'ms'].forEach(prefix => document.addEventListener(prefix + 'fullscreenchange', handleFullScreenChange));
      videoEl.addEventListener('webkitendfullscreen', handleFullScreenChange);
      videoEl.addEventListener('timeupdate', handleVideoUpdate);
      videoEl.addEventListener('ended', handleVideoEnd);
      window.addEventListener('beforeunload', handleWindowUnload);
    }
    const resetVideo = () => {
      if (videoEl) {
        ['', 'webkit', 'moz', 'ms'].forEach(prefix => document.removeEventListener(prefix + 'fullscreenchange', handleFullScreenChange));
        videoEl.removeEventListener('webkitendfullscreen', handleFullScreenChange);
        videoEl.removeEventListener('timeupdate', handleVideoUpdate);
        videoEl.removeEventListener('ended', handleVideoEnd);
        window.removeEventListener('beforeunload', handleWindowUnload);
      }
    };
    return () => {
      resetVideo();
    };
  }, [hasEnded, trackingLabel]);
  const isFullScreen = () => {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
  };
  const handlePlayClick = () => {
    const videoEl = videoRef.current;
    playerRef.current.fullscreen.enter();
    playerRef.current.fullscreen.trapFocus();
    playerRef.current.play();
    videoEl.focus();
    setIsPlaying(true);
    if (!hasPlayed) {
      tracking.track({
        event: 'video_start',
        eventModel: {
          video_title: trackingLabel
        }
      });
      setHasPlayed(true);
    }
  };
  return /*#__PURE__*/React.createElement(VideoContainer$1, _extends({
    ref: ref
  }, props), !isPlaying && /*#__PURE__*/React.createElement(DisplayContainer, null, /*#__PURE__*/React.createElement(PlayButton$1, {
    onClick: handlePlayClick,
    ref: playBtnRef
  }, /*#__PURE__*/React.createElement("span", {
    ref: playButtonLabelEl
  }, "Play")), /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(ImageContainerInner, null, image))), /*#__PURE__*/React.createElement(PlayerContainer, {
    $hidden: !isPlaying
  }, /*#__PURE__*/React.createElement(MobileFirstVideo, {
    ref: videoRef,
    playerRef: playerRef,
    publicId: videoId,
    preload: "none",
    quality: quality,
    trackTextId: trackTextId
  })), ",");
});
const VideoContainer$1 = styled(Box).withConfig({
  displayName: "ImageVideo__VideoContainer",
  componentId: "sc-itywv-0"
})(["overflow:hidden;position:relative;height:100%;width:100%;"]);
const DisplayContainer = styled.div.withConfig({
  displayName: "ImageVideo__DisplayContainer",
  componentId: "sc-itywv-1"
})(["position:relative;z-index:2;"]);
const PlayerContainer = styled.div.withConfig({
  displayName: "ImageVideo__PlayerContainer",
  componentId: "sc-itywv-2"
})(["visibility:", ";"], _ref2 => {
  let {
    $hidden
  } = _ref2;
  return $hidden ? 'hidden' : 'visible';
});
const ImageContainer = styled.div.withConfig({
  displayName: "ImageVideo__ImageContainer",
  componentId: "sc-itywv-3"
})(["border-radius:50%;overflow:hidden;transform:scale3d(1,1,1);"]);
const ImageContainerInner = styled.div.withConfig({
  displayName: "ImageVideo__ImageContainerInner",
  componentId: "sc-itywv-4"
})(["transition:transform 0.3s ease-out;transform:scale3d(1,1,1);"]);
const PlayButton$1 = styled.button.withConfig({
  displayName: "ImageVideo__PlayButton",
  componentId: "sc-itywv-5"
})(["border:none;background:none;position:absolute;border-radius:50%;z-index:2;margin:0;padding:0;width:100%;height:100%;cursor:pointer;color:#ffffff;&:hover,&:focus{span{background:", ";}& + ", " ", "{transform:scale3d(1.05,1.05,1);}}span{display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);margin:0;padding:0;width:80px;height:80px;line-height:80px;text-align:center;border-radius:50%;background-color:rgba(0,0,0,0.5);transition:background 0.3s ease-out;color:#ffffff;font-size:16px;cursor:pointer;}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
}, ImageContainer, ImageContainerInner);
const millisecsToPercent = (duration, time) => Math.floor(time / duration * 100);
const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    zIndex: 20,
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }
}));
function ScrollTop(props) {
  const {
    children,
    window
  } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100
  });
  const handleClick = event => {
    tracking.track({
      event: 'user_interaction',
      eventModel: {
        track_id: 'back_to_top_btn'
      }
    });
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Scroll to top"
  }, /*#__PURE__*/React.createElement(Zoom, {
    in: trigger
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: classes.root
  }, children)));
}
const BackToTop = props => {
  return /*#__PURE__*/React.createElement(ScrollTop, props, /*#__PURE__*/React.createElement(Fab, {
    color: "primary",
    size: "small",
    "aria-label": "scroll back to top"
  }, /*#__PURE__*/React.createElement(KeyboardArrowUpIcon, null)));
};
const TextField = _ref => {
  let {
    helperText,
    variant = 'outlined',
    type = 'text',
    ...props
  } = _ref;
  const [field, meta] = useField(props);
  return /*#__PURE__*/React.createElement(StyledMuiTextField, _extends({
    variant: variant,
    error: meta.touched && !!meta.error,
    helperText: meta.touched && meta.error || helperText,
    type: type
  }, field, props));
};
const StyledMuiTextField = styled(MuiTextField).withConfig({
  displayName: "TextField__StyledMuiTextField",
  componentId: "sc-19ubczo-0"
})(["label.Mui-focused{color:", ";}&.Mui-disabled,.Mui-disabled{cursor:not-allowed;}"], props => props.theme.palette.text.secondary);
const SelectField = _ref => {
  let {
    helperText,
    variant = 'outlined',
    ...props
  } = _ref;
  const [field, meta] = useField(props);
  return /*#__PURE__*/React.createElement(MuiSelectField, _extends({
    variant: variant,
    error: meta.touched && !!meta.error,
    helperText: meta.touched && meta.error || helperText
  }, field, props));
};
const MuiSelectField = _ref2 => {
  let {
    label,
    options,
    variant,
    id,
    name,
    error,
    helperText,
    fullWidth,
    inputProps = {},
    disabled,
    ...restProps
  } = _ref2;
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    error: error
  }, fullWidth ? {
    fullWidth
  } : null, variant ? {
    variant
  } : null, {
    disabled: disabled
  }), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: id,
    ref: inputLabel
  }, label), /*#__PURE__*/React.createElement(MuiSelect, _extends({}, restProps, {
    inputProps: {
      name,
      id,
      ...inputProps
    },
    labelId: id,
    labelWidth: labelWidth
  }), options && options.map(_ref3 => {
    let {
      label,
      value,
      disabled: optionDisabled
    } = _ref3;
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: value,
      value: value,
      disabled: optionDisabled
    }, label);
  })), helperText && /*#__PURE__*/React.createElement(FormHelperText, null, helperText));
};
const RadioGroup = _ref => {
  let {
    helperText,
    ...props
  } = _ref;
  const [field, meta] = useField(props);
  return /*#__PURE__*/React.createElement(MuiRadioField, _extends({
    error: meta.touched && !!meta.error,
    helperText: meta.touched && meta.error || helperText
  }, field, props));
};
const MuiRadioField = _ref2 => {
  let {
    label,
    options,
    id,
    name,
    error,
    helperText,
    fullWidth,
    disabled,
    ...restProps
  } = _ref2;
  const labelId = "".concat(id, "-label");
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    component: "fieldset",
    error: error,
    disabled: disabled
  }, fullWidth ? {
    fullWidth
  } : null), label && /*#__PURE__*/React.createElement(FormLabel, {
    component: "legend",
    id: labelId
  }, label), /*#__PURE__*/React.createElement(MuiRadioGroup, _extends({
    id: id,
    name: name
  }, label && {
    'aria-labelledby': labelId
  }, restProps), options && options.map(_ref3 => {
    let {
      label,
      value,
      disabled: optionDisabled
    } = _ref3;
    return /*#__PURE__*/React.createElement(FormControlLabel$1, {
      key: value,
      value: value,
      disabled: optionDisabled,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: label
    });
  })), helperText && /*#__PURE__*/React.createElement(FormHelperText, null, helperText));
};
const Checkbox$1 = _ref => {
  let {
    helperText,
    ...props
  } = _ref;
  const [field, meta] = useField(props);
  return /*#__PURE__*/React.createElement(LabeledCheckbox, _extends({
    error: meta.touched && !!meta.error,
    helperText: meta.touched && meta.error || helperText
  }, field, props));
};
const defaultProps = {
  labelProps: {}
};
const LabeledCheckbox = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    label,
    labelPlacement = 'top',
    onMouseOver,
    onMouseLeave,
    onTouchStart,
    onTouchEnd,
    onFocus,
    onBlur,
    helperText,
    error,
    labelProps = defaultProps.labelProps,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(FormControl$1, {
    error: error
  }, /*#__PURE__*/React.createElement(StyledFormControlLabel, _extends({
    ref: ref,
    htmlFor: restProps.id,
    label,
    labelPlacement,
    onMouseOver,
    onMouseLeave,
    onTouchStart,
    onTouchEnd,
    onFocus,
    onBlur,
    control: /*#__PURE__*/React.createElement(Checkbox$2, _extends({
      checked: restProps.value,
      color: "primary"
    }, restProps))
  }, labelProps)), helperText && /*#__PURE__*/React.createElement(FormHelperText$1, null, helperText));
});
const StyledFormControlLabel = styled(FormControlLabel).withConfig({
  displayName: "Checkbox__StyledFormControlLabel",
  componentId: "sc-ts8mvv-0"
})(["[class*='MuiFormControlLabel-label-']{color:", ";}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.text.primary;
});
const CheckboxGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    name,
    label,
    labelPlacement = 'end',
    options,
    helperText
  } = props;
  const [field, meta] = useField({
    name
  });
  const hasError = meta.touched && !!meta.error;
  const _helperText = meta.touched && meta.error || helperText;
  return /*#__PURE__*/React.createElement(FormControl$1, {
    className: className,
    component: "fieldset",
    error: hasError,
    ref: ref
  }, label && /*#__PURE__*/React.createElement(FormLabel$1, {
    component: "legend"
  }, label), /*#__PURE__*/React.createElement(FormGroup, null, options.map(props => /*#__PURE__*/React.createElement(Checkbox, _extends({
    key: props.id,
    labelPlacement: labelPlacement,
    name: name
  }, field, props)))), _helperText && /*#__PURE__*/React.createElement(FormHelperText$1, null, _helperText));
});
const Checkbox = props => {
  const {
    label,
    id,
    labelPlacement,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    htmlFor: id,
    label: label,
    labelPlacement: labelPlacement,
    control: /*#__PURE__*/React.createElement(Checkbox$2, _extends({
      id: id,
      color: "primary"
    }, rest))
  });
};
const noOp = () => {};
const UploadField = props => {
  const {
    name,
    label,
    variant = 'outlined',
    supportedFileTypes,
    maxFileSize = MAX_FILE_SIZE,
    fileMetaMap = FILE_META_MAP,
    helperText = getSupportedFileTypesLabel(props.supportedFileTypes),
    uploadProgress,
    onChange = noOp,
    ...restProps
  } = props;
  const [field, meta, helper] = useField(props);
  const [selectedFile, setSelectedFile] = React.useState();
  const fileInputRef = React.useRef();
  const fileInputName = "".concat(name, "-fileinput");
  const hasError = meta.touched && !!meta.error;
  const _helperText = meta.touched && meta.error || helperText;
  const _label = (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name) || label;
  const isUploading = !(uploadProgress === false);
  const isClearable = !isUploading && !!selectedFile;
  const supportedFileTypesStr = supportedFileTypes === null || supportedFileTypes === void 0 ? void 0 : supportedFileTypes.join(', ');
  const handleOnChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    const filename = file.name;
    const fileExt = filename.split('.').pop().toLowerCase();
    const testFile = async file => {
      try {
        const isSupported = !supportedFileTypes || supportedFileTypes.includes(fileExt);
        if (file.size > maxFileSize) {
          const fileSizeInMB = Math.ceil(maxFileSize / 10000);
          throw new Error("File is loo large - ".concat(fileSizeInMB, " Mb maximum"));
        } else if (!isSupported) {
          throw new Error("Your file is invalid. Valid filetypes: ".concat(supportedFileTypes.join(', ')));
        }
        helper.setError(false);
        helper.setValue('');
        onChange(e, file);
      } catch (e) {
        console.log('Failed to upload file:', e);
        helper.setError(e);
      }
    };
    testFile(file);
    helper.setTouched(true, false);
    setSelectedFile(file);
  };
  const handleClearFiles = e => {
    e.preventDefault();
    fileInputRef.current.value = '';
    helper.setError(false);
    setSelectedFile(undefined);
  };
  const handleLabelClick = e => {
    if (isUploading) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: fileInputName,
    hasError: hasError,
    variant: variant,
    onClick: handleLabelClick
  }, /*#__PURE__*/React.createElement(LabelTextContainer, {
    isUploading: isUploading
  }, /*#__PURE__*/React.createElement("span", null, isUploading ? "Uploading... ".concat(uploadProgress, "%") : _label), isClearable && /*#__PURE__*/React.createElement(ClearButton, {
    type: "button",
    onClick: handleClearFiles
  }, /*#__PURE__*/React.createElement(IconClose, null))), /*#__PURE__*/React.createElement(UploadIcon, {
    disabled: isUploading
  }, isUploading ? /*#__PURE__*/React.createElement(_StyledCircularProgress, {
    size: 26
  }) : /*#__PURE__*/React.createElement(CloudUpload, null)), /*#__PURE__*/React.createElement(FileInput, {
    id: fileInputName,
    type: "file",
    ref: fileInputRef,
    accept: supportedFileTypesStr,
    onChange: handleOnChange
  }), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: uploadProgress
  }), /*#__PURE__*/React.createElement("input", _extends({
    type: "hidden",
    id: name
  }, field, restProps))), _helperText && /*#__PURE__*/React.createElement(FormHelperText, {
    error: hasError
  }, _helperText));
};
const MAX_FILE_SIZE = 100000000; // one hundred MB
const FILE_META_MAP = {
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  zip: 'application/zip',
  key: 'application/vnd.apple.keynote',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};
const getSupportedFileTypesLabel = supportedFileTypes => "* Supported formats: ".concat((supportedFileTypes === null || supportedFileTypes === void 0 ? void 0 : supportedFileTypes.join(', ').concat('.')) || '*.*');
const IconClose = styled(Close).withConfig({
  displayName: "UploadField__IconClose",
  componentId: "sc-1tzu3n6-0"
})(["color:white;background:grey;border-radius:50%;padding:10%;cursor:pointer;"]);
const ClearButton = styled.button.withConfig({
  displayName: "UploadField__ClearButton",
  componentId: "sc-1tzu3n6-1"
})(["position:absolute;right:0;background:white;border:none;:hover,:focus{", "{background:", ";}}"], IconClose, props => props.theme.palette.primary.main);
const FileInput = styled.input.withConfig({
  displayName: "UploadField__FileInput",
  componentId: "sc-1tzu3n6-2"
})(["opacity:0;width:0.1px;height:0.1px;position:absolute;overflow:hidden;z-index:-1;"]);
const uploadIconWidth = '85px';
const UploadIcon = styled.div.withConfig({
  displayName: "UploadField__UploadIcon",
  componentId: "sc-1tzu3n6-3"
})(["display:flex;justify-content:center;align-items:center;vertical-align:middle;width:", ";height:100%;text-align:center;background-color:", ";color:#fff;position:absolute;top:0;right:0;cursor:pointer;"], uploadIconWidth, props => props.disabled ? 'grey' : props.theme.palette.primary.main);
const Label = styled.label.withConfig({
  displayName: "UploadField__Label",
  componentId: "sc-1tzu3n6-4"
})(["position:relative;display:block;overflow:hidden;cursor:pointer;height:56px;", ""], _ref => {
  let {
    variant,
    hasError,
    theme
  } = _ref;
  if (variant === 'outlined') {
    const muErrorColor = '#F44336';
    const borderColor = hasError ? muErrorColor : theme.palette.primary.main;
    return "\n      ".concat(UploadIcon, " {\n        border: 1px solid rgba(0, 0, 0, 0.23);\n        border-left: 0;\n        border-color: ").concat(borderColor, ";\n      }\n\n\n      ").concat(LabelTextContainer, " {\n        border: 1px solid rgba(0, 0, 0, 0.23);\n        border-right: 0;\n        border-color: ").concat(borderColor, ";\n      }\n    ");
  }
});
const ProgressBar = styled.div.attrs(_ref2 => {
  let {
    progress
  } = _ref2;
  return {
    style: {
      width: "".concat(progress, "%")
    }
  };
}).withConfig({
  displayName: "UploadField__ProgressBar",
  componentId: "sc-1tzu3n6-5"
})(["position:absolute;left:1px;bottom:0;margin:0;padding:0;height:3px;background:", ";transition:width 300ms ease-out;"], props => "linear-gradient(\n    to right,\n    ".concat(props.theme.palette.primary.main, " 0%,\n    ").concat(props.theme.palette.primary.main, " calc(100% - 120px),\n    transparent 100%\n  )"));
const LabelTextContainer = styled.div.withConfig({
  displayName: "UploadField__LabelTextContainer",
  componentId: "sc-1tzu3n6-6"
})(["position:absolute;top:0;bottom:0;display:flex;align-items:center;justify-content:space-between;width:calc(100% - ", ");padding:14px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:14px;font-family:'Roboto','Helvetica','Arial',sans-serif;color:", ";border:1px solid rgba(0,0,0,0.23);"], uploadIconWidth, _ref3 => {
  let {
    isUploading
  } = _ref3;
  return isUploading ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 0.54)';
});
var _StyledCircularProgress = styled(CircularProgress).withConfig({
  displayName: "UploadField___StyledCircularProgress",
  componentId: "sc-1tzu3n6-7"
})(["color:white;"]);
const UploadFileToLeverField = props => {
  const {
    leverEndpoint,
    name,
    ...rest
  } = props;
  const [uploadProgress, setUploadProgress] = React.useState(false);
  const {
    2: helper
  } = useField({
    name
  });
  const uploadUri = "".concat(leverEndpoint, "/uploads");
  const handleOnChange = (e, file) => {
    console.log({
      file
    });
    async function uploadToLever(file) {
      const formData = new FormData();
      formData.append('file', file);
      const uri = await axios.post(uploadUri, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: e => {
          const percentUploaded = Math.round(e.loaded * 100 / e.total);
          console.log("".concat(percentUploaded, "%"));
          setUploadProgress(percentUploaded);
        }
      }).then(_ref => {
        let {
          data
        } = _ref;
        setUploadProgress(false);
        return data.data.uri;
      });
      console.log({
        uri
      });
      helper.setValue(uri);
    }
    uploadToLever(file);
  };
  return /*#__PURE__*/React.createElement(UploadField, _extends({
    name: name,
    onChange: handleOnChange,
    uploadProgress: uploadProgress
  }, rest));
};
const ContentBlock = _ref => {
  let {
    heading,
    decorator,
    subheading,
    content,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Box$1, rest, heading && typeof heading === 'string' ? /*#__PURE__*/React.createElement(Heading, {
    variant: "h2"
  }, heading) : heading, decorator && /*#__PURE__*/React.createElement(Decorator, null), subheading && /*#__PURE__*/React.createElement(Heading, {
    variant: "h4",
    component: "p"
  }, subheading), content);
};
const WithCircle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    shouldLighten = true,
    shouldDarken = true
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    position: "relative"
  }, /*#__PURE__*/React.createElement(FadeIn$1, {
    from: "left"
  }, /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    zIndex: 2
  }, children)), /*#__PURE__*/React.createElement(FadeIn$1, {
    from: "right"
  }, /*#__PURE__*/React.createElement(Circle, {
    $shouldDarken: shouldDarken,
    $shouldLighten: shouldLighten
  })));
});
const breathe = _ref2 => {
  let {
    theme,
    $shouldLighten,
    $shouldDarken
  } = _ref2;
  const color = theme.palette.primary.main;
  return keyframes(["from{transform:translate(-50%,-50%) scale(1);background-color:", ";}to{transform:translate(-50%,-50%) scale(1.1);background-color:", ";}"], $shouldDarken ? darken$1(color, 0.3) : color, $shouldLighten ? lighten$1(color, 0.3) : color);
};
const Circle = styled.div.withConfig({
  displayName: "WithCircle__Circle",
  componentId: "sc-r22lxk-0"
})(["animation:", " 2s alternate infinite ease-in-out;background:radial-gradient(circle,transparent,", ");height:130px;width:130px;position:absolute;border-radius:50%;z-index:1;top:20px;left:100px;", "{height:400px;width:400px;top:50%;left:0;}"], props => breathe(props), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
}, match.isSM);
const useDebounce = function (fnToDebounce) {
  let durationInMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  const callRef = React.useRef();
  return () => {
    if (callRef.current !== undefined) {
      clearTimeout(callRef.current);
    }
    callRef.current = setTimeout(fnToDebounce, durationInMs);
  };
};
const ControlBar = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(ControlBarContainer, {
    p: 1
  }, children));
};
const ControlBarContainer = styled(Box).withConfig({
  displayName: "ControlBar__ControlBarContainer",
  componentId: "sc-2og8n6-0"
})(["margin-top:0;transition:all 0.3s;color:#999;font-size:0.7rem;text-transform:uppercase;lost-utility:clearfix;width:100%;display:flex;flex-direction:row;align-itmes:center;"]);
const PlayButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    isPlaying,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: isPlaying ? 'Pause' : 'Play',
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    ref: ref,
    size: "small",
    onClick: onClick,
    role: "button",
    "aria-pressed": isPlaying,
    "aria-label": "Play button"
  }, isPlaying ? /*#__PURE__*/React.createElement(PauseRounded, null) : /*#__PURE__*/React.createElement(PlayArrowRounded, null)));
});
const MuteButton = _ref2 => {
  let {
    volume,
    setVolume,
    fullscreen,
    defaultValue,
    seekState,
    onMouseEnter,
    isMute,
    setIsMute
  } = _ref2;
  let icon;
  if (isMute) icon = /*#__PURE__*/React.createElement(VolumeOffRounded, null);else if (volume >= 75) icon = /*#__PURE__*/React.createElement(VolumeUpRounded, null);else if (volume < 75 && volume >= 25) icon = /*#__PURE__*/React.createElement(VolumeDownRounded, null);else icon = /*#__PURE__*/React.createElement(VolumeMuteRounded, null);
  return /*#__PURE__*/React.createElement(PopupContainer, null, /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Volume Control",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => {
      setIsMute(!isMute);
    },
    role: "button",
    "aria-pressed": volume === 0,
    "aria-label": "Mute button",
    onMouseEnter: onMouseEnter
  }, icon)), !isMute && /*#__PURE__*/React.createElement(PopupBox, {
    $width: '48px',
    $height: '150px'
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      py: 3,
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Slider$1, {
    orientation: "vertical",
    defaultValue: defaultValue,
    value: volume,
    onChange: (e, newValue) => {
      setVolume(newValue);
      if (newValue >= 5) seekState.current.volumeSliderVal = newValue;
    },
    onChangeCommitted: (e, newValue) => {
      setVolume(newValue);
      if (newValue >= 5) seekState.current.volumeSliderVal = newValue;
    }
  }))));
};
const ForwardTenButton = _ref5 => {
  let {
    onClick
  } = _ref5;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Skip 10 seconds",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onClick,
    role: "button",
    "aria-label": "Skip 10 seconds"
  }, /*#__PURE__*/React.createElement(Forward10Rounded, null)));
};
const ReplayTenButton = _ref6 => {
  let {
    onClick
  } = _ref6;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Rewind 10 seconds",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onClick,
    role: "button",
    "aria-label": "Rewind 10 seconds"
  }, /*#__PURE__*/React.createElement(Replay10Rounded, null)));
};
const ClosedCaptionButton = _ref7 => {
  let {
    ccActive,
    setCCActive,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Toggle closed captions",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    size: "small",
    onClick: () => {
      setCCActive(!ccActive);
    },
    role: "button",
    "aria-label": "Toggle closed captions",
    "aria-pressed": ccActive
  }, rest), /*#__PURE__*/React.createElement(ClosedCaption, {
    color: ccActive ? 'primary' : 'secondary'
  })));
};
const ToggleInteractiveTranscript = _ref8 => {
  let {
    active,
    setActive,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Toggle interactive transcript",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    size: "small",
    onClick: () => {
      setActive(!active);
    },
    role: "button",
    "aria-label": "Toggle interactive transcript",
    "aria-pressed": active
  }, rest), /*#__PURE__*/React.createElement(Subject, {
    color: active ? 'primary' : 'secondary'
  })));
};
const DownloadTranscript = _ref9 => {
  let {
    href,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: "Download transcript",
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true
    }
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    size: "small"
  }, rest), /*#__PURE__*/React.createElement(Subtitles, null)));
};
const FullscreenButton = _ref10 => {
  let {
    fullscreen = false,
    onClick,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    title: fullscreen ? 'Exit Fullscreen' : 'Fullscreen',
    arrow: true,
    placement: "top",
    PopperProps: {
      disablePortal: true,
      style: {
        color: 'red'
      }
    }
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    size: "small",
    onClick: onClick,
    role: "button",
    "aria-label": "Fullscreen",
    "aria-pressed": fullscreen
  }, rest), fullscreen ? /*#__PURE__*/React.createElement(FullscreenExitRounded, null) : /*#__PURE__*/React.createElement(FullscreenRounded, null)));
};
const Timestamp = _ref11 => {
  let {
    timeState: {
      position = 0,
      duration = 0
    }
  } = _ref11;
  const spanWidth = React.useMemo(() => {
    const charCount = msToTime(parseInt(duration) * 1000).length;
    return "".concat(charCount, "ch");
  }, [duration]);
  return /*#__PURE__*/React.createElement(CenterAlignBox, {
    mx: 2
  }, /*#__PURE__*/React.createElement(P, {
    variant: "body2",
    component: "p"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: 'right',
      width: spanWidth,
      display: 'inline-block'
    }
  }, msToTime(parseInt(position) * 1000)), ' ', "|", ' ', /*#__PURE__*/React.createElement("span", {
    style: {
      width: spanWidth,
      display: 'inline-block'
    }
  }, msToTime(parseInt(duration) * 1000))));
};
const playbackSpeeds = [2, 1.5, 1.25, 1, 0.75];
const settingViews = {
  MENU: 'menu',
  QUALITY: 'quality',
  PLAYBACK: 'playback',
  LANGUAGE: 'language'
};
function getIsSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
const SettingsButton = _ref12 => {
  let {
    qualityState,
    setQualityState,
    playbackSpeed,
    setPlaybackSpeed,
    autoplay,
    toggleAutoplay,
    settingsOpen,
    setSettingsOpen,
    selectedLanguage,
    setSelectedLanguage,
    languages
  } = _ref12;
  const prevState = React.useRef({
    view: settingViews.MENU
  });
  const theme = useTheme$2();
  const isMobile = useMediaQuery$1(theme.breakpoints.down('sm'));
  const qualityRef = React.useRef();
  const playbackRef = React.useRef();
  const backQuality = React.useRef();
  const backPlayBack = React.useRef();
  const languagePlayBack = React.useRef();
  const [view, setView] = React.useState(settingViews.MENU);
  const toggleOpen = e => {
    e.stopPropagation();
    setSettingsOpen(!settingsOpen);
  };
  const qualityLabels = React.useMemo(() => {
    return qualityState.levels.map(level => level.label);
  }, [qualityState.levels]);
  React.useEffect(() => {
    if (settingsOpen) ;else {
      setView(settingViews.MENU);
    }
  }, [settingsOpen]);
  let currentQuality = qualityLabels[qualityState.qualityIndex] || qualityState.qualityLabel;
  if (qualityState.qualityIndex === 0 && qualityState.qualityLabel !== 'Auto') {
    currentQuality = "".concat(qualityLabels[qualityState.qualityIndex], " (").concat(qualityState.qualityLabel, ")");
  }
  return /*#__PURE__*/React.createElement(PopupContainer, null, /*#__PURE__*/React.createElement(PortalWithState, {
    closeOnEsc: true,
    onClose: () => {
      document.body.style.overflowY = 'unset';
      document.documentElement.style.overflowY = 'unset';
    },
    onOpen: () => {
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    }
  }, _ref13 => {
    let {
      openPortal,
      closePortal,
      isOpen,
      portal
    } = _ref13;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledTooltip, {
      title: "".concat(settingsOpen ? 'Hide' : 'Show', " Settings"),
      arrow: true,
      placement: "top",
      PopperProps: {
        disablePortal: true
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      role: "button",
      "aria-label": "Show settings",
      "aria-pressed": settingsOpen,
      onClick: e => {
        if (isMobile) {
          openPortal();
        } else {
          toggleOpen(e);
        }
      }
    }, /*#__PURE__*/React.createElement(StyledSettings, {
      $active: settingsOpen
    })))), portal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      onClick: closePortal,
      sx: {
        position: 'fixed',
        inset: 0,
        zIndex: 1200,
        background: '#000',
        opacity: 0.7
      },
      onScroll: () => {
        closePortal();
      }
    }), /*#__PURE__*/React.createElement(Box, {
      sx: {
        pointerEvents: 'none',
        position: 'fixed',
        inset: 0,
        zIndex: 1201,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      onClick: e => {
        // Do not want to closePortal when clicked.
        e.stopPropagation();
      },
      sx: {
        pointerEvents: 'all',
        background: 'black',
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(Box, {
      minWidth: "250px",
      sx: {
        display: 'grid',
        gap: '32px'
      }
    }, !getIsSafari() ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InputLabel$1, {
      htmlFor: "select-quality"
    }, "Quality"), /*#__PURE__*/React.createElement(StyledNativeSelect, {
      id: "select-quality",
      variant: "outlined",
      defaultValue: "hello",
      value: qualityState.qualityIndex,
      onChange: e => {
        setQualityState({
          ...qualityState,
          qualityIndex: Number(e.target.value)
        });
      }
    }, qualityState.levels.map((level, index) => /*#__PURE__*/React.createElement("option", {
      key: index,
      value: index
    }, level.label)))) : null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InputLabel$1, {
      htmlFor: "select-speed"
    }, "Speed"), /*#__PURE__*/React.createElement(StyledNativeSelect, {
      id: "select-speed",
      variant: "outlined",
      value: playbackSpeed,
      onChange: e => {
        setPlaybackSpeed(Number(e.target.value));
      }
    }, playbackSpeeds.map((speed, index) => /*#__PURE__*/React.createElement("option", {
      key: speed,
      value: speed
    }, speed, "x")))), Object.values(languages).length > 0 && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InputLabel$1, {
      htmlFor: "select-language"
    }, "Language"), /*#__PURE__*/React.createElement(StyledNativeSelect, {
      id: "select-language",
      variant: "outlined",
      value: selectedLanguage.locale,
      onChange: e => {
        const langObj = languages[e.target.value];
        setSelectedLanguage(langObj);
      }
    }, Object.values(languages).map((_ref14, index) => {
      let {
        long,
        locale
      } = _ref14;
      return /*#__PURE__*/React.createElement("option", {
        key: locale,
        value: locale
      }, long);
    }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InputLabel$1, {
      htmlFor: "switch-autoplay"
    }, "Autoplay"), /*#__PURE__*/React.createElement(Switch, {
      id: "switch-autoplay",
      checked: autoplay,
      name: "Autoplay",
      size: "small",
      onChange: (event, newVal) => {
        toggleAutoplay(newVal);
      }
    }))))))));
  }), settingsOpen && /*#__PURE__*/React.createElement(PermanentPopupBox, {
    onClick: e => {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(Slide, {
    in: view === settingViews.MENU,
    direction: "right",
    unmountOnExit: true,
    onEnter: () => {
      switch (prevState.current.view) {
        case settingViews.QUALITY:
          qualityRef.current.firstChild.focus();
          break;
        case settingViews.PLAYBACK:
          playbackRef.current.firstChild.focus();
          break;
      }
      prevState.current.view = settingViews.MENU;
    }
  }, /*#__PURE__*/React.createElement(SettingsList, {
    $show: view === settingViews.MENU
  }, !getIsSafari() ? /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    ref: qualityRef,
    variant: "text",
    onClick: e => {
      setView(settingViews.QUALITY);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, "Quality")), /*#__PURE__*/React.createElement(StyledSecondaryText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, currentQuality), /*#__PURE__*/React.createElement(ChevronRight, null))) : null, /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    ref: playbackRef,
    variant: "text",
    onClick: e => {
      setView(settingViews.PLAYBACK);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, "Speed")), /*#__PURE__*/React.createElement(StyledSecondaryText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, playbackSpeed, "x"), /*#__PURE__*/React.createElement(ChevronRight, null))), Object.values(languages).length > 0 && /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    ref: playbackRef,
    variant: "text",
    onClick: e => {
      setView(settingViews.LANGUAGE);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, "Language")), /*#__PURE__*/React.createElement(StyledSecondaryText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, selectedLanguage.long || 'English'), /*#__PURE__*/React.createElement(ChevronRight, null))), /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    variant: "text"
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(StyledP, {
    component: "span",
    variant: "body2"
  }, "Autoplay")), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React.createElement(Switch, {
    checked: autoplay,
    name: "Autoplay",
    size: "small",
    onChange: (event, newVal) => {
      toggleAutoplay(newVal);
    }
  })))))), /*#__PURE__*/React.createElement(Slide, {
    in: view === settingViews.QUALITY,
    direction: "left",
    unmountOnExit: true,
    onEnter: () => {
      prevState.current.view = settingViews.QUALITY;
      backQuality.current.focus();
    }
  }, /*#__PURE__*/React.createElement(SettingsList, {
    $show: view === settingViews.QUALITY
  }, /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    divider: true,
    component: ButtonBase,
    ref: backQuality,
    variant: "text",
    onClick: e => {
      setView(settingViews.MENU);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(ChevronLeft, null), " Quality")))), qualityState.levels.map((level, index) => /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    variant: "text",
    onClick: e => {
      setView(settingViews.MENU);
      setQualityState({
        ...qualityState,
        qualityIndex: index
      });
    },
    key: index
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, level.label)))))), /*#__PURE__*/React.createElement(Slide, {
    in: view === settingViews.PLAYBACK,
    direction: "left",
    unmountOnExit: true,
    onEnter: () => {
      prevState.current.view = settingViews.PLAYBACK;
      backPlayBack.current.focus();
    }
  }, /*#__PURE__*/React.createElement(SettingsList, {
    $show: view === settingViews.PLAYBACK
  }, /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    divider: true,
    ref: backPlayBack,
    variant: "text",
    onClick: e => {
      setView(settingViews.MENU);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(ChevronLeft, null), " Speed")))), playbackSpeeds.map((speed, index) => /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    variant: "text",
    onClick: e => {
      setView(settingViews.MENU);
      setPlaybackSpeed(speed);
    },
    key: index
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, speed, "x")))))), /*#__PURE__*/React.createElement(Slide, {
    in: view === settingViews.LANGUAGE,
    direction: "left",
    unmountOnExit: true,
    onEnter: () => {
      prevState.current.view = settingViews.LANGUAGE;
      languagePlayBack.current.focus();
    }
  }, /*#__PURE__*/React.createElement(SettingsList, {
    $show: view === settingViews.LANGUAGE
  }, /*#__PURE__*/React.createElement(ListItem, {
    dense: true,
    component: ButtonBase,
    divider: true,
    ref: languagePlayBack,
    variant: "text",
    onClick: e => {
      setView(settingViews.MENU);
    }
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
    component: "span",
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(ChevronLeft, null), " Language")))), Object.values(languages).map((_ref15, index) => {
    let {
      long,
      locale
    } = _ref15;
    return /*#__PURE__*/React.createElement(ListItem, {
      dense: true,
      component: ButtonBase,
      variant: "text",
      onClick: e => {
        setView(settingViews.MENU);
        setSelectedLanguage({
          long,
          locale
        });
      },
      key: index
    }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(P, {
      component: "span",
      variant: "body2"
    }, long)));
  })))));
};
const StyledNativeSelect = styled(NativeSelect).withConfig({
  displayName: "Controls__StyledNativeSelect",
  componentId: "sc-15gkce6-0"
})(["width:100%;"]);
const StyledTooltip = withStyles$1(theme => ({
  tooltip: {
    textTransform: 'none'
  }
}))(Tooltip);
const CenterAlignBox = styled(Box).withConfig({
  displayName: "Controls__CenterAlignBox",
  componentId: "sc-15gkce6-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;"]);
const PopupBox = styled.div.withConfig({
  displayName: "Controls__PopupBox",
  componentId: "sc-15gkce6-2"
})(["height:", ";width:", ";position:absolute;bottom:100%;", ":0px;background-color:#2f2f38;z-index:1000;overflow:auto;overflow-x:hidden;transition:all 0.3s;transform-origin:bottom ", ";"], _ref16 => {
  let {
    $height
  } = _ref16;
  return $height;
}, _ref17 => {
  let {
    $width
  } = _ref17;
  return $width;
}, _ref18 => {
  let {
    $fixTo
  } = _ref18;
  return $fixTo || 'right';
}, _ref19 => {
  let {
    $fixTo
  } = _ref19;
  return $fixTo || 'right';
});
const PermanentPopupBox = styled.div.withConfig({
  displayName: "Controls__PermanentPopupBox",
  componentId: "sc-15gkce6-3"
})(["height:fit-content;width:fit-content;position:absolute;bottom:100%;", ":0px;background-color:#2f2f38;z-index:1000;overflow:auto;overflow-x:hidden;"], _ref20 => {
  let {
    $fixTo
  } = _ref20;
  return $fixTo || 'right';
});
const PopupContainer = styled.div.withConfig({
  displayName: "Controls__PopupContainer",
  componentId: "sc-15gkce6-4"
})(["position:relative;", "{visibility:hidden;transform:scale(0);}&:hover,&:focus-within{", "{visibility:visible;transform:scale(1);}}"], PopupBox, PopupBox);
const SettingsList = styled(List).withConfig({
  displayName: "Controls__SettingsList",
  componentId: "sc-15gkce6-5"
})(["min-width:200px;position:", ";"], _ref21 => {
  let {
    $show
  } = _ref21;
  return $show ? 'relative' : 'absolute';
});
const StyledSecondaryText = styled(ListItemSecondaryAction).withConfig({
  displayName: "Controls__StyledSecondaryText",
  componentId: "sc-15gkce6-6"
})(["text-transform:none;pointer-events:none;display:flex;flex-direction:row;align-items:center;& > span{margin:0px;}"]);
const StyledP = styled(P).withConfig({
  displayName: "Controls__StyledP",
  componentId: "sc-15gkce6-7"
})(["text-transform:none;"]);
const StyledSettings = styled(Settings).withConfig({
  displayName: "Controls__StyledSettings",
  componentId: "sc-15gkce6-8"
})(["transition:transform 0.3s;transform:rotate(", ");"], _ref22 => {
  let {
    $active
  } = _ref22;
  return $active ? '30deg' : '0deg';
});
const getEventX$1 = e => {
  if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
    var _e$touches, _e$changedTouches;
    var touch = (e === null || e === void 0 || (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : _e$touches[0]) || (e === null || e === void 0 || (_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : _e$changedTouches[0]);
    return (touch === null || touch === void 0 ? void 0 : touch.clientX) || 0;
  } else {
    return e.clientX;
  }
};
const clamp = (num, _ref) => {
  let {
    min,
    max
  } = _ref;
  return Math.min(Math.max(num, min), max);
};
const MIN_SIZE_MOBILE = 36.5;
const MIN_SIZE_DESKTOP = 28;
const getEventY = e => {
  if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
    var _e$touches2, _e$changedTouches2;
    var touch = (e === null || e === void 0 || (_e$touches2 = e.touches) === null || _e$touches2 === void 0 ? void 0 : _e$touches2[0]) || (e === null || e === void 0 || (_e$changedTouches2 = e.changedTouches) === null || _e$changedTouches2 === void 0 ? void 0 : _e$changedTouches2[0]);
    return (touch === null || touch === void 0 ? void 0 : touch.clientY) || 0;
  } else {
    return e.clientY;
  }
};
const DragContainer = props => {
  const {
    children,
    setTranscriptPercentages,
    ...rest
  } = props;
  const containerRef = React.useRef();
  const dragPositionRef = React.useRef({
    mobile: storageItemExists$1('mobileTranscriptPosition') ? Number(getStorageItem('mobileTranscriptPosition')) : MIN_SIZE_MOBILE,
    desktop: storageItemExists$1('desktopTranscriptPosition') ? Number(getStorageItem('desktopTranscriptPosition')) : MIN_SIZE_DESKTOP
  });
  const theme = useTheme$2();
  const isMobile = useMediaQuery$1(theme.breakpoints.down('sm'));
  const doDrag = e => {
    e.preventDefault();
    const prop = isMobile ? 'height' : 'width';
    const parentElem = containerRef.current.parentElement;
    const parentRect = parentElem.getBoundingClientRect();
    const parentSize = isMobile ? parentRect.height : parentRect.width;
    const parentPosition = isMobile ? parentRect.y : parentRect.x;
    const eventFn = isMobile ? getEventY : getEventX$1;
    const percentage = 100 - (eventFn(e) - parentPosition) / parentSize * 100;
    const newVal = isMobile ? clamp(percentage, {
      min: MIN_SIZE_MOBILE,
      max: 80
    }) : clamp(percentage, {
      min: MIN_SIZE_DESKTOP,
      max: 80
    });
    containerRef.current.style[prop] = "".concat(newVal, "%");
    setStorageItem("".concat(isMobile ? 'mobile' : 'desktop', "TranscriptPosition"), newVal);
    dragPositionRef.current[isMobile ? 'mobile' : 'desktop'] = newVal;
  };
  const stopDrag = e => {
    document.documentElement.removeEventListener('mousemove', doDrag, false);
    document.documentElement.removeEventListener('mouseup', stopDrag, false);
    document.documentElement.removeEventListener('touchmove', doDrag, false);
    document.documentElement.removeEventListener('touchend', stopDrag, false);
    document.documentElement.removeEventListener('touchcancel', stopDrag, false);
  };
  const initDrag = e => {
    document.documentElement.addEventListener('mousemove', doDrag, false);
    document.documentElement.addEventListener('mouseup', stopDrag, false);
    document.documentElement.addEventListener('touchmove', doDrag, false);
    document.documentElement.addEventListener('touchend', stopDrag, false);
    document.documentElement.addEventListener('touchcancel', stopDrag, false);
  };
  React.useEffect(() => {
    if (isMobile) {
      containerRef.current.style.width = "100%";
      containerRef.current.style.height = "".concat(dragPositionRef.current.mobile, "%");
    }
    if (!isMobile) {
      containerRef.current.style.width = "".concat(dragPositionRef.current.desktop, "%");
      containerRef.current.style.height = "100%";
    }
  }, [isMobile]);
  return /*#__PURE__*/React.createElement(ResizeContainer, _extends({
    ref: containerRef
  }, rest), /*#__PURE__*/React.createElement(ResizeHandleMobile, {
    onMouseDown: initDrag,
    onTouchStart: initDrag
  }), /*#__PURE__*/React.createElement(ResizeHandleDesktop, {
    onMouseDown: initDrag,
    onTouchStart: initDrag
  }), /*#__PURE__*/React.createElement(ResizeContent, null, children));
};
const ResizeContainer = styled(Box).withConfig({
  displayName: "DragContainer__ResizeContainer",
  componentId: "sc-12nquuo-0"
})(["display:flex;touch-action:none;"]);
const ResizeHandleMobile = styled.div.withConfig({
  displayName: "DragContainer__ResizeHandleMobile",
  componentId: "sc-12nquuo-1"
})(["display:block;position:absolute;width:100%;min-height:12px;cursor:ns-resize;transition:background 0.3s;background-color:#2f2f38;&:hover{background:#494949;}&::before{content:'';height:2px;width:20px;background:rgba(255,255,255,0.75);position:absolute;left:calc(50% - 8px);top:2px;}&::after{content:'';height:2px;width:20px;background:rgba(255,255,255,0.75);position:absolute;left:calc(50% - 8px);bottom:2px;}", "{display:none;}"], match.isMD);
const ResizeHandleDesktop = styled.div.withConfig({
  displayName: "DragContainer__ResizeHandleDesktop",
  componentId: "sc-12nquuo-2"
})(["display:none;position:relative;height:100%;min-width:8px;cursor:ew-resize;transition:background 0.3s;&:hover{background:#494949;}&::before{content:'';width:1px;height:16px;background:rgba(255,255,255,0.75);position:absolute;top:calc(50% - 8px);left:2px;}&::after{content:'';width:1px;height:16px;background:rgba(255,255,255,0.75);position:absolute;top:calc(50% - 8px);right:2px;}", "{display:block;}"], match.isMD);
const ResizeContent = styled.div.withConfig({
  displayName: "DragContainer__ResizeContent",
  componentId: "sc-12nquuo-3"
})(["flex:1;"]);
gsap$1.registerPlugin(ScrollToPlugin);
const InteractiveTranscript = _ref => {
  let {
    captionObj,
    transcriptObj,
    setSeekTo,
    position,
    seekState,
    playState
  } = _ref;
  const transcriptContainer = useRef();
  const captionRefs = useRef([]);
  const [autoScroll, setAutoScroll] = useState(storageItemExists('autoscroll') ? localStorage.getItem('autoscroll') === 'true' : true);
  const captionIndex = useMemo(() => getActiveCaptionIndex(captionObj, position * 1000), [captionObj, position]);
  const memoizedJSX = useMemo(() => {
    const seekTo = index => {
      seekState.current.wasPaused = playState === 'paused';
      setSeekTo(captionObj[index].begin / 1000);
    };
    return getJSXFromTranscript(transcriptObj, captionIndex, seekTo, captionRefs);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [captionIndex, transcriptObj, captionObj]);
  useEffect(() => {
    if (!captionRefs.current[captionIndex] || !transcriptContainer.current || seekState.current.isScrubbing || !autoScroll) return;
    const captionElm = captionRefs.current[captionIndex];
    const scrollOffset = transcriptContainer.current.offsetHeight * 0.33;
    let scrollPosition = captionElm.offsetTop - transcriptContainer.current.offsetTop - scrollOffset;
    gsap$1.to(transcriptContainer.current, {
      duration: 0.5,
      scrollTo: scrollPosition
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captionIndex]);
  if (!transcriptObj.length && !captionObj.length) return null;
  return /*#__PURE__*/React.createElement(StyledDragContainer, null, /*#__PURE__*/React.createElement(Container, {
    component: "aside"
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(InteractiveTranscriptContainer, {
    p: 2,
    ref: transcriptContainer
  }, memoizedJSX), /*#__PURE__*/React.createElement(AutoScrollToggleContainer, {
    p: 2
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, {
      checked: autoScroll,
      onChange: () => setAutoScroll(!autoScroll),
      name: "AutoScroll",
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement(P, {
      component: "span"
    }, "Auto scroll"),
    labelPlacement: "start"
  }))))));
};
const storageItemExists = item => localStorage.getItem(item) !== null;
const getJSXFromTranscript = (transcript, activeIndex, seekTo, captionRefs) => {
  let captionIndex = -1; // start at -1 to make captions index zero based;

  // Create captions for each sentence of a paragraph
  const getCaption = (caption, i) => {
    captionIndex += 1;
    const index = captionIndex;
    return [/*#__PURE__*/React.createElement(CaptionSpan, {
      variant: "body1",
      $isActive: index === activeIndex,
      key: i,
      onClick: e => {
        seekTo(index);
      },
      component: "span",
      role: "button",
      ref: ref => captionRefs.current[index] = ref
    }, caption), ' '];
  };

  // Create paragraphs of a single speaker
  const getParagraph = (paragraph, i) => /*#__PURE__*/React.createElement(P, {
    key: i
  }, paragraph.map(getCaption));

  // Create speaker chunks for each time someone speaks
  const getSpeakerChunk = (speakerChunk, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, speakerChunk.speaker && /*#__PURE__*/React.createElement(P, {
    variant: "body1"
  }, speakerChunk.speaker, ": "), speakerChunk.content.map(getParagraph));
  return transcript.map(getSpeakerChunk);
};
const getActiveCaptionIndex = (captions, time) => {
  return findIndex$1(captions, caption => time >= caption.begin && time <= caption.end);
};
const StyledDragContainer = styled(DragContainer).withConfig({
  displayName: "InteractiveTranscript__StyledDragContainer",
  componentId: "sc-13o6c7g-0"
})(["background-color:#2f2f38;"]);
const Container = styled(Box).withConfig({
  displayName: "InteractiveTranscript__Container",
  componentId: "sc-13o6c7g-1"
})(["height:100%;width:100%;display:flex;flex-direction:column;"]);
const InteractiveTranscriptContainer = styled(Box).withConfig({
  displayName: "InteractiveTranscript__InteractiveTranscriptContainer",
  componentId: "sc-13o6c7g-2"
})(["flex:1;max-height:100%;overflow:auto;-ms-overflow-style:none;scrollbar-width:none;overflow-y:scroll;&::-webkit-scrollbar{display:none;}"]);
const AutoScrollToggleContainer = styled(Box).withConfig({
  displayName: "InteractiveTranscript__AutoScrollToggleContainer",
  componentId: "sc-13o6c7g-3"
})(["border-top:1px solid #97979b;display:flex;flex-direction:column;align-items:flex-end;width:100%;"]);
const CaptionSpan = styled(P).withConfig({
  displayName: "InteractiveTranscript__CaptionSpan",
  componentId: "sc-13o6c7g-4"
})(["background:", ";text-align:left;font-weight:bold;border:none;color:inherit;padding:0px;margin:0px;font:inherit;cursor:pointer;outline:inherit;transition:all 0.3s;&:hover{background:", ";}"], _ref2 => {
  let {
    $isActive,
    theme
  } = _ref2;
  return $isActive ? theme.palette.primary.main : 'transparent';
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
});
const eventNames = ['ready', 'setupError', 'remove', 'playlist', 'playlistItem', 'playlistComplete', 'bufferChange', 'autostartNotAllowed', 'play', 'pause', 'playAttemptFailed', 'buffer', 'idle', 'complete', 'firstFrame', 'error', 'playbackRateChanged', 'seek', 'seeked', 'time', 'mute', 'volume', 'fullscreen', 'resize', 'levels', 'levelsChanged', 'visualQuality', 'audioTracks', 'audioTrackChanged', 'captionsList', 'captionsChanged', 'controls', 'displayClick', 'adBlock', 'beforePlay', 'beforeComplete', 'adBidRequest', 'adBidResponse', 'adClick', 'adCompanions', 'adComplete', 'adSkipped', 'adError', 'adRequest', 'adStarted', 'adImpression', 'adPlay', 'adPause', 'adTime', 'adBreakStart', 'adBreakEnd', 'adManager', 'adMeta', 'adSchedule', 'meta'];
const getHandlerName = eventName => "on".concat(eventName.charAt(0).toUpperCase()).concat(eventName.slice(1));
const ReactJWPlayer = /*#__PURE__*/forwardRef((props, ref) => {
  const [internalPlayer, setInternalPlayer] = useState(null);
  const [properties, setProperties] = useState({});
  const createPlayer = () => {
    if (!ref.current) return console.warn('Container ref was null, please investigate.');
    if (internalPlayer) destroyPlayer();

    // create player
    const playerOpts = {
      ...props.opts,
      // preload the `videoId` video if one is already given
      file: props.file
    };
    const _internalPlayer = window.jwplayer(ref.current).setup(playerOpts);
    _internalPlayer.setPlaybackRate(props.currentSpeed);
    const createEventHandler = handlerName => function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return props[handlerName](...args, _internalPlayer);
    };
    eventNames.forEach(eventName => {
      const handlerName = getHandlerName(eventName);
      if (typeof props[handlerName] === 'function') {
        // const eventHandler = this.getEventHandler(handlerName);
        const eventHandler = createEventHandler(handlerName);
        _internalPlayer.on(eventName, eventHandler);
      }
    });
    setInternalPlayer(_internalPlayer);
  };
  const destroyPlayer = () => {
    if (!internalPlayer) return;
    internalPlayer.remove();
    setInternalPlayer(null);
  };
  useEffect(() => {
    // only load the jwplayer script once
    if (window.jwplayer === undefined) {
      require('./_assets/js/vendor/jwplayer');
    }
    createPlayer();
    setProperties(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!internalPlayer) return;
    if (properties.playState !== props.playState && props.playState === 'paused') {
      internalPlayer.pause();
    }
    if (properties.playState !== props.playState && props.playState === 'playing') {
      internalPlayer.play();
    }
    if (properties.seekTo !== props.seekTo && props.seekTo !== null) {
      internalPlayer.seek(props.seekTo);
    }
    if (properties.captionsIndex !== props.captionsIndex) {
      internalPlayer.setCurrentCaptions(props.captionsIndex);
    }
    if (properties.qualityIndex !== props.qualityIndex) {
      internalPlayer.setCurrentQuality(props.qualityIndex);
    }
    if (properties.currentSpeed !== props.currentSpeed) {
      internalPlayer.setPlaybackRate(props.currentSpeed);
    }
    if (properties.volume !== props.volume) {
      internalPlayer.setVolume(props.volume);
    }
    if (properties.mute !== props.mute) {
      internalPlayer.setMute(props.mute);
    }
    if (properties.file !== props.file) {
      createPlayer();
    }
    setProperties(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  });
});
const regEx = /(?:#EXTINF:)([\d]+),\n(?:#EXT-X-TILES:RESOLUTION=)([\d]+)x([\d]+),(?:LAYOUT=)([\d]+)x([\d]+),(?:DURATION=)([\d]+)\n(.+)\n/g;
const getTiles = _ref => {
  let {
    thumbWidth,
    thumbHeight,
    columns,
    rows,
    timeStart,
    tileSetDuration,
    tileDuration,
    fileName
  } = _ref;
  const vttEntries = [];
  let index = 0;
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < columns; x++) {
      const pos = {
        x: thumbWidth * x,
        y: thumbHeight * y,
        w: thumbWidth,
        h: thumbHeight
      };
      const seconds = tileDuration * index;
      const thumbStart = timeStart + seconds;
      if (thumbStart >= tileSetDuration + timeStart) break;
      const url = "".concat(fileName, "#xywh=").concat(pos.x, ",").concat(pos.y, ",").concat(pos.w, ",").concat(pos.h);
      vttEntries.push({
        url,
        tileSetDuration,
        tileDuration,
        rows,
        columns
      });
      index++;
    }
  }
  return vttEntries;
};
const thumbsToObject = _ref2 => {
  let {
    m3u8File,
    videoUri
  } = _ref2;
  const sprites = [...m3u8File.matchAll(regEx)];
  if (!sprites) return '';
  let timeStart = 0;
  const thumbs = sprites.reduce((acc, sprite, index) => {
    const [, extInf, thumbWidth, thumbHeight, rows, columns, duration, fileName] = sprite;
    const absFilename = "".concat(videoUri, "/").concat(fileName);
    const tileSetDuration = Number(extInf);
    const tileDuration = Number(duration);
    const tiles = getTiles({
      thumbWidth: Number(thumbWidth),
      thumbHeight: Number(thumbHeight),
      rows: Number(rows),
      columns: Number(columns),
      timeStart,
      tileSetDuration,
      tileDuration,
      fileName: absFilename
    });
    timeStart += Number(extInf);
    return [...acc, ...tiles];
  }, []);
  return thumbs;
};
const ThumbTip = _ref => {
  var _URL, _hash$split;
  let {
    thumbsUrl,
    duration,
    sliderRef,
    thumbRef
  } = _ref;
  const [thumbsArr, setThumbsArr] = React.useState([]);
  const [hoverX, setHoverX] = React.useState();
  const [timelineWidth, setTimelineWidth] = React.useState();
  const ratio = hoverX / timelineWidth;
  const milaDuration = duration * 1000;
  const hoverMiliseconds = milaDuration * ratio;
  const timeCode = msToTime(hoverMiliseconds);
  React.useEffect(() => {
    if (!thumbsUrl) return;
    const getThumbData = async () => {
      try {
        const data = await fetch(thumbsUrl);
        const m3u8File = await data.text();
        const videoUri = thumbsUrl.substring(0, thumbsUrl.lastIndexOf('/'));
        const thumbs = thumbsToObject({
          m3u8File,
          videoUri
        });
        setThumbsArr(thumbs);
      } catch {
        console.log('no thumbs file found');
      }
    };
    getThumbData();
  }, [thumbsUrl]);
  React.useEffect(() => {
    const slider = sliderRef.current;
    const thumb = thumbRef.current;
    const handleHover = e => {
      const bnds = slider.getBoundingClientRect();
      const relativeX = e.clientX - bnds.left;
      const x = relativeX > 0 ? relativeX : 0;
      setHoverX(x);
      setTimelineWidth(bnds.width);
    };
    const handleLeave = e => {
      setHoverX(undefined);
    };
    const handleDragEnd = () => {
      document.removeEventListener('mousemove', handleHover);
      document.removeEventListener('touchmove', handleHover);
      handleLeave();
    };
    const handleDragStart = () => {
      document.addEventListener('mousemove', handleHover);
      document.addEventListener('touchmove', handleHover);
      document.addEventListener('touchend', handleDragEnd);
      document.addEventListener('touchcancel', handleDragEnd);
      document.addEventListener('mouseup', handleDragEnd);
    };
    if (slider && thumb) {
      slider.addEventListener('mousemove', handleHover);
      slider.addEventListener('mouseleave', handleLeave);
      slider.addEventListener('touchmove', handleHover);
      slider.addEventListener('touchstart', handleDragStart);
      slider.addEventListener('touchend', handleLeave);
      slider.addEventListener('touchcancel', handleLeave);
      thumb.addEventListener('mousedown', handleDragStart);
    }
    return () => {
      slider.removeEventListener('mousemove', handleHover);
      slider.removeEventListener('mouseleave', handleLeave);
      slider.removeEventListener('touchmove', handleHover);
      slider.removeEventListener('touchend', handleLeave);
      slider.removeEventListener('touchcancel', handleLeave);
      thumb.removeEventListener('mousedown', handleDragStart);
    };
  }, [sliderRef, milaDuration, thumbRef]);
  if (!hoverMiliseconds || !(thumbsArr !== null && thumbsArr !== void 0 && thumbsArr.length)) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const thumbIndex = Math.round((thumbsArr.length - 1) * ratio);
  const thumbObj = thumbsArr[thumbIndex];
  if (!thumbObj) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const {
    rows,
    columns,
    url
  } = thumbObj;
  const hash = (_URL = new URL(url)) === null || _URL === void 0 ? void 0 : _URL.hash;
  const [x, y, w, h] = (hash === null || hash === void 0 || (_hash$split = hash.split('=')) === null || _hash$split === void 0 || (_hash$split = _hash$split[1]) === null || _hash$split === void 0 ? void 0 : _hash$split.split(',')) || [];
  const padding = 10;
  const halfTileWidth = w / 2;
  const minOffset = padding;
  const maxOffset = timelineWidth - w - minOffset;
  const rawX = hoverX - halfTileWidth;
  const xPos = rawX < minOffset ? minOffset : rawX > maxOffset ? maxOffset : rawX;
  return /*#__PURE__*/React.createElement(ThumbTipComponent, {
    xPos: xPos
  }, /*#__PURE__*/React.createElement(StyledThumb, {
    src: thumbObj.url,
    thumb: {
      x,
      y,
      w,
      h,
      rows,
      columns
    }
  }), /*#__PURE__*/React.createElement(Timecode, null, timeCode));
};
const ThumbTipComponent = styled.div.attrs(_ref2 => {
  let {
    xPos
  } = _ref2;
  return {
    style: {
      transform: "translateX(".concat(xPos, "px) translateY(-100%)")
    }
  };
}).withConfig({
  displayName: "ThumbTip__ThumbTipComponent",
  componentId: "sc-1x1dobf-0"
})(["position:absolute;top:0;left:0;display:flex;flex-direction:column;align-items:stretch;align-content:stretch;pointer-events:none;"]);
const StyledThumb = styled.img.attrs(_ref3 => {
  let {
    thumb
  } = _ref3;
  return {
    style: {
      objectPosition: "-".concat(thumb.x, "px -").concat(thumb.y, "px"),
      width: "".concat(thumb.w, "px"),
      height: "".concat(thumb.h, "px")
    }
  };
}).withConfig({
  displayName: "ThumbTip__StyledThumb",
  componentId: "sc-1x1dobf-1"
})(["object-fit:none;flex-grow:1;backgroundcolor:red;transform-origin:bottom center;transform:scale(0.5);", "{transform:scale(1);}"], match.isMD);
const Timecode = styled.div.withConfig({
  displayName: "ThumbTip__Timecode",
  componentId: "sc-1x1dobf-2"
})(["font-weight:700;color:white;text-align:center;text-shadow:#000 2px 2px 2px;"]);
const getFormattedTime = time => {
  let seconds = time;
  let minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  return "".concat(minutes, " Minutes ").concat(Math.round(seconds), " Seconds");
};
const getEventX = e => {
  if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
    var _e$touches3, _e$changedTouches3;
    var touch = (e === null || e === void 0 || (_e$touches3 = e.touches) === null || _e$touches3 === void 0 ? void 0 : _e$touches3[0]) || (e === null || e === void 0 || (_e$changedTouches3 = e.changedTouches) === null || _e$changedTouches3 === void 0 ? void 0 : _e$changedTouches3[0]);
    return (touch === null || touch === void 0 ? void 0 : touch.clientX) || 0;
  } else {
    return e.clientX;
  }
};
const Timeline = _ref => {
  let {
    duration,
    position,
    playState,
    setPlayState,
    setSeekTo,
    seekState,
    buffer,
    thumbsUrl
  } = _ref;
  const containerRef = React.useRef();
  const progressRef = React.useRef();
  const scrubRef = React.useRef();
  const dataRef = React.useRef({
    previousValue: 0,
    containerOffsetLeft: 0,
    containerWidth: 0,
    animation: undefined
  });
  React.useEffect(() => {
    const newVal = normalizePosition(position, duration);
    if (!progressRef.current || !scrubRef.current) return;
    const instantJump = () => {
      if (dataRef.current.animInterval) cancelAnimationFrame(dataRef.current.animation);
      progressRef.current.style.width = "".concat(newVal, "%");
      scrubRef.current.style.left = "".concat(newVal, "%");
      dataRef.current.previousValue = newVal;
    };
    if (seekState.current.isSeeking) {
      return instantJump();
    }
    let iteration = 0;
    const increment = newVal - dataRef.current.previousValue;
    const animate = () => {
      if (!progressRef.current || !scrubRef.current) return;
      if (iteration === 15) return;
      iteration++;
      const newPos = dataRef.current.previousValue + increment * (iteration / 15);
      progressRef.current.style.width = "".concat(newPos, "%");
      scrubRef.current.style.left = "".concat(newPos, "%");
      return requestAnimationFrame(animate);
    };
    if (dataRef.current.animation) cancelAnimationFrame(dataRef.current.animation);
    dataRef.current.animation = animate();
    dataRef.current.previousValue = newVal;
  }, [position, duration, seekState]);
  const getMousePercentX = React.useCallback(e => {
    const {
      containerOffsetLeft,
      containerWidth
    } = dataRef.current;
    const eventX = getEventX(e);
    if (eventX >= containerOffsetLeft && eventX <= containerOffsetLeft + containerWidth) return (eventX - containerOffsetLeft) / containerWidth * 100;else if (eventX < containerOffsetLeft) return 0;else if (eventX > containerOffsetLeft + containerWidth) return 100;
    return false;
  }, []);
  const onMove = React.useCallback(e => {
    e = e || window.event;
    e.preventDefault();
    const percentX = getMousePercentX(e);
    if (typeof percentX === 'number') {
      progressRef.current.style.width = "".concat(percentX, "%");
      scrubRef.current.style.left = "".concat(percentX, "%");
      dataRef.current.previousValue = percentX;
    }
  }, [getMousePercentX]);
  const handleScrubCompletion = React.useCallback(e => {
    if (e.type === 'mouseout' && !(e.clientX < 0 || e.clientX > window.innerWidth)) return;
    const percentX = getMousePercentX(e);
    if (typeof percentX === 'number') {
      setSeekTo(denormalizeValue(Number(percentX), duration));
    }
    seekState.current.isScrubbing = false;
    seekState.current.isSeeking = false;
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', handleScrubCompletion);
    window.removeEventListener('mouseout', handleScrubCompletion);
    document.removeEventListener('touchmove', onMove, false);
    document.removeEventListener('touchend', handleScrubCompletion);
    document.removeEventListener('touchcancel', handleScrubCompletion);
  }, [duration, getMousePercentX, onMove, seekState, setSeekTo]);
  const onMouseDown = React.useCallback(e => {
    e.stopPropagation();
    seekState.current.isScrubbing = true;
    seekState.current.isSeeking = true;
    seekState.current.wasPaused = playState === 'paused';
    setPlayState('paused');
    const {
      width,
      left
    } = containerRef.current.getBoundingClientRect();
    dataRef.current.containerOffsetLeft = left + document.body.scrollLeft;
    dataRef.current.containerWidth = width;
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', handleScrubCompletion);
    window.addEventListener('mouseout', handleScrubCompletion);
  }, [handleScrubCompletion, onMove, playState, seekState, setPlayState]);
  const onTouchStart = React.useCallback(e => {
    e.stopPropagation();
    seekState.current.isScrubbing = true;
    seekState.current.isSeeking = true;
    seekState.current.wasPaused = playState === 'paused';
    setPlayState('paused');
    const {
      width,
      left
    } = containerRef.current.getBoundingClientRect();
    dataRef.current.containerOffsetLeft = left + document.body.scrollLeft;
    dataRef.current.containerWidth = width;
    document.addEventListener('touchmove', onMove);
    document.addEventListener('touchend', handleScrubCompletion);
    document.addEventListener('touchcancel', handleScrubCompletion);
  }, [handleScrubCompletion, onMove, playState, seekState, setPlayState]);
  const skipTo = React.useCallback(e => {
    seekState.current.isSeeking = true;
    const {
      width,
      left
    } = containerRef.current.getBoundingClientRect();
    dataRef.current.containerOffsetLeft = left + document.body.scrollLeft;
    dataRef.current.containerWidth = width;
    const percentX = getMousePercentX(e);
    if (typeof percentX === 'number') {
      setSeekTo(denormalizeValue(Number(percentX), duration));
    }
  }, [duration, getMousePercentX, seekState, setSeekTo]);
  const valuetext = "".concat(getFormattedTime(position), " of ").concat(getFormattedTime(duration));
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(TimelineContainer, {
    ref: containerRef,
    tabIndex: "0",
    role: "slider",
    "aria-valuemin": "0",
    "aria-valuemax": duration,
    "aria-valuenow": position,
    "aria-valuetext": valuetext,
    onClick: skipTo
  }, /*#__PURE__*/React.createElement(TimelineBounds, null), thumbsUrl && /*#__PURE__*/React.createElement(ThumbTip, {
    thumbsUrl: thumbsUrl,
    duration: duration,
    sliderRef: containerRef,
    thumbRef: scrubRef
  }), /*#__PURE__*/React.createElement(TimelineRail, null), /*#__PURE__*/React.createElement(TimelineBuffer, {
    style: {
      width: "".concat(buffer, "%")
    }
  }), /*#__PURE__*/React.createElement(TimelineProgress, {
    ref: progressRef
  }), /*#__PURE__*/React.createElement(TimelineScrubber, {
    ref: scrubRef,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart
  })));
};
const resolution = 100;
const normalizePosition = (position, duration) => position / duration * resolution;
const denormalizeValue = (value, duration) => value * duration / resolution;
const TimelineRail = styled.div.withConfig({
  displayName: "Timeline__TimelineRail",
  componentId: "sc-vv9oek-0"
})(["position:absolute;top:0px;left:0px;background:rgba(255,255,255,0.125);width:100%;transition:height 0.3s;"]);
const TimelineBuffer = styled.div.withConfig({
  displayName: "Timeline__TimelineBuffer",
  componentId: "sc-vv9oek-1"
})(["position:absolute;top:0px;left:0px;background:rgba(255,255,255,0.25);transition:height 0.3s;"]);
const TimelineProgress = styled.div.withConfig({
  displayName: "Timeline__TimelineProgress",
  componentId: "sc-vv9oek-2"
})(["position:absolute;top:0px;left:0px;background:", ";transition:height 0.3s;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primary.main;
});
const TimelineScrubber = styled.div.withConfig({
  displayName: "Timeline__TimelineScrubber",
  componentId: "sc-vv9oek-3"
})(["position:absolute;height:0px;width:0px;top:0px;left:0px;transform:translate(-50%,calc(-50% + 2.5px));border-radius:13px;background:", ";transition:height 0.3s,width 0.3s;cursor:pointer;touch-action:none;"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.primary.main;
});
const TimelineBounds = styled.div.withConfig({
  displayName: "Timeline__TimelineBounds",
  componentId: "sc-vv9oek-4"
})(["position:absolute;width:100%;height:20px;left:0px;top:0px;transform:translateY(calc(-50% + (5px / 2)));"]);
const TimelineContainer = styled(Box).withConfig({
  displayName: "Timeline__TimelineContainer",
  componentId: "sc-vv9oek-5"
})(["position:relative;width:100%;height:5px;transform:translateY(-50%);transition:height 0.3s;cursor:pointer;touch-action:none;", ",", ",", "{height:3px;}&:hover,&:focus-within{", ",", ",", "{height:5px;}", "{height:13px;width:13px;}}"], TimelineRail, TimelineBuffer, TimelineProgress, TimelineRail, TimelineBuffer, TimelineProgress, TimelineScrubber);
function createTranscriptObject(text) {
  const speakerFlag = /(^>>[a-zA-Z0-9-.' ]*):/g;
  return text
  // Create array dividing by speaker flag (ex.'>>')
  .split(/[\r\n\t](?=.*:)/g).map(item => {
    // Attempt to split resulting array into speaker and content
    // content is then split into paragraphs
    const speakerContent = item.split(speakerFlag);
    if (speakerContent.length > 1) {
      return {
        speaker: speakerContent[1].replace('>>', '').trim(),
        content: speakerContent[2].split(/[\r\n\t]{2,}/gm).filter(content => !!content).map(paragraph => paragraph.replace(/[\r\n\t]/gm, ' ').trim())
      };
    }
    return {
      speaker: null,
      content: speakerContent[0].split(/[\r\n\t]{2,}/gm).filter(content => !!content).map(paragraph => paragraph.replace(/[\r\n\t]/gm, ' ').trim())
    };
  });
}
function transcriptToObject(captionsObj, rawTranscript) {
  const transcriptArray = createTranscriptObject(rawTranscript);
  const captionsArray = captionsObj.map(caption => caption.text);
  function splitParagraphsByCaption(content) {
    let tempContent = content;
    const tempArray = [];
    const initialLength = captionsArray.length;
    for (let i = 0; i < initialLength; i += 1) {
      if (tempContent.indexOf(captionsArray[0]) !== -1) {
        tempContent = tempContent.replace(captionsArray[0], '').trim();
        tempArray.push(captionsArray.shift());
      } else {
        break;
      }
    }
    return tempArray;
  }
  return transcriptArray.map(speakerChunk => ({
    speaker: speakerChunk.speaker,
    content: speakerChunk.content.map(splitParagraphsByCaption)
  }));
}

// Make sure timestamp is followed by text by checking for linebreak
function hasText(entry) {
  return entry.indexOf('\n') !== -1;
}
const convertDurationToMS = duration => {
  const a = duration.split(':'); // split it at the colons
  const b = a[2].split('.');

  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  const seconds = +a[0] * 60 * 60 + +a[1] * 60 + +b[0];
  const milliseconds = seconds * 1000 + Number(b[1]);
  return milliseconds;
};
function vttToObject(subtitles) {
  let splitPattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n\n';
  let formatFunc = arguments.length > 2 ? arguments[2] : undefined;
  let splitSubtitles = subtitles.split(splitPattern);

  // Remove "WEBVTT" entry at index zero
  splitSubtitles.shift();
  if (formatFunc) splitSubtitles = formatFunc(splitSubtitles);
  return splitSubtitles.filter(hasText).map(subtitle => {
    const a = subtitle.split('\n');

    // Remove empty entry caused by linebreak before the timestamp
    if (a[0] === '') a.shift();
    const i = a[0].indexOf(' --> ');

    // Caption text
    let t = a[1];
    if (a[2]) {
      t += " ".concat(a[2]);
    }
    // t = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return {
      // begin: moment.duration(a[0].substr(0, i)).asMilliseconds(),
      begin: convertDurationToMS(a[0].substr(0, i)),
      btext: a[0].substr(3, i - 7),
      // end: moment.duration(a[0].substr(i + 5).split(' ')[0]).asMilliseconds(),
      end: convertDurationToMS(a[0].substr(i + 5).split(' ')[0]),
      text: t
    };
  });
}
const LOCALE_OPTIONS = {
  'en-US': {
    long: 'English',
    locale: 'en-US'
  },
  de: {
    long: 'German',
    locale: 'de'
  },
  es: {
    long: 'Spanish',
    locale: 'es'
  },
  js: {
    long: 'Japanese',
    locale: 'js'
  },
  'pt-BR': {
    long: 'Portuguese',
    locale: 'pt-BR'
  }
};
const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};
const defaultOpts = {
  key: 'Xu7tTZbnBRJBLDAvJFHvnljjR4gxFeV8eqsPLxVDBgE=',
  preload: 'auto',
  aspectratio: '16:9',
  width: '100%',
  primary: 'html5',
  fallback: false,
  controls: false,
  displaytitle: false,
  autostart: false
};
const getLanguageResourceURL = (url, language) => {
  if (!language || language === 'en-US') return url;
  const split = url.split('.');
  const suffix = split.pop();
  const base = split.join('.');
  return "".concat(base, ".").concat(language, ".").concat(suffix);
};
const VideoPlayer = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _controlsRef$current, _controlsRef$current$;
  const {
    title,
    file,
    thumbnail,
    transcriptUrl,
    captionsUrl,
    thumbsUrl,
    autohide = true,
    opts = {},
    // Note: onPercentageWatched will fire every 10%. It does not fire again if you rewind the video, as in, the percentage watched value will only ever increment, not decrement in value.
    onPercentageWatched = noop$2,
    languages,
    defaultLanguage,
    ...rest
  } = props;
  const theme = useTheme$1();
  const containerRef = React.useRef();
  const videoRef = React.useRef();
  const controlsRef = React.useRef();
  const playButtonRef = React.useRef();
  const qualityRef = React.useRef([]);
  const seekState = React.useRef({
    wasPaused: false,
    isScrubbing: false,
    isSeeking: false,
    hasCompleted: false,
    prevSeekVal: 0,
    volumeSliderVal: 100
  });
  const [autoplay, setAutoplay] = React.useState(() => {
    return storageItemExists$1('autoplay') ? getStorageItem('autoplay') === 'true' : true;
  });
  const [playState, setPlayState] = React.useState(() => {
    return autoplay ? PLAY_STATES.PLAYING : PLAY_STATES.PAUSED;
  });
  const [timeState, setTimeState] = React.useState({
    currentTime: undefined,
    position: undefined,
    duration: undefined
  });
  const [buffer, setBuffer] = React.useState(0);
  const [seekTo, setSeekTo] = React.useState(null);
  const [volume, setVolume] = React.useState(100);
  const [isMute, setIsMute] = React.useState(false);
  const [validLangs, setValidLangs] = React.useState({});
  const [defaultMute, setDefaultMute] = React.useState(true);
  const [autoPlayMuted, setAutoPlayMuted] = React.useState(false);
  const [isFullscreen, setIsFullScreen] = React.useState(false);
  const [playbackSpeed, setPlaybackSpeed] = React.useState(1);
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [showControls, setShowControls] = React.useState(false);
  const [showCaptions, setShowCaptions] = React.useState(storageItemExists$1('captions') ? getStorageItem('captions') === 'true' : false);
  const [showTranscript, setShowTranscript] = React.useState(() => {
    const isDesktop = window.innerWidth > theme.breakpoints.values.sm;
    return storageItemExists$1('transcript') ? getStorageItem('transcript') === 'true' : isDesktop;
  });
  const [qualityState, setQualityState] = React.useState({
    qualityIndex: 0,
    qualityLabel: 'Auto',
    levels: []
  });
  const options = React.useRef({
    ...defaultOpts,
    ...opts,
    image: thumbnail,
    autostart: autoplay,
    // Note: if we remove autostartMuted, jwplayer incorrectly reports the mute state in the onReady function. It will say false, but the audio is actually muted.
    // Hopefully we will resolve that in a future ticket and we will then remove autostartMuted.
    autostartMuted: true,
    tracks: [...Object.values(LOCALE_OPTIONS).map((_ref, idx) => {
      let {
        long,
        locale
      } = _ref;
      return {
        file: getLanguageResourceURL(captionsUrl, locale),
        label: long,
        kind: 'captions'
      };
    })]
  });
  const isMountedRef = React.useRef(true);
  React.useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const [transcriptObj, setTranscriptObj] = React.useState([]);
  const [captionObj, setCaptionObj] = React.useState([]);
  const [selectedLanguage, setSelectedLanguage] = React.useState(LOCALE_OPTIONS[storageItemExists$1('idx-player-lang') ? getStorageItem('idx-player-lang') : defaultLanguage]);
  const [captionsIndex, setCaptionsIndex] = React.useState(1 + Object.values(LOCALE_OPTIONS).map(opt => opt.locale).indexOf(selectedLanguage.locale));
  React.useEffect(() => {
    setCaptionsIndex(1 + Object.values(LOCALE_OPTIONS).map(opt => opt.locale).indexOf(selectedLanguage.locale));
    setStorageItem('idx-player-lang', selectedLanguage.locale);
    Promise.all([fetch(getLanguageResourceURL(captionsUrl, selectedLanguage.locale)), fetch(getLanguageResourceURL(transcriptUrl, selectedLanguage.locale))]).then(responses => Promise.all(responses.map(res => {
      if (res.status !== 200) throw new Error('Could not locate transcript');
      return res.text();
    }))).then(_ref2 => {
      let [captions, transcript] = _ref2;
      if (!isMountedRef.current) return;
      const parsedCaption = vttToObject(captions);
      const parsedTranscript = transcriptToObject(parsedCaption, transcript);
      setTranscriptObj(parsedTranscript);
      setCaptionObj(parsedCaption);
    }).catch(error => {
      console.error(error.message);
      setTranscriptObj([]);
      setCaptionObj([]);
    });
  }, [captionsUrl, transcriptUrl, selectedLanguage]);
  React.useEffect(() => {
    // check that the associative language files are available on the server
    Promise.all(Object.values(LOCALE_OPTIONS).map(_ref3 => {
      let {
        locale
      } = _ref3;
      return fetch(getLanguageResourceURL(captionsUrl, locale), {
        method: 'HEAD'
      });
    })).then(responses => {
      const array_locales = Object.keys(LOCALE_OPTIONS);
      const newValidLangs = {};
      responses.forEach((res, idx) => {
        if (res.status === 200) newValidLangs[array_locales[idx]] = LOCALE_OPTIONS[array_locales[idx]];
      });
      setValidLangs(newValidLangs);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    const onFSChange = () => setIsFullScreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onFSChange);
    document.addEventListener('mozfullscreenchange', onFSChange);
    document.addEventListener('webkitfullscreenchange', onFSChange);
    document.addEventListener('msfullscreenchange', onFSChange);
    return () => {
      document.removeEventListener('fullscreenchange', onFSChange);
      document.removeEventListener('mozfullscreenchange', onFSChange);
      document.removeEventListener('webkitfullscreenchange', onFSChange);
      document.removeEventListener('msfullscreenchange', onFSChange);
    };
  }, []);
  React.useEffect(() => {
    let timeout;
    if (!seekState.current.hasCompleted) return;
    seekState.current.isSeeking = false;
    if (seekState.current.prevSeekVal === 0) {
      seekState.current.prevSeekVal = seekTo;
      setSeekTo(0);
    } else {
      timeout = setTimeout(() => {
        setSeekTo(seekState.current.prevSeekVal);
        seekState.current.hasCompleted = false;
        seekState.current.prevSeekVal = 0;
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [seekTo]);
  const userActionDebounce = useDebounce(() => {
    if (showControls && controlsRef !== null && controlsRef !== void 0 && controlsRef.current) {
      const hasFocus = controlsRef.current.matches(':focus-within');
      const hasHover = controlsRef.current.matches(':hover');
      if (hasFocus || hasHover) return;
      setShowControls(false);
      setSettingsOpen(false);
    }
  }, 3000);
  const userActionHandler = React.useCallback(() => {
    if (!autohide) return;
    if (!showControls) setShowControls(true);
    return userActionDebounce();
  }, [autohide, showControls, userActionDebounce]);
  const handleFullscreen = React.useCallback(() => {
    var _containerRef$current;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (document.webkitFullscreenElement) {
      // Need this to support Safari
      document.webkitExitFullscreen();
    } else if (containerRef.current.webkitRequestFullscreen) {
      // Need this to support Safari
      containerRef.current.webkitRequestFullscreen();
    } else if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.requestFullscreen) {
      var _containerRef$current2;
      (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || _containerRef$current2.requestFullscreen();
    } else {
      var _containerRef$current3;
      // for iPhone safari - See issue for details: https://github.com/KlickMarketing/idx/issues/601#issuecomment-1093316771
      const videoElem = (_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.querySelector('.jw-video');
      videoElem === null || videoElem === void 0 || videoElem.webkitEnterFullscreen();

      // iOS pauses videos when you exit fullscreen, so we need to update the play state.
      videoElem.addEventListener('webkitendfullscreen', () => {
        setPlayState(PLAY_STATES.PAUSED);
      }, {
        once: true
      });
    }
  }, []);
  const togglePlay = React.useCallback(() => {
    setPlayState(playState === PLAY_STATES.PAUSED ? PLAY_STATES.PLAYING : PLAY_STATES.PAUSED);
  }, [playState]);
  React.useEffect(() => {
    {
      setDefaultMute(false);
    }
  }, [playState]);
  const incrementalSeek = React.useCallback(seconds => {
    seekState.current.isSeeking = true;
    seekState.current.wasPaused = playState === PLAY_STATES.PAUSED;
    const position = timeState.position || 0;
    if (seconds > 0) setSeekTo(addSeconds(position, seconds, timeState.duration));else setSeekTo(minusSeconds(position, Math.abs(seconds)));
  }, [playState, timeState.duration, timeState.position]);
  const handlePlayerKeyDown = React.useCallback(event => {
    const duration = timeState.duration || 0;
    switch (event.key) {
      case ' ':
        togglePlay();
        break;
      case 'ArrowLeft':
        incrementalSeek(-10);
        break;
      case 'ArrowRight':
        incrementalSeek(10);
        break;
      case 'ArrowDown':
        setVolume(Math.max(volume - 5, 0));
        break;
      case 'ArrowUp':
        setVolume(Math.min(volume + 5, 100));
        break;
      case 't':
        setShowTranscript(!showTranscript);
        break;
      case 'c':
        setShowCaptions(!showCaptions);
        break;
      case 'f':
        handleFullscreen();
        break;
      case 'm':
        setVolume(volume === 0 ? seekState.current.volumeSliderVal : 0);
        break;
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        incrementalSeek(duration / 10 * parseInt(event.key));
        break;
      default:
        return;
    }
    event.stopPropagation();
    event.preventDefault();
    userActionHandler();
  }, [handleFullscreen, incrementalSeek, showCaptions, showTranscript, timeState.duration, togglePlay, userActionHandler, volume]);
  React.useEffect(() => {
    function spaceToggle(e) {
      if (['Spacebar', ' '].includes(e.key)) {
        e.preventDefault();
        togglePlay();
      }
    }
    window.addEventListener('keypress', spaceToggle);
    return () => window.removeEventListener('keypress', spaceToggle);
  }, [togglePlay]);
  const onReady = React.useCallback((_, player) => {
    if (!isMountedRef.current) return;
    const muteState = player.getMute();
    setIsMute(muteState);
    setDefaultMute(muteState);
  }, []);
  const toggleAutoplay = React.useCallback(bool => {
    setStorageItem('autoplay', bool);
    setAutoplay(bool);
  }, []);
  const toggleCaptions = React.useCallback(bool => {
    setStorageItem('captions', bool);
    setShowCaptions(bool);
  }, []);
  const toggleTranscript = React.useCallback(bool => {
    setStorageItem('transcript', bool);
    setShowTranscript(bool);
  }, []);
  const onMute = React.useCallback(bool => {
    if (!isMountedRef.current) return;
    setIsMute(!!bool);
    setAutoPlayMuted(false);
    setDefaultMute(false);
  }, []);
  const onAutoStart = React.useCallback((playerState, player) => {
    if (!isMountedRef.current) return;
    const muteState = player.getMute();
    setIsMute(muteState);
    setDefaultMute(muteState);
    if (muteState) {
      setAutoPlayMuted(true);
    }
  }, []);
  const onSeeked = React.useCallback((event, player) => {
    if (!isMountedRef.current) return;
    const {
      wasPaused
    } = seekState.current;
    if (wasPaused) {
      player.pause();
    } else {
      setPlayState(PLAY_STATES.PLAYING);
    }
  }, []);
  const onLevels = React.useCallback(_ref4 => {
    let {
      levels,
      currentQuality
    } = _ref4;
    if (!isMountedRef.current) return;
    qualityRef.current.levels = levels;
    setQualityState(current => ({
      ...current,
      levels
    }));
  }, []);
  const onMeta = React.useCallback(_ref5 => {
    let {
      duration
    } = _ref5;
    if (!isMountedRef.current) return;
    setTimeState({
      position: 0,
      duration
    });
  }, []);
  const onTime = React.useCallback(ts => {
    if (seekState.current.isScrubbing) return;
    if (!isMountedRef.current) return;
    setTimeState(ts);
  }, []);
  const [percentageWatched, setPercentageWatched] = React.useState();
  React.useEffect(() => {
    if (typeof timeState.currentTime === 'undefined') return;
    if (typeof timeState.duration === 'undefined') return;
    const percentageIncrementBy10 = Math.floor(timeState.currentTime / timeState.duration * 10) * 10;
    const percentage = percentageWatched || 0;

    // Note: We likely don't want to send an event if they rewind the video. We only want to increment the percentage watched. We need to initialize it with 0 though.
    if (percentageIncrementBy10 > percentage || typeof percentageWatched === 'undefined') {
      setPercentageWatched(percentageIncrementBy10);
    }
  }, [timeState.currentTime, timeState.duration, percentageWatched]);
  React.useEffect(() => {
    if (typeof percentageWatched === 'undefined') return;

    // Note: The team's decision was to have tracking live inside the video player component, but it could also be moved out and passed in as a callback with "onPercentageWatched"
    tracking.track({
      event: 'video_progress',
      eventModel: {
        video_title: title,
        video_percent: percentageWatched
      }
    });
    onPercentageWatched({
      percentageWatched
    });
  }, [percentageWatched, title, file, onPercentageWatched]);
  const onComplete = React.useCallback((event, player) => {
    if (!isMountedRef.current) return;
    setPlayState(PLAY_STATES.PAUSED);
    seekState.current.hasCompleted = true;
  }, []);
  const onBufferChange = React.useCallback(bufferState => {
    if (!isMountedRef.current) return;
    setBuffer(bufferState.bufferPercent);
  }, []);
  const onPlay = useEventCallback((pState, player) => {
    if (!isMountedRef.current) return;
    if (pState && pState.playReason === 'autostart') {
      onAutoStart(pState, player);
    }
    if (playState !== PLAY_STATES.PLAYING) {
      setPlayState(PLAY_STATES.PLAYING);
    }
  }, [onAutoStart, playState]);
  const onQuality = React.useCallback(current => {
    if (!isMountedRef.current) return;
    const _qualityState = {
      levels: qualityRef.current.levels
    };
    if (typeof current === 'number') {
      _qualityState.qualityIndex = Math.max(current, 0);
    }
    if (typeof current === 'string') {
      _qualityState.qualityLabel = current;
    }
    setQualityState(_qualityState);
  }, []);
  const onVisualQuality = useEventCallback(quality => {
    if (!isMountedRef.current) return;
    if (!(quality !== null && quality !== void 0 && quality.level)) return;
    onQuality("".concat(quality.level.height, "p"));
  }, [onQuality]);
  const defaultMuteRef = React.useRef();
  const onDisplayClick = useEventCallback(() => {
    if (!isMountedRef.current) return;
    if (defaultMute) {
      var _defaultMuteRef$curre, _defaultMuteRef$curre2;
      return defaultMuteRef === null || defaultMuteRef === void 0 || (_defaultMuteRef$curre = defaultMuteRef.current) === null || _defaultMuteRef$curre === void 0 || (_defaultMuteRef$curre2 = _defaultMuteRef$curre.click) === null || _defaultMuteRef$curre2 === void 0 ? void 0 : _defaultMuteRef$curre2.call(_defaultMuteRef$curre);
    }
    if (!isTouchDevice()) {
      playButtonRef.current.click();
    } else if (showControls) {
      playButtonRef.current.click();
      userActionHandler();
    } else {
      userActionHandler();
    }
  }, [showControls, userActionHandler, defaultMute]);
  const isControlsVisible = !autohide || showControls;
  const hasCaptions = !!captionObj.length;
  const hasTranscript = !!transcriptObj.length;
  const captionsBottomOffset = isControlsVisible ? ((_controlsRef$current = controlsRef.current) === null || _controlsRef$current === void 0 || (_controlsRef$current$ = _controlsRef$current.getBoundingClientRect) === null || _controlsRef$current$ === void 0 || (_controlsRef$current$ = _controlsRef$current$.call(_controlsRef$current)) === null || _controlsRef$current$ === void 0 ? void 0 : _controlsRef$current$.height) || 50 : 0;
  const [unmuteText] = React.useState(() => isTouchDevice() ? 'Tap' : 'Click');
  return /*#__PURE__*/React.createElement(ResponsiveVideoContainer, {
    ref: containerRef,
    $showTranscript: showTranscript,
    $captionsBottomOffset: captionsBottomOffset
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'space-between',
      flexDirection: {
        xs: 'column',
        md: 'row'
      }
    }
  }, /*#__PURE__*/React.createElement(VideoContainer, {
    onClick: userActionHandler,
    onMouseMoveCapture: userActionHandler,
    onKeyDownCapture: handlePlayerKeyDown
  }, /*#__PURE__*/React.createElement(ReactJWPlayer, _extends({
    ref: videoRef,
    file: file,
    opts: options.current,
    qualityIndex: qualityState.currentQuality,
    currentSpeed: playbackSpeed,
    playState: playState,
    seekTo: seekTo,
    volume: volume,
    mute: isMute,
    onReady: onReady,
    onPlay: onPlay,
    onSeeked: onSeeked,
    onTime: onTime,
    onLevels: onLevels,
    onMeta: onMeta,
    onComplete: onComplete,
    onVisualQuality: onVisualQuality,
    onBufferChange: onBufferChange,
    onDisplayClick: onDisplayClick,
    captionsIndex: showCaptions ? captionsIndex : 0
  }, rest)), (playState === PLAY_STATES.PAUSED || showControls) && /*#__PURE__*/React.createElement(MobileOverlay, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      userActionHandler();
      togglePlay();
    }
  }, playState === PLAY_STATES.PAUSED ? /*#__PURE__*/React.createElement(PlayArrowRounded, {
    style: {
      fill: '#fff',
      width: '4em',
      height: '4em',
      opacity: 0.9
    }
  }) : /*#__PURE__*/React.createElement(PauseRounded, {
    style: {
      fill: '#fff',
      width: '4em',
      height: '4em',
      opacity: 0.9
    }
  }))), defaultMute && /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onBlack"
  }, /*#__PURE__*/React.createElement(DefaultMuteButton, {
    ref: defaultMuteRef,
    component: ButtonBase,
    onClick: e => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      onMute(false);
    }
  }, /*#__PURE__*/React.createElement(VolumeOffRounded, {
    fontSize: "large"
  }), /*#__PURE__*/React.createElement(P, {
    variant: "body2",
    component: "span"
  }, unmuteText, " to unmute"))), /*#__PURE__*/React.createElement(VideoControls, {
    ref: controlsRef,
    $visible: isControlsVisible
  }, /*#__PURE__*/React.createElement(Timeline, _extends({}, timeState, {
    playState: playState,
    setPlayState: setPlayState,
    setSeekTo: setSeekTo,
    seekState: seekState,
    thumbsUrl: thumbsUrl,
    buffer: buffer
  })), /*#__PURE__*/React.createElement(ControlBar, null, /*#__PURE__*/React.createElement(PlayButton, {
    ref: playButtonRef,
    isPlaying: playState === PLAY_STATES.PLAYING,
    onClick: () => togglePlay()
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: {
        xs: 'none',
        sm: 'flex',
        alignItems: 'center'
      }
    }
  }, /*#__PURE__*/React.createElement(Timestamp, {
    timeState: timeState
  })), /*#__PURE__*/React.createElement(ReplayTenButton, {
    onClick: () => {
      incrementalSeek(-10);
    }
  }), /*#__PURE__*/React.createElement(ForwardTenButton, {
    onClick: () => {
      incrementalSeek(10);
    }
  }), /*#__PURE__*/React.createElement(ControlSpacer, null), hasCaptions && /*#__PURE__*/React.createElement(ClosedCaptionButton, {
    ccActive: showCaptions,
    setCCActive: toggleCaptions
  }), hasTranscript && /*#__PURE__*/React.createElement(DownloadTranscript, {
    onClick: () => downloadResource(transcriptUrl, "transcript-".concat(kebabCase(title), ".txt"))
  }), hasTranscript && /*#__PURE__*/React.createElement(ToggleInteractiveTranscript, {
    active: showTranscript,
    setActive: toggleTranscript
  }), /*#__PURE__*/React.createElement(MuteButton, {
    seekState: seekState,
    fullscreen: isFullscreen,
    volume: volume,
    setVolume: setVolume,
    defaultValue: 100,
    isMute: isMute || autoPlayMuted,
    setIsMute: onMute,
    onMouseEnter: () => settingsOpen && setSettingsOpen(false)
  }), /*#__PURE__*/React.createElement(SettingsButton, {
    qualityState: qualityState,
    setQualityState: setQualityState,
    playbackSpeed: playbackSpeed,
    setPlaybackSpeed: setPlaybackSpeed,
    autoplay: autoplay,
    toggleAutoplay: toggleAutoplay,
    settingsOpen: settingsOpen && showControls,
    setSettingsOpen: setSettingsOpen,
    selectedLanguage: selectedLanguage,
    languages: validLangs,
    setSelectedLanguage: setSelectedLanguage
  }), /*#__PURE__*/React.createElement(FullscreenButton, {
    fullscreen: isFullscreen,
    onClick: handleFullscreen,
    style: {
      alignSelf: 'flex-end'
    }
  })))), hasCaptions && hasTranscript && showTranscript && /*#__PURE__*/React.createElement(InteractiveTranscript, {
    transcriptObj: transcriptObj,
    captionObj: captionObj,
    position: timeState.position,
    setSeekTo: setSeekTo,
    playState: playState,
    seekState: seekState
  })));
});
function forceDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
}
function downloadResource(url, filename) {
  // Current blob size limit is around 500MB for browsers
  if (!filename) filename = url.split('\\').pop().split('/').pop();
  fetch(url, {
    headers: new Headers({
      Origin: window.location.origin
    }),
    mode: 'cors'
  }).then(response => response.blob()).then(blob => {
    let blobUrl = window.URL.createObjectURL(blob);
    forceDownload(blobUrl, filename);
  }).catch(e => console.error(e));
}
const convertSecstoMS = secs => secs * 1000;
const convertMStoSecs = ms => ms / 1000;
const minusSeconds = (current, sub) => convertMStoSecs(Math.max(convertSecstoMS(current) - convertSecstoMS(sub), 0));
const addSeconds = (current, add, max) => convertMStoSecs(Math.min(convertSecstoMS(current) + convertSecstoMS(add), convertSecstoMS(max)));
const PLAY_STATES = {
  PLAYING: 'playing',
  PAUSED: 'paused'
};
function useEventCallback(fn, dependencies) {
  // Note: THIS IS AN ESCAPE HATCH. USE SPARINGLY.
  // This is used since ReactJWPlayer only sets the callbacks once upon initial load and their internal state gets out of date.
  // Slack discussion: https://klick.slack.com/archives/G82A81B1T/p1649358727108769
  // React Docs: https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
  const ref = React.useRef(() => {
    throw new Error('Cannot call an event handler while rendering.');
  });
  React.useEffect(() => {
    ref.current = fn;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn, ...dependencies]);
  return React.useCallback(() => {
    const fn = ref.current;
    return fn();
  }, [ref]);
}
const VideoControls = styled(Box).withConfig({
  displayName: "VideoPlayer__VideoControls",
  componentId: "sc-1aao859-0"
})(["width:100%;padding:0px 1em;padding-top:16px;height:auto;position:absolute;bottom:0px;left:0em;display:flex;flex-direction:column;justify-content:flex-end;background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.85) 100%);transform:translateY(", ");transition:transform 0.3s;"], _ref6 => {
  let {
    $visible
  } = _ref6;
  return $visible ? '0%' : '100%';
});
const VideoContainer = styled(Box).withConfig({
  displayName: "VideoPlayer__VideoContainer",
  componentId: "sc-1aao859-1"
})(["flex:1;position:relative;height:auto;min-height:40%;display:flex;flex-direction:column;justify-content:center;overflow:hidden;"]);
const DefaultMuteButton = styled(Box).withConfig({
  displayName: "VideoPlayer__DefaultMuteButton",
  componentId: "sc-1aao859-2"
})(["position:absolute;top:16px;left:16px;background:rgba(0,0,0,0.5);display:flex;flex-direction:row;align-items:center;justify-content:center;padding:16px;pointer-events:none;& > span{margin:0px;margin-left:8px;}& > svg{fill:white;}", "{top:32px;left:32px;}"], match.isMD);
const ControlSpacer = styled.div.withConfig({
  displayName: "VideoPlayer__ControlSpacer",
  componentId: "sc-1aao859-3"
})(["flex:1;"]);
const ResponsiveVideoContainer = styled.div.withConfig({
  displayName: "VideoPlayer__ResponsiveVideoContainer",
  componentId: "sc-1aao859-4"
})(["overflow:hidden;height:0;background:black;position:relative;padding-top:", ";", "{padding-top:", ";}video{cursor:pointer;}.jw-text-track-display{top:unset !important;bottom:", "px !important;}"], _ref7 => {
  let {
    $showTranscript
  } = _ref7;
  return $showTranscript ? 'calc(544 / 613 * 100%)' : 'calc(9 / 16 * 100%)';
}, match.isMD, _ref8 => {
  let {
    $showTranscript
  } = _ref8;
  return $showTranscript ? 'calc(500 / 1235 * 100%)' : 'calc(9 / 16 * 100%)';
}, _ref9 => {
  let {
    $captionsBottomOffset
  } = _ref9;
  return $captionsBottomOffset;
});
const MobileOverlay = styled.div.withConfig({
  displayName: "VideoPlayer__MobileOverlay",
  componentId: "sc-1aao859-5"
})(["position:absolute;top:0px;left:0px;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;pointer-events:none;", "{display:none;}"], match.isSM);
const MAX_LINE_LENGTH = 80;
const getTxtURLFromTranscript = transcriptOBJ => {
  let outputString = '';
  let lineLength = 0;
  transcriptOBJ.forEach((_ref, index) => {
    let {
      content,
      speaker
    } = _ref;
    content.forEach(elements => {
      elements.forEach(text => {
        // this adds line wrapping
        const words = text.split(' ');
        words.forEach(word => {
          lineLength += word.length;
          if (lineLength > MAX_LINE_LENGTH) {
            lineLength = 0;
            outputString += '\n';
          }
          outputString += word + ' ';
        });
      });
    });
    lineLength = 0;
    if (content[0].length !== 0) outputString += '\n \n';
    if (speaker) outputString += speaker + ': \n';
  });
  const blob = new Blob([outputString], {
    type: 'octet/stream'
  });
  return window.URL.createObjectURL(blob);
};
const vttObjectToTranscript = function () {
  let vttObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let speakerObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let index = -1;
  const transcriptObject = [];
  const addNewTranscriptEntry = function () {
    let speaker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    transcriptObject.push({
      speaker,
      content: [[]]
    });
    index++;
  };
  const speakerObjectCopy = [...speakerObject];
  vttObject.forEach(_ref => {
    let {
      text,
      begin
    } = _ref;
    if (!!~text.indexOf('[') || !!~text.indexOf(']')) {
      addNewTranscriptEntry();
      transcriptObject[index].content[0].push(text);
      addNewTranscriptEntry();
      return;
    }
    if (speakerObjectCopy[0] && begin >= speakerObjectCopy[0].begin) {
      addNewTranscriptEntry(speakerObjectCopy[0].text);
      speakerObjectCopy.shift();
    }
    if (index === -1) addNewTranscriptEntry();
    transcriptObject[index].content[0].push(text);
  });
  return transcriptObject;
};
var chrome = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%20192%20192%22%3E%3Cdefs%3E%3Ccircle%20id%3D%22a%22%20cx%3D%2296%22%20cy%3D%2296%22%20r%3D%2288%22%2F%3E%3C%2Fdefs%3E%3CclipPath%20id%3D%22b%22%3E%3Cuse%20xlink%3Ahref%3D%22%23a%22%20overflow%3D%22visible%22%2F%3E%3C%2FclipPath%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cpath%20fill%3D%22%23DB4437%22%20d%3D%22M21.97%208v108h39.39L96%2056h88V8z%22%2F%3E%3ClinearGradient%20id%3D%22c%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%2229.337%22%20y1%3D%2275.021%22%20x2%3D%2281.837%22%20y2%3D%2244.354%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23a52714%22%20stop-opacity%3D%22.6%22%2F%3E%3Cstop%20offset%3D%22.66%22%20stop-color%3D%22%23a52714%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23c%29%22%20d%3D%22M21.97%208v108h39.39L96%2056h88V8z%22%2F%3E%3C%2Fg%3E%3Cpath%20clip-path%3D%22url%28%23b%29%22%20fill%3D%22%233E2723%22%20fill-opacity%3D%22.15%22%20d%3D%22M62.31%20115.65L22.48%2047.34l-.58%201%2039.54%2067.8z%22%2F%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cpath%20fill%3D%22%230F9D58%22%20d%3D%22M8%20184h83.77l38.88-38.88V116H61.36L8%2024.48z%22%2F%3E%3ClinearGradient%20id%3D%22d%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22110.872%22%20y1%3D%22164.495%22%20x2%3D%2252.538%22%20y2%3D%22130.329%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23055524%22%20stop-opacity%3D%22.4%22%2F%3E%3Cstop%20offset%3D%22.33%22%20stop-color%3D%22%23055524%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23d%29%22%20d%3D%22M8%20184h83.77l38.88-38.88V116H61.36L8%2024.48z%22%2F%3E%3C%2Fg%3E%3Cpath%20clip-path%3D%22url%28%23b%29%22%20fill%3D%22%23263238%22%20fill-opacity%3D%22.15%22%20d%3D%22M129.84%20117.33l-.83-.48L90.62%20184h1.15l38.1-66.64z%22%2F%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cdefs%3E%3Cpath%20id%3D%22e%22%20d%3D%22M8%20184h83.77l38.88-38.88V116H61.36L8%2024.48z%22%2F%3E%3C%2Fdefs%3E%3CclipPath%20id%3D%22f%22%3E%3Cuse%20xlink%3Ahref%3D%22%23e%22%20overflow%3D%22visible%22%2F%3E%3C%2FclipPath%3E%3Cg%20clip-path%3D%22url%28%23f%29%22%3E%3Cpath%20fill%3D%22%23FFCD40%22%20d%3D%22M96%2056l34.65%2060-38.88%2068H184V56z%22%2F%3E%3ClinearGradient%20id%3D%22g%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22121.858%22%20y1%3D%2249.804%22%20x2%3D%22136.547%22%20y2%3D%22114.13%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23ea6100%22%20stop-opacity%3D%22.3%22%2F%3E%3Cstop%20offset%3D%22.66%22%20stop-color%3D%22%23ea6100%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23g%29%22%20d%3D%22M96%2056l34.65%2060-38.88%2068H184V56z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cpath%20fill%3D%22%23FFCD40%22%20d%3D%22M96%2056l34.65%2060-38.88%2068H184V56z%22%2F%3E%3ClinearGradient%20id%3D%22h%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22121.858%22%20y1%3D%2249.804%22%20x2%3D%22136.547%22%20y2%3D%22114.13%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23ea6100%22%20stop-opacity%3D%22.3%22%2F%3E%3Cstop%20offset%3D%22.66%22%20stop-color%3D%22%23ea6100%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23h%29%22%20d%3D%22M96%2056l34.65%2060-38.88%2068H184V56z%22%2F%3E%3C%2Fg%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cdefs%3E%3Cpath%20id%3D%22i%22%20d%3D%22M96%2056l34.65%2060-38.88%2068H184V56z%22%2F%3E%3C%2Fdefs%3E%3CclipPath%20id%3D%22j%22%3E%3Cuse%20xlink%3Ahref%3D%22%23i%22%20overflow%3D%22visible%22%2F%3E%3C%2FclipPath%3E%3Cg%20clip-path%3D%22url%28%23j%29%22%3E%3Cpath%20fill%3D%22%23DB4437%22%20d%3D%22M21.97%208v108h39.39L96%2056h88V8z%22%2F%3E%3ClinearGradient%20id%3D%22k%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%2229.337%22%20y1%3D%2275.021%22%20x2%3D%2281.837%22%20y2%3D%2244.354%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23a52714%22%20stop-opacity%3D%22.6%22%2F%3E%3Cstop%20offset%3D%22.66%22%20stop-color%3D%22%23a52714%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23k%29%22%20d%3D%22M21.97%208v108h39.39L96%2056h88V8z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3CradialGradient%20id%3D%22l%22%20cx%3D%22668.176%22%20cy%3D%2255.948%22%20r%3D%2284.078%22%20gradientTransform%3D%22translate%28-576%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%233e2723%22%20stop-opacity%3D%22.2%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%233e2723%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3Cpath%20clip-path%3D%22url%28%23b%29%22%20fill%3D%22url%28%23l%29%22%20d%3D%22M96%2056v20.95L174.4%2056z%22%2F%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cdefs%3E%3Cpath%20id%3D%22m%22%20d%3D%22M21.97%208v40.34L61.36%20116%2096%2056h88V8z%22%2F%3E%3C%2Fdefs%3E%3CclipPath%20id%3D%22n%22%3E%3Cuse%20xlink%3Ahref%3D%22%23m%22%20overflow%3D%22visible%22%2F%3E%3C%2FclipPath%3E%3Cg%20clip-path%3D%22url%28%23n%29%22%3E%3Cpath%20fill%3D%22%230F9D58%22%20d%3D%22M8%20184h83.77l38.88-38.88V116H61.36L8%2024.48z%22%2F%3E%3ClinearGradient%20id%3D%22o%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%22110.872%22%20y1%3D%22164.495%22%20x2%3D%2252.538%22%20y2%3D%22130.329%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23055524%22%20stop-opacity%3D%22.4%22%2F%3E%3Cstop%20offset%3D%22.33%22%20stop-color%3D%22%23055524%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3Cpath%20fill%3D%22url%28%23o%29%22%20d%3D%22M8%20184h83.77l38.88-38.88V116H61.36L8%2024.48z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3CradialGradient%20id%3D%22p%22%20cx%3D%22597.875%22%20cy%3D%2248.52%22%20r%3D%2278.044%22%20gradientTransform%3D%22translate%28-576%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%233e2723%22%20stop-opacity%3D%22.2%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%233e2723%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3Cpath%20clip-path%3D%22url%28%23b%29%22%20fill%3D%22url%28%23p%29%22%20d%3D%22M21.97%2048.45l57.25%2057.24L61.36%20116z%22%2F%3E%3CradialGradient%20id%3D%22q%22%20cx%3D%22671.844%22%20cy%3D%2296.138%22%20r%3D%2287.87%22%20gradientTransform%3D%22translate%28-576%29%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23263238%22%20stop-opacity%3D%22.2%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23263238%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3Cpath%20clip-path%3D%22url%28%23b%29%22%20fill%3D%22url%28%23q%29%22%20d%3D%22M91.83%20183.89l20.96-78.2L130.65%20116z%22%2F%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Ccircle%20fill%3D%22%23F1F1F1%22%20cx%3D%2296%22%20cy%3D%2296%22%20r%3D%2240%22%2F%3E%3Ccircle%20fill%3D%22%234285F4%22%20cx%3D%2296%22%20cy%3D%2296%22%20r%3D%2232%22%2F%3E%3C%2Fg%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cpath%20fill%3D%22%233E2723%22%20fill-opacity%3D%22.2%22%20d%3D%22M96%2055c-22.09%200-40%2017.91-40%2040v1c0-22.09%2017.91-40%2040-40h88v-1H96z%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20fill-opacity%3D%22.1%22%20d%3D%22M130.6%20116c-6.92%2011.94-19.81%2020-34.6%2020-14.8%200-27.69-8.06-34.61-20h-.04L8%2024.48v1L61.36%20117h.04c6.92%2011.94%2019.81%2020%2034.61%2020%2014.79%200%2027.68-8.05%2034.6-20h.05v-1h-.06z%22%2F%3E%3Cpath%20opacity%3D%22.1%22%20fill%3D%22%233E2723%22%20d%3D%22M97%2056c-.17%200-.33.02-.5.03C118.36%2056.3%20136%2074.08%20136%2096s-17.64%2039.7-39.5%2039.97c.17%200%20.33.03.5.03%2022.09%200%2040-17.91%2040-40s-17.91-40-40-40z%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20fill-opacity%3D%22.2%22%20d%3D%22M131%20117.33c3.4-5.88%205.37-12.68%205.37-19.96%200-4.22-.66-8.28-1.87-12.09.95%203.42%201.5%207.01%201.5%2010.73%200%207.28-1.97%2014.08-5.37%2019.96l.02.04-38.88%2068h1.16l38.09-66.64-.02-.04z%22%2F%3E%3C%2Fg%3E%3Cg%20clip-path%3D%22url%28%23b%29%22%3E%3Cpath%20fill%3D%22%23FFF%22%20fill-opacity%3D%22.2%22%20d%3D%22M96%209c48.43%200%2087.72%2039.13%2087.99%2087.5%200-.17.01-.33.01-.5%200-48.6-39.4-88-88-88S8%2047.4%208%2096c0%20.17.01.33.01.5C8.28%2048.13%2047.57%209%2096%209z%22%2F%3E%3Cpath%20fill%3D%22%233E2723%22%20fill-opacity%3D%22.15%22%20d%3D%22M96%20183c48.43%200%2087.72-39.13%2087.99-87.5%200%20.17.01.33.01.5%200%2048.6-39.4%2088-88%2088S8%20144.6%208%2096c0-.17.01-.33.01-.5C8.28%20143.87%2047.57%20183%2096%20183z%22%2F%3E%3C%2Fg%3E%3CradialGradient%20id%3D%22r%22%20cx%3D%2234.286%22%20cy%3D%2232.014%22%20r%3D%22176.746%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23fff%22%20stop-opacity%3D%22.1%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23fff%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3Ccircle%20fill%3D%22url%28%23r%29%22%20cx%3D%2296%22%20cy%3D%2296%22%20r%3D%2288%22%2F%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h192v192H0z%22%2F%3E%3C%2Fsvg%3E";
var edge = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAC/VBMVEUAAACv4/C/4Om12uW75ei34uSGqc1N0ItGd65hsuZNpOBnkcGFsNWY1u9zmMOs7ryh4vCKvOA/m+CH3dhCwe1y4nwlY6aJ4JOBweqw77zD9M59pMQNRoRTztZd0mY2drRn1nNs1u1OeaxqteaV5NKW5akbVZROzeQnk+IihdkyYpqC5pFt1d6K5pqJ3vIDH2VT0J1Uy/E1lNxm0u9i089SisJ427x52+Ydh94fit0pjsRSzl1g1Gkxl+Fs1Xic76BNwcF55II0oe0Yh99HyPQXhd8Zit8ai+EVX6cYht0UXKQUYKoVYa1AydwUXaYcj+JCyeRByOEVWqNEyeodkuEfleMWV50UWqEVV6A/ydkhmOQRVJg/ydVDyedGyPESV51FyO4jm+UknecjmN1AytFFyewjk9VP06506nJe3Y8ji8RX151v53hV1qEPUJFh3otZ2plAyctl4IZJ0LpN0rQPSops5H1b25Rs5HZi3nFGzHEgiMRCy8EhjMpIz7No4nRP1Klb2W1GzqpByt8ikM5BysZGzYZo44FEzLpGzI9GzH5IzFEZiNdHzGoclexHzsNIz79T1qZk4IFHzGRJzFgej9o/yc5FzcgZgMNS1ZNd3H5c23dY2mRR1FgUd9oTc9gfj9Uei9Edg8Fj33pV1WcXgMwahMdN0aFEzKFO04Fo4ntGzXdV1nJIzF8WcK0GQZBv53FT1F8aj+och8tO1fwISJRZ2otT1Ytg3YVY2IRMz1Qsvu8Vf9wahtFDy80dgbwRa7wKTp1R1JpU1ntO025g3moww+FCyrAIR5pEy5ZLz/Y1rdYXgNIWbKhIzpoFOYgjovESbdUWesAYd7hi5WBL1fIQZ7EMVqUGQZg6yEBG1uwwxNITccMad680wfIxwOg1x5sDK3pN0GZD0t8VeckokrpKzn1O0XY0xjgllMkwwsM4yYgKPXlAzUI9ut4uns00xrsswa4mqvgQZ9VF1dIfhLI0yS09xfIajeUxxWRG00wtwkgyrbwuw3Meo6jxapdAAAAAQ3RSTlMAOwkcKBJU/rmgtZBpWXFZTEDIhPzn5YltRTEv/t3XzcO5pod0cvHv5eXUw6+ni/7t3NfLxL+onvfx8ezi16+a4tbSO3hnpAAAC8NJREFUaN6sl2tIk1EYx9+ZFd3ImtGNCMuKyu5R0JcKogsVFdaHyoaZVq5cN/OSZmlaCqOLkLcZ5ERTiyEomohtaFPcnK0tDVbLhe2DJd5Q+hLR85zzvjvb3llm/UEEP/x+53mec95z5MYY/4DgtVuDNi/CbA7ZKp0hmcD9r/hJpCGLDn7gk/Phw1fMQPKOEGnAxH+nzwhZ0Qw5CDmOCQsLi4zMuXLlSsbXgcGBzM3B/v+Cl2xF+hHMnYOCAww5xJCRnDwwMNiyOXi83ZqxCeiHMW4K4B/HGnLAAApwDA62bJGMAx8Q1Nx1CgJ8pmBFRLoMmZktg46/VkiCurpCQ4Efeuowc9wRFMIgqCAlJc3h2PJXw1iL+KhQCFpEBhAIbQIFCFLOpTlapRPHvPwN9d/Do6JAQA0QKsBQAypIDYLg9u1n39bPHOvy62WycIjL4TEKFBwMozUQwbVrKedQEJP1bctYdn5Q/XcZEVCHyMC6hIbcBw+vpRBBTMyFxm+r/7hlJ2yo37Vrl4wqWBViA92tTPAIBBcu3639Q5skgcjHoEMQMIPHgQDDqwwQXItFAfLj48vLl/1283/6xPOZwasG16DJGEgFsSiIoYLouufBv+HXMz4zsEmLm/RKEDyigujo6LoboxoWkPWLDaEeBuCLBbRDKLh0qeD1zFHmG8j4fxwDbiSRIJ4IrqpGMcD+GbsAIhZQ/tWrqhcLfPCDgD9uwSN3Qfa91Dk+zi/w/16QSwTnUAAjEPj34grXiA7Ap+/jELBNBHyhgHsgqCic7z0ArwEbDNUkBoNBBnwvAeCZACrAc0wEOAHgx8Xp53g3iK16lwG4ssA+I0nfkagOCP2m8tuUnjRPAVaABWQj/+LFi4XbPV4lQoOQbgg09su1dg2N3T7i7DcesXXY2DkTzRgKwE2KBQiCSr37TtpUz+OrqwONcrvJpLFqtVo1Rqu12kHj7O+z2ViHmIDNmHaI8DHvVrtNmPIR32NHOJKT1EmuqLXwZycq2DEL8xRc9hScP1/5boFbAdh7A+A1JkovRWzVzaSbVCCHH63JBIpu5EPolZaby0YgCCpQcB7CSgjAG0xWbejXdFrVeXnq0tLSqqqb7pHL5UlyuVZjct6xAd/3h4LNGAVYgr+rgHDg91n3W/Py8pCO+KKiovT0ovSn6RjBoTXZjbZuwocCmIBtoquCAEvYzk+gKzzc0NHf2Wnh8UWYp5izJLxDjrGanN3ddACRkVcyeEGMmyCOCc77EcHWrlBDR88BsvwqiqdwGiZBBRQx0t0NfP7CpDe+sEvZDKhhJrnlV3R1dPSQ5QO/geIfQ8644qFIQgN9FmUkkwv5NmlRvGsGCXAK3Ho0ozmK8YHO4CdOiBykCM3I8HAO8EGQSQV0xkSQjRUIPSLfi5Bm6D/lN5DFHz2K7BOnIREREfiLOXiDc/gVProEwTNB8JIKErAGKKKy0h87ZDMiv6SkoUEJqwf+McRTPoZYeMPTIhx2kubHMH364rsUBY284CUIKlAABggOQXL4iE4H+Crg83gasUKpxBpKLWq52v51mPBRAI+6xsYL+fHRNS4BhArmcpy0uUdH1q9UEjxGZMDsPjNl3qyFC2fNm7LNotY6HzwQXtZpz0CQn59fU1NDBJAETGVlwju4d4KMOgtpDwiQzwz8GIjDfP/MUtercOK8bRbrj4eARz4viBcE2Sjgo4evxYpSXQld/6GjEMSLaxhSLvb3eIBM7dRmYloIn1UAhmIw3BIEOzl/o+4L4e8GPhMwAyqGPi7hvLK080cs8N0EtURQUFAMucUH7rWAHh02CPgQovA2nDAPvV/FiTJ1JLYFwgvyiaCOCLKLiyt4QeIcLtjysaQN1r/nEDVgmAFjNp9cN1Es8Ns2mEYEZe20gNramrq6AgiWwCqQ6kraGpT7CJ8ZmOKMOUKxbrrPf0J/puH6y8ra29vziaCOCRJpAYU7uSm6tjbk8/EexDFzxPV1yzmf2eEAOgQEyGcCFQhoCldzUz/C+nfvgYgMGLNZ0ft5mm+B1CHwsyZPBn45EagKVCqVIHiyhpv9Fvgo8N2kob29ijeTfAskDspvzcqaDCkHQVMT4CGJKsLXP1nGbWwDPhh8K4YsvQqFYuEor/EyR1l7K4QIyiFNTU2Un5hK+Hp4361s2wdoHwbSoMe9108qTo4i8FvvaKV8FFA+UaSqUlP1qXrgJ/r9Ks18XpsGwzge13W2a62uYDd1bGUycQNBBEHxx8FQm7SlQtGmmEPBPyC3XnbzMnBzvThvW3qZpzmChV5GDg14iDCpVbAteJmMWZg9DYbbGPg8fdum7dtsXfdhjJ2+nzzvN+/7BsZMqZANhk7L9PKV+FcUxbipYAfSkdnZ2doAH4HXBFAcwFF0RyXZ+AshAsK3H5APmAisX3bekHxgGwUYjwLC0tIBfAG7VXz6jjMknycS8PxxzaTkKzskHJjb3t7+A9QFKxAP+Zdxx8tPERD423vAAVCQcZq8pkf1+DkQrEL+58+QvwIsrSwBFbzz7TUB0GKACp6LOIAgKCb74PYOCSf5qxCPrDQElYfVU1Fm2aqCepe+fR/FASIBfbxj/sWjevwqMDND4gmfgOXKVQYYkVmgkyHJjeICCYECZ+kkOH9khAMLCwu/AcgmLO8NM8iQ6qsbsAWj6eR7Sarmh4N6pxJu7ZP4mXr8OxAA1XBgz1vbjrwhgHBjUye3cICYEOBC+l06f3J/dc5Ih3hgbW0Ns5FPe2NMjZsqW4UIDEPy5ygMEIEBQkGtn9oDM/vt6cDi4vr68vI6Pv+YtXEzpWqCVsWzF4EEDBAIcMFQqHiXEizszyy0pC8i6wA4Dva8fUydkRTPElpW6R8vStUGID9UoEeYPHxHso30eaAqKFWGmw9dGQXE0LSpkxukYg7yqRGQ4cPDNQhHSDoB4stjV1uOrPsq76NnSG6RFSKCYNFJnxTe+cPSPHn2BpVyeWySqWGUwPN8swEVyV+GACjo/QzF1WHvYqlcLpdKpUoFfsFfDx5fpC/vlI+nDYaAoHugNhrLlcnhx96xhw8ePBzzPh6+Yu10rN+TWb59lfwoiMUC4ZogGCqOM8fQZ+hp7HmWjGAoiAA7DtYEwSAU3SPnUj4ftUqUAAy2Xg2PUmzNYCjwLYrhNjAE4eK4pTfBhTyO0GpIf5BaBAinxwZ6HYFvNzx7K0LJbQJO0x19PbWQ9yHYtbGp4xIt4ApFT09DuPPQQksP/nQo0dgHhgCHsA2dFGd1TbT9R6Q/pfJthmQWBAIt4MK6Zjt2in7HjRz1wWzf9REaWy6Npx22TAm4gK57HCZjWFw2MZcRN6lX+j72jNRn8PsFKY4lBNsF4TAX1oqaZ8J1ra81fMBhi2aUjCjmRq10z2q1Z6PpZJaUQAmQQCCiFfW4Z9zmcLicTpfLMWHzRDM5RYxGRVHaxDU0XSTEWCMTARIpaJpezOiKosBzZzQtHkVEskAU7l2+oSCGENYcBoOZABGEGBJtYnO684E4lWebDXz6Ax5H+KYGjxUIbYJcwmLyeqXqRbNNI0RgkU4lUDbPmW9oGQ1EAUALUlyIhLnTCDJGwTQXduWmHnx8MjuKmw0MXQpikO869lxNyb6mHvzpcAJaAEOXAsh3Mscy1OiBR9K8KEENsLW6EyjKiUdh/1TeZyighgQYYIauBLkbQ8yJWN27apOh/n0U5rgTBEI8N93djWfPy0YPLFzOEmkaMRcImdxEt5fRpam8ypKTCQzpLQm/UuE7O2wugMe/cYqbqM+eSvkIOMOGCBsuhoqOAlQoyoTldJeou/7CYtNsKEGGCMAYlCASySjTp79IL9zJNxT/0lsifMWAQ6gpAoYBFt/jZHph5I6cUutVs1kRpsDVhkfGaPhBNEWZdjG9MjB4LyWrYIAhkm+zgpSAK4JYkLim5KJwP58Fy8jgPRkluE7+rZ+CKCUSEpJRckrU5rIwZ8Z66br7vioDajrNbvzKhgrI13HHgJF+ZsmQ87p90P3oJvDkyaD9unPIynTFf2y0lR3fgEikAAAAAElFTkSuQmCC";
var firefox = "data:image/png;base64,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";
var safari = "data:image/png;base64,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";

// IMPORTANT: This contents of this dangerouslySetInnerHTML CANNOT contain and
// code requiring transpilation as it will be included pre-transpilation.
const UpgradeBrowserScript = () => /*#__PURE__*/React.createElement("script", {
  id: "upgrade-browser-script",
  dangerouslySetInnerHTML: {
    __html: "(".concat(function () {
      const isIntersectionObserverSupported = function () {
        return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
      };
      const targetURI = '/upgrade-browser';
      const isTargetPath = window.location.pathname.indexOf(targetURI) !== -1;
      if (!isIntersectionObserverSupported() && !isTargetPath) {
        window.location.replace(targetURI);
      }
    }, ")()")
  }
});
const browsers = [{
  link: 'https://www.google.com/chrome/',
  label: 'Chrome',
  logo: chrome
}, {
  link: 'https://www.microsoft.com/en-us/edge',
  label: 'Edge',
  logo: edge
}, {
  link: 'https://www.mozilla.org/en-US/firefox/new/',
  label: 'Firefox',
  logo: firefox
}, {
  link: 'https://support.apple.com/downloads/safari',
  label: 'Safari',
  logo: safari
}];
const UpgradeBrowserPage = () => {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    themeType: "onWhite"
  }, /*#__PURE__*/React.createElement(Section, {
    name: "Upgrade Browser",
    textAlign: "center",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Container$4, {
    maxWidth: "md"
  }, /*#__PURE__*/React.createElement(StyledKlickLogo, null), /*#__PURE__*/React.createElement(Heading, {
    variant: "h3",
    component: "h1"
  }, "Your browser is not supported."), /*#__PURE__*/React.createElement(P, {
    variant: "blurb2"
  }, "As a future forward company with strong digital roots, we pride ourselves on building experiences online that truly stand out. To ensure the best experience for our visitors, we have made the decision to no longer support legacy browsers."), /*#__PURE__*/React.createElement(P, {
    variant: "blurb2"
  }, "We encourage you to enjoy this website to the fullest by updating your browser or downloading one of the following browsers:"), /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, browsers.map(_ref => {
    let {
      link,
      logo,
      label
    } = _ref;
    return /*#__PURE__*/React.createElement(StyledLogo, {
      key: link
    }, /*#__PURE__*/React.createElement(ExternalLink, {
      href: link
    }, /*#__PURE__*/React.createElement("img", {
      height: "48",
      width: "48",
      src: logo,
      alt: label
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(P, {
      variant: "body1"
    }, /*#__PURE__*/React.createElement(StyledLink, {
      href: link,
      component: ExternalLink
    }, label)));
  })))));
};
const StyledKlickLogo = styled(KlickLogo).withConfig({
  displayName: "UpgradeBrowser__StyledKlickLogo",
  componentId: "sc-b3ymjv-0"
})(["height:130px;display:inline-block;margin:", ";"], _ref2 => {
  let {
    theme
  } = _ref2;
  return "0 0 ".concat(theme.spacing(3), "px 0");
});
const StyledLogo = styled.div.withConfig({
  displayName: "UpgradeBrowser__StyledLogo",
  componentId: "sc-b3ymjv-1"
})(["display:inline-block;padding-right:24px;&:last-child{padding-right:0;}"]);
const StyledLink = styled(TextLink).withConfig({
  displayName: "UpgradeBrowser__StyledLink",
  componentId: "sc-b3ymjv-2"
})(["color:", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.text.primary;
});
export { AccessibilityDialog$1 as AccessibilityDialog, AccessibilityProvider, Accordion, AddressField, AutoCompleteField, AvoidWrap, BackToTop, BreakoutItem, Button, ButtonLoader, Carousel, Checkbox$1 as Checkbox, CheckboxGroup, CircleImage, ClientOnly, ConsentText, ContentBlock, ContentReveal, ContentfulImageWrapper as ContentfulImage, Copyright, Decorator, ResponsiveDialog as Dialog, DotCircle, DoubleSlideshow, Ecosystem, Em, EnhancedProvider, ExternalLink, EyebrowBar$1 as EyebrowBar, FadeIn$1 as FadeIn, Footer$1 as Footer, Heading, Hero, HeroMaskIntro, HeroVideo, Hr, ImageVideo, InView, InViewContext, InternalLink, IntroProvider, KlickLogo, LanguagePicker$1 as LanguagePicker, LazyLoad, Link, LogoCarousel, MainNavBar, MobileFirstVideo, ModalProvider, MuiSelectField, NoWrap, Ol, OneTrustController$1 as OneTrustController, P, Page404, People, PlyrVideo, RadioGroup, ReactJWPlayer, ScrollIndicator, ScrollProvider, ScrollToTop as ScrollTo, Section, SelectField as Select, Seo, ShadowBox, SkipToContentBar, SocialButtons, Stack, TextField, TextLink, ThemeProvider, TrapFocus, TwoColumnGrid, Ul, UpgradeBrowserPage, UpgradeBrowserScript, UploadField, UploadFileToLeverField as UploadToLeverField, VideoPlayer, WithCircle, brandColors, brandStyles, calcPageFillRadius, capitalize$1 as capitalize, checkScrollAmount, consoleKlickSignature, deleteAllCookies, getCookie, getDataFromJsonQuery, getDevicePixelRatio, getRandomInt, getStorageItem, getTxtURLFromTranscript, groupBy, handleToggleInfoDisplay, hsIdentify, isBrowser, isIntersectionObserverSupported, loadScript, match, msToTime, reduceImages, removeStorageItem, setCookie, setStorageItem, storageItemExists$1 as storageItemExists, themes, timestampToTime, tracking, useAccessibilityContext, useEnhancedContext, useGSAPLabels, useI18nBridge, useInViewContext, useInstance, useIntersect, useIntroContext, useModalContext, useParallax, useQueryLatestData, useResizeObserver, useScrollAnimation, useScrollDispatchContext, useScrollStateContext, vttObjectToTranscript, vttToObject, withI18next };